/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AccountNumber: string;
  BigInt: number;
  Byte: number;
  CountryCode: string;
  CountryName: string;
  Cuid: string;
  Currency: string;
  DID: string;
  Date: string;
  DateTime: string;
  DateTimeISO: string;
  DeweyDecimal: string;
  Duration: string;
  EmailAddress: string;
  GUID: string;
  GeoJSON: string;
  HSL: string;
  HSLA: string;
  HexColorCode: string;
  Hexadecimal: string;
  IBAN: string;
  IP: string;
  IPCPatent: string;
  IPv4: string;
  IPv6: string;
  ISBN: string;
  ISO8601Duration: string;
  JSON: unknown;
  JSONObject: Record<string, unknown>;
  JWT: string;
  LCCSubclass: string;
  Latitude: number;
  LocalDate: string;
  LocalDateTime: string;
  LocalEndTime: string;
  LocalTime: string;
  Locale: string;
  Long: number;
  Longitude: number;
  MAC: string;
  NegativeFloat: number;
  NegativeInt: number;
  NonEmptyString: string;
  NonNegativeFloat: number;
  NonNegativeInt: number;
  NonPositiveFloat: number;
  NonPositiveInt: number;
  ObjectID: string;
  PhoneNumber: string;
  Port: number;
  PositiveFloat: number;
  PositiveInt: number;
  PostalCode: string;
  RGB: string;
  RGBA: string;
  RoutingNumber: string;
  SESSN: string;
  SafeInt: number;
  SemVer: string;
  Time: string;
  TimeZone: string;
  Timestamp: number;
  URL: string;
  USCurrency: string;
  UUID: string;
  UnsignedFloat: number;
  UnsignedInt: number;
  UtcOffset: string;
  Void: void;
};

/** A profile within the current user's account, returned by currentAccountProfiles */
export type AccountMemberProfile = {
  __typename?: 'AccountMemberProfile';
  /** The account owner uid */
  accountOwnerUid?: Maybe<Scalars['ID']>;
  /** The account owner uuid */
  accountOwnerUuid?: Maybe<Scalars['ID']>;
  /** External ID for referencing user billing information */
  billingAccountId?: Maybe<Scalars['String']>;
  /** Additional external Number for referencing user billing information */
  billingAccountNumber?: Maybe<Scalars['String']>;
  /** Users birthday */
  birthday?: Maybe<Scalars['String']>;
  /** Source service from which user was created */
  creationSource?: Maybe<Scalars['String']>;
  /** Display name (firstName or username fallback) */
  displayName?: Maybe<Scalars['String']>;
  /** The user email */
  email?: Maybe<Scalars['String']>;
  /** Indicates email registered in both Gaia and an external system */
  emailRegisteredExternally?: Maybe<Scalars['Boolean']>;
  /** First name of the user */
  firstName?: Maybe<Scalars['String']>;
  /** Last name of the user */
  lastName?: Maybe<Scalars['String']>;
  /** Profile picture URLs matching REST portal endpoint format */
  profilePicture?: Maybe<ProfilePictureUrls>;
  /** The status of the user */
  status?: Maybe<Scalars['String']>;
  /** The legacy user id */
  uid: Scalars['ID'];
  /** UUID for referencing the UserAccount */
  userAccountId?: Maybe<Scalars['ID']>;
  /** Federated identity — Brooklyn resolves avatar on this */
  userInfo?: Maybe<UserInfoPublic>;
  /** Public username */
  username?: Maybe<Scalars['String']>;
  /** The user UUID */
  uuid?: Maybe<Scalars['ID']>;
};

export type AdjacentCenter = {
  __typename?: 'AdjacentCenter';
  adjacencyType: Scalars['String'];
  centerId: Scalars['Int'];
  centerName: Scalars['String'];
  sharedContentCount: Scalars['Int'];
};

export type AlchemizePlaylistInput = {
  /** Content language (affects retrieval and metadata language) */
  language?: InputMaybe<Scalars['String']>;
  /** Maximum number of videos to return (default 10, max 15) */
  maxVideos?: InputMaybe<Scalars['Int']>;
  /** Free-text prompt describing the desired playlist */
  prompt: Scalars['String'];
  /** Target total playlist duration in minutes (optional — LLM will aim for this) */
  targetDurationMinutes?: InputMaybe<Scalars['Int']>;
};

export type AlchemizePlaylistResult = {
  __typename?: 'AlchemizePlaylistResult';
  /** Whether the playlist contains practice content (yoga/meditation/fitness) vs non-practice */
  isPractice: Scalars['Boolean'];
  /** Editorial narrative describing the playlist (1-2 sentences) */
  narrative?: Maybe<Scalars['String']>;
  /** Suggested playlist name (3-8 words, auto-populates name field) */
  suggestedName?: Maybe<Scalars['String']>;
  /** Sum of all video durations in seconds */
  totalDurationSeconds: Scalars['Int'];
  /** Ordered list of videos forming the playlist */
  videos: Array<AlchemizePlaylistVideo>;
};

export type AlchemizePlaylistVideo = {
  __typename?: 'AlchemizePlaylistVideo';
  centers?: Maybe<Array<Scalars['String']>>;
  /** Federated Content entity for full resolution (avoid querying nested fields — use flat fields above instead) */
  content?: Maybe<Content>;
  /** Content business key (shared across translations) */
  contentId: Scalars['Int'];
  contentType: Scalars['String'];
  durationSeconds?: Maybe<Scalars['Int']>;
  episodeNumber?: Maybe<Scalars['Int']>;
  focus?: Maybe<Scalars['String']>;
  genres?: Maybe<Array<Scalars['String']>>;
  /** Database primary key — required for Content federation */
  id: Scalars['ID'];
  instructor?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  seasonNumber?: Maybe<Scalars['Int']>;
  seriesTitle?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** Ambassador lead */
export type AmbassadorLead = {
  __typename?: 'AmbassadorLead';
  /** The ambassador ID */
  ambassadorId?: Maybe<Scalars['Int']>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The ambassador email */
  email: Scalars['String'];
  /** When this ambassador lead expires */
  expiresAt: Scalars['DateTime'];
  /** The primary identifier for this record */
  id: Scalars['ID'];
  /** When the postback was sent */
  postbackSentAt?: Maybe<Scalars['DateTime']>;
  /** Ambassador ID before Everflow migration */
  preMigrationAmbassadorId?: Maybe<Scalars['Int']>;
  /** The ambassador referral ID */
  referralId?: Maybe<Scalars['String']>;
  /** The ambassador referral source */
  referralSource?: Maybe<Scalars['String']>;
  /** The ambassador referral source ID */
  referralSourceId?: Maybe<Scalars['Int']>;
  /** The ambassador tracking data */
  trackingData: Scalars['JSON'];
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The associated user info uuid */
  userInfoUuid?: Maybe<Scalars['ID']>;
  /** The ambassador UTM campaign */
  utmCampaign?: Maybe<Scalars['String']>;
  /** The ambassador UTM medium */
  utmMedium?: Maybe<Scalars['String']>;
  /** The ambassador UTM source */
  utmSource?: Maybe<Scalars['String']>;
  /** The uuid value */
  uuid: Scalars['ID'];
};

/** Ambassador lead where created at input type */
export type AmbassadorLeadWhereCreatedAtInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['DateTime']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['DateTime']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['DateTime']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']>;
};

/** Ambassador lead where id input type */
export type AmbassadorLeadWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Ambassador lead where updated at input type */
export type AmbassadorLeadWhereUpdatedAtInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['DateTime']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['DateTime']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['DateTime']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']>;
};

/** Ambassador lead count response */
export type AmbassadorLeadsCountResponse = {
  __typename?: 'AmbassadorLeadsCountResponse';
  /** The number of rows */
  count: Scalars['Int'];
};

/** Ambassador lead list response */
export type AmbassadorLeadsListResponse = {
  __typename?: 'AmbassadorLeadsListResponse';
  /** A list of Ambassador lead */
  ambassadorLeads: Array<AmbassadorLead>;
};

export type AmbassadorLeadsS3Input = {
  /** The object access control policy */
  acl?: InputMaybe<S3Acl>;
  /** The primary identifier for the file */
  fileName: Scalars['ID'];
};

/** Ambassador lead upload file response */
export type AmbassadorLeadsUploadFileToS3Response = {
  __typename?: 'AmbassadorLeadsUploadFileToS3Response';
  /** Total ambassador leads rows processed */
  ambassadorLeadsProcessed: Scalars['Int'];
  /** The max ambassador lead id processed */
  maxAmbassadorLeadIdProcessed: Scalars['Int'];
};

/** Ambassador lead where conditions to filter rows */
export type AmbassadorLeadsWhereInput = {
  /** The created at field where clause */
  createdAt?: InputMaybe<AmbassadorLeadWhereCreatedAtInput>;
  /** The id field where clause */
  id?: InputMaybe<AmbassadorLeadWhereIdInput>;
  /** The updated at field where clause */
  updatedAt?: InputMaybe<AmbassadorLeadWhereUpdatedAtInput>;
};

/** API key for machine-to-machine access; maps to a user, roles, and OAuth/API scopes. */
export type ApiKey = {
  __typename?: 'ApiKey';
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  keyPrefix: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  roleIds: Array<Scalars['Int']>;
  scope?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ApiKeyListResponse = {
  __typename?: 'ApiKeyListResponse';
  apiKeys?: Maybe<Array<Maybe<ApiKey>>>;
  count?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type ApiKeyListWhereEnabledInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
};

export type ApiKeyListWhereIdInput = {
  eq?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
};

export type ApiKeyListWhereInput = {
  enabled?: InputMaybe<ApiKeyListWhereEnabledInput>;
  id?: InputMaybe<ApiKeyListWhereIdInput>;
  userInfoUuid?: InputMaybe<ApiKeyListWhereUserInfoUuidInput>;
};

export type ApiKeyListWhereUserInfoUuidInput = {
  eq?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
};

/** Result of create or revoke API key mutations */
export type ApiKeyMutationResponse = {
  __typename?: 'ApiKeyMutationResponse';
  apiKey?: Maybe<ApiKey>;
  /** Only set on create — the secret key string shown once */
  plainTextKey?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AppError = {
  __typename?: 'AppError';
  code: Scalars['String'];
  message: Scalars['String'];
};

/**
 * Asset represents a file (image, video, document, text track, etc.) that can be associated with content.
 *
 * Conceptually, assets are the actual files stored in cloud storage (AWS S3, ImgIX, Brightcove, etc.)
 * that are referenced by content. Assets can include:
 * - Images (thumbnails, posters, artwork)
 * - Video files
 * - Text tracks (subtitles, closed captions, chapters)
 * - Documents (PDFs, etc.)
 *
 * ASSET vs IMAGE PREFERENCE:
 * Assets are PREFERRED over Images for accessing content-related files. Assets have a deterministic
 * relationship to content through ContentAssetReference, which provides a clear, predictable way to
 * associate files with content. Images exist for backward compatibility but have a non-deterministic
 * relationship to content through ImageContentRelationship, making them less reliable for programmatic access.
 * Always prefer using Assets (via contentAssetReferences) over Images when possible.
 *
 * Important Usage Notes:
 * - To get the actual asset file, use the renderUrl field and make an HTTP GET request to that URL.
 *   This is the most efficient way to retrieve asset data, as it leverages CDN caching and direct
 *   file access rather than going through GraphQL.
 *
 * - The renderUrl supports query parameters for dynamic image transformations:
 *   - w: width (1-7680 pixels)
 *   - h: height (1-4320 pixels)
 *   - fm: format (e.g., "jpg", "png", "webp")
 *   - q: quality (1-100)
 *   - auto: auto optimization
 *   - upscale: allow upscaling (boolean)
 *   - cs: color space (e.g., "strip", "srgb")
 *   - genFill: generate fill for missing image margins (boolean)
 *
 *   Example: renderUrl + "?w=800&h=600&fm=webp&q=85" to get a WebP image at 800x600 with 85% quality.
 *
 * - For text tracks (subtitles, closed captions): If you only need the raw VTT file data, it is
 *   more efficient to access the renderUrl directly via REST/HTTP rather than using GraphQL.
 *   GraphQL is better when you need parsed metadata or relationships, but for raw file content,
 *   direct URL access is preferred.
 */
export type Asset = {
  __typename?: 'Asset';
  /** The asset providers directly linked to this asset */
  assetProviders?: Maybe<Array<Maybe<AssetProvider>>>;
  /** The content asset reference directly linked to this asset */
  contentAssetReference?: Maybe<ContentAssetReference>;
  /** Get course item progress for this asset (if it is an asset in a course) */
  courseItemProgress?: Maybe<UserStateProgressCourseItem>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The optional duration of the asset in seconds for assets that have a duration e.g. videos */
  duration?: Maybe<Scalars['Int']>;
  /** The hash of the file to allow checking of assets changes without loading the file */
  fileHash?: Maybe<Scalars['String']>;
  /** The file size in bytes */
  fileSize?: Maybe<Scalars['Int']>;
  /** The height of the asset in pixels for assets that have a height */
  height?: Maybe<Scalars['Int']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /**
   * The image linked to the asset (if this asset is associated with an Image record).
   * NOTE: Assets are preferred over Images. This field exists for backward compatibility with the Image type.
   * Use contentAssetReference to access the deterministic relationship to content instead.
   */
  image?: Maybe<Image>;
  /** The optional language of asset that was used to create all of the translations (NULL if the file has no language) */
  language?: Maybe<Scalars['String']>;
  /** The mime type of the asset */
  mimeType?: Maybe<Scalars['String']>;
  /** The original name of the file for the asset */
  originalFileName?: Maybe<Scalars['String']>;
  /** The URL for the provider when proxing the asset for internal usage (do not use this in an application) */
  providerSourceRenderUrl?: Maybe<Scalars['String']>;
  /** The provider to render the asset */
  renderProvider?: Maybe<AssetProviders>;
  /**
   * The URL to retrieve and display the asset in an application.
   * This is the most efficient way to get the actual asset file - make an HTTP GET request to this URL.
   * Supports query parameters for dynamic transformations (w, h, fm, q, auto, upscale, cs, genFill).
   * For text tracks, accessing this URL directly via REST is preferred over GraphQL if you only need raw data.
   */
  renderUrl?: Maybe<Scalars['String']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The public identifier for this record to be used with external api calls */
  uuid?: Maybe<Scalars['ID']>;
  /** The width of the asset in pixels for assets that have a width */
  width?: Maybe<Scalars['Int']>;
};


/**
 * Asset represents a file (image, video, document, text track, etc.) that can be associated with content.
 *
 * Conceptually, assets are the actual files stored in cloud storage (AWS S3, ImgIX, Brightcove, etc.)
 * that are referenced by content. Assets can include:
 * - Images (thumbnails, posters, artwork)
 * - Video files
 * - Text tracks (subtitles, closed captions, chapters)
 * - Documents (PDFs, etc.)
 *
 * ASSET vs IMAGE PREFERENCE:
 * Assets are PREFERRED over Images for accessing content-related files. Assets have a deterministic
 * relationship to content through ContentAssetReference, which provides a clear, predictable way to
 * associate files with content. Images exist for backward compatibility but have a non-deterministic
 * relationship to content through ImageContentRelationship, making them less reliable for programmatic access.
 * Always prefer using Assets (via contentAssetReferences) over Images when possible.
 *
 * Important Usage Notes:
 * - To get the actual asset file, use the renderUrl field and make an HTTP GET request to that URL.
 *   This is the most efficient way to retrieve asset data, as it leverages CDN caching and direct
 *   file access rather than going through GraphQL.
 *
 * - The renderUrl supports query parameters for dynamic image transformations:
 *   - w: width (1-7680 pixels)
 *   - h: height (1-4320 pixels)
 *   - fm: format (e.g., "jpg", "png", "webp")
 *   - q: quality (1-100)
 *   - auto: auto optimization
 *   - upscale: allow upscaling (boolean)
 *   - cs: color space (e.g., "strip", "srgb")
 *   - genFill: generate fill for missing image margins (boolean)
 *
 *   Example: renderUrl + "?w=800&h=600&fm=webp&q=85" to get a WebP image at 800x600 with 85% quality.
 *
 * - For text tracks (subtitles, closed captions): If you only need the raw VTT file data, it is
 *   more efficient to access the renderUrl directly via REST/HTTP rather than using GraphQL.
 *   GraphQL is better when you need parsed metadata or relationships, but for raw file content,
 *   direct URL access is preferred.
 */
export type AssetCourseItemProgressArgs = {
  courseTitleGroupId: Scalars['String'];
};

/** Asset filter input */
export type AssetFilterInput = {
  /** The asset language */
  language?: InputMaybe<Scalars['String']>;
};

/** Asset */
export type AssetProvider = {
  __typename?: 'AssetProvider';
  /** The asset linked to this asset provider */
  asset?: Maybe<Asset>;
  /** The the asset linked to this provider */
  assetsId?: Maybe<Scalars['ID']>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** The provider where the asset is stored e.g. AWS_S3 */
  provider?: Maybe<AssetProviders>;
  /** The unique key for the asset on providers system e.g. on S3 it would be file key or it might be a url for an external provider */
  providerKey?: Maybe<Scalars['String']>;
  /** The url to render this specific provider asset (in an application it is preferred to use the asset render url) */
  renderUrl?: Maybe<Scalars['String']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** AssetProvider where id input */
export type AssetProviderWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** AssetProvider where input */
export type AssetProviderWhereInput = {
  /** AssetProvider where id clause */
  id?: InputMaybe<AssetProviderWhereIdInput>;
};

/** Asset providers */
export enum AssetProviders {
  /** AWS S3 */
  AwsS3 = 'AWS_S3',
  /** The Brightcove assets service */
  BrightcoveImages = 'BRIGHTCOVE_IMAGES',
  /** The ImgIX assets service */
  Imgix = 'IMGIX'
}

/** AssetProviders list response */
export type AssetProvidersListResponse = {
  __typename?: 'AssetProvidersListResponse';
  /** A list of assetProviders */
  assetProviders?: Maybe<Array<Maybe<AssetProvider>>>;
};

/** Asset where id input */
export type AssetWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** Asset where input */
export type AssetWhereInput = {
  /** Asset where id clause */
  id?: InputMaybe<AssetWhereIdInput>;
  /** Asset where language clause */
  language?: InputMaybe<AssetWhereLanguageInput>;
  /** Asset where mimeTypes clause */
  mimeType?: InputMaybe<AssetWhereMimeTypeInput>;
  /** Asset where uuid clause */
  uuid?: InputMaybe<AssetWhereUuidInput>;
};

/** Asset where language input */
export type AssetWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type AssetWhereMimeTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Asset where uuid input */
export type AssetWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Assets list response */
export type AssetsListResponse = {
  __typename?: 'AssetsListResponse';
  /** A list of assets */
  assets?: Maybe<Array<Maybe<Asset>>>;
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
};

/** Result of attaching Brightcove CMS captions to existing Gaia clips for playlist videos */
export type AttachClipCaptionsFromBrightcovePlaylistResponse = {
  __typename?: 'AttachClipCaptionsFromBrightcovePlaylistResponse';
  /** Non-fatal caption/text-track issues (does not increment failureCount) */
  captionWarnings: Array<ClipImportCaptionWarning>;
  errors: Array<ClipImportError>;
  /** Per-video failures (Brightcove fetch, etc.; matches errors length) */
  failureCount: Scalars['Int'];
  /** Playlist videos where an ms_clip existed and caption import ran */
  processedCount: Scalars['Int'];
  /** Skips: no Gaia clip for Brightcove video id */
  skipped: Array<ClipImportSkippedRow>;
  /** Playlist videos with no Gaia clip for that Brightcove id */
  skippedCount: Scalars['Int'];
};

/** Audit Category Type */
export enum AuditCategoryType {
  /** Ambassador */
  Ambassador = 'ambassador',
  /** Billing */
  Billing = 'billing',
  /** User */
  User = 'user'
}

/** Audit Field Name */
export enum AuditFieldName {
  AccountOwnerChange = 'ACCOUNT_OWNER_CHANGE',
  AnonymizeUser = 'ANONYMIZE_USER',
  Active = 'Active',
  BusinessName = 'BusinessName',
  Cancel = 'CANCEL',
  Chargeback = 'CHARGEBACK',
  Comp = 'COMP',
  CurrencyChange = 'CURRENCY_CHANGE',
  ContactEmail = 'ContactEmail',
  ContactName = 'ContactName',
  Created = 'Created',
  EmailChange = 'EMAIL_CHANGE',
  EntitlementAdded = 'ENTITLEMENT_ADDED',
  EntitlementChange = 'ENTITLEMENT_CHANGE',
  EntitlementRemoved = 'ENTITLEMENT_REMOVED',
  EverflowAffiliateId = 'EverflowAffiliateId',
  GiftPurchase = 'GIFT_PURCHASE',
  GiftRedemption = 'GIFT_REDEMPTION',
  Hold = 'HOLD',
  LeadExpirationOverrideDays = 'LeadExpirationOverrideDays',
  NameChangeFirst = 'NAME_CHANGE_FIRST',
  NameChangeLast = 'NAME_CHANGE_LAST',
  PasswordChange = 'PASSWORD_CHANGE',
  PlanChange = 'PLAN_CHANGE',
  PostalCodeChange = 'POSTAL_CODE_CHANGE',
  PostalCodeCleanup = 'POSTAL_CODE_CLEANUP',
  ProfileAdd = 'PROFILE_ADD',
  ProfileDelete = 'PROFILE_DELETE',
  Parent = 'Parent',
  PayoutCurrency = 'PayoutCurrency',
  Processed = 'Processed',
  Reactivation = 'REACTIVATION',
  Refund = 'REFUND',
  RefundCancel = 'REFUND_CANCEL',
  RefundDowngrade = 'REFUND_DOWNGRADE',
  RemovePaymentMethods = 'REMOVE_PAYMENT_METHODS',
  Resume = 'RESUME',
  Relationship = 'Relationship',
  RelationshipOwner = 'RelationshipOwner',
  ResidenceCountry = 'ResidenceCountry',
  Ripple1Percentage = 'Ripple1Percentage',
  Ripple2Percentage = 'Ripple2Percentage',
  Signup = 'SIGNUP',
  StatusChange = 'STATUS_CHANGE',
  StartedAt = 'StartedAt',
  UpdateBillingAddress = 'UPDATE_BILLING_ADDRESS',
  UpdatePaymentMethod = 'UPDATE_PAYMENT_METHOD',
  UsernameChange = 'USERNAME_CHANGE',
  UserSubscriptionImport = 'USER_SUBSCRIPTION_IMPORT'
}

/** Auth role */
export type AuthRole = {
  __typename?: 'AuthRole';
  /** The time in milliseconds where expired authentication will still be considered valid and renewed for users with this role, null is infinity */
  authenticationExpiredValidMilliseconds?: Maybe<Scalars['Int']>;
  /** The time in milliseconds where authentication should expire for users with this role, null is infinity */
  authenticationExpiresMilliseconds?: Maybe<Scalars['Int']>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The description of the role */
  description?: Maybe<Scalars['String']>;
  /** The maximum allowed failed login attempt for users with this role, null is infinity */
  maxFailedLoginAttempts?: Maybe<Scalars['Int']>;
  /** The name of the role */
  name: Scalars['String'];
  /** The primary key */
  role: Scalars['ID'];
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user roles associated with this record */
  userRoles?: Maybe<Array<Maybe<UserRole>>>;
};


/** Auth role */
export type AuthRoleUserRolesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Input type for creating a new auth role */
export type AuthRoleCreateInput = {
  /** The time in milliseconds where expired authentication will still be considered valid and renewed for users with this role, null is infinity */
  authenticationExpiredValidMilliseconds?: InputMaybe<Scalars['Int']>;
  /** The time in milliseconds where authentication should expire for users with this role, null is infinity */
  authenticationExpiresMilliseconds?: InputMaybe<Scalars['Int']>;
  /** The description of the role */
  description?: InputMaybe<Scalars['String']>;
  /** The maximum allowed failed login attempt for users with this role, null is infinity */
  maxFailedLoginAttempts?: InputMaybe<Scalars['Int']>;
  /** The name of the role */
  name: Scalars['String'];
  /** The primary key (optional) */
  role?: InputMaybe<Scalars['ID']>;
};

/** Input type for deleting an existing auth role */
export type AuthRoleDeleteInput = {
  /** The primary key of the auth role to delete */
  role: Scalars['ID'];
};

/** Auth role list response */
export type AuthRoleListResponse = {
  __typename?: 'AuthRoleListResponse';
  /** A list of userInfo reference */
  authRoles?: Maybe<Array<Maybe<AuthRole>>>;
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
};

/** Auth role where conditions to filter rows */
export type AuthRoleListWhereInput = {
  /** The name field where clause */
  name?: InputMaybe<AuthRoleListWhereNameInput>;
  /** The role field where clause */
  role?: InputMaybe<AuthRoleListWhereRoleInput>;
};

/** Auth role name where input type */
export type AuthRoleListWhereNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Auth role id where input type */
export type AuthRoleListWhereRoleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** Response object containing a boolean property of success and the created/deleted auth role */
export type AuthRoleMutationResponse = {
  __typename?: 'AuthRoleMutationResponse';
  /** The created or deleted auth role */
  authRole?: Maybe<AuthRole>;
  /** A boolean property of success indicating whether the operation was successful */
  success: Scalars['Boolean'];
};

/** Input type for updating an existing auth role */
export type AuthRoleUpdateInput = {
  /** The time in milliseconds where expired authentication will still be considered valid and renewed for users with this role, null is infinity (optional) */
  authenticationExpiredValidMilliseconds?: InputMaybe<Scalars['Int']>;
  /** The time in milliseconds where authentication should expire for users with this role, null is infinity (optional) */
  authenticationExpiresMilliseconds?: InputMaybe<Scalars['Int']>;
  /** The description of the role (optional) */
  description?: InputMaybe<Scalars['String']>;
  /** The maximum allowed failed login attempt for users with this role, null is infinity (optional) */
  maxFailedLoginAttempts?: InputMaybe<Scalars['Int']>;
  /** The name of the role */
  name?: InputMaybe<Scalars['String']>;
  /** The primary key of the auth role to update */
  role: Scalars['ID'];
};

/** Registered OAuth scope (gaia:resource:action) */
export type AuthScope = {
  __typename?: 'AuthScope';
  /** Created at */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Description */
  description?: Maybe<Scalars['String']>;
  /** Primary key */
  id: Scalars['ID'];
  /** Scope token */
  name: Scalars['String'];
  /** Updated at */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Result of checking scope strings against OIDC built-ins and the auth_scope registry (same rules as OAuth2 authorize/token). */
export type AuthScopeCheckResponse = {
  __typename?: 'AuthScopeCheckResponse';
  /** Invalid tokens in first-seen order; duplicates appear once. */
  invalidScopes: Array<Scalars['String']>;
  /** True when every parsed token is valid (no invalid scopes). */
  success: Scalars['Boolean'];
  /** Valid tokens in first-seen order (OIDC built-in or registered gaia: name); duplicates appear once. */
  validScopes: Array<Scalars['String']>;
};

export type AuthScopeCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type AuthScopeDeleteInput = {
  id: Scalars['ID'];
};

export type AuthScopeListResponse = {
  __typename?: 'AuthScopeListResponse';
  authScopes?: Maybe<Array<Maybe<AuthScope>>>;
  count?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type AuthScopeListWhereIdInput = {
  eq?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
};

export type AuthScopeListWhereInput = {
  id?: InputMaybe<AuthScopeListWhereIdInput>;
  name?: InputMaybe<AuthScopeListWhereNameInput>;
};

export type AuthScopeListWhereNameInput = {
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AuthScopeMutationResponse = {
  __typename?: 'AuthScopeMutationResponse';
  authScope?: Maybe<AuthScope>;
  success: Scalars['Boolean'];
};

export type AuthScopeUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

/** Payload aligned with GET /v1/authentication/check `payload` (uid, roles, JWT scope tokens, …). */
export type AuthenticationCheckPayload = {
  __typename?: 'AuthenticationCheckPayload';
  audience?: Maybe<Array<Maybe<Scalars['String']>>>;
  authType?: Maybe<Scalars['String']>;
  authenticationGroupId: Scalars['Int'];
  clientAttributes: Array<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  grantType?: Maybe<Scalars['String']>;
  issuer?: Maybe<Scalars['String']>;
  jti?: Maybe<Scalars['String']>;
  jwt?: Maybe<Scalars['String']>;
  privateKeyId?: Maybe<Scalars['String']>;
  roles: Array<Scalars['Int']>;
  scopes: Array<Scalars['String']>;
  sub?: Maybe<Scalars['String']>;
  subscriptions: Array<Scalars['Int']>;
  uid: Scalars['Int'];
  userAccountAuthenticationGroupId: Scalars['Int'];
  userAccountId: Scalars['String'];
  uuid: Scalars['String'];
};

/** Response from requesting a banner image upload */
export type BannerImageUploadRequest = {
  __typename?: 'BannerImageUploadRequest';
  /** When the presigned URL expires */
  expiresAt: Scalars['DateTime'];
  /** UUID for the pending image */
  imageUuid: Scalars['ID'];
  /** Presigned S3 PUT URL */
  uploadUrl: Scalars['String'];
};

/** Response from confirming a banner image upload */
export type BannerImageUploadResponse = {
  __typename?: 'BannerImageUploadResponse';
  /** The banner image URL */
  bannerImage?: Maybe<ProfileBannerImage>;
  /** Whether the upload was confirmed successfully */
  success: Scalars['Boolean'];
};

/** Billing Account */
export type BillingAccount = {
  __typename?: 'BillingAccount';
  /** Whether this account has been closed */
  accountClosed?: Maybe<Scalars['Boolean']>;
  /** Billing Provider associated with this Billing Account */
  billingProvider?: Maybe<BillingProvider>;
  /** The billing provider ID of the billing account */
  billingProviderId?: Maybe<Scalars['Int']>;
  /** The date the user accepted the cancel offer */
  cancelOfferAcceptedDate?: Maybe<Scalars['Date']>;
  /** The country for the billing account */
  country?: Maybe<Scalars['String']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The currency for the billing account */
  currency?: Maybe<Scalars['String']>;
  /** The id of the billing account */
  id?: Maybe<Scalars['ID']>;
  /** Whether the initial authorization was successful */
  initialAuthSuccess?: Maybe<Scalars['Boolean']>;
  /** The postal code for the billing account */
  postalCode?: Maybe<Scalars['String']>;
  /** Whether this is the primary billing account for the user */
  primaryAccount?: Maybe<Scalars['Boolean']>;
  /** The billing provider's account alternate ID for the billing account (Zuora only) */
  providerAccountAltId?: Maybe<Scalars['String']>;
  /** The billing provider's account ID for the billing account */
  providerAccountId?: Maybe<Scalars['String']>;
  /** The state for the billing account */
  state?: Maybe<Scalars['String']>;
  /** The tax jurisdiction code for the billing account (Avalara PCode) */
  taxJurisdictionCode?: Maybe<Scalars['String']>;
  /** When the row was updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** User associated with this Billing Account */
  userInfo?: Maybe<UserInfo>;
  /** The User UUID of the billing account */
  userInfoUuid?: Maybe<Scalars['ID']>;
  /** The UUID of the billing account */
  uuid?: Maybe<Scalars['ID']>;
};

/** Billing Account create input type */
export type BillingAccountCreateInput = {
  /** Whether this account has been closed */
  accountClosed?: InputMaybe<Scalars['Boolean']>;
  /** The billing provider ID of the billing account */
  billingProviderId: Scalars['Int'];
  /** The date the user accepted the cancel offer */
  cancelOfferAcceptedDate?: InputMaybe<Scalars['Date']>;
  /** The country for the billing account */
  country?: InputMaybe<Scalars['String']>;
  /** The currency for the billing account */
  currency: Scalars['String'];
  /** Whether the initial authorization was successful */
  initialAuthSuccess?: InputMaybe<Scalars['Boolean']>;
  /** The postal code for the billing account */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Whether this is the primary billing account for the user */
  primaryAccount: Scalars['Boolean'];
  /** The billing provider's account alternate ID for the billing account (Zuora only) */
  providerAccountAltId?: InputMaybe<Scalars['String']>;
  /** The billing provider's account ID for the billing account */
  providerAccountId: Scalars['String'];
  /** The state for the billing account */
  state?: InputMaybe<Scalars['String']>;
  /** The tax jurisdiction code for the billing account (Avalara PCode) */
  taxJurisdictionCode?: InputMaybe<Scalars['String']>;
  /** The User UUID of the billing account */
  userInfoUuid: Scalars['ID'];
  /** The UUID of the billing account */
  uuid?: InputMaybe<Scalars['ID']>;
};

/** Billing Account list response */
export type BillingAccountListResponse = {
  __typename?: 'BillingAccountListResponse';
  /** A list of billing account reference */
  billingAccounts?: Maybe<Array<Maybe<BillingAccount>>>;
};

/** Billing Account list where Boolean input type */
export type BillingAccountListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** Billing Account list where Date input type */
export type BillingAccountListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']>;
};

/** Billing Account list where ID input type */
export type BillingAccountListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing Account list where input type */
export type BillingAccountListWhereInput = {
  /** The billing account accountClosed field where clause */
  accountClosed?: InputMaybe<BillingAccountListWhereBooleanInput>;
  /** The billing account billingProviderId field where clause */
  billingProviderId?: InputMaybe<BillingAccountListWhereIntInput>;
  /** The billing account cancelOfferAcceptedDate field where clause */
  cancelOfferAcceptedDate?: InputMaybe<BillingAccountListWhereDateInput>;
  /** The billing account country field where clause */
  country?: InputMaybe<BillingAccountListWhereStringInput>;
  /** The billing account createdAt field where clause */
  createdAt?: InputMaybe<BillingAccountListWhereDateInput>;
  /** The billing account currency field where clause */
  currency?: InputMaybe<BillingAccountListWhereStringInput>;
  /** The billing account id field where clause */
  id?: InputMaybe<BillingAccountListWhereIdInput>;
  /** The billing account initialAuthSuccess field where clause */
  initialAuthSuccess?: InputMaybe<BillingAccountListWhereBooleanInput>;
  /** The billing account postalCode field where clause */
  postalCode?: InputMaybe<BillingAccountListWhereStringInput>;
  /** The billing account primaryAccount field where clause */
  primaryAccount?: InputMaybe<BillingAccountListWhereBooleanInput>;
  /** The billing account providerAccountAltId field where clause */
  providerAccountAltId?: InputMaybe<BillingAccountListWhereStringInput>;
  /** The billing account providerAccountId field where clause */
  providerAccountId?: InputMaybe<BillingAccountListWhereStringInput>;
  /** The billing account state field where clause */
  state?: InputMaybe<BillingAccountListWhereStringInput>;
  /** The billing account taxJurisdictionCode field where clause */
  taxJurisdictionCode?: InputMaybe<BillingAccountListWhereStringInput>;
  /** The billing account userInfoUuid field where clause */
  userInfoUuid?: InputMaybe<BillingAccountListWhereStringInput>;
  /** The billing account uuid field where clause */
  uuid?: InputMaybe<BillingAccountListWhereStringInput>;
};

/** Billing Account list where Int input type */
export type BillingAccountListWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Billing Account list where String input type */
export type BillingAccountListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Billing Account update input type */
export type BillingAccountUpdateInput = {
  /** Whether this account has been closed */
  accountClosed?: InputMaybe<Scalars['Boolean']>;
  /** The billing provider ID of the billing account */
  billingProviderId?: InputMaybe<Scalars['Int']>;
  /** The date the user accepted the cancel offer */
  cancelOfferAcceptedDate?: InputMaybe<Scalars['Date']>;
  /** The country for the billing account */
  country?: InputMaybe<Scalars['String']>;
  /** The currency for the billing account */
  currency?: InputMaybe<Scalars['String']>;
  /** The id of the billing account */
  id: Scalars['ID'];
  /** Whether the initial authorization was successful */
  initialAuthSuccess?: InputMaybe<Scalars['Boolean']>;
  /** The postal code for the billing account */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Whether this is the primary billing account for the user */
  primaryAccount?: InputMaybe<Scalars['Boolean']>;
  /** The billing provider's account alternate ID for the billing account (Zuora only) */
  providerAccountAltId?: InputMaybe<Scalars['String']>;
  /** The billing provider's account ID for the billing account */
  providerAccountId?: InputMaybe<Scalars['String']>;
  /** The state for the billing account */
  state?: InputMaybe<Scalars['String']>;
  /** The tax jurisdiction code for the billing account (Avalara PCode) */
  taxJurisdictionCode?: InputMaybe<Scalars['String']>;
  /** The User UUID of the billing account */
  userInfoUuid?: InputMaybe<Scalars['ID']>;
};

/** Billing discount */
export type BillingDiscount = {
  __typename?: 'BillingDiscount';
  /** Whether the discount is allowed for plan changes */
  allowedForPlanChange: Scalars['Boolean'];
  /** The amount discount (currency code to amount) */
  amountDiscount?: Maybe<Scalars['JSON']>;
  /** The global redemption cap for the discount */
  availableCount?: Maybe<Scalars['Int']>;
  /** The number of billing cycles the discount applied to (including trial segment) */
  billingCycles?: Maybe<Scalars['Int']>;
  /** The discount code */
  code: Scalars['String'];
  /** Defines the countries the discount is limited to (could be an inclusion or exclusion list) */
  countries?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The countries operator - whether the countries list is an inclusion or exclusion list */
  countriesOperator?: Maybe<InNotInOperator>;
  /** The creation date */
  createdAt: Scalars['DateTime'];
  /** Defines the currencies the discount is limited to (could be an inclusion or exclusion list) */
  currencies?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The currencies operator - whether the currencies list is an inclusion or exclusion list */
  currenciesOperator?: Maybe<InNotInOperator>;
  /** Human-readable description for admins */
  description?: Maybe<Scalars['String']>;
  /** Defines the ecommerce SKUs the discount is limited to via the plan SKU. THe plan must be tied to a bonus in this list (could be an inclusion or exclusion list) */
  ecommerceSkus?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The ecommerce SKUs operator - whether the ecommerce SKUs list is an inclusion or exclusion list */
  ecommerceSkusOperator?: Maybe<InNotInOperator>;
  /** Whether the discount is enabled */
  enabled: Scalars['Boolean'];
  /** When the discount becomes unavailable (optional) */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The primary identifier for this record */
  id: Scalars['ID'];
  /** Defines the languages the discount is limited to (could be an inclusion or exclusion list) */
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The languages operator - whether the languages list is an inclusion or exclusion list */
  languagesOperator?: Maybe<InNotInOperator>;
  /** Defines the minimum plan recurring price per currency (ISO 4217 code to amount) */
  minimumPrice?: Maybe<Scalars['JSON']>;
  /** Minimum plan trial segment price per currency (ISO 4217 code to amount) */
  minimumTrialSegmentPrice?: Maybe<Scalars['JSON']>;
  /** The percentage discount */
  percentageDiscount?: Maybe<Scalars['Float']>;
  /** Defines the plan categories the discount is limited to (could be an inclusion or exclusion list) */
  planCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The plan categories operator - whether the plan categories list is an inclusion or exclusion list */
  planCategoriesOperator?: Maybe<InNotInOperator>;
  /** The number of redemptions for the discount */
  redemptionCount: Scalars['Int'];
  /** The number of redemptions per user */
  redemptionsPerUser: Scalars['Int'];
  /** An optional number of months to limit the user redemption count to */
  redemptionsPerUserMonths?: Maybe<Scalars['Int']>;
  /** Defines the SKUs the discount is limited to (could be an inclusion or exclusion list) */
  skus?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The SKUs operator - whether the SKUs list is an inclusion or exclusion list */
  skusOperator?: Maybe<InNotInOperator>;
  /** When the discount becomes available (optional) */
  startDate?: Maybe<Scalars['DateTime']>;
  /** When set, only these user_info.uid values may redeem the discount (other eligibility rules still apply) */
  uids?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** The update date */
  updatedAt: Scalars['DateTime'];
};

/** Discount eligibility check error */
export enum BillingDiscountEligibilityErrorCode {
  /** Country mismatch */
  CountryMismatch = 'COUNTRY_MISMATCH',
  /** Currency mismatch */
  CurrencyMismatch = 'CURRENCY_MISMATCH',
  /** Discount disabled */
  DiscountDisabled = 'DISCOUNT_DISABLED',
  /** Discount exhausted */
  DiscountExhausted = 'DISCOUNT_EXHAUSTED',
  /** Discount inactive */
  DiscountInactive = 'DISCOUNT_INACTIVE',
  /** Discount not found */
  DiscountNotFound = 'DISCOUNT_NOT_FOUND',
  /** Ecommerce SKU mismatch */
  EcommerceSkuMismatch = 'ECOMMERCE_SKU_MISMATCH',
  /** Language mismatch */
  LanguageMismatch = 'LANGUAGE_MISMATCH',
  /** Plan category mismatch */
  PlanCategoryMismatch = 'PLAN_CATEGORY_MISMATCH',
  /** Plan change not allowed */
  PlanChangeNotAllowed = 'PLAN_CHANGE_NOT_ALLOWED',
  /** Plan not found */
  PlanNotFound = 'PLAN_NOT_FOUND',
  /** Plan recurring price is below the discount minimum for this currency */
  PlanPriceMinimumNotMet = 'PLAN_PRICE_MINIMUM_NOT_MET',
  /** Plan pricing row not found for request currency */
  PlanPricingNotFound = 'PLAN_PRICING_NOT_FOUND',
  /** Plan trial segment price is below the discount minimum for this currency */
  PlanTrialSegmentPriceMinimumNotMet = 'PLAN_TRIAL_SEGMENT_PRICE_MINIMUM_NOT_MET',
  /** Redemption limit exceeded */
  RedemptionLimitExceeded = 'REDEMPTION_LIMIT_EXCEEDED',
  /** SKU mismatch */
  SkuMismatch = 'SKU_MISMATCH',
  /** Signed-in user is not in the discount uid allow list */
  UidMismatch = 'UID_MISMATCH',
  /** User required */
  UserRequired = 'USER_REQUIRED'
}

/** Result of a discount eligibility check */
export type BillingDiscountEligibilityResult = {
  __typename?: 'BillingDiscountEligibilityResult';
  /** The discount that was checked */
  discount?: Maybe<BillingDiscount>;
  /** The discounted pricing */
  discountedPricing?: Maybe<BillingProviderProductPricingDiscounted>;
  /** Whether the discount is eligible */
  eligible: Scalars['Boolean'];
  /** Error code if the discount is not eligible */
  errorCode?: Maybe<BillingDiscountEligibilityErrorCode>;
};

/** Billing discount list response */
export type BillingDiscountListResponse = {
  __typename?: 'BillingDiscountListResponse';
  /** A list of billing discounts */
  billingDiscounts?: Maybe<Array<Maybe<BillingDiscount>>>;
};

/** Billing discount list where Boolean input type */
export type BillingDiscountListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** Billing discount list where ID input type */
export type BillingDiscountListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing discount list where input type */
export type BillingDiscountListWhereInput = {
  /** The billing discount active field where clause */
  active?: InputMaybe<BillingDiscountListWhereBooleanInput>;
  /** The billing discount code field where clause */
  code?: InputMaybe<BillingDiscountListWhereStringInput>;
  /** The billing discount enabled field where clause */
  enabled?: InputMaybe<BillingDiscountListWhereBooleanInput>;
  /** The billing discount id field where clause */
  id?: InputMaybe<BillingDiscountListWhereIdInput>;
  /** The billing discount sku field where clause */
  sku?: InputMaybe<BillingDiscountListWhereStringInput>;
};

/** Billing discount list where String input type */
export type BillingDiscountListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** A single redemption of a billing discount */
export type BillingDiscountRedemption = {
  __typename?: 'BillingDiscountRedemption';
  /** Whether the discount was used at signup (checkout) or plan change */
  action: BillingDiscountRedemptionAction;
  /** The billing discount this redemption applies to */
  billingDiscountId: Scalars['ID'];
  /** Row creation time */
  createdAt: Scalars['DateTime'];
  /** Primary key */
  id: Scalars['ID'];
  /** When the discount was recorded as redeemed */
  redeemedAt: Scalars['DateTime'];
  /** Plan SKU at redemption time */
  sku: Scalars['String'];
  /** User id (user_info.uid) */
  uid: Scalars['BigInt'];
  /** Row update time */
  updatedAt: Scalars['DateTime'];
};

/** Whether a billing discount redemption was at signup or plan change */
export enum BillingDiscountRedemptionAction {
  /** Signup / checkout */
  Checkout = 'checkout',
  /** Plan change */
  PlanChange = 'planChange'
}

/**
 * Billing events are payment events sent from individual payment providers (Google Play, Apple App Store,
 * PayPal, Amazon, Adyen, Zuora, etc.) when transactions occur. These are the raw, unprocessed events that
 * represent the complete payment history for a user.
 *
 * These events are used to:
 * 1. Create and update user entitlements (access rights) when payments are successful
 * 2. Track payment history and subscription status
 * 3. Calculate financial metrics (aggregated in billingEventsOverview)
 * 4. Handle subscription renewals, cancellations, refunds, and plan changes
 * 5. Determine user payment state and subscription status
 *
 * Event Flow:
 * - Payment provider sends webhook/notification → BillingEvent created
 * - Event processing → UserEntitlement created/updated based on event type
 * - Event aggregation → billingEventsOverview calculated for financial reporting
 *
 * Understanding Payment State from Events:
 * To determine a user's current payment state, examine the most recent events (ordered by txnDate DESC):
 *
 * 1. Active Subscription:
 *    - Look for recent "payment" or "renewal" events with paymentStatus="completed"
 *    - Check paidThroughDate: if in the future, user has paid access
 *    - Check endDate: if in the future or null, subscription is active
 *    - Check expiresDate: if in the future, subscription hasn't expired
 *
 * 2. Payment Issues:
 *    - paymentStatus="failed" or "pending" indicates payment problems
 *    - errorCode field contains details about payment failures
 *    - Check if paidThroughDate is in the past (access may be suspended)
 *
 * 3. Subscription Status:
 *    - "cancellation" event: Subscription cancelled (check cancelReason)
 *    - "refund" event: Payment was refunded (may affect entitlements)
 *    - "plan_change" event: User upgraded/downgraded subscription
 *    - "trial_start"/"trial_end": Trial period tracking (isTrialPeriod=true)
 *
 * 4. Payment Method State:
 *    - paymentMethod indicates how user pays (credit_card, paypal, google_wallet, etc.)
 *    - paymentType indicates payment structure (subscription, one_time, trial)
 *    - scheduledPaymentDate shows when next payment is expected
 *
 * 5. Access Period:
 *    - startDate: When access period begins
 *    - endDate: When access period ends (null = no expiration)
 *    - paidThroughDate: Date through which user has paid (key indicator of active access)
 *
 * Common transaction types (txnType):
 * - "payment": Successful payment (one-time or initial subscription payment)
 * - "renewal": Subscription renewal (recurring payment)
 * - "cancellation": Subscription cancelled (may still have access until endDate/paidThroughDate)
 * - "refund": Payment refunded (may revoke entitlements)
 * - "plan_change": Subscription plan changed (upgrade/downgrade)
 * - "trial_start": Trial period started
 * - "trial_end": Trial period ended
 * - "hold": Subscription paused (temporary suspension)
 * - "sync_billing": Billing synchronization event (for app store subscriptions)
 *
 * The source field identifies the payment provider (e.g., "google", "apple", "paypal", "amazon", "adyen", "zuora").
 * Events are linked to users via the uid field, which corresponds to UserInfo.uid.
 *
 * IMPORTANT: To get the complete payment picture, query all events for a user and analyze the sequence.
 * The most recent event with paymentStatus="completed" and a future paidThroughDate typically indicates
 * active payment status. However, always check for subsequent cancellation or refund events that may
 * have changed the state.
 */
export type BillingEvent = {
  __typename?: 'BillingEvent';
  /**
   * Whether this event has been processed for account history. Used to track
   * which events have been included in historical calculations.
   */
  accountHistoryProcessed?: Maybe<Scalars['Boolean']>;
  /** The payment amount (in the specified currency) */
  amount?: Maybe<Scalars['Float']>;
  /** Reason for cancellation (if this is a cancellation event) */
  cancellationReason?: Maybe<Scalars['String']>;
  /** When the row was created in the database */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The currency code for the payment amount (e.g., USD, EUR, GBP) */
  currency?: Maybe<Scalars['String']>;
  /**
   * The end date for the subscription or access period. When the user's access ends.
   * If null, the subscription has no expiration. Compare with current date to determine
   * if access is still valid. This is a key field for determining active subscription status.
   */
  endDate?: Maybe<Scalars['DateTime']>;
  /**
   * Error code if the payment failed or had issues. Contains provider-specific error codes
   * when paymentStatus is "failed" or "pending". Use this along with providerComments
   * to understand why a payment failed and what action might be needed.
   *
   * Common scenarios:
   * - Payment method declined (insufficient funds, expired card, etc.)
   * - Provider-specific errors (network issues, account problems, etc.)
   * - Validation errors (invalid payment details)
   *
   * If errorCode is set, the payment did not complete successfully and entitlements
   * should not be granted based on this event.
   */
  errorCode?: Maybe<Scalars['String']>;
  /**
   * The date when the subscription or access expires. Similar to endDate but may
   * represent a different expiration concept depending on the provider. Check both
   * endDate and expiresDate to fully understand access expiration.
   *
   * If expiresDate is in the future, the subscription hasn't expired yet.
   * If in the past, the subscription has expired and may need renewal.
   */
  expiresDate?: Maybe<Scalars['DateTime']>;
  /** The primary identifier for this record (auto-incrementing integer) */
  id?: Maybe<Scalars['ID']>;
  /**
   * Whether this transaction is part of a trial period. If true, this is a trial
   * payment and the user may not have been charged (or charged a reduced amount).
   * Trial periods typically convert to paid subscriptions after trial_end events.
   *
   * Use this field along with txnType="trial_start" or "trial_end" to track trial
   * status and understand when trial converts to paid subscription.
   */
  isTrialPeriod?: Maybe<Scalars['Boolean']>;
  /** Linkshare affiliate identifier (for affiliate tracking) */
  linkshareAffiliate?: Maybe<Scalars['String']>;
  /** The date when the Linkshare affiliate was recorded */
  linkshareDate?: Maybe<Scalars['DateTime']>;
  /** The amount that will be billed next (for recurring subscriptions) */
  nextBillAmount?: Maybe<Scalars['Float']>;
  /**
   * The date through which the user has paid (subscription paid through date).
   * This is CRITICAL for determining payment state:
   * - If paidThroughDate is in the future: User has paid access until that date
   * - If paidThroughDate is in the past: User's paid access has expired
   * - If null: May indicate one-time payment or trial (check paymentType)
   *
   * This date is typically set when a payment is successful and determines when
   * entitlements should be active. Always check this field along with paymentStatus
   * to understand current payment state.
   */
  paidThroughDate?: Maybe<Scalars['DateTime']>;
  /**
   * The parent transaction ID. For subscription renewals or related transactions,
   * this links to the original transaction.
   */
  parentTxnId?: Maybe<Scalars['String']>;
  /**
   * The payment method (e.g., "credit_card", "paypal", "google_wallet", "apple_pay", "amazon_pay").
   * Identifies how the user pays. Useful for understanding payment provider relationships
   * and troubleshooting payment issues specific to payment methods.
   */
  paymentMethod?: Maybe<Scalars['String']>;
  /**
   * The payment status (e.g., "completed", "pending", "failed", "refunded", "voided").
   * CRITICAL field for understanding payment state:
   * - "completed": Payment successful, entitlements should be granted
   * - "pending": Payment processing, entitlements may be delayed
   * - "failed": Payment failed, no entitlements granted, check errorCode
   * - "refunded": Payment was refunded, entitlements may be revoked
   * - "voided": Payment was voided/cancelled before completion
   *
   * Always check this field to determine if the payment was actually successful.
   * Only events with paymentStatus="completed" should result in active entitlements.
   */
  paymentStatus?: Maybe<Scalars['String']>;
  /**
   * The payment type (e.g., "subscription", "one_time", "trial").
   * - "subscription": Recurring payment (expect renewals)
   * - "one_time": Single payment (no automatic renewals)
   * - "trial": Trial period payment (may convert to subscription)
   *
   * Use this to understand the payment structure and predict future events.
   */
  paymentType?: Maybe<Scalars['String']>;
  /** The plan ID associated with this transaction (system identifier) */
  planId?: Maybe<Scalars['String']>;
  /** The plan name associated with this transaction (human-readable) */
  planName?: Maybe<Scalars['String']>;
  /**
   * Plan segment data stored as JSON. Contains information about the plan segments,
   * pricing tiers, or product variations.
   */
  planSegmentData?: Maybe<Scalars['JSON']>;
  /**
   * The date and time when this event was processed by the system. Indicates when
   * the event was received and stored, which may differ from txnDate (when the
   * transaction actually occurred at the provider). Useful for debugging event
   * processing delays and understanding event timeline.
   */
  processedAt?: Maybe<Scalars['DateTime']>;
  /** Comments or notes from the payment provider */
  providerComments?: Maybe<Scalars['String']>;
  /**
   * Raw provider data stored as JSON. Contains the complete response from the payment provider,
   * including provider-specific fields and metadata.
   */
  providerData?: Maybe<Scalars['JSON']>;
  /** The subscription ID in the payment provider's system (for recurring subscriptions) */
  providerSubscriptionId?: Maybe<Scalars['String']>;
  /** The user ID in the payment provider's system */
  providerUserId?: Maybe<Scalars['String']>;
  /** Referral channels (how the user was referred) */
  referralChannels?: Maybe<Scalars['String']>;
  /** Referral source (where the user came from) */
  referralSource?: Maybe<Scalars['String']>;
  /**
   * Referral source data stored as JSON. Contains detailed referral information
   * and tracking parameters.
   */
  referralSourceJsonb?: Maybe<Scalars['JSON']>;
  /**
   * The scheduled date for the next payment (for recurring subscriptions).
   * Indicates when the next billing cycle will occur. Useful for understanding
   * subscription renewal timeline and predicting future payment state.
   */
  scheduledPaymentDate?: Maybe<Scalars['DateTime']>;
  /** The country code where the user signed up */
  signupCountry?: Maybe<Scalars['String']>;
  /**
   * The payment provider source (e.g., "google", "apple", "paypal", "amazon", "adyen").
   * Identifies which payment system sent this event.
   */
  source?: Maybe<Scalars['String']>;
  /**
   * The start date for the subscription or access period. When the user's access begins.
   * Compare with current date to determine if access period has started.
   */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The tax amount for this transaction */
  taxAmount?: Maybe<Scalars['Float']>;
  /** The date and time when the transaction occurred */
  txnDate?: Maybe<Scalars['DateTime']>;
  /**
   * The transaction ID from the payment provider. Unique identifier for this transaction
   * in the provider's system.
   */
  txnId?: Maybe<Scalars['String']>;
  /**
   * The transaction type (e.g., "payment", "renewal", "cancellation", "refund", "plan_change",
   * "trial_start", "trial_end"). Describes what kind of event this is.
   */
  txnType?: Maybe<Scalars['String']>;
  /** The user uid (legacy identifier) linking this event to UserInfo */
  uid?: Maybe<Scalars['ID']>;
  /** When the row was last updated in the database */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /**
   * The user associated with this event. Links to UserInfo via the uid field.
   * This is the user who made the payment or whose subscription was affected.
   *
   * To understand a user's complete payment state:
   * 1. Query all billingEvents for this user (ordered by txnDate DESC)
   * 2. Filter by source if user has multiple payment providers
   * 3. Check the most recent events with paymentStatus="completed"
   * 4. Examine paidThroughDate to determine if access is currently active
   * 5. Look for cancellation or refund events that may have changed state
   * 6. Check scheduledPaymentDate to predict future payment state
   * 7. Review errorCode and paymentStatus for any payment issues
   *
   * The sequence of events tells the story of the user's payment journey:
   * - Initial payment → Renewals → Plan changes → Cancellations → Refunds
   * Each event represents a state change in the user's payment relationship.
   */
  userInfo?: Maybe<UserInfo>;
  /**
   * User referral data stored as JSON. Contains information about user referrals
   * and referral program participation.
   */
  userReferralJsonb?: Maybe<Scalars['JSON']>;
  /** The event UUID (unique identifier for this specific event) */
  uuid?: Maybe<Scalars['ID']>;
};

export type BillingEventCountResponse = {
  __typename?: 'BillingEventCountResponse';
  /** The count of rows */
  count: Scalars['Int'];
};

/** EventCreateInput */
export type BillingEventCreateInput = {
  /** The account history processed date for event */
  accountHistoryProcessed?: InputMaybe<Scalars['Boolean']>;
  /** The payment amount for event */
  amount?: InputMaybe<Scalars['Float']>;
  /** The cancellation reason for event */
  cancellationReason?: InputMaybe<Scalars['String']>;
  /** The payment currency for event */
  currency?: InputMaybe<Scalars['String']>;
  /** The end date for event */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** The error code for event */
  errorCode?: InputMaybe<Scalars['String']>;
  /** The expires date for event */
  expiresDate?: InputMaybe<Scalars['DateTime']>;
  /** The is trial period flag for event */
  isTrialPeriod?: InputMaybe<Scalars['Boolean']>;
  /** The linkshare affiliate for event */
  linkshareAffiliate?: InputMaybe<Scalars['String']>;
  /** The linkshare share date for event */
  linkshareDate?: InputMaybe<Scalars['DateTime']>;
  /** The next bill amount for event */
  nextBillAmount?: InputMaybe<Scalars['Float']>;
  /** The paid through date for event */
  paidThroughDate?: InputMaybe<Scalars['DateTime']>;
  /** The parent transaction Id for event */
  parentTxnId: Scalars['String'];
  /** The payment method for event */
  paymentMethod?: InputMaybe<Scalars['String']>;
  /** The payment status for event */
  paymentStatus?: InputMaybe<Scalars['String']>;
  /** The payment type for event */
  paymentType?: InputMaybe<Scalars['String']>;
  /** The plan id for event */
  planId: Scalars['String'];
  /** The plan name for event */
  planName: Scalars['String'];
  /** The plan segment data response for event */
  planSegmentData?: InputMaybe<Scalars['JSON']>;
  /** The processed date for event */
  processedAt?: InputMaybe<Scalars['DateTime']>;
  /** The provider comments for event */
  providerComments?: InputMaybe<Scalars['String']>;
  /** The provider data response for event */
  providerData?: InputMaybe<Scalars['JSON']>;
  /** The provider subscription Id for event */
  providerSubscriptionId?: InputMaybe<Scalars['String']>;
  /** The provider user Id for event */
  providerUserId?: InputMaybe<Scalars['String']>;
  /** The referral channels for event */
  referralChannels?: InputMaybe<Scalars['String']>;
  /** The referral source for event */
  referralSource?: InputMaybe<Scalars['String']>;
  /** The referral source data for event */
  referralSourceJsonb?: InputMaybe<Scalars['JSON']>;
  /** The scheduled payment date for event */
  scheduledPaymentDate?: InputMaybe<Scalars['DateTime']>;
  /** The signup country for event */
  signupCountry?: InputMaybe<Scalars['String']>;
  /** The source for event */
  source: Scalars['String'];
  /** The start date for event */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** The tax amount for event */
  taxAmount?: InputMaybe<Scalars['Float']>;
  /** The transaction date for event */
  txnDate: Scalars['DateTime'];
  /** The transaction Id for event */
  txnId: Scalars['String'];
  /** The transaction type for event */
  txnType: Scalars['String'];
  /** The user uid for event */
  uid: Scalars['ID'];
  /** The user referral data for event */
  userReferralJsonb?: InputMaybe<Scalars['JSON']>;
};

/** Billing event policy list response */
export type BillingEventListResponse = {
  __typename?: 'BillingEventListResponse';
  /** A list of user accounts */
  billingEvents?: Maybe<Array<Maybe<BillingEvent>>>;
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
};

/** Event id type where input type */
export type BillingEventListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Event where conditions to filter rows */
export type BillingEventListWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<BillingEventListWhereIdInput>;
  /** The signupCountry field where clause */
  signupCountry?: InputMaybe<BillingEventListWhereSignupCountryInput>;
  /** The source field where clause */
  source?: InputMaybe<BillingEventListWhereSourceInput>;
  /** The txnType field where clause */
  txnType?: InputMaybe<BillingEventListWhereTxnTypeInput>;
  /** The uid field where clause */
  uid?: InputMaybe<BillingEventListWhereUidInput>;
};

/** Event signup country where input type */
export type BillingEventListWhereSignupCountryInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Event source where input type */
export type BillingEventListWhereSourceInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Event transaction where input type */
export type BillingEventListWhereTxnTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Event uid type where input type */
export type BillingEventListWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** EventUpdateInput */
export type BillingEventUpdateInput = {
  /** The account history processed date for event */
  accountHistoryProcessed?: InputMaybe<Scalars['Boolean']>;
  /** The payment amount for event */
  amount?: InputMaybe<Scalars['Float']>;
  /** The cancellation reason for event */
  cancellationReason?: InputMaybe<Scalars['String']>;
  /** The payment currency for event */
  currency?: InputMaybe<Scalars['String']>;
  /** The end date for event */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** The error code for event */
  errorCode?: InputMaybe<Scalars['String']>;
  /** The expires date for event */
  expiresDate?: InputMaybe<Scalars['DateTime']>;
  /** The primary identifier for this record */
  id: Scalars['ID'];
  /** The is trial period flag for event */
  isTrialPeriod?: InputMaybe<Scalars['Boolean']>;
  /** The linkshare affiliate for event */
  linkshareAffiliate?: InputMaybe<Scalars['String']>;
  /** The linkshare share date for event */
  linkshareDate?: InputMaybe<Scalars['DateTime']>;
  /** The next bill amount for event */
  nextBillAmount?: InputMaybe<Scalars['Float']>;
  /** The paid through date for event */
  paidThroughDate?: InputMaybe<Scalars['DateTime']>;
  /** The parent transaction Id for event */
  parentTxnId?: InputMaybe<Scalars['String']>;
  /** The payment method for event */
  paymentMethod?: InputMaybe<Scalars['String']>;
  /** The payment status for event */
  paymentStatus?: InputMaybe<Scalars['String']>;
  /** The payment type for event */
  paymentType?: InputMaybe<Scalars['String']>;
  /** The plan id for event */
  planId?: InputMaybe<Scalars['String']>;
  /** The plan name for event */
  planName?: InputMaybe<Scalars['String']>;
  /** The plan segment data response for event */
  planSegmentData?: InputMaybe<Scalars['JSON']>;
  /** The processed date for event */
  processedAt?: InputMaybe<Scalars['DateTime']>;
  /** The provider comments for event */
  providerComments?: InputMaybe<Scalars['String']>;
  /** The provider data response for event */
  providerData?: InputMaybe<Scalars['JSON']>;
  /** The provider subscription Id for event */
  providerSubscriptionId?: InputMaybe<Scalars['String']>;
  /** The provider user Id for event */
  providerUserId?: InputMaybe<Scalars['String']>;
  /** The referral channels for event */
  referralChannels?: InputMaybe<Scalars['String']>;
  /** The referral source for event */
  referralSource?: InputMaybe<Scalars['String']>;
  /** The referral source data for event */
  referralSourceJsonb?: InputMaybe<Scalars['JSON']>;
  /** The scheduled payment date for event */
  scheduledPaymentDate?: InputMaybe<Scalars['DateTime']>;
  /** The signup country for event */
  signupCountry?: InputMaybe<Scalars['String']>;
  /** The source for event */
  source?: InputMaybe<Scalars['String']>;
  /** The start date for event */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** The tax amount for event */
  taxAmount?: InputMaybe<Scalars['Float']>;
  /** The transaction date for event */
  txnDate?: InputMaybe<Scalars['DateTime']>;
  /** The transaction Id for event */
  txnId?: InputMaybe<Scalars['String']>;
  /** The transaction type for event */
  txnType?: InputMaybe<Scalars['String']>;
  /** The user uid for event */
  uid?: InputMaybe<Scalars['ID']>;
  /** The user referral data for event */
  userReferralJsonb?: InputMaybe<Scalars['JSON']>;
};

/**
 * Billing events overview provides aggregated financial metrics for a user's payment history.
 * This is calculated from all BillingEvent records for the user and provides a summary view
 * of their financial relationship with the platform.
 *
 * The overview aggregates individual billing events to calculate:
 * - Profit metrics (gross, net, tax)
 * - Loss totals (refunds, chargebacks, etc.)
 * - Currency information
 *
 * IMPORTANT: All payment amounts are in the user's currency. If multiple currencies are present,
 * the aggregate totals may not be valid for direct comparison.
 *
 * This overview is useful for:
 * - Understanding a user's lifetime value
 * - Calculating revenue metrics
 * - Financial reporting and analysis
 * - Customer support inquiries about payment history
 *
 * The profit and loss calculations use specific transaction types (defined in eventProfitTxnTypes
 * and eventLossTxnTypes) to categorize events appropriately.
 */
export type BillingEventsOverview = {
  __typename?: 'BillingEventsOverview';
  /**
   * The currencies for all of the payment events. This is an array of all unique currency codes
   * found in the user's billing events.
   *
   * WARNING: If there is more than one currency, the aggregate totals (profit, loss, etc.) are not
   * valid for direct comparison as they mix different currencies. Always check the currencies array
   * before using aggregate totals.
   */
  currencies?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * The event transaction types used to filter loss events. These are the txnType values
   * from BillingEvent that are considered losses (e.g., "refund", "chargeback").
   */
  eventLossTxnTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * The event transaction types used to filter profit events. These are the txnType values
   * from BillingEvent that are considered profit-generating (e.g., "payment", "renewal").
   */
  eventProfitTxnTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * The loss total: total of all loss events (refunds, chargebacks, cancellations, etc.).
   * This represents money returned to customers or lost due to failed transactions.
   */
  lossTotal?: Maybe<Scalars['Float']>;
  /**
   * The profit: final profit calculation after deducting cost of goods sold, tax, and losses.
   * This is the net profit after all deductions and losses are accounted for.
   */
  profit?: Maybe<Scalars['Float']>;
  /**
   * The profit gross: profit without deducting any costs. This is the raw revenue
   * from all profitable transactions before any deductions.
   */
  profitGross?: Maybe<Scalars['Float']>;
  /**
   * The profit net: profit after deducting cost of goods sold, with only tax deducted.
   * This represents the net profit from profitable transactions.
   */
  profitNet?: Maybe<Scalars['Float']>;
  /**
   * The profit tax: total tax collected for all profitable events. This is the sum
   * of tax amounts from all profit-generating transactions.
   */
  profitTax?: Maybe<Scalars['Float']>;
  /** The user uid linking this overview to UserInfo */
  uid?: Maybe<Scalars['ID']>;
};

/** Billing Invoice */
export type BillingInvoice = {
  __typename?: 'BillingInvoice';
  /** The balance of the billing invoice */
  balance?: Maybe<Scalars['Float']>;
  /** Billing One Time Purchase associated with this Billing Invoice */
  billingOneTimePurchase?: Maybe<BillingOneTimePurchase>;
  /** The billing one time purchase ID of the billing invoice */
  billingOneTimePurchaseId?: Maybe<Scalars['ID']>;
  /** The billing provider product ID of the billing invoice */
  billingProviderProductId?: Maybe<Scalars['ID']>;
  /** Billing Subscription Plan associated with this Billing Invoice */
  billingSubscriptionPlan?: Maybe<BillingSubscriptionPlan>;
  /** The billing subscription ID of the billing invoice */
  billingSubscriptionPlanId?: Maybe<Scalars['ID']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The due date of the billing invoice */
  dueDate?: Maybe<Scalars['DateTime']>;
  /** The id of the billing invoice */
  id?: Maybe<Scalars['ID']>;
  /** The period end of the billing invoice */
  periodEnd?: Maybe<Scalars['DateTime']>;
  /** The period start of the billing invoice */
  periodStart?: Maybe<Scalars['DateTime']>;
  /** The billing provider invoice ID of the billing invoice */
  providerInvoiceId?: Maybe<Scalars['String']>;
  /** The quantity of the billing invoice */
  quantity?: Maybe<Scalars['Int']>;
  /** The tax amount of the billing invoice */
  taxAmount?: Maybe<Scalars['Float']>;
  /** The tax amount of the billing invoice */
  taxJurisdictionCode?: Maybe<Scalars['String']>;
  /** The total amount of the billing invoice */
  totalAmount?: Maybe<Scalars['Float']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The UUID of the billing invoice */
  uuid?: Maybe<Scalars['ID']>;
  /** The balance of the billing invoice */
  writtenOff?: Maybe<Scalars['Boolean']>;
};

/** Create input for Billing Invoice */
export type BillingInvoiceCreateInput = {
  /** Balance of the billing invoice */
  balance?: InputMaybe<Scalars['Float']>;
  /** The billing one time purchase Id of the billing invoice */
  billingOneTimePurchaseId?: InputMaybe<Scalars['ID']>;
  /** The billing provider product Id of the billing invoice */
  billingProviderProductId: Scalars['ID'];
  /** The billing subscription plan Id of the billing invoice */
  billingSubscriptionPlanId?: InputMaybe<Scalars['ID']>;
  /** Due date of the billing invoice */
  dueDate: Scalars['DateTime'];
  /** Period ends of the billing invoice */
  periodEnd: Scalars['DateTime'];
  /** Period starts of the billing invoice */
  periodStart: Scalars['DateTime'];
  /** The provider invoice Id of the billing invoice */
  providerInvoiceId?: InputMaybe<Scalars['ID']>;
  /** The quantity of the billing invoice */
  quantity: Scalars['Int'];
  /** Tax amount of the billing invoice */
  taxAmount: Scalars['Float'];
  /** Tax Jurisdiction code of the billing invoice */
  taxJurisdictionCode?: InputMaybe<Scalars['String']>;
  /** Total amount of the billing invoice */
  totalAmount: Scalars['Float'];
  /** Whether the invoice was written off */
  writtenOff: Scalars['Boolean'];
};

/** Billing Invoice list response */
export type BillingInvoiceListResponse = {
  __typename?: 'BillingInvoiceListResponse';
  billingInvoices?: Maybe<Array<Maybe<BillingInvoice>>>;
};

/** Billing Invoice boolean where input type */
export type BillingInvoiceListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** Billing Invoice list where Date input type */
export type BillingInvoiceListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']>;
};

/** Billing Invoice float where input type */
export type BillingInvoiceListWhereFloatInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Float']>;
};

/** Billing Invoice list id where input type */
export type BillingInvoiceListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing Invoice list where input type */
export type BillingInvoiceListWhereInput = {
  /** The billingInvoice balance field where clause */
  balance?: InputMaybe<BillingInvoiceListWhereFloatInput>;
  /** The billingInvoice billingOneTimePurchaseId field where clause */
  billingOneTimePurchaseId?: InputMaybe<BillingInvoiceListWhereIdInput>;
  /** The billingInvoice billingProviderProductId field where clause */
  billingProviderProductId?: InputMaybe<BillingInvoiceListWhereIdInput>;
  /** The billingInvoice billingSubscriptionPlanId field where clause */
  billingSubscriptionPlanId?: InputMaybe<BillingInvoiceListWhereIdInput>;
  /** The billingInvoice createdAt field where clause */
  createdAt?: InputMaybe<BillingInvoiceListWhereDateInput>;
  /** The billingInvoice dueDate field where clause */
  dueDate?: InputMaybe<BillingInvoiceListWhereDateInput>;
  /** The billingInvoice id field where clause */
  id?: InputMaybe<BillingInvoiceListWhereIdInput>;
  /** The billingInvoice periodEnd field where clause */
  periodEnd?: InputMaybe<BillingInvoiceListWhereDateInput>;
  /** The billingInvoice periodStart field where clause */
  periodStart?: InputMaybe<BillingInvoiceListWhereDateInput>;
  /** The billingInvoice providerInvoiceId field where clause */
  providerInvoiceId?: InputMaybe<BillingInvoiceListWhereIdInput>;
  /** The billingInvoice quantity field where clause */
  quantity?: InputMaybe<BillingInvoiceListWhereIntInput>;
  /** The billingInvoice taxAmount field where clause */
  taxAmount?: InputMaybe<BillingInvoiceListWhereFloatInput>;
  /** The billingInvoice taxJurisdictionCode field where clause */
  taxJurisdictionCode?: InputMaybe<BillingInvoiceListWhereStringInput>;
  /** The billingInvoice totalAmount field where clause */
  totalAmount?: InputMaybe<BillingInvoiceListWhereFloatInput>;
  /** The billingInvoice uuid field where clause */
  uuid?: InputMaybe<BillingInvoiceListWhereStringInput>;
  /** The billingInvoice writtenOff field where clause */
  writtenOff?: InputMaybe<BillingInvoiceListWhereBooleanInput>;
};

/** Billing Invoice integer where input type */
export type BillingInvoiceListWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Billing Invoice string where input type */
export type BillingInvoiceListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Update input for Billing Invoice */
export type BillingInvoiceUpdateInput = {
  /** Balance of the billing invoice */
  balance?: InputMaybe<Scalars['Float']>;
  /** The billing one time purchase Id of the billing invoice */
  billingOneTimePurchaseId?: InputMaybe<Scalars['ID']>;
  /** The billing provider product Id of the billing invoice */
  billingProviderProductId?: InputMaybe<Scalars['ID']>;
  /** The billing subscription plan Id of the billing invoice */
  billingSubscriptionPlanId?: InputMaybe<Scalars['ID']>;
  /** Due date of the billing invoice */
  dueDate?: InputMaybe<Scalars['DateTime']>;
  /** The id of the billing payment */
  id: Scalars['ID'];
  /** Period ends of the billing invoice */
  periodEnd?: InputMaybe<Scalars['DateTime']>;
  /** Period starts of the billing invoice */
  periodStart?: InputMaybe<Scalars['DateTime']>;
  /** The provider invoice Id of the billing invoice */
  providerInvoiceId?: InputMaybe<Scalars['ID']>;
  /** The quantity of the billing invoice */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Tax amount of the billing invoice */
  taxAmount?: InputMaybe<Scalars['Float']>;
  /** Tax Jurisdiction code of the billing invoice */
  taxJurisdictionCode?: InputMaybe<Scalars['String']>;
  /** Total amount of the billing invoice */
  totalAmount?: InputMaybe<Scalars['Float']>;
  /** Whether the invoice was written off */
  writtenOff?: InputMaybe<Scalars['Boolean']>;
};

/** Billing One Time Purchase */
export type BillingOneTimePurchase = {
  __typename?: 'BillingOneTimePurchase';
  /** When the Billing one time Purchase end date */
  accessEndDate?: Maybe<Scalars['DateTime']>;
  /** When the Billing one time Purchase was started */
  accessStartDate?: Maybe<Scalars['DateTime']>;
  /** The Billing Account Id of the Billing one time Purchase */
  billingAccountId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The gift bulk purchase Id of the Billing one time Purchase */
  giftBulkPurchaseId?: Maybe<Scalars['ID']>;
  /** The gift Id of the Billing one time Purchase */
  giftId?: Maybe<Scalars['ID']>;
  /** The id of the Billing one time Purchase */
  id?: Maybe<Scalars['ID']>;
  /** The billing provider order ID of the Billing one time Purchase */
  providerOrderId?: Maybe<Scalars['ID']>;
  /** When the Billing one time Purchase was purchase */
  purchaseDate?: Maybe<Scalars['DateTime']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The UUID of the Billing one time Purchase */
  uuid?: Maybe<Scalars['ID']>;
};

/** Create input for Billing One Time Purchase */
export type BillingOneTimePurchaseCreateInput = {
  /** The effective accessEndDate of the Billing one time Purchase */
  accessEndDate?: InputMaybe<Scalars['DateTime']>;
  /** The effective accessStartDate of the Billing one time Purchase */
  accessStartDate?: InputMaybe<Scalars['DateTime']>;
  /** The billing billingAccountId of the Billing one time Purchase */
  billingAccountId: Scalars['ID'];
  /** The billing giftBulkPurchaseId of the Billing one time Purchase */
  giftBulkPurchaseId?: InputMaybe<Scalars['ID']>;
  /** The billing giftId of the Billing one time Purchase */
  giftId?: InputMaybe<Scalars['ID']>;
  /** The provider providerOrderId of the Billing one time Purchase */
  providerOrderId?: InputMaybe<Scalars['String']>;
  /** The effective purchaseDate of the Billing one time Purchase */
  purchaseDate: Scalars['DateTime'];
};

/** Billing One Time Purchase list response */
export type BillingOneTimePurchaseListResponse = {
  __typename?: 'BillingOneTimePurchaseListResponse';
  billingOneTimePurchases?: Maybe<Array<Maybe<BillingOneTimePurchase>>>;
};

/** Billing One Time Purchase list where Date input type */
export type BillingOneTimePurchaseListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']>;
};

/** Billing One Time Purchase list id where input type */
export type BillingOneTimePurchaseListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing One Time Purchase list where input type */
export type BillingOneTimePurchaseListWhereInput = {
  /** The billingOneTimePurchase accessEndDate field where clause */
  accessEndDate?: InputMaybe<BillingOneTimePurchaseListWhereDateInput>;
  /** The billingOneTimePurchase accessStartDate field where clause */
  accessStartDate?: InputMaybe<BillingOneTimePurchaseListWhereDateInput>;
  /** The billingOneTimePurchase billingAccountId field where clause */
  billingAccountId?: InputMaybe<BillingOneTimePurchaseListWhereIdInput>;
  /** The billingOneTimePurchase createdAt field where clause */
  createdAt?: InputMaybe<BillingOneTimePurchaseListWhereDateInput>;
  /** The billingOneTimePurchase giftBulkPurchaseId field where clause */
  giftBulkPurchaseId?: InputMaybe<BillingOneTimePurchaseListWhereIdInput>;
  /** The billingOneTimePurchase giftId field where clause */
  giftId?: InputMaybe<BillingOneTimePurchaseListWhereIdInput>;
  /** The billingOneTimePurchase id field where clause */
  id?: InputMaybe<BillingOneTimePurchaseListWhereIdInput>;
  /** The billingOneTimePurchase providerOrderId field where clause */
  providerOrderId?: InputMaybe<BillingOneTimePurchaseListWhereStringInput>;
  /** The billingOneTimePurchase purchaseDate field where clause */
  purchaseDate?: InputMaybe<BillingOneTimePurchaseListWhereDateInput>;
  /** The billingOneTimePurchase uuid field where clause */
  uuid?: InputMaybe<BillingOneTimePurchaseListWhereStringInput>;
};

/** Billing One Time Purchase string where input type */
export type BillingOneTimePurchaseListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Update input for Billing One Time Purchase */
export type BillingOneTimePurchaseUpdateInput = {
  /** The effective accessEndDate of the Billing one time Purchase */
  accessEndDate?: InputMaybe<Scalars['DateTime']>;
  /** The effective accessStartDate of the Billing one time Purchase */
  accessStartDate?: InputMaybe<Scalars['DateTime']>;
  /** The billing billingAccountId of the Billing one time Purchase */
  billingAccountId?: InputMaybe<Scalars['ID']>;
  /** The billing giftBulkPurchaseId of the Billing one time Purchase */
  giftBulkPurchaseId?: InputMaybe<Scalars['ID']>;
  /** The billing giftId of the Billing one time Purchase */
  giftId?: InputMaybe<Scalars['ID']>;
  /** The id of the Billing one time Purchase */
  id: Scalars['ID'];
  /** The provider providerOrderId of the Billing one time Purchase */
  providerOrderId?: InputMaybe<Scalars['String']>;
  /** The effective purchaseDate of the Billing one time Purchase */
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
};

/** Billing Payment */
export type BillingPayment = {
  __typename?: 'BillingPayment';
  /** The payment amount */
  amount?: Maybe<Scalars['Float']>;
  /** Billing Invoice associated with this Billing Payment */
  billingInvoice?: Maybe<BillingInvoice>;
  /** The billing invoice ID of the billing payment */
  billingInvoiceId?: Maybe<Scalars['ID']>;
  /** Billing Payment Method associated with this Billing Payment */
  billingPaymentMethod?: Maybe<BillingPaymentMethod>;
  /** ID of billing payment method */
  billingPaymentMethodId?: Maybe<Scalars['String']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The payment currency */
  currency?: Maybe<Scalars['String']>;
  /** The payment gateway error */
  gatewayError?: Maybe<Scalars['String']>;
  /** The id of the billing payment */
  id?: Maybe<Scalars['ID']>;
  /** The payment date */
  paymentDate?: Maybe<Scalars['DateTime']>;
  /** Provider payment id */
  providerPaymentId?: Maybe<Scalars['String']>;
  /** Whether the payment method has been success */
  success?: Maybe<Scalars['Boolean']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The UUID of the billing payment */
  uuid?: Maybe<Scalars['ID']>;
};

/** Create input for Billing Payment */
export type BillingPaymentCreateInput = {
  /** The payment amount */
  amount: Scalars['Float'];
  /** The billing invoice ID of the billing payment */
  billingInvoiceId: Scalars['ID'];
  /** The billing payment method ID of the billing payment */
  billingPaymentMethodId?: InputMaybe<Scalars['ID']>;
  /** The payment currency */
  currency: Scalars['String'];
  /** The gateway error of payment */
  gatewayError?: InputMaybe<Scalars['String']>;
  /** Date of payment date */
  paymentDate: Scalars['DateTime'];
  /** The provider payment ID of the billing payment */
  providerPaymentId: Scalars['String'];
  /** Whether the payment has been success */
  success?: InputMaybe<Scalars['Boolean']>;
};

/** Billing Payment list response */
export type BillingPaymentListResponse = {
  __typename?: 'BillingPaymentListResponse';
  billingPayments?: Maybe<Array<Maybe<BillingPayment>>>;
};

/** Billing Payment boolean where input type */
export type BillingPaymentListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** Billing Payment list where Date input type */
export type BillingPaymentListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']>;
};

/** Billing Payment float where input type */
export type BillingPaymentListWhereFloatInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Float']>;
};

/** Billing Payment list id where input type */
export type BillingPaymentListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing Payment list where input type */
export type BillingPaymentListWhereInput = {
  /** The billingPayment billingInvoiceId field where clause */
  billingInvoiceId?: InputMaybe<BillingPaymentListWhereIdInput>;
  /** The billingPayment billingPaymentMethodId field where clause */
  billingPaymentMethodId?: InputMaybe<BillingPaymentListWhereIdInput>;
  /** The billingPayment createdAt field where clause */
  createdAt?: InputMaybe<BillingPaymentListWhereDateInput>;
  /** The billingPayment currency field where clause */
  currency?: InputMaybe<BillingPaymentListWhereStringInput>;
  /** The billingPayment gatewayError field where clause */
  gatewayError?: InputMaybe<BillingPaymentListWhereStringInput>;
  /** The billingPayment id field where clause */
  id?: InputMaybe<BillingPaymentListWhereIdInput>;
  /** The billingPayment paymentDate field where clause */
  paymentDate?: InputMaybe<BillingPaymentListWhereDateInput>;
  /** The billingPayment provider payment Id field where clause */
  providerPaymentId?: InputMaybe<BillingPaymentListWhereStringInput>;
  /** The billingPayment success field where clause */
  success?: InputMaybe<BillingPaymentListWhereBooleanInput>;
  /** The billingPayment amount field where clause */
  type?: InputMaybe<BillingPaymentListWhereFloatInput>;
  /** The billingPayment uuid field where clause */
  uuid?: InputMaybe<BillingPaymentListWhereStringInput>;
};

/** Billing Payment string where input type */
export type BillingPaymentListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Billing Payment Method */
export type BillingPaymentMethod = {
  __typename?: 'BillingPaymentMethod';
  /** The Adyen Recurring Detail Reference */
  adyenRecurringDetailReference?: Maybe<Scalars['String']>;
  /** The Adyen Shopper Reference */
  adyenShopperReference?: Maybe<Scalars['String']>;
  /** Billing Account associated with this Billing Payment Method */
  billingAccount?: Maybe<BillingAccount>;
  /** The billing account ID of the billing payment method */
  billingAccountId?: Maybe<Scalars['ID']>;
  /** The credit card summary (last 4 digits) */
  cardSummary?: Maybe<Scalars['String']>;
  /** The credit card type (Visa, MasterCard, etc) */
  cardType?: Maybe<Scalars['String']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The payment gateway name */
  gatewayName?: Maybe<Scalars['String']>;
  /** The id of the billing payment method */
  id?: Maybe<Scalars['ID']>;
  /** The PayPal Agreement ID */
  paypalAgreementId?: Maybe<Scalars['String']>;
  /** Whether the payment method is the primary payment method for the account */
  primaryPaymentMethod?: Maybe<Scalars['Boolean']>;
  /** ID of payment method in source system (zuora only) */
  providerPaymentMethodId?: Maybe<Scalars['String']>;
  /** Whether the payment method has been removed */
  removed?: Maybe<Scalars['Boolean']>;
  /** The payment method type */
  type?: Maybe<PaymentMethodType>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The UUID of the billing payment method */
  uuid?: Maybe<Scalars['ID']>;
};

/** Create input for Billing Payment Method */
export type BillingPaymentMethodCreateInput = {
  /** The Adyen Recurring Detail Reference */
  adyenRecurringDetailReference?: InputMaybe<Scalars['String']>;
  /** The Adyen Shopper Reference */
  adyenShopperReference?: InputMaybe<Scalars['String']>;
  /** The billing account ID of the billing payment method */
  billingAccountId: Scalars['ID'];
  /** The credit card summary (last 4 digits) */
  cardSummary?: InputMaybe<Scalars['String']>;
  /** The credit card type (Visa, MasterCard, etc) */
  cardType?: InputMaybe<Scalars['String']>;
  /** The payment gateway name */
  gatewayName: Scalars['String'];
  /** The PayPal Agreement ID */
  paypalAgreementId?: InputMaybe<Scalars['String']>;
  /** Whether the payment method is the primary payment method for the account */
  primaryPaymentMethod: Scalars['Boolean'];
  /** ID of payment method in source system (zuora only) */
  providerPaymentMethodId: Scalars['String'];
  /** Whether the payment method has been removed */
  removed?: InputMaybe<Scalars['Boolean']>;
  /** The payment method type */
  type: PaymentMethodType;
};

/** Billing Payment Method list response */
export type BillingPaymentMethodListResponse = {
  __typename?: 'BillingPaymentMethodListResponse';
  /** A list of billingProviderProductPricing reference */
  billingPaymentMethods?: Maybe<Array<Maybe<BillingPaymentMethod>>>;
};

/** Billing Payment Method boolean where input type */
export type BillingPaymentMethodListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** Billing Payment Method list id where input type */
export type BillingPaymentMethodListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing Payment Method list where input type */
export type BillingPaymentMethodListWhereInput = {
  /** The billingPaymentMethod adyenRecurringDetailReference field where clause */
  adyenRecurringDetailReference?: InputMaybe<BillingPaymentMethodListWhereStringInput>;
  /** The billingPaymentMethod adyenShopperReference field where clause */
  adyenShopperReference?: InputMaybe<BillingPaymentMethodListWhereStringInput>;
  /** The billingPaymentMethod billingAccountId field where clause */
  billingAccountId?: InputMaybe<BillingPaymentMethodListWhereIdInput>;
  /** The billingPaymentMethod cardSummary field where clause */
  cardSummary?: InputMaybe<BillingPaymentMethodListWhereStringInput>;
  /** The billingPaymentMethod cardType field where clause */
  cardType?: InputMaybe<BillingPaymentMethodListWhereStringInput>;
  /** The billingPaymentMethod gatewayName field where clause */
  gatewayName?: InputMaybe<BillingPaymentMethodListWhereStringInput>;
  /** The billingPaymentMethod id field where clause */
  id?: InputMaybe<BillingPaymentMethodListWhereIdInput>;
  /** The billingPaymentMethod paypalAgreementId field where clause */
  paypalAgreementId?: InputMaybe<BillingPaymentMethodListWhereStringInput>;
  /** The billingPaymentMethod primaryPaymentMethod field where clause */
  primaryPaymentMethod?: InputMaybe<BillingPaymentMethodListWhereBooleanInput>;
  /** The billingPaymentMethod providerPaymentMethodId field where clause */
  providerPaymentMethodId?: InputMaybe<BillingPaymentMethodListWhereStringInput>;
  /** The billingPaymentMethod removed field where clause */
  removed?: InputMaybe<BillingPaymentMethodListWhereBooleanInput>;
  /** The billingPaymentMethod type field where clause */
  type?: InputMaybe<BillingPaymentMethodListWhereStringInput>;
  /** The billingPaymentMethod uuid field where clause */
  uuid?: InputMaybe<BillingPaymentMethodListWhereStringInput>;
};

/** Billing Payment Method string where input type */
export type BillingPaymentMethodListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Update input for Billing Payment Method */
export type BillingPaymentMethodUpdateInput = {
  /** The Adyen Recurring Detail Reference */
  adyenRecurringDetailReference?: InputMaybe<Scalars['String']>;
  /** The Adyen Shopper Reference */
  adyenShopperReference?: InputMaybe<Scalars['String']>;
  /** The billing account ID of the billing payment method */
  billingAccountId?: InputMaybe<Scalars['ID']>;
  /** The credit card summary (last 4 digits) */
  cardSummary?: InputMaybe<Scalars['String']>;
  /** The credit card type (Visa, MasterCard, etc) */
  cardType?: InputMaybe<Scalars['String']>;
  /** The payment gateway name */
  gatewayName?: InputMaybe<Scalars['String']>;
  /** The id of the billing payment method */
  id: Scalars['ID'];
  /** The PayPal Agreement ID */
  paypalAgreementId?: InputMaybe<Scalars['String']>;
  /** Whether the payment method is the primary payment method for the account */
  primaryPaymentMethod?: InputMaybe<Scalars['Boolean']>;
  /** ID of payment method in source system (zuora only) */
  providerPaymentMethodId?: InputMaybe<Scalars['String']>;
  /** Whether the payment method has been removed */
  removed?: InputMaybe<Scalars['Boolean']>;
  /** The payment method type */
  type?: InputMaybe<PaymentMethodType>;
};

/** Update input for Billing Payment */
export type BillingPaymentUpdateInput = {
  /** The payment amount */
  amount?: InputMaybe<Scalars['Float']>;
  /** The billing invoice ID of the billing payment */
  billingInvoiceId?: InputMaybe<Scalars['ID']>;
  /** The billing payment method ID of the billing payment */
  billingPaymentMethodId?: InputMaybe<Scalars['ID']>;
  /** The payment currency */
  currency?: InputMaybe<Scalars['String']>;
  /** The gateway error of payment */
  gatewayError?: InputMaybe<Scalars['String']>;
  /** The id of the billing payment */
  id: Scalars['ID'];
  /** Date of payment date */
  paymentDate?: InputMaybe<Scalars['DateTime']>;
  /** The provider payment ID of the billing payment */
  providerPaymentId?: InputMaybe<Scalars['String']>;
  /** Whether the payment has been success */
  success?: InputMaybe<Scalars['Boolean']>;
};

/** Billing Plan Grid */
export type BillingPlanGrid = {
  __typename?: 'BillingPlanGrid';
  /** The best value plan ID in the plan grid for the user */
  bestValueBillingProviderProductId?: Maybe<Scalars['Int']>;
  /** The plan grid matches if the user's current or next billing product ID is in this list */
  billingProductIdIn?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** The plan grid matches if the user's current or next billing product ID is not in this list */
  billingProductIdNotIn?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** The plan grid matches if the user's current or next billing provider product ID is in this list */
  billingProviderProductIdIn?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** The plan grid matches if the user's current or next billing provider product ID is not in this list */
  billingProviderProductIdNotIn?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** The ordered list of user specific billing provider products in the plan grid */
  billingProviderProducts: Array<BillingProviderProduct>;
  /** The plan grid matches if the user's country is in this list */
  countryIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The plan grid matches if the user's country is not in this list */
  countryNotIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** When the row was created */
  createdAt: Scalars['DateTime'];
  /** The plan grid matches if the user's currency is in this list */
  currencyIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The plan grid matches if the user's currency is not in this list */
  currencyNotIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether this plan grid is the default for the given page */
  defaultPageGrid: Scalars['Boolean'];
  /** The plan grid matches if the user's device type is in this list */
  deviceTypeIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The plan grid matches if the user's device type is not in this list */
  deviceTypeNotIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether the billing plan grid is enabled */
  enabled: Scalars['Boolean'];
  /** The end date of the billing plan grid */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The best value plan ID in the plan grid for existing members */
  existingMemberBestValueBillingProviderProductId?: Maybe<Scalars['Int']>;
  /** The first plan ID in the plan grid for existing members */
  existingMemberBillingProviderProductId1: Scalars['Int'];
  /** The second plan ID in the plan grid for existing members */
  existingMemberBillingProviderProductId2?: Maybe<Scalars['Int']>;
  /** The third plan ID in the plan grid for existing members */
  existingMemberBillingProviderProductId3?: Maybe<Scalars['Int']>;
  /** The fourth plan ID in the plan grid for existing members */
  existingMemberBillingProviderProductId4?: Maybe<Scalars['Int']>;
  /** The id of the billing plan grid */
  id: Scalars['ID'];
  /** The plan grid matches if the user's language is in this list */
  languageIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The plan grid matches if the user's language is not in this list */
  languageNotIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The best value plan ID in the plan grid for new members */
  newMemberBestValueBillingProviderProductId?: Maybe<Scalars['Int']>;
  /** The first plan ID in the plan grid for new members */
  newMemberBillingProviderProductId1: Scalars['Int'];
  /** The second plan ID in the plan grid for new members */
  newMemberBillingProviderProductId2?: Maybe<Scalars['Int']>;
  /** The third plan ID in the plan grid for new members */
  newMemberBillingProviderProductId3?: Maybe<Scalars['Int']>;
  /** The first plan ID in the plan grid for new members */
  newMemberBillingProviderProductId4?: Maybe<Scalars['Int']>;
  /** The page the billing plan grid belongs to */
  page: Scalars['String'];
  /** The priority of the plan grid */
  priority: Scalars['Int'];
  /** The start date of the billing plan grid */
  startDate?: Maybe<Scalars['DateTime']>;
  /** When the row was last updated */
  updatedAt: Scalars['DateTime'];
  /** The variant name of the billing plan grid */
  variantName?: Maybe<Scalars['String']>;
};

/** Billing Plan Grid list response */
export type BillingPlanGridListResponse = {
  __typename?: 'BillingPlanGridListResponse';
  billingPlanGrids?: Maybe<Array<Maybe<BillingPlanGrid>>>;
};

/** Billing Plan Grid list boolean where input type */
export type BillingPlanGridListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** Billing Plan Grid list where Date input type */
export type BillingPlanGridListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']>;
};

/** Billing Plan Grid list device type where input type */
export type BillingPlanGridListWhereDeviceTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<PlanGridDeviceType>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<PlanGridDeviceType>>>;
};

/** Billing Plan Grid list id where input type */
export type BillingPlanGridListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing Plan Grid list ID list where input type */
export type BillingPlanGridListWhereIdListInput = {
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing Plan Grid list where input type */
export type BillingPlanGridListWhereInput = {
  /** The filter for the billing plan grid billing product id in */
  billingProductIdIn?: InputMaybe<BillingPlanGridListWhereIdListInput>;
  /** The filter for the billing plan grid billing product id not in */
  billingProductIdNotIn?: InputMaybe<BillingPlanGridListWhereIdListInput>;
  /** The filter for the billing plan grid billing provider product id in */
  billingProviderProductIdIn?: InputMaybe<BillingPlanGridListWhereIdListInput>;
  /** The filter for the billing plan grid billing provider product id not in */
  billingProviderProductIdNotIn?: InputMaybe<BillingPlanGridListWhereIdListInput>;
  /** The filter for the billing plan grid country in */
  countryIn?: InputMaybe<BillingPlanGridListWhereStringListInput>;
  /** The filter for the billing plan grid country not in */
  countryNotIn?: InputMaybe<BillingPlanGridListWhereStringListInput>;
  /** The filter for the billing plan grid currency in */
  currencyIn?: InputMaybe<BillingPlanGridListWhereStringListInput>;
  /** The filter for the billing plan grid currency not in */
  currencyNotIn?: InputMaybe<BillingPlanGridListWhereStringListInput>;
  /** The filter for the billing plan grid default page grid */
  defaultPageGrid?: InputMaybe<BillingPlanGridListWhereBooleanInput>;
  /** The filter for the billing plan grid enabled */
  enabled?: InputMaybe<BillingPlanGridListWhereBooleanInput>;
  /** The filter for the billing plan grid end date */
  endDate?: InputMaybe<BillingPlanGridListWhereDateInput>;
  /** The filter for the billing plan grid id */
  id?: InputMaybe<BillingPlanGridListWhereIdInput>;
  /** The filter for the billing plan grid language in */
  languageIn?: InputMaybe<BillingPlanGridListWhereStringListInput>;
  /** The filter for the billing plan grid language not in */
  languageNotIn?: InputMaybe<BillingPlanGridListWhereStringListInput>;
  /** The filter for the billing plan grid page */
  page?: InputMaybe<BillingPlanGridListWhereStringInOrEqListInput>;
  /** The filter for the billing plan grid priority */
  priority?: InputMaybe<BillingPlanGridListWhereIntInput>;
  /** The filter for the billing plan grid start date */
  startDate?: InputMaybe<BillingPlanGridListWhereDateInput>;
  /** The filter for the billing plan grid variant name */
  variantName?: InputMaybe<BillingPlanGridListWhereStringInOrEqListInput>;
};

/** Billing Plan Grid list int where input type */
export type BillingPlanGridListWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Billing Plan Grid list string list where eq input type */
export type BillingPlanGridListWhereStringEqListInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
};

/** Billing Plan Grid list string list where in or eq input type */
export type BillingPlanGridListWhereStringInOrEqListInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Billing Plan Grid list string list where in input type */
export type BillingPlanGridListWhereStringListInput = {
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Billing Product */
export type BillingProduct = {
  __typename?: 'BillingProduct';
  /** Billing Provider Products associated with this Billing Product */
  billingProviderProducts?: Maybe<Array<Maybe<BillingProviderProduct>>>;
  /** The content set id of the billing product */
  contentSetId?: Maybe<Scalars['Int']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The id of the billing product */
  id?: Maybe<Scalars['ID']>;
  /** The name of the billing product */
  name?: Maybe<Scalars['String']>;
  /** The platform of the billing product */
  platform?: Maybe<ProductPlatform>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The UUID of the billing product */
  uuid?: Maybe<Scalars['ID']>;
};

/** Billing Product Change Log */
export type BillingProductChangeLog = {
  __typename?: 'BillingProductChangeLog';
  /** The type of change */
  changeType: ProductChangeLogType;
  /** When the row was created */
  createdAt: Scalars['DateTime'];
  /** The billing discount code when the entity is Discount */
  discountCode?: Maybe<Scalars['String']>;
  /** The ecommerce sku of the changed entity */
  ecommerceSku?: Maybe<Scalars['String']>;
  /** The entity that was changed */
  entityName: Scalars['String'];
  /** The id of the billing product */
  id: Scalars['ID'];
  /** The new values of the row */
  newValues?: Maybe<Scalars['JSON']>;
  /** The plan grid page of the changed entity */
  planGridPage?: Maybe<Scalars['String']>;
  /** The plan grid variant of the changed entity */
  planGridVariant?: Maybe<Scalars['String']>;
  /** The previous values of the row */
  previousValues?: Maybe<Scalars['JSON']>;
  /** The pricing currency of the changed entity */
  pricingCurrency?: Maybe<Scalars['String']>;
  /** The product of the changed entity */
  productName?: Maybe<Scalars['String']>;
  /** The provider of the changed entity */
  providerName?: Maybe<Scalars['String']>;
  /** The sku of the changed entity */
  sku?: Maybe<Scalars['String']>;
  /** The text key of the changed entity */
  textKey?: Maybe<Scalars['String']>;
  /** The text language of the changed entity */
  textLanguage?: Maybe<Scalars['String']>;
  /** When the row was last updated */
  updatedAt: Scalars['DateTime'];
  /** UUID of the user who made the change */
  userInfoUuid: Scalars['ID'];
  /** The username of the user who made the change */
  username: Scalars['String'];
};

/** Billing Product Change Log input type */
export type BillingProductChangeLogInput = {
  /** The type of change */
  changeType: ProductChangeLogType;
  /** The billing discount code when the entity is Discount */
  discountCode?: InputMaybe<Scalars['String']>;
  /** The ecommerce sku of the changed entity */
  ecommerceSku?: InputMaybe<Scalars['String']>;
  /** The entity that was changed */
  entityName: ProductChangeLogEntityName;
  /** The new values of the row */
  newValues?: InputMaybe<Scalars['JSON']>;
  /** The plan grid page of the changed entity */
  planGridPage?: InputMaybe<Scalars['String']>;
  /** The plan grid variant of the changed entity */
  planGridVariant?: InputMaybe<Scalars['String']>;
  /** The previous values of the row */
  previousValues?: InputMaybe<Scalars['JSON']>;
  /** The pricing currency of the changed entity */
  pricingCurrency?: InputMaybe<Scalars['String']>;
  /** The product of the changed entity */
  productName?: InputMaybe<Scalars['String']>;
  /** The provider of the changed entity */
  providerName?: InputMaybe<Scalars['String']>;
  /** The sku of the changed entity */
  sku?: InputMaybe<Scalars['String']>;
  /** The text key of the changed entity */
  textKey?: InputMaybe<Scalars['String']>;
  /** The text language of the changed entity */
  textLanguage?: InputMaybe<Scalars['String']>;
};

export type BillingProductChangeLogListResponse = {
  __typename?: 'BillingProductChangeLogListResponse';
  /** A list of billingProductChangeLog reference */
  billingProductChangeLogs?: Maybe<Array<Maybe<BillingProductChangeLog>>>;
};

/** Billing Product Change Log list where Date input type */
export type BillingProductChangeLogListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']>;
};

/** Billing Product Change Log list id where input type */
export type BillingProductChangeLogListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type BillingProductChangeLogListWhereInput = {
  /** The billingProduct type field where clause */
  changeType?: InputMaybe<BillingProductChangeLogWhereChangeTypeInput>;
  /** The billingProduct createdAt field where clause */
  createdAt?: InputMaybe<BillingProductChangeLogListWhereDateInput>;
  /** The billingProduct discountCode field where clause */
  discountCode?: InputMaybe<BillingProductChangeLogWhereStringInput>;
  /** The billingProduct ecommerceSku field where clause */
  ecommerceSku?: InputMaybe<BillingProductChangeLogWhereStringInput>;
  /** The billingProduct entityName field where clause */
  entityName?: InputMaybe<BillingProductChangeLogWhereEntityNameInput>;
  /** The billingProduct id field where clause */
  id?: InputMaybe<BillingProductChangeLogListWhereIdInput>;
  /** The billingProduct planGridPage field where clause */
  planGridPage?: InputMaybe<BillingProductChangeLogWhereStringInput>;
  /** The billingProduct planGridVariant field where clause */
  planGridVariant?: InputMaybe<BillingProductChangeLogWhereStringInput>;
  /** The billingProduct pricingCurrency field where clause */
  pricingCurrency?: InputMaybe<BillingProductChangeLogWhereStringInput>;
  /** The billingProduct productName field where clause */
  productName?: InputMaybe<BillingProductChangeLogWhereStringInput>;
  /** The billingProduct providerName field where clause */
  providerName?: InputMaybe<BillingProductChangeLogWhereStringInput>;
  /** The billingProduct sku field where clause */
  sku?: InputMaybe<BillingProductChangeLogWhereStringInput>;
  /** The billingProduct textKey field where clause */
  textKey?: InputMaybe<BillingProductChangeLogWhereStringInput>;
  /** The billingProduct textLanguage field where clause */
  textLanguage?: InputMaybe<BillingProductChangeLogWhereLanguageInput>;
  /** The billingProduct updatedAt field where clause */
  updatedAt?: InputMaybe<BillingProductChangeLogListWhereDateInput>;
  /** The billingProduct uuid field where clause */
  userInfoUuid?: InputMaybe<BillingProductChangeLogListWhereIdInput>;
};

/** Billing Product Change Log User */
export type BillingProductChangeLogUser = {
  __typename?: 'BillingProductChangeLogUser';
  /** The username of the user */
  username: Scalars['String'];
  /** The UUID of the user */
  uuid: Scalars['ID'];
};

export type BillingProductChangeLogUserListResponse = {
  __typename?: 'BillingProductChangeLogUserListResponse';
  /** A list of unique users who made changes */
  users?: Maybe<Array<Maybe<BillingProductChangeLogUser>>>;
};

/** BillingProduct Change Log change type where input type */
export type BillingProductChangeLogWhereChangeTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProductChangeLogType>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProductChangeLogType>>>;
};

/** Billing Product Change Log entity name where input type */
export type BillingProductChangeLogWhereEntityNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProductChangeLogEntityName>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProductChangeLogEntityName>>>;
};

/** BillingProduct Change Log language where input type */
export type BillingProductChangeLogWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProviderProductLanguage>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProviderProductLanguage>>>;
};

/** Billing Product Change Log string where input type */
export type BillingProductChangeLogWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Billing Product list response */
export type BillingProductListResponse = {
  __typename?: 'BillingProductListResponse';
  /** A list of billingProducts */
  billingProducts?: Maybe<Array<Maybe<BillingProduct>>>;
};

/** Billing Product list id where input type */
export type BillingProductListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing Product list where input type */
export type BillingProductListWhereInput = {
  /** The billingProduct contentSetId field where clause */
  contentSetId?: InputMaybe<BillingProductWhereIntInput>;
  /** The billingProduct id field where clause */
  id?: InputMaybe<BillingProductListWhereIdInput>;
  /** The billingProduct name field where clause */
  name?: InputMaybe<BillingProductWhereStringInput>;
  /** The billingProduct platform field where clause */
  platform?: InputMaybe<BillingProductWherePlatformInput>;
  /** The billingProduct uuid field where clause */
  uuid?: InputMaybe<BillingProductListWhereIdInput>;
};

/** Billing Product boolean where input type */
export type BillingProductWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** Billing Product int where input type */
export type BillingProductWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Billing Product platform where input type */
export type BillingProductWherePlatformInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProductPlatform>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProductPlatform>>>;
};

/** Billing Product string where input type */
export type BillingProductWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Billing Provider */
export type BillingProvider = {
  __typename?: 'BillingProvider';
  /** Billing Provider Products associated with this Billing Provider */
  billingProviderProducts?: Maybe<Array<Maybe<BillingProviderProduct>>>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The id of the billing provider */
  id?: Maybe<Scalars['ID']>;
  /** The name of the billing provider */
  name?: Maybe<BillingProviderName>;
  /** Whether the billing provider has subscription management */
  subscriptionManagement?: Maybe<Scalars['Boolean']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The UUID of the billing provider */
  uuid?: Maybe<Scalars['ID']>;
};

/** Billing Provider Currency */
export type BillingProviderCurrency = {
  __typename?: 'BillingProviderCurrency';
  /** Billing Provider associated with this Billing Provider Currency */
  billingProvider?: Maybe<BillingProvider>;
  /** Billing Provider ID */
  billingProviderId?: Maybe<Scalars['ID']>;
  /** Provider Currency countryCodeISO2 */
  countryCodeISO2?: Maybe<Scalars['String']>;
  /** Provider Currency countryCodeISO3 */
  countryCodeISO3?: Maybe<Scalars['String']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The billing provider currency */
  currency?: Maybe<Scalars['String']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Billing Provider Currency UUID */
  uuid?: Maybe<Scalars['ID']>;
};

/** Billing Provider Currency Input */
export type BillingProviderCurrencyInput = {
  /** Billing Provider ID */
  billingProviderId: Scalars['ID'];
  /** Provider Currency countryCodeISO2 */
  countryCodeISO2: Scalars['String'];
  /** Provider Currency countryCodeISO3 */
  countryCodeISO3: Scalars['String'];
  /** The billing provider currency */
  currency: Scalars['String'];
};

/** Billing Provider Currency list billingProvider input type */
export type BillingProviderCurrencyListBillingProviderInput = {
  /** The billingProvider name field where clause */
  name?: InputMaybe<BillingProviderCurrencyWhereStringInput>;
};

/** Billing Provider Currency list response */
export type BillingProviderCurrencyListResponse = {
  __typename?: 'BillingProviderCurrencyListResponse';
  /** A list of billingProviderCurrency */
  billingProviderCurrency?: Maybe<Array<Maybe<BillingProviderCurrency>>>;
};

/** Billing Provider Currency list ID where input type */
export type BillingProviderCurrencyListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing Provider Currency list where input type */
export type BillingProviderCurrencyListWhereInput = {
  /** The billingProviderCurrency billingProviderId field where clause */
  billingProviderId?: InputMaybe<BillingProviderCurrencyListWhereIdInput>;
  /** The billingProviderCurrency countryCodeISO2 field where clause */
  countryCodeISO2?: InputMaybe<BillingProviderCurrencyWhereStringInput>;
  /** The billingProviderCurrency countryCodeISO3 field where clause */
  countryCodeISO3?: InputMaybe<BillingProviderCurrencyWhereStringInput>;
  /** The billingProviderCurrency currency field where clause */
  currency?: InputMaybe<BillingProviderCurrencyWhereStringInput>;
  /** The billingProviderCurrency id field where clause */
  id?: InputMaybe<BillingProviderCurrencyListWhereIdInput>;
};

/** Billing Provider Currency Update Input */
export type BillingProviderCurrencyUpdateInput = {
  /** Billing Provider ID */
  billingProviderId?: InputMaybe<Scalars['ID']>;
  /** Provider Currency countryCodeISO2 */
  countryCodeISO2?: InputMaybe<Scalars['String']>;
  /** Provider Currency countryCodeISO3 */
  countryCodeISO3?: InputMaybe<Scalars['String']>;
  /** The billing provider currency */
  currency?: InputMaybe<Scalars['String']>;
  /** The billingProviderCurrency id */
  id: Scalars['ID'];
};

/** Billing Product int where input type */
export type BillingProviderCurrencyWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Billing Provider Currency string where input type */
export type BillingProviderCurrencyWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Billing Provider list response */
export type BillingProviderListResponse = {
  __typename?: 'BillingProviderListResponse';
  /** A list of billingProviders */
  billingProviders?: Maybe<Array<Maybe<BillingProvider>>>;
};

/** Billing Product list id where input type */
export type BillingProviderListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing Product list where input type */
export type BillingProviderListWhereInput = {
  /** The billingProvider id field where clause */
  id?: InputMaybe<BillingProviderListWhereIdInput>;
  /** The billingProvider name field where clause */
  name?: InputMaybe<BillingProviderWhereStringInput>;
  /** The billingProvider subscriptionManagement field where clause */
  subscriptionManagement?: InputMaybe<BillingProviderWhereBooleanInput>;
  /** The billingProvider uuid field where clause */
  uuid?: InputMaybe<BillingProviderListWhereIdInput>;
};

/** Billing Provider Name */
export enum BillingProviderName {
  /** Amazon */
  Amazon = 'amazon',
  /** Google Play */
  Google = 'google',
  /** iTunes */
  Itunes = 'itunes',
  /** My Yoga Online PayPal */
  MyoPaypal = 'myo_paypal',
  /** PayPal */
  Paypal = 'paypal',
  /** Roku */
  Roku = 'roku',
  /** Zuora */
  Zuora = 'zuora'
}

/** Billing Provider Product */
export type BillingProviderProduct = {
  __typename?: 'BillingProviderProduct';
  /** Whether the plan can be changed */
  allowChangePlan?: Maybe<Scalars['Boolean']>;
  /** Billing Plan Grids associated with this Billing Provider Product */
  billingPlanGrids?: Maybe<Array<Maybe<BillingPlanGrid>>>;
  /** Billing Product associated with this Billing Provider Product */
  billingProduct?: Maybe<BillingProduct>;
  /** Billing Product ID */
  billingProductId?: Maybe<Scalars['ID']>;
  /** Billing Provider associated with this Billing Provider Product */
  billingProvider?: Maybe<BillingProvider>;
  /** Billing Provider ID */
  billingProviderId?: Maybe<Scalars['ID']>;
  /** Plan eligibility rules associated with this Billing Provider Product */
  billingProviderProductEligibilities?: Maybe<Array<Maybe<BillingProviderProductEligibility>>>;
  /** Billing Provider Product Pricing array associated with this Billing Provider Product */
  billingProviderProductPrices?: Maybe<Array<Maybe<BillingProviderProductPricing>>>;
  /** Billing Provider Product Text array associated with this Billing Provider Product */
  billingProviderProductText?: Maybe<Array<Maybe<BillingProviderProductText>>>;
  /** Whether checkout is enabled for this provider product */
  checkoutEnabled?: Maybe<Scalars['Boolean']>;
  /** Date when checkout is disabled for this product */
  checkoutEnabledEnd?: Maybe<Scalars['DateTime']>;
  /** Date when checkout is enabled for this product */
  checkoutEnabledStart?: Maybe<Scalars['DateTime']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Whether the logged in user's current plan matches this product (plan level) */
  currentSubscriptionPlanMatchesProduct?: Maybe<Scalars['Boolean']>;
  /** Whether the logged in user's current plan matches this provider product (specific plan) */
  currentSubscriptionPlanMatchesProviderProduct?: Maybe<Scalars['Boolean']>;
  /** Default Oracle personality from Oracle API for this billing provider product */
  defaultOraclePersonality?: Maybe<OraclePersonality>;
  /** Default Oracle personality ID from Oracle API for this billing provider product */
  defaultOraclePersonalityId?: Maybe<Scalars['Int']>;
  /** Provider Product description */
  description?: Maybe<Scalars['String']>;
  /** Discount eligibility and discounted pricing for a code on this plan (signed-in user) */
  discount?: Maybe<BillingDiscountEligibilityResult>;
  ecommerceSkuMappingBonusEligibilities?: Maybe<Array<Maybe<EcommerceSkuMappingBonusEligibility>>>;
  eligibility?: Maybe<BillingProviderProductEligibilityResult>;
  /** Whether the user is eligible for this plan */
  eligible?: Maybe<Scalars['Boolean']>;
  /** Enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** Whether the logged in user's next plan matches this product (plan level) */
  nextSubscriptionPlanMatchesProduct?: Maybe<Scalars['Boolean']>;
  /** Whether the logged in user's next plan matches this provider product (specific plan) */
  nextSubscriptionPlanMatchesProviderProduct?: Maybe<Scalars['Boolean']>;
  /** Primary stakeholder of the billing provider product */
  primaryStakeholder?: Maybe<ProviderProductPrimaryStakeholder>;
  /** ID of main product in source system (zuora only) */
  providerFirstSegmentId?: Maybe<Scalars['String']>;
  /** ID of recurring product in source system (zuora only).  Only populated for trial plans. */
  providerSecondSegmentId?: Maybe<Scalars['String']>;
  /** Savings Comparison Billing Provider Product ID */
  savingsComparisonId?: Maybe<Scalars['ID']>;
  /** Provider Product sku */
  sku?: Maybe<Scalars['String']>;
  /** Whether this plan is taxed */
  taxable?: Maybe<Scalars['Boolean']>;
  /** Provider Product term length - null denotes lifetime access (courses) */
  termLength?: Maybe<Scalars['Int']>;
  /** Term type range */
  termType?: Maybe<ProviderProductTermType>;
  /** Provider Product trial length - null denotes no trial */
  trialLength?: Maybe<Scalars['Int']>;
  /** Provider Product trial term range */
  trialTermType?: Maybe<ProviderProductTermType>;
  /** Provider Product type */
  type?: Maybe<ProviderProductType>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Billing Provider Product UUID */
  uuid?: Maybe<Scalars['ID']>;
};


/** Billing Provider Product */
export type BillingProviderProductBillingPlanGridsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['String']>;
};


/** Billing Provider Product */
export type BillingProviderProductBillingProviderProductPricesArgs = {
  currency?: InputMaybe<Scalars['String']>;
  subscriptionPricingReplacementType?: InputMaybe<SubscriptionPricingReplacementType>;
};


/** Billing Provider Product */
export type BillingProviderProductBillingProviderProductTextArgs = {
  currency?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['DateTime']>;
  language?: InputMaybe<ProviderProductLanguage>;
  skipReplacement?: InputMaybe<Scalars['Boolean']>;
  subscriptionPricingReplacementType?: InputMaybe<SubscriptionPricingReplacementType>;
};


/** Billing Provider Product */
export type BillingProviderProductDiscountArgs = {
  currency?: InputMaybe<Scalars['String']>;
  discountCode: Scalars['String'];
  language: ProviderProductLanguage;
  page: PlanEligibilityPage;
};


/** Billing Provider Product */
export type BillingProviderProductEcommerceSkuMappingBonusEligibilitiesArgs = {
  effectiveDate?: InputMaybe<Scalars['DateTime']>;
  languages?: InputMaybe<Array<InputMaybe<ProviderProductLanguage>>>;
};


/** Billing Provider Product */
export type BillingProviderProductEligibilityArgs = {
  page: PlanEligibilityPage;
};


/** Billing Provider Product */
export type BillingProviderProductEligibleArgs = {
  page: PlanEligibilityPage;
};

/** Billing Provider Product Delete By Id Input */
export type BillingProviderProductDeleteByIdInput = {
  /** The id to delete */
  id: Scalars['ID'];
};

/** Billing Provider Product Eligibility rule */
export type BillingProviderProductEligibility = {
  __typename?: 'BillingProviderProductEligibility';
  /** Billing Provider Product this rule belongs to */
  billingProviderProduct?: Maybe<BillingProviderProduct>;
  /** Billing Provider Product this rule applies to */
  billingProviderProductId: Scalars['ID'];
  /** Country ISO codes for Country rule type (required with countryOperator) */
  countries?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether request country must be in or not in countries (Country rule type) */
  countryOperator?: Maybe<PlanEligibilityCountryOperator>;
  /** When the row was created */
  createdAt: Scalars['DateTime'];
  /** Ecommerce SKUs (SKU rule type) */
  ecommerceSkus?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether the rule is enabled */
  enabled: Scalars['Boolean'];
  /** Rule end timestamp */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The primary identifier */
  id: Scalars['ID'];
  /** Lifetime value in USD (LifetimeValue rule type) */
  lifetimeValue?: Maybe<Scalars['Float']>;
  /** Lifetime value operator (LifetimeValue rule type) */
  lifetimeValueOperator?: Maybe<PlanEligibilityNumericOperator>;
  /** Max purchases (MaxPurchases rule type) */
  maxPurchases?: Maybe<Scalars['Int']>;
  /** Months since last purchase (MonthsSinceLastPurchase rule type). Rule passes when user has no purchases or at least this many months since last purchase. */
  monthsSinceLastPurchase?: Maybe<Scalars['Int']>;
  /** Plan categories from billing_product.name (PlanCategory rule type) */
  planCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Plan SKUs (SKU rule type) */
  planSkus?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Rule type */
  ruleType: PlanEligibilityRuleType;
  /** Scope: Checkout, PlanChange, or All */
  scope: PlanEligibilityScope;
  /** SKU check type (SKU rule type) */
  skuCheckType?: Maybe<SkuCheckType>;
  /** SKU operator AND/OR (SKU rule type when both ecommerce and plan SKUs present) */
  skuOperator?: Maybe<SkuOperator>;
  /** Rule start timestamp */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Tenure in days (Tenure rule type) */
  tenure?: Maybe<Scalars['Int']>;
  /** Tenure operator (Tenure rule type) */
  tenureOperator?: Maybe<PlanEligibilityNumericOperator>;
  /** When the row was last updated */
  updatedAt: Scalars['DateTime'];
};

/** Result of deleting a plan eligibility rule */
export type BillingProviderProductEligibilityDeleteResponse = {
  __typename?: 'BillingProviderProductEligibilityDeleteResponse';
  /** Whether the delete succeeded */
  success?: Maybe<Scalars['Boolean']>;
};

/** Plan eligibility error code */
export enum BillingProviderProductEligibilityErrorCode {
  /** User has active subscription entitlements (checkout does not allow active entitlements) */
  ActiveEntitlements = 'ACTIVE_ENTITLEMENTS',
  /** Subscription is active (checkout does not allow active subscription) */
  ActiveSubscription = 'ACTIVE_SUBSCRIPTION',
  /** Free trial not allowed (user already has had a subscription) */
  FreeTrialNotAllowed = 'FREE_TRIAL_NOT_ALLOWED',
  /** Subscription is not active (plan change requires active subscription) */
  InactiveSubscription = 'INACTIVE_SUBSCRIPTION',
  /** Plan change not allowed for this plan */
  PlanChangeNotAllowed = 'PLAN_CHANGE_NOT_ALLOWED',
  /** Plan disabled */
  PlanDisabled = 'PLAN_DISABLED',
  /** The given plan was not found */
  PlanNotFound = 'PLAN_NOT_FOUND',
  /** One or more rules failed */
  RulesFailed = 'RULES_FAILED',
  /** Subscription is required to determine eligibility but no subscription present */
  SubscriptionNotFound = 'SUBSCRIPTION_NOT_FOUND',
  /** Subscription is paused (prevents plan change) */
  SubscriptionPaused = 'SUBSCRIPTION_PAUSED',
  /** Subscription is past paid-through date but not cancelled (suspended) */
  SubscriptionSuspended = 'SUBSCRIPTION_SUSPENDED',
  /** User already has this plan */
  UserAlreadyHasPlan = 'USER_ALREADY_HAS_PLAN',
  /** User is required to determine eligibility but no user present */
  UserRequired = 'USER_REQUIRED'
}

/** Plan eligibility failure type */
export enum BillingProviderProductEligibilityFailureType {
  /** Base criteria */
  BaseCriteria = 'BaseCriteria',
  /** Rules */
  Rules = 'Rules'
}

/** Billing Provider Product Eligibility list response */
export type BillingProviderProductEligibilityListResponse = {
  __typename?: 'BillingProviderProductEligibilityListResponse';
  billingProviderProductEligibilities?: Maybe<Array<Maybe<BillingProviderProductEligibility>>>;
};

/** Eligibility list where Boolean input (eq) */
export type BillingProviderProductEligibilityListWhereBooleanInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** Eligibility list where ID input (eq / in) */
export type BillingProviderProductEligibilityListWhereIdInput = {
  eq?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Where input for eligibility list */
export type BillingProviderProductEligibilityListWhereInput = {
  /** Filter by billing provider product id */
  billingProviderProductId?: InputMaybe<BillingProviderProductEligibilityListWhereIdInput>;
  /** Filter by enabled */
  enabled?: InputMaybe<BillingProviderProductEligibilityListWhereBooleanInput>;
  /** Filter by rule type */
  ruleType?: InputMaybe<BillingProviderProductEligibilityListWhereRuleTypeInput>;
  /** Filter by scope */
  scope?: InputMaybe<BillingProviderProductEligibilityListWhereScopeInput>;
  /** Filter by sku */
  sku?: InputMaybe<BillingProviderProductEligibilityListWhereStringInput>;
};

/** Eligibility list where rule type input (eq / in) */
export type BillingProviderProductEligibilityListWhereRuleTypeInput = {
  eq?: InputMaybe<PlanEligibilityRuleType>;
  in?: InputMaybe<Array<InputMaybe<PlanEligibilityRuleType>>>;
};

/** Eligibility list where scope input (eq / in) */
export type BillingProviderProductEligibilityListWhereScopeInput = {
  eq?: InputMaybe<PlanEligibilityScope>;
  in?: InputMaybe<Array<InputMaybe<PlanEligibilityScope>>>;
};

/** Eligibility list where String input (eq / in) */
export type BillingProviderProductEligibilityListWhereStringInput = {
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Result of checking plan eligibility for a given plan and page */
export type BillingProviderProductEligibilityResult = {
  __typename?: 'BillingProviderProductEligibilityResult';
  /** Whether the user/guest is eligible for the plan on the given page */
  eligible: Scalars['Boolean'];
  /** The error code */
  errorCode?: Maybe<BillingProviderProductEligibilityErrorCode>;
  /** The failure type */
  failureType?: Maybe<BillingProviderProductEligibilityFailureType>;
  /** Failed rules in the eligibility check */
  failures?: Maybe<Array<Maybe<BillingProviderProductEligibility>>>;
};

/** Billing Provider Product Input */
export type BillingProviderProductInput = {
  /** Whether the plan can be changed */
  allowChangePlan?: InputMaybe<Scalars['Boolean']>;
  /** Billing Product ID */
  billingProductId: Scalars['ID'];
  /** Billing Provider ID */
  billingProviderId: Scalars['ID'];
  /** Date when checkout is disabled for this product */
  checkoutEnabledEnd?: InputMaybe<Scalars['DateTime']>;
  /** Date when checkout is enabled for this product */
  checkoutEnabledStart?: InputMaybe<Scalars['DateTime']>;
  /** Default AI persona ID from Oracle API for this billing provider product */
  defaultOraclePersonalityId?: InputMaybe<Scalars['Int']>;
  /** Provider Product description */
  description: Scalars['String'];
  /** Enabled */
  enabled: Scalars['Boolean'];
  /** Primary stakeholder of the billing provider product */
  primaryStakeholder?: InputMaybe<ProviderProductPrimaryStakeholder>;
  /** ID of main product in source system (zuora only) */
  providerFirstSegmentId?: InputMaybe<Scalars['String']>;
  /** ID of recurring product in source system (zuora only).  Only populated for trial plans. */
  providerSecondSegmentId?: InputMaybe<Scalars['String']>;
  /** Savings Comparison Billing Provider Product ID */
  savingsComparisonId?: InputMaybe<Scalars['ID']>;
  /** Provider Product sku */
  sku: Scalars['String'];
  /** Whether this plan is taxed */
  taxable: Scalars['Boolean'];
  /** Provider Product term length - null denotes lifetime access (courses) */
  termLength: Scalars['Int'];
  /** Term type range */
  termType: ProviderProductTermType;
  /** Provider Product trial length - null denotes no trial */
  trialLength?: InputMaybe<Scalars['Int']>;
  /** Provider Product trial term range */
  trialTermType?: InputMaybe<ProviderProductTermType>;
  /** Provider Product type */
  type: ProviderProductType;
};

/** Billing Product input type */
export type BillingProviderProductListBillingProductInput = {
  /** The billingProduct contentSetId field where clause */
  contentSetId?: InputMaybe<BillingProductWhereIntInput>;
  /** The billingProduct name field where clause */
  name?: InputMaybe<BillingProviderProductWhereStringInput>;
  /** The billingProduct platform field where clause */
  platform?: InputMaybe<BillingProductWherePlatformInput>;
};

/** Billing Provider Product list billingProvider input type */
export type BillingProviderProductListBillingProviderInput = {
  /** The billingProvider name field where clause */
  name?: InputMaybe<BillingProviderWhereNameInput>;
};

/** Billing Provider Product list response */
export type BillingProviderProductListResponse = {
  __typename?: 'BillingProviderProductListResponse';
  /** A list of billingProviderProducts */
  billingProviderProducts?: Maybe<Array<Maybe<BillingProviderProduct>>>;
};

/** Billing Provider Product list ID where input type */
export type BillingProviderProductListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing Provider Product list where input type */
export type BillingProviderProductListWhereInput = {
  /** The billingProviderProduct billingProductId field where clause */
  billingProductId?: InputMaybe<BillingProviderProductListWhereIdInput>;
  /** The billingProviderProduct billingProviderId field where clause */
  billingProviderId?: InputMaybe<BillingProviderProductListWhereIdInput>;
  /** The billingProviderProduct checkoutEnabled field where clause */
  checkoutEnabled?: InputMaybe<BillingProductWhereBooleanInput>;
  /** The billingProviderProduct enabled field where clause */
  enabled?: InputMaybe<BillingProductWhereBooleanInput>;
  /** The billingProviderProduct id field where clause */
  id?: InputMaybe<BillingProviderProductListWhereIdInput>;
  /** The billingProviderProduct primaryStakeholder field where clause */
  primaryStakeholder?: InputMaybe<BillingProviderProductListWhereStakeholderInput>;
  /** The billingProviderProduct providerFirstSegmentId (zuora rate plan ID) field where clause */
  providerFirstSegmentId?: InputMaybe<BillingProviderProductWhereStringInput>;
  /** The billingProviderProduct providerSecondSegmentId field where clause */
  providerSecondSegmentId?: InputMaybe<BillingProviderProductWhereStringInput>;
  /** The billingProviderProduct sku field where clause */
  sku?: InputMaybe<BillingProviderProductWhereStringInput>;
  /** The billingProviderProduct taxable field where clause */
  taxable?: InputMaybe<BillingProductWhereBooleanInput>;
  /** The billingProviderProduct termLength field where clause */
  termLength?: InputMaybe<BillingProductWhereIntInput>;
  /** The billingProviderProduct term type field where clause */
  termType?: InputMaybe<BillingProviderProductWhereTermTypeInput>;
  /** The billingProviderProduct trialLength field where clause */
  trialLength?: InputMaybe<BillingProductWhereIntInput>;
  /** The billingProviderProduct trial term type field where clause */
  trialTermType?: InputMaybe<BillingProviderProductWhereTermTypeInput>;
  /** The billingProviderProduct type field where clause */
  type?: InputMaybe<BillingProviderProductWhereTypeInput>;
};

/** Billing Provider Product list primary stakeholder where input type */
export type BillingProviderProductListWhereStakeholderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProviderProductPrimaryStakeholder>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProviderProductPrimaryStakeholder>>>;
};

/** Billing Provider Product Pricing Input */
export type BillingProviderProductPriceInput = {
  /** The billingProviderProductPrice currency */
  currency: Scalars['String'];
  /** The billingProviderProductPrice price */
  price: Scalars['Float'];
  /** The billingProviderProductPrice trialSegmentPrice */
  trialSegmentPrice?: InputMaybe<Scalars['Float']>;
};

/** Billing Provider Product Pricing type */
export type BillingProviderProductPricing = {
  __typename?: 'BillingProviderProductPricing';
  /** Billing Provider Product associated with this Billing Provider Product Pricing */
  billingProviderProduct?: Maybe<BillingProviderProduct>;
  /** The billing provider product id of the billing provider product pricing */
  billingProviderProductId?: Maybe<Scalars['ID']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The billing provider product pricing currency */
  currency?: Maybe<Scalars['String']>;
  /** The billing provider product pricing currency symbol */
  currencySymbol?: Maybe<Scalars['String']>;
  /** The id of the billing provider product pricing */
  id?: Maybe<Scalars['ID']>;
  /** Percent Savings - If savings comparison ID is defined on the billingProviderProduct */
  percentSavings?: Maybe<Scalars['Int']>;
  /** The billing provider product pricing price */
  price?: Maybe<Scalars['Float']>;
  /** The billing provider product pricing formatted price */
  priceFormatted?: Maybe<Scalars['String']>;
  /** The billing provider product pricing price per month equivalent */
  pricePerMonth?: Maybe<Scalars['Float']>;
  /** The billing provider product pricing formatted price per month equivalent */
  pricePerMonthFormatted?: Maybe<Scalars['String']>;
  /** The billing provider product price per week equivalent */
  pricePerWeek?: Maybe<Scalars['Float']>;
  /** The billing provider product formatted price per week equivalent */
  pricePerWeekFormatted?: Maybe<Scalars['String']>;
  /** Trial Segment Percent Savings - If savings comparison ID is defined on the billingProviderProduct */
  trialPercentSavings?: Maybe<Scalars['Int']>;
  /** The billing provider product trial segment price */
  trialSegmentPrice?: Maybe<Scalars['Float']>;
  /** The billing provider product formatted trial segment price */
  trialSegmentPriceFormatted?: Maybe<Scalars['String']>;
  /** The billing provider product trial segment price per month equivalent */
  trialSegmentPricePerMonth?: Maybe<Scalars['Float']>;
  /** The billing provider product formatted trial segment price per month equivalent */
  trialSegmentPricePerMonthFormatted?: Maybe<Scalars['String']>;
  /** The billing provider product trial segment price per week equivalent */
  trialSegmentPricePerWeek?: Maybe<Scalars['Float']>;
  /** The billing provider product formatted trial segment price per week equivalent */
  trialSegmentPricePerWeekFormatted?: Maybe<Scalars['String']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The UUID of the billing provider product pricing */
  uuid?: Maybe<Scalars['ID']>;
};


/** Billing Provider Product Pricing type */
export type BillingProviderProductPricingPriceFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<ProviderProductLanguage>;
};


/** Billing Provider Product Pricing type */
export type BillingProviderProductPricingPricePerMonthFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<ProviderProductLanguage>;
};


/** Billing Provider Product Pricing type */
export type BillingProviderProductPricingPricePerWeekFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<ProviderProductLanguage>;
};


/** Billing Provider Product Pricing type */
export type BillingProviderProductPricingTrialSegmentPriceFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<ProviderProductLanguage>;
};


/** Billing Provider Product Pricing type */
export type BillingProviderProductPricingTrialSegmentPricePerMonthFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<ProviderProductLanguage>;
};


/** Billing Provider Product Pricing type */
export type BillingProviderProductPricingTrialSegmentPricePerWeekFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<ProviderProductLanguage>;
};

/** Create a billingProviderProductPricing input type */
export type BillingProviderProductPricingCreateInput = {
  /** The billing provider product id of the billing provider product pricing */
  billingProviderProductId: Scalars['ID'];
  /** The billing provider product pricing currency */
  currency: Scalars['String'];
  /** The billing provider product pricing price */
  price: Scalars['Float'];
  /** The billing provider product trial segment price */
  trialSegmentPrice?: InputMaybe<Scalars['Float']>;
};

/** Billing Provider Product Pricing Delete response */
export type BillingProviderProductPricingDeleteResponse = {
  __typename?: 'BillingProviderProductPricingDeleteResponse';
  /** The success status of the delete operation */
  success?: Maybe<Scalars['Boolean']>;
};

/** Billing provider product pricing discounted */
export type BillingProviderProductPricingDiscounted = {
  __typename?: 'BillingProviderProductPricingDiscounted';
  /** The currency */
  currency?: Maybe<Scalars['String']>;
  /** The currency symbol */
  currencySymbol?: Maybe<Scalars['String']>;
  /** The recurring price 1 - discount bill cycle definition can create two recurring prices */
  recurringPrice1?: Maybe<Scalars['Float']>;
  /** Whether the recurring price 1 is discounted */
  recurringPrice1Discounted?: Maybe<Scalars['Boolean']>;
  /** Formatted first recurring segment price */
  recurringPrice1Formatted?: Maybe<Scalars['String']>;
  /** First recurring segment price per month equivalent */
  recurringPrice1PerMonth?: Maybe<Scalars['Float']>;
  /** Formatted first recurring segment price per month equivalent */
  recurringPrice1PerMonthFormatted?: Maybe<Scalars['String']>;
  /** The recurring price 2 (if applicable) - discount bill cycle definition can create two recurring prices */
  recurringPrice2?: Maybe<Scalars['Float']>;
  /** Whether the recurring price 2 is discounted */
  recurringPrice2Discounted?: Maybe<Scalars['Boolean']>;
  /** Formatted second recurring segment price */
  recurringPrice2Formatted?: Maybe<Scalars['String']>;
  /** Second recurring segment price per month equivalent */
  recurringPrice2PerMonth?: Maybe<Scalars['Float']>;
  /** Formatted second recurring segment price per month equivalent */
  recurringPrice2PerMonthFormatted?: Maybe<Scalars['String']>;
  /** The length of the recurring term 1 */
  recurringTermLength1?: Maybe<Scalars['Int']>;
  /** The length of the recurring term 2 (if applicable) */
  recurringTermLength2?: Maybe<Scalars['Int']>;
  /** The type of the recurring term 1 */
  recurringTermType1?: Maybe<ProviderProductTermType>;
  /** The type of the recurring term 2 (if applicable) */
  recurringTermType2?: Maybe<ProviderProductTermType>;
  /** The trial segment price */
  trialSegmentPrice?: Maybe<Scalars['Float']>;
  /** Whether the trial segment price is discounted */
  trialSegmentPriceDiscounted?: Maybe<Scalars['Boolean']>;
  /** Formatted trial segment price */
  trialSegmentPriceFormatted?: Maybe<Scalars['String']>;
  /** Trial segment price per month equivalent */
  trialSegmentPricePerMonth?: Maybe<Scalars['Float']>;
  /** Formatted trial segment price per month equivalent */
  trialSegmentPricePerMonthFormatted?: Maybe<Scalars['String']>;
  /** The trial term length */
  trialTermLength?: Maybe<Scalars['Int']>;
  /** The trial term type */
  trialTermType?: Maybe<ProviderProductTermType>;
};


/** Billing provider product pricing discounted */
export type BillingProviderProductPricingDiscountedRecurringPrice1FormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<ProviderProductLanguage>;
};


/** Billing provider product pricing discounted */
export type BillingProviderProductPricingDiscountedRecurringPrice1PerMonthFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<ProviderProductLanguage>;
};


/** Billing provider product pricing discounted */
export type BillingProviderProductPricingDiscountedRecurringPrice2FormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<ProviderProductLanguage>;
};


/** Billing provider product pricing discounted */
export type BillingProviderProductPricingDiscountedRecurringPrice2PerMonthFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<ProviderProductLanguage>;
};


/** Billing provider product pricing discounted */
export type BillingProviderProductPricingDiscountedTrialSegmentPriceFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<ProviderProductLanguage>;
};


/** Billing provider product pricing discounted */
export type BillingProviderProductPricingDiscountedTrialSegmentPricePerMonthFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<ProviderProductLanguage>;
};

/** Billing Provider Product Pricing list response */
export type BillingProviderProductPricingListResponse = {
  __typename?: 'BillingProviderProductPricingListResponse';
  /** A list of billingProviderProductPricing reference */
  billingProviderProductPrices?: Maybe<Array<Maybe<BillingProviderProductPricing>>>;
};

/** Billing Provider Product Pricing list id where input type */
export type BillingProviderProductPricingListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing Provider Product Pricing list where input type */
export type BillingProviderProductPricingListWhereInput = {
  /** The billingProviderProductPricing billingProviderProductId field where clause */
  billingProviderProductId?: InputMaybe<BillingProviderProductPricingListWhereIdInput>;
  /** The billingProviderProductPricing currency field where clause */
  currency?: InputMaybe<BillingProviderProductPricingWhereStringInput>;
  /** The billingProviderProductPricing id field where clause */
  id?: InputMaybe<BillingProviderProductPricingListWhereIdInput>;
  /** The billingProviderProductPricing uuid field where clause */
  uuid?: InputMaybe<BillingProviderProductPricingListWhereIdInput>;
};

/** Update a billingProviderProductPricing input type */
export type BillingProviderProductPricingUpdateInput = {
  /** The billing provider product id of the billing provider product pricing */
  billingProviderProductId?: InputMaybe<Scalars['ID']>;
  /** The billing provider product pricing currency */
  currency?: InputMaybe<Scalars['String']>;
  /** The id of the billing provider product pricing */
  id: Scalars['ID'];
  /** The billing provider product pricing price */
  price?: InputMaybe<Scalars['Float']>;
  /** The billing provider product trial segment price */
  trialSegmentPrice?: InputMaybe<Scalars['Float']>;
};

/** Billing Provider Product Pricing string where input type */
export type BillingProviderProductPricingWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Billing Provider Product Text */
export type BillingProviderProductText = {
  __typename?: 'BillingProviderProductText';
  /** Billing Provider Product associated with this Billing Provider Product Text */
  billingProviderProduct?: Maybe<BillingProviderProduct>;
  /** The billing provider product id of the billing provider product text */
  billingProviderProductId?: Maybe<Scalars['ID']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The billingProviderProductText ecommerce sku (Indicates this is a value prop that relates to a bonus) */
  ecommerceSku?: Maybe<Scalars['ID']>;
  /** Ecommerce SKU Mapping (Bonus) associated with this Billing Provider Product Text */
  ecommerceSkuMapping?: Maybe<EcommerceSkuMapping>;
  /** Ecommerce SKU Mapping Bonus Eligibilities (Bonus Campaigns) associated with this Billing Provider Product Text */
  ecommerceSkuMappingBonusEligibilities?: Maybe<Array<Maybe<EcommerceSkuMappingBonusEligibility>>>;
  /** Whether the text is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The id of the billing provider product text */
  id?: Maybe<Scalars['ID']>;
  /** Whether the text is a value proposition */
  isValueProp?: Maybe<Scalars['Boolean']>;
  /** Key */
  key?: Maybe<Scalars['String']>;
  /** Language */
  language?: Maybe<Scalars['String']>;
  /** String replacement parameters */
  parameters?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The UUID of the billing provider product text */
  uuid?: Maybe<Scalars['ID']>;
  /** Value */
  value?: Maybe<Scalars['String']>;
  /** The order of the value proposition */
  valuePropOrder?: Maybe<Scalars['Int']>;
};


/** Billing Provider Product Text */
export type BillingProviderProductTextEcommerceSkuMappingBonusEligibilitiesArgs = {
  effectiveDate?: InputMaybe<Scalars['DateTime']>;
  languages?: InputMaybe<Array<InputMaybe<ProviderProductLanguage>>>;
};

/** Billing Provider Product Text Create Input */
export type BillingProviderProductTextCreateInput = {
  /** The billingProviderProductText billingProviderProductId */
  billingProviderProductId: Scalars['ID'];
  /** The billingProviderProductText ecommerceSku */
  ecommerceSku?: InputMaybe<Scalars['ID']>;
  /** The billingProviderProductText enabled */
  enabled: Scalars['Boolean'];
  /** The billingProviderProductText isValueProp */
  isValueProp: Scalars['Boolean'];
  /** The billingProviderProductText key */
  key: Scalars['String'];
  /** The billingProviderProductText language */
  language: ProviderProductLanguage;
  /** The billingProviderProductText parameters */
  parameters?: InputMaybe<Array<InputMaybe<BillingProviderProductTextParameters>>>;
  /** The billingProviderProductText value */
  value: Scalars['String'];
  /** The billingProviderProductText valuePropOrder */
  valuePropOrder?: InputMaybe<Scalars['Int']>;
};

/** Billing Provider Product Text Delete response */
export type BillingProviderProductTextDeleteResponse = {
  __typename?: 'BillingProviderProductTextDeleteResponse';
  /** The success status of the delete operation */
  success?: Maybe<Scalars['Boolean']>;
};

/** Billing Provider Product Text Input */
export type BillingProviderProductTextInput = {
  /** The billingProviderProductText ecommerce sku (Indicates this is a value prop that relates to a bonus) */
  ecommerceSku?: InputMaybe<Scalars['ID']>;
  /** Whether the billingProviderProductText is enabled */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether this text is a value prop */
  isValueProp?: InputMaybe<Scalars['Boolean']>;
  /** The billingProviderProductText key */
  key: Scalars['String'];
  /** The billingProviderProductText language */
  language: ProviderProductLanguage;
  /** The billingProviderProductText parameters */
  parameters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billingProviderProductText value */
  value: Scalars['String'];
  /** The billingProviderProductText value prop order */
  valuePropOrder?: InputMaybe<Scalars['Int']>;
};

/** Billing Provider Product Text list response */
export type BillingProviderProductTextListResponse = {
  __typename?: 'BillingProviderProductTextListResponse';
  /** A list of billingProviderProductText */
  billingProviderProductText?: Maybe<Array<Maybe<BillingProviderProductText>>>;
};

/** Billing Provider Product Text list id where input type */
export type BillingProviderProductTextListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing Provider Product Text list where input type */
export type BillingProviderProductTextListWhereInput = {
  /** The billingProviderProductText billingProviderProductId field where clause */
  billingProviderProductId?: InputMaybe<BillingProviderProductTextListWhereIdInput>;
  /** The billingProviderProductText billingProviderProduct sku field where clause */
  billingProviderProductSku?: InputMaybe<BillingProviderProductTextWhereStringInput>;
  /** The billingProviderProductText ecommerceSku field where clause */
  ecommerceSku?: InputMaybe<BillingProviderProductTextWhereStringInput>;
  /** The billingProviderProductText enabled field where clause */
  enabled?: InputMaybe<BillingProviderProductTextWhereBooleanInput>;
  /** The billingProviderProductText id field where clause */
  id?: InputMaybe<BillingProviderProductTextListWhereIdInput>;
  /** The billingProviderProductText isValueProp field where clause */
  isValueProp?: InputMaybe<BillingProviderProductTextWhereBooleanInput>;
  /** The billingProviderProductText key field where clause */
  key?: InputMaybe<BillingProviderProductTextWhereStringInput>;
  /** The billingProviderProductText language field where clause */
  language?: InputMaybe<BillingProviderProductTextWhereLanguageInput>;
  /** The billingProviderProductText uuid field where clause */
  uuid?: InputMaybe<BillingProviderProductTextListWhereIdInput>;
  /** The billingProviderProductText valuePropOrder field where clause */
  valuePropOrder?: InputMaybe<BillingProviderProductTextListWhereIntInput>;
};

/** Billing Provider Product Text list int where input type */
export type BillingProviderProductTextListWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Billing Provider Product Text Parameters */
export enum BillingProviderProductTextParameters {
  /** Percent savings of the billing provider product over another billing provider product (Monthly) */
  PercentSavings = 'percentSavings',
  /** Primary price of the billing provider product */
  Price = 'price',
  /** Trial segment percent savings of the billing provider product over another billing provider product (Monthly) */
  TrialPercentSavings = 'trialPercentSavings',
  /** Trial segment price of the billing provider product */
  TrialSegmentPrice = 'trialSegmentPrice'
}

/** Input for billingProviderProductText translation */
export type BillingProviderProductTextTranslateInput = {
  /** The billingProviderProduct to base translation on */
  billingProviderProduct?: InputMaybe<BillingProviderProductTextTranslateProviderProductInput>;
  /** The billingProviderProductText to translate */
  billingProviderProductText?: InputMaybe<BillingProviderProductTextTranslateProviderProductTextInput>;
  /** Whether to check for existing translations (default: true) */
  checkForExistingTranslations?: InputMaybe<Scalars['Boolean']>;
  /** The languages to translate to */
  languages?: InputMaybe<Array<InputMaybe<ProviderProductLanguage>>>;
  /** String replacement parameters (if providing text) */
  parameters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Text to translate (not in the database) */
  text?: InputMaybe<Scalars['String']>;
};

/** Input for translation of all text for a billingProviderProduct */
export type BillingProviderProductTextTranslateProviderProductInput = {
  /** The billingProviderProduct ID */
  id?: InputMaybe<Scalars['Int']>;
  /** The billingProviderProduct SKU */
  sku?: InputMaybe<Scalars['String']>;
};

/** Input for translation of a billingProviderProductText */
export type BillingProviderProductTextTranslateProviderProductTextInput = {
  /** The billingProviderProductText ID */
  id?: InputMaybe<Scalars['Int']>;
  /** The billingProviderProduct key */
  key?: InputMaybe<Scalars['String']>;
};

/** Response for billingProviderProductText translation */
export type BillingProviderProductTextTranslateResponse = {
  __typename?: 'BillingProviderProductTextTranslateResponse';
  /** The translations */
  translations: Array<Maybe<BillingProviderProductTextTranslation>>;
};

/** Translation for billingProviderProductText */
export type BillingProviderProductTextTranslation = {
  __typename?: 'BillingProviderProductTextTranslation';
  /** Whether the translation was retrieved from the database */
  fromDatabase?: Maybe<Scalars['Boolean']>;
  /** The input billingProviderProductText ID */
  id?: Maybe<Scalars['Int']>;
  /** The key of the billingProviderProductText */
  key?: Maybe<Scalars['String']>;
  /** The language of the translation */
  language: ProviderProductLanguage;
  /** The translated text */
  value: Scalars['String'];
};

/** Input for billingProviderProductText translation options */
export type BillingProviderProductTextTranslationOptionsInput = {
  /** Additional context to help the translation */
  additionalContext?: InputMaybe<Scalars['String']>;
  /** The level of formality to use in the translation */
  formality?: InputMaybe<TranslationFormality>;
  /** Whether to preserve the original formatting */
  preserveFormatting?: InputMaybe<Scalars['Boolean']>;
  /** Whether to split the text into sentences */
  splitSentences?: InputMaybe<Scalars['Boolean']>;
  /** The translation model to use */
  translationModel?: InputMaybe<TranslationModel>;
};

/** Billing Provider Product Text Update Input */
export type BillingProviderProductTextUpdateInput = {
  /** The billingProviderProductText ecommerceSku */
  ecommerceSku?: InputMaybe<Scalars['ID']>;
  /** The billingProviderProductText enabled */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** The billingProviderProductText id */
  id: Scalars['ID'];
  /** The billingProviderProductText isValueProp */
  isValueProp?: InputMaybe<Scalars['Boolean']>;
  /** The billingProviderProductText key */
  key?: InputMaybe<Scalars['String']>;
  /** The billingProviderProductText language */
  language?: InputMaybe<ProviderProductLanguage>;
  /** The billingProviderProductText parameters */
  parameters?: InputMaybe<Array<InputMaybe<BillingProviderProductTextParameters>>>;
  /** The billingProviderProductText value */
  value?: InputMaybe<Scalars['String']>;
  /** The billingProviderProductText valuePropOrder */
  valuePropOrder?: InputMaybe<Scalars['Int']>;
};

/** Billing Provider Product Text Verify Error */
export type BillingProviderProductTextVerifyError = {
  __typename?: 'BillingProviderProductTextVerifyError';
  /** The error type of the billing provider product text verification */
  errorType?: Maybe<Scalars['String']>;
  /** The text of the string from the file */
  fileString?: Maybe<Scalars['String']>;
  /** Whether the text is a value proposition */
  isValueProp?: Maybe<Scalars['Boolean']>;
  /** The key of the billing provider product text */
  key?: Maybe<Scalars['String']>;
  /** The language of the billing provider product text */
  language?: Maybe<Scalars['String']>;
  /** The parameter related to the error */
  param?: Maybe<Scalars['String']>;
  /** The text of the string from the database */
  rawDbString?: Maybe<Scalars['String']>;
  /** The text of the string from the database with parameters replaced */
  replacedDbString?: Maybe<Scalars['String']>;
  /** The sku the billing provider product text belongs to */
  sku?: Maybe<Scalars['String']>;
  /** The order of the value proposition */
  valuePropOrder?: Maybe<Scalars['Int']>;
};

/** Billing Provider Product Text list where input type */
export type BillingProviderProductTextVerifyWhereInput = {
  /** The billingProviderProductText language field where clause */
  language?: InputMaybe<BillingProviderProductTextWhereLanguageInput>;
  /** The billingProviderProductText sku field where clause */
  sku?: InputMaybe<BillingProviderProductTextWhereStringInput>;
};

/** Billing Provider Product Text boolean where input type */
export type BillingProviderProductTextWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** Billing Provider Product Text language where input type */
export type BillingProviderProductTextWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProviderProductLanguage>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProviderProductLanguage>>>;
};

/** Billing Provider Product Text string where input type */
export type BillingProviderProductTextWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Billing Provider Product Update Input */
export type BillingProviderProductUpdateInput = {
  /** Whether the plan can be changed */
  allowChangePlan?: InputMaybe<Scalars['Boolean']>;
  /** Billing Product ID */
  billingProductId?: InputMaybe<Scalars['ID']>;
  /** Billing Provider ID */
  billingProviderId?: InputMaybe<Scalars['ID']>;
  /** Date when checkout is disabled for this product */
  checkoutEnabledEnd?: InputMaybe<Scalars['DateTime']>;
  /** Date when checkout is enabled for this product */
  checkoutEnabledStart?: InputMaybe<Scalars['DateTime']>;
  /** Default AI persona ID from Oracle API for this billing provider product */
  defaultOraclePersonalityId?: InputMaybe<Scalars['Int']>;
  /** Provider Product description */
  description?: InputMaybe<Scalars['String']>;
  /** Enabled */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** The billingProviderProduct id */
  id: Scalars['ID'];
  /** Primary stakeholder of the billing provider product */
  primaryStakeholder?: InputMaybe<ProviderProductPrimaryStakeholder>;
  /** ID of main product in source system (zuora only) */
  providerFirstSegmentId?: InputMaybe<Scalars['String']>;
  /** ID of recurring product in source system (zuora only).  Only populated for trial plans. */
  providerSecondSegmentId?: InputMaybe<Scalars['String']>;
  /** Savings Comparison Billing Provider Product ID */
  savingsComparisonId?: InputMaybe<Scalars['ID']>;
  /** Whether this plan is taxed */
  taxable?: InputMaybe<Scalars['Boolean']>;
  /** Provider Product term length - null denotes lifetime access (courses) */
  termLength?: InputMaybe<Scalars['Int']>;
  /** Term type range */
  termType?: InputMaybe<ProviderProductTermType>;
  /** Provider Product trial length - null denotes no trial */
  trialLength?: InputMaybe<Scalars['Int']>;
  /** Provider Product trial term range */
  trialTermType?: InputMaybe<ProviderProductTermType>;
  /** Provider Product type */
  type?: InputMaybe<ProviderProductType>;
};

/** Billing Provider Product string where input type */
export type BillingProviderProductWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Billing Provider Product where term type input type */
export type BillingProviderProductWhereTermTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProviderProductTermType>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProviderProductTermType>>>;
};

/** Billing Provider Product where type input type */
export type BillingProviderProductWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProviderProductType>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProviderProductType>>>;
};

/** Billing Provider boolean where input type */
export type BillingProviderWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** Billing Provider Product Name where input type */
export type BillingProviderWhereNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<BillingProviderName>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<BillingProviderName>>>;
};

/** Billing Product string where input type */
export type BillingProviderWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<BillingProviderName>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<BillingProviderName>>>;
};

/** Billing Refund */
export type BillingRefund = {
  __typename?: 'BillingRefund';
  /** The refund amount */
  amount?: Maybe<Scalars['Float']>;
  /** The billing refund ID of the billing refund */
  billingPaymentId?: Maybe<Scalars['ID']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The refund gateway error */
  gatewayError?: Maybe<Scalars['String']>;
  /** The id of the billing refund */
  id?: Maybe<Scalars['ID']>;
  /** ID of provider refund */
  providerRefundId?: Maybe<Scalars['String']>;
  /** When the refund was processed */
  refundDate?: Maybe<Scalars['DateTime']>;
  /** Whether the refund has been success */
  success?: Maybe<Scalars['Boolean']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The UUID of the billing refund */
  uuid?: Maybe<Scalars['ID']>;
};

/** Create input for Billing Refund */
export type BillingRefundCreateInput = {
  /** The refund amount */
  amount: Scalars['Float'];
  /** The billing payment ID of the billing refund */
  billingPaymentId: Scalars['ID'];
  /** The gateway error of payment */
  gatewayError?: InputMaybe<Scalars['String']>;
  /** The provider refund ID of the billing refund */
  providerRefundId: Scalars['String'];
  /** Date of refund date */
  refundDate: Scalars['DateTime'];
  /** Whether the payment has been success */
  success: Scalars['Boolean'];
};

/** Billing Refund list response */
export type BillingRefundListResponse = {
  __typename?: 'BillingRefundListResponse';
  billingRefunds?: Maybe<Array<Maybe<BillingRefund>>>;
};

/** Billing Refund boolean where input type */
export type BillingRefundListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** Billing Refund list where Date input type */
export type BillingRefundListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']>;
};

/** Billing Refund float where input type */
export type BillingRefundListWhereFloatInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Float']>;
};

/** Billing Refund list id where input type */
export type BillingRefundListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing Refund list where input type */
export type BillingRefundListWhereInput = {
  /** The billingRefund amount field where clause */
  amount?: InputMaybe<BillingRefundListWhereFloatInput>;
  /** The billingRefund billingPaymentId field where clause */
  billingPaymentId?: InputMaybe<BillingRefundListWhereIdInput>;
  /** The billingRefund createdAt field where clause */
  createdAt?: InputMaybe<BillingRefundListWhereDateInput>;
  /** The billingRefund gatewayError field where clause */
  gatewayError?: InputMaybe<BillingRefundListWhereStringInput>;
  /** The billingRefund id field where clause */
  id?: InputMaybe<BillingRefundListWhereIdInput>;
  /** The billingRefund providerRefundId field where clause */
  providerRefundId?: InputMaybe<BillingRefundListWhereStringInput>;
  /** The billingRefund refundDate field where clause */
  refundDate?: InputMaybe<BillingRefundListWhereDateInput>;
  /** The billingRefund success field where clause */
  success?: InputMaybe<BillingRefundListWhereBooleanInput>;
  /** The billingRefund uuid field where clause */
  uuid?: InputMaybe<BillingRefundListWhereStringInput>;
};

/** Billing Refund string where input type */
export type BillingRefundListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Update input for Billing Refund */
export type BillingRefundUpdateInput = {
  /** The refund amount */
  amount?: InputMaybe<Scalars['Float']>;
  /** The billing payment ID of the billing refund */
  billingPaymentId?: InputMaybe<Scalars['ID']>;
  /** The gateway error of payment */
  gatewayError?: InputMaybe<Scalars['String']>;
  /** The id of the billing refund */
  id: Scalars['ID'];
  /** The provider refund ID of the billing refund */
  providerRefundId?: InputMaybe<Scalars['String']>;
  /** Date of refund date */
  refundDate?: InputMaybe<Scalars['DateTime']>;
  /** Whether the payment has been success */
  success?: InputMaybe<Scalars['Boolean']>;
};

/** Billing subscriptions */
export type BillingSubscription = {
  __typename?: 'BillingSubscription';
  /** The billing account ID of subscription */
  billingAccountId?: Maybe<Scalars['ID']>;
  /** The billing provider ID of subscription */
  billingProviderId?: Maybe<Scalars['ID']>;
  /** The cancelDate of subscription */
  cancelDate?: Maybe<Scalars['DateTime']>;
  /** The cancelReason of subscription */
  cancelReason?: Maybe<Scalars['String']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The endDate of subscription */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** The latamPricing of subscription */
  latamPricing?: Maybe<Scalars['Boolean']>;
  /** The nextInvoiceAmount of subscription */
  nextInvoiceAmount?: Maybe<Scalars['Float']>;
  /** The nextInvoiceDate of subscription */
  nextInvoiceDate?: Maybe<Scalars['DateTime']>;
  /** The paidThroughDate of subscription */
  paidThroughDate?: Maybe<Scalars['DateTime']>;
  /** The pauseDate of subscription */
  pauseDate?: Maybe<Scalars['DateTime']>;
  /** The priceOverrideReason of subscription */
  priceOverrideReason?: Maybe<SubscriptionPriceOverrideReason>;
  /** The provider subscription id */
  providerSubscriptionId?: Maybe<Scalars['String']>;
  /** The resumeDate of subscription */
  resumeDate?: Maybe<Scalars['DateTime']>;
  /** The startDate of subscription */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The status of subscription */
  status?: Maybe<SubscriptionStatus>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The billing subscription uuid */
  uuid?: Maybe<Scalars['ID']>;
};

/** Create input for Billing Subscription */
export type BillingSubscriptionCreateInput = {
  /** The billing account ID of subscription */
  billingAccountId: Scalars['ID'];
  /** The billing provider ID of subscription */
  billingProviderId: Scalars['ID'];
  /** The cancelDate of subscription */
  cancelDate?: InputMaybe<Scalars['DateTime']>;
  /** The cancelReason of subscription */
  cancelReason?: InputMaybe<Scalars['String']>;
  /** The endDate of subscription */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** The latamPricing of subscription */
  latamPricing: Scalars['Boolean'];
  /** The nextInvoiceAmount of subscription */
  nextInvoiceAmount?: InputMaybe<Scalars['DateTime']>;
  /** The nextInvoiceDate of subscription */
  nextInvoiceDate?: InputMaybe<Scalars['DateTime']>;
  /** The paidThroughDate of subscription */
  paidThroughDate: Scalars['DateTime'];
  /** The pauseDate of subscription */
  pauseDate?: InputMaybe<Scalars['DateTime']>;
  /** The priceOverrideReason of subscription */
  priceOverrideReason?: InputMaybe<SubscriptionPriceOverrideReason>;
  /** The provider subscription ID of subscription */
  providerSubscriptionId: Scalars['String'];
  /** The resumeDate of subscription */
  resumeDate?: InputMaybe<Scalars['DateTime']>;
  /** The startDate of subscription */
  startDate: Scalars['DateTime'];
  /** The status of subscription */
  status: SubscriptionStatus;
};

/** Billing subscription policy list response */
export type BillingSubscriptionListResponse = {
  __typename?: 'BillingSubscriptionListResponse';
  /** A list of user accounts */
  billingSubscriptions?: Maybe<Array<Maybe<BillingSubscription>>>;
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
};

/** Billing subscription id type where input type */
export type BillingSubscriptionListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing subscription policy where conditions to filter rows */
export type BillingSubscriptionListWhereInput = {
  /** The billingAccountId: field where clause */
  billingAccountId?: InputMaybe<BillingSubscriptionListWhereIdInput>;
  /** The billingProviderId: field where clause */
  billingProviderId?: InputMaybe<BillingSubscriptionListWhereIdInput>;
  /** The id field where clause */
  id?: InputMaybe<BillingSubscriptionListWhereIdInput>;
  /** The providerSubscriptionId: field where clause */
  providerSubscriptionId?: InputMaybe<BillingSubscriptionWhereStringInput>;
  /** The billing subscription status: field where clause */
  status?: InputMaybe<BillingSubscriptionOrderListWhereStatusInput>;
};

/** Billing Subscription Order */
export type BillingSubscriptionOrder = {
  __typename?: 'BillingSubscriptionOrder';
  /** The billing subscription ID of the billing subscription order */
  billingSubscriptionId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** When the billing subscription order was effective date */
  effectiveDate?: Maybe<Scalars['DateTime']>;
  /** The id of the billing subscription order */
  id?: Maybe<Scalars['ID']>;
  /** Order request of billing subscription order */
  orderRequest?: Maybe<Scalars['JSON']>;
  /** Order response of billing subscription order */
  orderResponse?: Maybe<Scalars['JSON']>;
  /** The provider order Id */
  providerOrderId?: Maybe<Scalars['String']>;
  /** Whether the billing subscription order has been removed */
  removed?: Maybe<Scalars['Boolean']>;
  /** Whether the billing subscription order has been success */
  success?: Maybe<Scalars['Boolean']>;
  /** The billing subscription order type */
  type?: Maybe<SubscriptionOrderType>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The UUID of the billing subscription order */
  uuid?: Maybe<Scalars['ID']>;
};

/** Create input for Billing Subscription Order */
export type BillingSubscriptionOrderCreateInput = {
  /** The billing subscription ID of the billing subscription order */
  billingSubscriptionId: Scalars['ID'];
  /** The effective date of the billing subscription order */
  effectiveDate: Scalars['DateTime'];
  /** The order request of the billing subscription order */
  orderRequest?: InputMaybe<Scalars['JSON']>;
  /** The order response of the billing subscription order */
  orderResponse?: InputMaybe<Scalars['JSON']>;
  /** The provider order Id of the billing subscription order */
  providerOrderId: Scalars['String'];
  /** Whether the billing subscription order has been removed */
  removed: Scalars['Boolean'];
  /** Whether the billing subscription order has been success */
  success: Scalars['Boolean'];
  /** The type of the billing subscription order */
  type: SubscriptionOrderType;
};

/** Billing Subscription Order list response */
export type BillingSubscriptionOrderListResponse = {
  __typename?: 'BillingSubscriptionOrderListResponse';
  billingSubscriptionOrders?: Maybe<Array<Maybe<BillingSubscriptionOrder>>>;
};

/** Billing Subscription Order boolean where input type */
export type BillingSubscriptionOrderListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** Billing Subscription Order list where Date input type */
export type BillingSubscriptionOrderListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']>;
};

/** Billing Subscription Order list id where input type */
export type BillingSubscriptionOrderListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing Subscription Order list where input type */
export type BillingSubscriptionOrderListWhereInput = {
  /** The billingSubscriptionOrder billingSubscriptionId field where clause */
  billingSubscriptionId?: InputMaybe<BillingSubscriptionOrderListWhereIdInput>;
  /** The billingSubscriptionOrder createdAt field where clause */
  createdAt?: InputMaybe<BillingSubscriptionOrderListWhereDateInput>;
  /** The billingSubscriptionOrder effectiveDate field where clause */
  effectiveDate?: InputMaybe<BillingSubscriptionOrderListWhereDateInput>;
  /** The billingSubscriptionOrder id field where clause */
  id?: InputMaybe<BillingSubscriptionOrderListWhereIdInput>;
  /** The billingSubscriptionOrder providerOrderId field where clause */
  providerOrderId?: InputMaybe<BillingSubscriptionOrderListWhereStringInput>;
  /** The billingSubscriptionOrder removed field where clause */
  removed?: InputMaybe<BillingSubscriptionOrderListWhereBooleanInput>;
  /** The billingSubscriptionOrder success field where clause */
  success?: InputMaybe<BillingSubscriptionOrderListWhereBooleanInput>;
  /** The billingSubscriptionOrder type field where clause */
  type?: InputMaybe<BillingSubscriptionOrderListWhereTypeInput>;
  /** The billingSubscriptionOrder uuid field where clause */
  uuid?: InputMaybe<BillingSubscriptionOrderListWhereStringInput>;
};

/** Billing Subscription status where input type */
export type BillingSubscriptionOrderListWhereStatusInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<SubscriptionStatus>>>;
};

/** Billing Subscription Order string where input type */
export type BillingSubscriptionOrderListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Billing Provider Product where type input type */
export type BillingSubscriptionOrderListWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<SubscriptionOrderType>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<SubscriptionOrderType>>>;
};

/** Billing subscriptions */
export type BillingSubscriptionOrderPlan = {
  __typename?: 'BillingSubscriptionOrderPlan';
  /** The action of subscription */
  action?: Maybe<SubscriptionOrderPlanAction>;
  /** The billingSubscriptionOrderId of subscription order plan */
  billingSubscriptionOrderId?: Maybe<Scalars['ID']>;
  /** The billingSubscriptionPlanId of subscription order plan */
  billingSubscriptionPlanId?: Maybe<Scalars['ID']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** The newValues of billing subscription order plan */
  newValues?: Maybe<Scalars['JSON']>;
  /** The oldValues of billing subscription order plan */
  oldValues?: Maybe<Scalars['JSON']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The billing subscription order plan uuid */
  uuid?: Maybe<Scalars['ID']>;
};

/** Create input for Billing Subscription Order Plan */
export type BillingSubscriptionOrderPlanCreateInput = {
  /** The action of subscription */
  action: SubscriptionOrderPlanAction;
  /** The billingSubscriptionOrderId of subscription order plan */
  billingSubscriptionOrderId: Scalars['ID'];
  /** The billingSubscriptionPlanId of subscription order plan */
  billingSubscriptionPlanId: Scalars['ID'];
  /** The newValues of billing subscription order plan */
  newValues?: InputMaybe<Scalars['JSON']>;
  /** The oldValues of billing subscription order plan */
  oldValues?: InputMaybe<Scalars['JSON']>;
};

/** Billing subscription policy list response */
export type BillingSubscriptionOrderPlanListResponse = {
  __typename?: 'BillingSubscriptionOrderPlanListResponse';
  /** A list of user accounts */
  billingSubscriptionOrderPlans?: Maybe<Array<Maybe<BillingSubscriptionOrderPlan>>>;
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
};

/** Billing subscription order plan status where input type */
export type BillingSubscriptionOrderPlanListWhereActionInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<SubscriptionOrderPlanAction>>>;
};

/** Billing subscription subscription order plan id type where input type */
export type BillingSubscriptionOrderPlanListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing subscription order plan policy where conditions to filter rows */
export type BillingSubscriptionOrderPlanListWhereInput = {
  /** The billing subscription status: field where clause */
  action?: InputMaybe<BillingSubscriptionOrderPlanListWhereActionInput>;
  /** The billingAccountId: field where clause */
  billingSubscriptionOrderId?: InputMaybe<BillingSubscriptionOrderPlanListWhereIdInput>;
  /** The billingSubscriptionPlanId: field where clause */
  billingSubscriptionPlanId?: InputMaybe<BillingSubscriptionOrderPlanListWhereIdInput>;
  /** The id field where clause */
  id?: InputMaybe<BillingSubscriptionOrderPlanListWhereIdInput>;
  /** The uuid field where clause */
  uuid?: InputMaybe<BillingSubscriptionOrderPlanWhereStringInput>;
};

/** Create input for Billing Subscription Order Plan */
export type BillingSubscriptionOrderPlanUpdateInput = {
  /** The action of subscription */
  action: SubscriptionOrderPlanAction;
  /** The billingSubscriptionOrderId of subscription order plan */
  billingSubscriptionOrderId?: InputMaybe<Scalars['ID']>;
  /** The billingSubscriptionPlanId of subscription order plan */
  billingSubscriptionPlanId?: InputMaybe<Scalars['ID']>;
  /** The ID of subscription order plan */
  id?: InputMaybe<Scalars['ID']>;
  /** The newValues of billing subscription order plan */
  newValues?: InputMaybe<Scalars['JSON']>;
  /** The oldValues of billing subscription order plan */
  oldValues?: InputMaybe<Scalars['JSON']>;
};

/** Billing subscription order plan string where input type */
export type BillingSubscriptionOrderPlanWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Update input for Billing Subscription Order */
export type BillingSubscriptionOrderUpdateInput = {
  /** The billing subscription ID of the billing subscription order */
  billingSubscriptionId?: InputMaybe<Scalars['ID']>;
  /** The effective date of the billing subscription order */
  effectiveDate?: InputMaybe<Scalars['DateTime']>;
  /** The id of the billing subscription order */
  id: Scalars['ID'];
  /** The order request of the billing subscription order */
  orderRequest?: InputMaybe<Scalars['JSON']>;
  /** The order response of the billing subscription order */
  orderResponse?: InputMaybe<Scalars['JSON']>;
  /** The provider order Id of the billing subscription order */
  providerOrderId?: InputMaybe<Scalars['String']>;
  /** Whether the billing subscription order has been removed */
  removed?: InputMaybe<Scalars['Boolean']>;
  /** Whether the billing subscription order has been success */
  success?: InputMaybe<Scalars['Boolean']>;
  /** The type of the billing subscription order */
  type?: InputMaybe<SubscriptionOrderType>;
};

/** Billing Subscription Plan */
export type BillingSubscriptionPlan = {
  __typename?: 'BillingSubscriptionPlan';
  /** The billing provider product ID of the billing subscription plan */
  billingProviderProductId?: Maybe<Scalars['ID']>;
  /** The billing subscription ID of the billing subscription plan */
  billingSubscriptionId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** When the billing subscription plan ends */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The id of the billing subscription plan */
  id?: Maybe<Scalars['ID']>;
  /** When the billing subscription plan trial ends date */
  priceOverride?: Maybe<Scalars['Float']>;
  /** Whether the billing subscription plan has been removed */
  removed?: Maybe<Scalars['Boolean']>;
  /** When the billing subscription plan starts */
  startDate?: Maybe<Scalars['DateTime']>;
  /** When the billing subscription plan trial ends date */
  trialEndDate?: Maybe<Scalars['DateTime']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The UUID of the billing subscription plan */
  uuid?: Maybe<Scalars['ID']>;
};

/** Create input for Billing Subscription Plan */
export type BillingSubscriptionPlanCreateInput = {
  /** The billingProviderProductId of the billing subscription plan */
  billingProviderProductId: Scalars['ID'];
  /** The billingSubscriptionId of the billing subscription plan */
  billingSubscriptionId: Scalars['ID'];
  /** The end date of the billing subscription plan */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** The price override of the billing subscription plan */
  priceOverride?: InputMaybe<Scalars['Float']>;
  /** Whether the billing subscription plan has been removed */
  removed: Scalars['Boolean'];
  /** The start date of the billing subscription plan */
  startDate: Scalars['DateTime'];
  /** The trial end date of the billing subscription plan */
  trialEndDate?: InputMaybe<Scalars['DateTime']>;
};

/** Billing Subscription Plan list response */
export type BillingSubscriptionPlanListResponse = {
  __typename?: 'BillingSubscriptionPlanListResponse';
  billingSubscriptionPlans?: Maybe<Array<Maybe<BillingSubscriptionPlan>>>;
};

/** Billing Subscription Plan boolean where input type */
export type BillingSubscriptionPlanListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** Billing Subscription Plan list where Date input type */
export type BillingSubscriptionPlanListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']>;
};

/** Billing Invoice float where input type */
export type BillingSubscriptionPlanListWhereFloatInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Float']>;
};

/** Billing Subscription Plan list id where input type */
export type BillingSubscriptionPlanListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Billing Subscription Plan list where input type */
export type BillingSubscriptionPlanListWhereInput = {
  /** The billingSubscriptionPlan billingProviderProductId field where clause */
  billingProviderProductId?: InputMaybe<BillingSubscriptionPlanListWhereIdInput>;
  /** The billingSubscriptionPlan billingSubscriptionId field where clause */
  billingSubscriptionId?: InputMaybe<BillingSubscriptionPlanListWhereIdInput>;
  /** The billingSubscriptionPlan createdAt field where clause */
  createdAt?: InputMaybe<BillingSubscriptionPlanListWhereDateInput>;
  /** The billingSubscriptionPlan endDate field where clause */
  endDate?: InputMaybe<BillingSubscriptionPlanListWhereDateInput>;
  /** The billingSubscriptionPlan id field where clause */
  id?: InputMaybe<BillingSubscriptionPlanListWhereIdInput>;
  /** The billingSubscriptionPlan priceOverride field where clause */
  priceOverride?: InputMaybe<BillingSubscriptionPlanListWhereFloatInput>;
  /** The billingSubscriptionPlan removed field where clause */
  removed?: InputMaybe<BillingSubscriptionPlanListWhereBooleanInput>;
  /** The billingSubscriptionPlan startDate field where clause */
  startDate?: InputMaybe<BillingSubscriptionPlanListWhereDateInput>;
  /** The billingSubscriptionPlan trialEndDate field where clause */
  trialEndDate?: InputMaybe<BillingSubscriptionPlanListWhereDateInput>;
  /** The billingSubscriptionPlan uuid field where clause */
  uuid?: InputMaybe<BillingSubscriptionPlanListWhereStringInput>;
};

/** Billing Subscription Plan string where input type */
export type BillingSubscriptionPlanListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Update input for Billing Subscription Plan */
export type BillingSubscriptionPlanUpdateInput = {
  /** The billingProviderProductId of the billing subscription plan */
  billingProviderProductId?: InputMaybe<Scalars['ID']>;
  /** The billingSubscriptionId of the billing subscription plan */
  billingSubscriptionId?: InputMaybe<Scalars['ID']>;
  /** The end date of the billing subscription plan */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** The id of the billing subscription plan */
  id: Scalars['ID'];
  /** The price override of the billing subscription plan */
  priceOverride?: InputMaybe<Scalars['Float']>;
  /** Whether the billing subscription plan has been removed */
  removed?: InputMaybe<Scalars['Boolean']>;
  /** The start date of the billing subscription plan */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** The trial end date of the billing subscription plan */
  trialEndDate?: InputMaybe<Scalars['DateTime']>;
};

/** Update input for Billing Subscription */
export type BillingSubscriptionUpdateInput = {
  /** The billing account ID of subscription */
  billingAccountId?: InputMaybe<Scalars['ID']>;
  /** The billing provider ID of subscription */
  billingProviderId?: InputMaybe<Scalars['ID']>;
  /** The cancelDate of subscription */
  cancelDate?: InputMaybe<Scalars['DateTime']>;
  /** The cancelReason of subscription */
  cancelReason?: InputMaybe<Scalars['String']>;
  /** The endDate of subscription */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** The billing ID of subscription */
  id: Scalars['ID'];
  /** The latamPricing of subscription */
  latamPricing?: InputMaybe<Scalars['Boolean']>;
  /** The nextInvoiceAmount of subscription */
  nextInvoiceAmount?: InputMaybe<Scalars['DateTime']>;
  /** The nextInvoiceDate of subscription */
  nextInvoiceDate?: InputMaybe<Scalars['DateTime']>;
  /** The paidThroughDate of subscription */
  paidThroughDate: Scalars['DateTime'];
  /** The pauseDate of subscription */
  pauseDate?: InputMaybe<Scalars['DateTime']>;
  /** The priceOverrideReason of subscription */
  priceOverrideReason?: InputMaybe<SubscriptionPriceOverrideReason>;
  /** The provider subscription ID of subscription */
  providerSubscriptionId?: InputMaybe<Scalars['String']>;
  /** The resumeDate of subscription */
  resumeDate?: InputMaybe<Scalars['DateTime']>;
  /** The startDate of subscription */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** The status of subscription */
  status?: InputMaybe<SubscriptionStatus>;
};

/** Billing subscription string where input type */
export type BillingSubscriptionWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Brightcove input for media */
export type BrightcoveInput = {
  /** Lemonade content id */
  contentId: Scalars['String'];
  /** Created date */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  /** Additional data */
  data?: InputMaybe<Scalars['String']>;
  /** Duration in seconds */
  duration?: InputMaybe<Scalars['Int']>;
  /** Hash value */
  hash?: InputMaybe<Scalars['String']>;
  /** Height in pixels */
  height?: InputMaybe<Scalars['Int']>;
  /** Language code */
  lang?: InputMaybe<Scalars['String']>;
  /** Last update date */
  lastUpdate?: InputMaybe<Scalars['DateTime']>;
  /** Rendition count */
  renditionCount?: InputMaybe<Scalars['Int']>;
  /** Updated date */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  /** Video ID */
  videoId: Scalars['String'];
  /** Width in pixels */
  width?: InputMaybe<Scalars['Int']>;
  /** Work status */
  workStatus?: InputMaybe<Scalars['String']>;
  /** Work status changed date */
  workStatusChanged?: InputMaybe<Scalars['DateTime']>;
};

/** Oracle AI: Channel prompt block */
export type ChannelPromptBlock = {
  __typename?: 'ChannelPromptBlock';
  blockKey?: Maybe<Scalars['String']>;
  blockOrder: Scalars['Int'];
  blockText: Scalars['String'];
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

/** Oracle AI: Input for channel prompt block */
export type ChannelPromptBlockInput = {
  blockKey?: InputMaybe<Scalars['String']>;
  blockOrder: Scalars['Int'];
  blockText: Scalars['String'];
  enabled?: Scalars['Boolean'];
};

/** Oracle AI: Channel prompt section */
export type ChannelPromptSection = {
  __typename?: 'ChannelPromptSection';
  blocks: Array<ChannelPromptBlock>;
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  instruction: Scalars['String'];
  sectionKey: Scalars['String'];
  sectionOrder: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

/** Oracle AI: Input for channel prompt section */
export type ChannelPromptSectionInput = {
  blocks?: Array<ChannelPromptBlockInput>;
  enabled?: Scalars['Boolean'];
  instruction: Scalars['String'];
  sectionKey: Scalars['String'];
  sectionOrder: Scalars['Int'];
};

/** Oracle AI: Channel prompt set */
export type ChannelPromptSet = {
  __typename?: 'ChannelPromptSet';
  channel: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  sections: Array<ChannelPromptSection>;
  status: ChannelPromptStatus;
  updatedAt: Scalars['DateTime'];
  version: Scalars['Int'];
};

/** Oracle AI: Input for creating channel prompt set */
export type ChannelPromptSetCreateInput = {
  channel: Scalars['String'];
  sections: Array<ChannelPromptSectionInput>;
  status?: ChannelPromptStatus;
  version?: InputMaybe<Scalars['Int']>;
};

/** Oracle AI: Response for channel prompt set delete mutation */
export type ChannelPromptSetDeleteResponse = {
  __typename?: 'ChannelPromptSetDeleteResponse';
  deleted?: Maybe<Scalars['Boolean']>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Oracle AI: Channel prompt set list response */
export type ChannelPromptSetListResponse = {
  __typename?: 'ChannelPromptSetListResponse';
  channelPromptSets: Array<ChannelPromptSet>;
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

/** Oracle AI: Response for channel prompt set mutations */
export type ChannelPromptSetMutationResponse = {
  __typename?: 'ChannelPromptSetMutationResponse';
  channelPromptSet?: Maybe<ChannelPromptSet>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Oracle AI: Input for replacing channel prompt set sections */
export type ChannelPromptSetReplaceSectionsInput = {
  id: Scalars['ID'];
  sections: Array<ChannelPromptSectionInput>;
};

/** Oracle AI: Input for updating channel prompt set status */
export type ChannelPromptSetStatusInput = {
  id: Scalars['ID'];
  status: ChannelPromptStatus;
};

export enum ChannelPromptStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** Chat history */
export type ChatHistory = {
  __typename?: 'ChatHistory';
  /** The chat sessions id */
  chatSessionsId: Scalars['ID'];
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The chat message data */
  data?: Maybe<Scalars['JSON']>;
  /** The chat history id */
  id: Scalars['ID'];
  /** The chat response data */
  responseData?: Maybe<Scalars['JSON']>;
  /** The chat message type */
  type?: Maybe<Scalars['String']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user linked to this chat history */
  userInfo?: Maybe<UserInfo>;
  /** The user info uuid */
  userInfoUuid: Scalars['ID'];
};

/** Chat history create input */
export type ChatHistoryCreateInput = {
  /** The chat session id */
  chatSessionsId: Scalars['ID'];
  /** The chat history data */
  data: Scalars['JSON'];
  /** The chat response data */
  responseData?: InputMaybe<Scalars['JSON']>;
  /** The chat history type */
  type?: InputMaybe<Scalars['String']>;
  /** The user info uuid (defaults to the requesting user) */
  userInfoUuid?: InputMaybe<Scalars['ID']>;
};

/** Chat history delete input */
export type ChatHistoryDeleteInput = {
  /** The chat history id */
  id: Scalars['ID'];
  /** The user info uuid (defaults to the requesting user) */
  userInfoUuid?: InputMaybe<Scalars['ID']>;
};

/** Chat history list response */
export type ChatHistoryListResponse = {
  __typename?: 'ChatHistoryListResponse';
  /** A list of Chat history */
  chatHistories?: Maybe<Array<Maybe<ChatHistory>>>;
};

/** Chat history mutation response */
export type ChatHistoryMutationResponse = {
  __typename?: 'ChatHistoryMutationResponse';
  /** The deleted chat history */
  chatHistory?: Maybe<ChatHistory>;
  /** When true successfully deleted */
  success?: Maybe<Scalars['Boolean']>;
};

/** Chat history update input */
export type ChatHistoryUpdateInput = {
  /** The chat history data (the entire value will be updated if defined) */
  data?: InputMaybe<Scalars['JSON']>;
  /** The chat history id */
  id: Scalars['ID'];
  /** The chat response data (the entire value will be updated  if defined) */
  responseData?: InputMaybe<Scalars['JSON']>;
  /** The chat history type */
  type?: InputMaybe<Scalars['String']>;
  /** The user info uuid (defaults to the requesting user) */
  userInfoUuid?: InputMaybe<Scalars['ID']>;
};

/** Chat history where title group id input type */
export type ChatHistoryWhereChatSessionsIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Chat history where title group id input type */
export type ChatHistoryWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Chat history where conditions to filter rows */
export type ChatHistoryWhereInput = {
  /** The chat session id field where clause */
  chatSessionsId?: InputMaybe<ChatHistoryWhereChatSessionsIdInput>;
  /** The id field where clause */
  id?: InputMaybe<ChatHistoryWhereIdInput>;
  /** The uid field where clause */
  userInfoUuid?: InputMaybe<ChatHistoryWhereUserInfoUuidInput>;
};

/** Chat history where id input type */
export type ChatHistoryWhereUserInfoUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Chat session */
export type ChatSession = {
  __typename?: 'ChatSession';
  /** The chat history for this session */
  chatHistory?: Maybe<Array<Maybe<ChatHistory>>>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The chat session description */
  description?: Maybe<Scalars['String']>;
  /** The chat session id */
  id: Scalars['ID'];
  /** The chat session title */
  title?: Maybe<Scalars['String']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user linked to this chat history */
  userInfo?: Maybe<UserInfo>;
  /** The user info uuid */
  userInfoUuid: Scalars['ID'];
};


/** Chat session */
export type ChatSessionChatHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Chat session create input */
export type ChatSessionCreateInput = {
  /** The chat session description */
  description?: InputMaybe<Scalars['String']>;
  /** The chat session title */
  title?: InputMaybe<Scalars['String']>;
  /** The user info uuid (defaults to the requesting user) */
  userInfoUuid?: InputMaybe<Scalars['ID']>;
};

/** Chat session delete input */
export type ChatSessionDeleteInput = {
  /** The chat session id */
  id: Scalars['ID'];
  /** The user info uuid (defaults to the requesting user) */
  userInfoUuid?: InputMaybe<Scalars['ID']>;
};

/** Chat session where title group id input type */
export type ChatSessionIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Chat session mutation response */
export type ChatSessionMutationResponse = {
  __typename?: 'ChatSessionMutationResponse';
  /** The deleted chat session */
  chatSession?: Maybe<ChatSession>;
  /** When true successfully deleted */
  success?: Maybe<Scalars['Boolean']>;
};

/** Chat session update input */
export type ChatSessionUpdateInput = {
  /** The chat session description */
  description?: InputMaybe<Scalars['String']>;
  /** The chat session id */
  id: Scalars['ID'];
  /** The chat session title */
  title?: InputMaybe<Scalars['String']>;
  /** The user info uuid (defaults to the requesting user) */
  userInfoUuid?: InputMaybe<Scalars['ID']>;
};

/** Chat session where conditions to filter rows */
export type ChatSessionWhereInput = {
  /** The session id field where clause */
  id?: InputMaybe<ChatSessionIdInput>;
  /** The id field where clause */
  userInfoUuid?: InputMaybe<ChatSessionWhereUserInfoUuidInput>;
};

/** Chat session where id input type */
export type ChatSessionWhereUserInfoUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Chat session list response */
export type ChatSessionsListResponse = {
  __typename?: 'ChatSessionsListResponse';
  /** A list of chat sessions */
  chatSessions?: Maybe<Array<Maybe<ChatSession>>>;
};

export type ClientSignal = {
  __typename?: 'ClientSignal';
  /** Optional JSON payload with signal-specific data */
  payload?: Maybe<Scalars['JSON']>;
  /** Signal type (e.g. 'workflow.completed') */
  type: Scalars['String'];
};

/** One row from Brightcove CMS for playlist preview */
export type ClipBrightcovePlaylistVideoRow = {
  __typename?: 'ClipBrightcovePlaylistVideoRow';
  brightcoveVideoId: Scalars['String'];
  /** Parent Brightcove video id when CMS marks a clip (clip_source_video_id or clip_source); null if absent */
  clipSourceVideoId?: Maybe<Scalars['String']>;
  /** Clip length in seconds from CMS video duration (milliseconds), Math.floor(ms/1000); null if absent or invalid */
  durationSeconds?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  referenceId?: Maybe<Scalars['String']>;
};

/** Input for creating a vertical clip from a parent video */
export type ClipCreateInput = {
  /** Optional clip length in seconds (stored on ms_clip media_assets.duration); playlist import sets from CMS duration ms via floor(ms/1000) */
  duration?: InputMaybe<Scalars['Int']>;
  /** The language of this clip (e.g. en, es) */
  language: Scalars['String'];
  /** The provider key of the parent video's media stream (ms media asset, alternative to parentTitleGroupId) */
  parentProviderKey?: InputMaybe<Scalars['String']>;
  /** The titleGroupId of the parent video this clip was extracted from (alternative: parentProviderKey) */
  parentTitleGroupId?: InputMaybe<Scalars['String']>;
  /** Optional URL path; omit and use generatePath to auto-generate */
  path?: InputMaybe<Scalars['String']>;
  /** The provider key for the clip stream (ms_clip media asset) */
  providerKey: Scalars['String'];
  /** Whether to publish the clip immediately (defaults to false) */
  published?: InputMaybe<Scalars['Boolean']>;
  /** Timestamp segments from Brightcove segments_time (stored in content_providers metadata) */
  segmentsTime?: InputMaybe<Scalars['JSON']>;
  /** The clip's display title */
  title: Scalars['String'];
  /** Virality score from Brightcove AI Content Multiplier (stored in content_providers metadata) */
  viralityScore?: InputMaybe<Scalars['Float']>;
};

/** Return type for clipCreate */
export type ClipCreateResponse = {
  __typename?: 'ClipCreateResponse';
  /** The newly created clip content row */
  content?: Maybe<Content>;
  /** Whether the clip was created successfully */
  success: Scalars['Boolean'];
};

/** Non-fatal caption/text-track issue during playlist import (clip row may still succeed) */
export type ClipImportCaptionWarning = {
  __typename?: 'ClipImportCaptionWarning';
  brightcoveVideoId: Scalars['String'];
  message: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

/** One failed clip row from a playlist import */
export type ClipImportError = {
  __typename?: 'ClipImportError';
  /** Brightcove video id */
  brightcoveVideoId: Scalars['String'];
  /** Human-readable failure reason */
  message: Scalars['String'];
  /** Video name from Brightcove when available */
  title?: Maybe<Scalars['String']>;
};

/** Result of importing clips from a Brightcove playlist */
export type ClipImportFromBrightcovePlaylistResponse = {
  __typename?: 'ClipImportFromBrightcovePlaylistResponse';
  /** Caption import issues when importTextTracks is true (does not increment failureCount) */
  captionWarnings: Array<ClipImportCaptionWarning>;
  /** Per-video failures (validation, Brightcove fetch, etc.) */
  errors: Array<ClipImportError>;
  /** Number of clips that failed (matches errors length) */
  failureCount: Scalars['Int'];
  /** Per-video skips (already imported) */
  skipped: Array<ClipImportSkippedRow>;
  /** Rows skipped because a clip already exists for that Brightcove video id */
  skippedCount: Scalars['Int'];
  /** Number of clips created successfully */
  successCount: Scalars['Int'];
};

/** When Brightcove has neither clip_source_video_id nor clip_source for the clip, supply exactly one parent field for that playlist video id. */
export type ClipImportPerVideoParentInput = {
  brightcoveVideoId: Scalars['String'];
  parentProviderKey?: InputMaybe<Scalars['String']>;
  parentTitleGroupId?: InputMaybe<Scalars['String']>;
};

/** Shared defaults for playlist import (language / publish). Parent is resolved per video from Brightcove clip_source_video_id, clip_source (AI clips), or perVideoParentOverrides. */
export type ClipImportSharedDefaultsInput = {
  /** The language of each imported clip (e.g. en, es) */
  language: Scalars['String'];
  /** Whether to publish each clip immediately */
  published?: InputMaybe<Scalars['Boolean']>;
};

/** Playlist row skipped during import (e.g. clip already exists for Brightcove id) */
export type ClipImportSkippedRow = {
  __typename?: 'ClipImportSkippedRow';
  brightcoveVideoId: Scalars['String'];
  reason: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

/** Comment type */
export type Comment = {
  __typename?: 'Comment';
  /** The body of the comment */
  comment?: Maybe<Scalars['String']>;
  /** The parent comment if this is a reply */
  commentParent?: Maybe<Comment>;
  /** The child comments if this is a parent comment */
  commentsChildren?: Maybe<Array<Maybe<Comment>>>;
  /** The content linked to this comment */
  content?: Maybe<Array<Maybe<Content>>>;
  /** The id of the content */
  contentId?: Maybe<Scalars['Int']>;
  /** The type of the content */
  contentType?: Maybe<Scalars['String']>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The depth type of the comment */
  depthType?: Maybe<CommentDepthType>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** The parent comment id if this comment is a reply */
  pid?: Maybe<Scalars['Int']>;
  /** The status of the comment i.e. approved or not approved */
  status?: Maybe<CommentStatus>;
  /** The subject (title) of the comment */
  subject?: Maybe<Scalars['String']>;
  /** The id of the user or null if anonymous */
  uid?: Maybe<Scalars['Int']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user info linked to this comment */
  userInfo?: Maybe<UserInfo>;
  /** Author's community profile (Brooklyn-local, no cross-service call). Null if user has no profile. */
  userProfile?: Maybe<UserProfile>;
};


/** Comment type */
export type CommentCommentsChildrenArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
};

/** Content filter for comments */
export type CommentContentFilter = {
  /** The id of the content */
  contentId?: InputMaybe<Scalars['Int']>;
  /** The type of the content */
  contentType?: InputMaybe<Scalars['String']>;
  /** When true the content must be published */
  published?: InputMaybe<Scalars['Boolean']>;
};

export type CommentCreateInput = {
  /** The comment body text */
  comment: Scalars['String'];
  /** The content ID being commented on */
  contentId: Scalars['Int'];
  /** Parent comment ID for replies (0 or omit for root comments) */
  pid?: InputMaybe<Scalars['Int']>;
  /** The subject/title (optional) */
  subject?: InputMaybe<Scalars['String']>;
};

/** The depth type of the comment */
export enum CommentDepthType {
  /** The comment is a reply */
  Reply = 'REPLY',
  /** The comment is a root comment */
  Root = 'ROOT'
}

export type CommentMutationResponse = {
  __typename?: 'CommentMutationResponse';
  /** The created or updated comment */
  comment?: Maybe<Comment>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean'];
};

/** Comment status enum */
export enum CommentStatus {
  /** The comment needs review */
  NeedsReview = 'NEEDS_REVIEW',
  /** The comment is published */
  Published = 'PUBLISHED',
  /** The comment is unpublished */
  Unpublished = 'UNPUBLISHED'
}

export type CommentUpdateInput = {
  /** Updated comment body */
  comment: Scalars['String'];
  /** The comment ID to update */
  id: Scalars['ID'];
  /** Updated subject (optional) */
  subject?: InputMaybe<Scalars['String']>;
};

/** Comment where id input type */
export type CommentWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** Comment where conditions to filter rows */
export type CommentWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<CommentWhereIdInput>;
  /** The parent id field where clause */
  pid?: InputMaybe<CommentWhereIdInput>;
  /** The status field where clause */
  status?: InputMaybe<CommentWhereIdInput>;
  /** The uid field where clause */
  uid?: InputMaybe<CommentWhereUidInput>;
};

/** Comment where uid input type */
export type CommentWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** Comment list response */
export type CommentsListResponse = {
  __typename?: 'CommentsListResponse';
  /** A list of comments */
  comments?: Maybe<Array<Maybe<Comment>>>;
  /** The total number of comments matching the query */
  count?: Maybe<Scalars['Int']>;
  /** The limit used in the query */
  limit?: Maybe<Scalars['Int']>;
  /** The offset used in the query */
  offset?: Maybe<Scalars['Int']>;
};

/** Community event type */
export type CommunityEvent = {
  __typename?: 'CommunityEvent';
  /** Number of registered attendees */
  attendeeCount: Scalars['Int'];
  /** Maximum number of attendees (null = unlimited) */
  capacity?: Maybe<Scalars['Int']>;
  /** The event description */
  content: Scalars['String'];
  /** When the event was created */
  createdAt: Scalars['DateTime'];
  /** Current viewer's RSVP status */
  currentUserRsvp: RegistrationStatus;
  /** When the event ends */
  endTime: Scalars['DateTime'];
  /** The feed ID this event belongs to */
  feedId: Scalars['ID'];
  /** The unique identifier for the event */
  id: Scalars['ID'];
  /** Event locations (virtual and/or physical) */
  locations: Array<CommunityEventLocation>;
  /** Reminder notification settings */
  reminderSettings?: Maybe<CommunityEventReminderSettings>;
  /** When the event starts */
  startTime: Scalars['DateTime'];
  /** Event status */
  status: CommunityEventStatus;
  /** IANA timezone (e.g., 'America/Denver', 'UTC') */
  timeZone: Scalars['String'];
  /** The event title */
  title: Scalars['String'];
  /** When the event was last updated */
  updatedAt: Scalars['DateTime'];
  /** Shareable URL for this event */
  url?: Maybe<Scalars['String']>;
};

/** Paginated events connection */
export type CommunityEventConnection = {
  __typename?: 'CommunityEventConnection';
  /** Event edges */
  edges: Array<CommunityEventEdge>;
  /** Pagination info */
  pageInfo: PageInfo;
};

export type CommunityEventEdge = {
  __typename?: 'CommunityEventEdge';
  cursor: Scalars['String'];
  node: CommunityEvent;
};

/** Event location (virtual or physical) */
export type CommunityEventLocation = {
  __typename?: 'CommunityEventLocation';
  /** Formatted address for physical locations */
  address?: Maybe<Scalars['String']>;
  /** Display name for physical locations */
  displayName?: Maybe<Scalars['String']>;
  /** Latitude coordinate (-90 to 90) */
  latitude?: Maybe<Scalars['Float']>;
  /** Longitude coordinate (-180 to 180) */
  longitude?: Maybe<Scalars['Float']>;
  /** Virtual meeting provider (e.g., 'Zoom', 'Google Meet') */
  provider?: Maybe<Scalars['String']>;
  /** Location type */
  type: EventLocationType;
  /** URL for virtual events (e.g., Zoom link) */
  url?: Maybe<Scalars['String']>;
};

/** Input for event location */
export type CommunityEventLocationInput = {
  /** Formatted address */
  address?: InputMaybe<Scalars['String']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']>;
  /** Latitude (-90 to 90) */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Longitude (-180 to 180) */
  longitude?: InputMaybe<Scalars['Float']>;
  /** Google Places ID */
  placeId?: InputMaybe<Scalars['String']>;
  /** Provider name (e.g., 'Zoom', 'Google Meet') */
  provider?: InputMaybe<Scalars['String']>;
  /** Location type */
  type: EventLocationType;
  /** Meeting URL (required for VIRTUAL type) */
  url?: InputMaybe<Scalars['String']>;
};

/** Event registration summary */
export type CommunityEventRegistrationSummary = {
  __typename?: 'CommunityEventRegistrationSummary';
  /** The event */
  event: CommunityEvent;
  /** When registered (null if not registered) */
  registeredAt?: Maybe<Scalars['DateTime']>;
  /** Current registration status */
  status: RegistrationStatus;
};

/** Event reminder settings */
export type CommunityEventReminderSettings = {
  __typename?: 'CommunityEventReminderSettings';
  /** Whether reminders are enabled */
  enabled: Scalars['Boolean'];
  /** Minutes before event to send reminder (null = default) */
  remindBeforeMinutes?: Maybe<Scalars['Int']>;
};

/** Input for reminder settings */
export type CommunityEventReminderSettingsInput = {
  /** Enable reminders */
  enabled: Scalars['Boolean'];
  /** Minutes before event (null = default, e.g., 60) */
  remindBeforeMinutes?: InputMaybe<Scalars['Int']>;
};

export enum CommunityEventStatus {
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** Community feed type */
export type CommunityFeed = {
  __typename?: 'CommunityFeed';
  /** Feed banner/cover image URL */
  bannerUrl?: Maybe<Scalars['String']>;
  /** When the feed was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Custom reactions available in this feed */
  customReactions: Array<CustomReaction>;
  /** The description of the feed */
  description?: Maybe<Scalars['String']>;
  /** Feed type: topic, circle, or null for general feeds */
  feedType?: Maybe<Scalars['String']>;
  /** The unique identifier for the feed */
  id: Scalars['ID'];
  /** Feed profile image URL */
  imageUrl?: Maybe<Scalars['String']>;
  /**
   * Whether the feed is invite-only
   * @deprecated Use visibility field instead
   */
  inviteOnly?: Maybe<Scalars['Boolean']>;
  /** Whether the current authenticated user is a member of this feed */
  isMember: Scalars['Boolean'];
  /** Whether the current authenticated user is a moderator of this feed */
  isModerator: Scalars['Boolean'];
  /**
   * Whether the feed is private
   * @deprecated Use visibility field instead
   */
  isPrivate?: Maybe<Scalars['Boolean']>;
  /** The number of members in the feed */
  memberCount?: Maybe<Scalars['Int']>;
  /** The display name of the feed */
  name?: Maybe<Scalars['String']>;
  /** Posts pinned to the top of this feed */
  pinnedPosts: Array<CommunityPost>;
  /** Number of top-level posts (discussions) in this feed */
  postCount?: Maybe<Scalars['Int']>;
  /** Feed value / Page Manager path (e.g. 'topics/ancient-teachings' or 'ancient-teachings') */
  slug?: Maybe<Scalars['String']>;
  /** Content ID of the linked center/topic (null if not a topic feed) */
  topicContentId?: Maybe<Scalars['Int']>;
  /** When the feed was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Feed visibility level (PUBLIC or PRIVATE) */
  visibility?: Maybe<FeedVisibility>;
};

/** Connection type for paginated CommunityFeed results */
export type CommunityFeedConnection = {
  __typename?: 'CommunityFeedConnection';
  /** List of feed edges */
  edges: Array<CommunityFeedEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
};

/** Edge type for CommunityFeed pagination */
export type CommunityFeedEdge = {
  __typename?: 'CommunityFeedEdge';
  /** Cursor for this feed */
  cursor: Scalars['String'];
  /** The feed node */
  node: CommunityFeed;
};

/** Community leaderboard entry */
export type CommunityLeaderboardEntry = {
  __typename?: 'CommunityLeaderboardEntry';
  /** Number of comments on posts */
  commentCount: Scalars['Int'];
  /** Number of events attended */
  eventCount: Scalars['Int'];
  /** Number of posts */
  postCount: Scalars['Int'];
  /** Rank position */
  rank: Scalars['Int'];
  /** Number of reactions received */
  reactionCount: Scalars['Int'];
  /** Total score */
  score: Scalars['Int'];
  /** The user */
  user: UserProfile;
};

/** Community moderation report */
export type CommunityModerationReport = {
  __typename?: 'CommunityModerationReport';
  /** The content that was flagged (post or comment) */
  contentId: Scalars['ID'];
  /** The content type (POST or COMMENT) */
  contentType: Scalars['String'];
  /** When the report was created */
  createdAt: Scalars['DateTime'];
  /** The unique identifier */
  id: Scalars['ID'];
  /** Reason for flagging */
  reason?: Maybe<Scalars['String']>;
  /** The user who flagged the content */
  reporter?: Maybe<UserProfile>;
  /** When the report was resolved */
  resolvedAt?: Maybe<Scalars['DateTime']>;
  /** Who resolved the report */
  resolvedBy?: Maybe<UserProfile>;
  /** Current moderation status */
  status: ModerationStatus;
};

/** Connection type for paginated CommunityModerationReport results */
export type CommunityModerationReportConnection = {
  __typename?: 'CommunityModerationReportConnection';
  /** List of report edges */
  edges: Array<CommunityModerationReportEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
};

/** Edge type for CommunityModerationReport pagination */
export type CommunityModerationReportEdge = {
  __typename?: 'CommunityModerationReportEdge';
  /** Cursor for this edge */
  cursor: Scalars['String'];
  /** The report node */
  node: CommunityModerationReport;
};

/** Community post type (includes both top-level posts and comments/replies) */
export type CommunityPost = {
  __typename?: 'CommunityPost';
  /** List of allowed reaction emojis for this post's feed */
  allowedReactions: Array<Scalars['String']>;
  /** The author of the post */
  author?: Maybe<UserProfile>;
  /** The post content */
  content?: Maybe<Scalars['String']>;
  /** When the post was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The feed ID this post belongs to */
  feedId?: Maybe<Scalars['ID']>;
  /** The unique identifier for the post */
  id: Scalars['ID'];
  /** Whether this post is pinned to its feed */
  isPinned: Scalars['Boolean'];
  /** Author UID of the parent post (null for top-level posts). Used by AI service for reply-to-user detection. */
  parentAuthorUid?: Maybe<Scalars['ID']>;
  /** The parent post ID for threading (null for top-level posts, non-null for comments) */
  parentId?: Maybe<Scalars['ID']>;
  /** When the post was pinned (null if not pinned) */
  pinnedAt?: Maybe<Scalars['DateTime']>;
  /** Aggregated reaction summary for inline display */
  reactions: Array<PostReactionSummary>;
  /** Total count of all reactions */
  reactionsCount: Scalars['Int'];
  /** Total count of replies/comments to this post */
  repliesCount: Scalars['Int'];
  /** The root post ID for deep threading (null for top-level posts) */
  rootPostId?: Maybe<Scalars['ID']>;
  /** The post status */
  status?: Maybe<Scalars['String']>;
  /** The post title (null for comments) */
  title?: Maybe<Scalars['String']>;
  /** When the post was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Connection type for paginated CommunityPost results */
export type CommunityPostConnection = {
  __typename?: 'CommunityPostConnection';
  /** List of post edges */
  edges: Array<CommunityPostEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
};

/** Edge type for CommunityPost pagination */
export type CommunityPostEdge = {
  __typename?: 'CommunityPostEdge';
  /** Cursor for this post */
  cursor: Scalars['String'];
  /** The post node */
  node: CommunityPost;
};

/** Sort order for community post listing */
export enum CommunityPostOrderBy {
  /** Sort by creation date (default) */
  CreatedAt = 'CREATED_AT',
  /** Sort by most recent engagement (reply or reaction) */
  LastActivityAt = 'LAST_ACTIVITY_AT',
  /** Sort by total reaction count (likes + custom reactions) */
  ReactionsCount = 'REACTIONS_COUNT',
  /** Sort by reply/comment count */
  RepliesCount = 'REPLIES_COUNT',
  /** Sort by trending score (engagement weighted by recency) */
  Trending = 'TRENDING'
}

/** Community reaction type */
export type CommunityReaction = {
  __typename?: 'CommunityReaction';
  /** The author of the reaction */
  author?: Maybe<UserProfile>;
  /** When the reaction was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The unique identifier for the reaction */
  id: Scalars['ID'];
  /** The post ID this reaction belongs to */
  postId: Scalars['ID'];
  /** The reaction emoji */
  reaction: Scalars['String'];
};

/** Consume discount input */
export type ConsumeDiscountInput = {
  /** Whether the discount was used at signup or on plan change */
  action: BillingDiscountRedemptionAction;
  /** Discount code */
  discountCode: Scalars['String'];
  /** When the discount was redeemed; defaults to the current time if omitted */
  redeemedAt?: InputMaybe<Scalars['DateTime']>;
  /** Plan SKU for this redemption */
  sku: Scalars['String'];
  /** User id (user_info.uid) */
  uid: Scalars['BigInt'];
};

/** Content entity from federated content service */
export type Content = {
  __typename?: 'Content';
  /** Anonymous description data for this content row (1:1 by content.id); null when no row exists */
  anon?: Maybe<ContentAnon>;
  /** The assets description */
  assetsDescription?: Maybe<Scalars['String']>;
  /** The assets label */
  assetsLabel?: Maybe<Scalars['String']>;
  /** Bundle for a tag, (d6 vocabulary vid) */
  bundle?: Maybe<Scalars['String']>;
  /** The cast in the video */
  cast?: Maybe<Scalars['String']>;
  /** The content analytic linked to this content */
  contentAnalytic?: Maybe<ContentAnalytic>;
  /** Content asset references linked to this content */
  contentAssetReferences?: Maybe<Array<Maybe<ContentAssetReference>>>;
  /** Clip Contents linked to this content (typically a video) via the clip-vert content reference */
  contentClips?: Maybe<Array<Maybe<Content>>>;
  /** All courses that contain this content (for videos via course modules) */
  contentCourses?: Maybe<Array<Maybe<Content>>>;
  /** The content document linked to this content */
  contentDocument?: Maybe<ContentDocument>;
  /** Content linked to this content as an episode which have a default order of seasonNumber and then episodeNumber */
  contentEpisodes?: Maybe<Array<Maybe<Content>>>;
  /** Content featured for this content */
  contentFeatured?: Maybe<ContentFeatured>;
  /** The content filter set to display for this content */
  contentFilterSet?: Maybe<ContentFilterSet>;
  /**
   * The content group identifier (NOT the primary key - do not confuse with id).
   * Also known as D6 nid. All translations of the same content share the same contentId.
   *
   * IMPORTANT: contentId is NOT useful without contentType. Always use contentId + contentType together
   * (and optionally language) to uniquely identify content. Use contentId + contentType + language to
   * uniquely identify a specific language version.
   *
   * NOTE: id is the primary key and is preferred for direct lookups. contentId + contentType is used for grouping translations.
   */
  contentId?: Maybe<Scalars['Int']>;
  /**
   * The content policy linked to this content that controls access, sharing, and availability.
   * Use contentPolicy.accessCheck to determine if the current user can access this content.
   */
  contentPolicy?: Maybe<ContentPolicy>;
  /**
   * A reference to the content policy that controls access, sharing, and availability rules for this content.
   * The content policy determines which users can access the content based on subscriptions, countries,
   * client attributes, and other access control rules.
   */
  contentPolicyPolicyId?: Maybe<Scalars['Int']>;
  /** The content provider linked to this content */
  contentProvider?: Maybe<ContentProvider>;
  /** The content references linked both to and from this content */
  contentReferences?: Maybe<Array<Maybe<ContentReference>>>;
  /** The content references link from this content */
  contentReferencesFrom?: Maybe<Array<Maybe<ContentReference>>>;
  /** The content references linked to this content */
  contentReferencesTo?: Maybe<Array<Maybe<ContentReference>>>;
  /**
   * Content related to this content which defaults to video.
   * When using this query consider using @defer or multiple GraphQL queries
   * in an application for performance
   */
  contentRelated?: Maybe<Array<Maybe<Content>>>;
  /** When true the content will be visible in content search */
  contentSearchNoIndex?: Maybe<Scalars['Boolean']>;
  /** Content linked to this content as a series */
  contentSeries?: Maybe<Array<Maybe<Content>>>;
  /** The content type which can be expanded in the future i.e. video or series */
  contentType?: Maybe<Scalars['String']>;
  /** The parent video Content for a clip (content_type=clip), resolved via the clip-vert content reference */
  contentVideo?: Maybe<Content>;
  /** The copyright date as text */
  copyright?: Maybe<Scalars['String']>;
  /** Get course item progress for this content (if it is a video in a course) */
  courseItemProgress?: Maybe<UserStateProgressCourseItem>;
  /** Get course module progress for this content (if it is a course module) */
  courseModuleProgress?: Maybe<UserStateProgressCourseModule>;
  /** Get course progress for this content (if it is a course) */
  courseProgress?: Maybe<UserStateProgressCourse>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** the deeplink path on the gaia app where the promoted item lives */
  ctaDeeplinkPath?: Maybe<Scalars['String']>;
  /** the call to action label */
  ctaLabel?: Maybe<Scalars['String']>;
  /** the path on the gaia web app where the promoted item lives */
  ctaPath?: Maybe<Scalars['String']>;
  /** The url to purchase the product */
  ctaProductUrl?: Maybe<Scalars['String']>;
  /** The day number */
  dayNumber?: Maybe<Scalars['Int']>;
  /** The description in the given language */
  description?: Maybe<Scalars['String']>;
  /** The format of the long description (null = plain text) */
  descriptionFormat?: Maybe<Scalars['String']>;
  /** The directions description */
  directionsDescription?: Maybe<Scalars['String']>;
  /** The directions label */
  directionsLabel?: Maybe<Scalars['String']>;
  /** The name of the directory of the video */
  director?: Maybe<Scalars['String']>;
  /** The display type to be used in UI rendering */
  displayType?: Maybe<Scalars['String']>;
  /** The series season episode number */
  episodeNumber?: Maybe<Scalars['Int']>;
  /** Get a count of all episodes linked to this content */
  episodesCount?: Maybe<Scalars['Int']>;
  /** When true the content will be excluded from recommendations */
  excludeFromRecommendations?: Maybe<Scalars['Boolean']>;
  /** If true the content is family friendly */
  familyFriendly?: Maybe<Scalars['Boolean']>;
  /** The feature media for this content */
  featureMedia?: Maybe<Media>;
  /** The foreign key to the media table to the feature media */
  featureMediaId?: Maybe<Scalars['ID']>;
  /** Optional filter type to include this content as a filter option */
  filterType?: Maybe<Scalars['String']>;
  /** The primary identifier for this content record */
  id?: Maybe<Scalars['ID']>;
  /** Image content relationships linked to this content */
  imageContentRelationships?: Maybe<Array<Maybe<ImageContentRelationship>>>;
  /** The name of the instructor in the video */
  instructor?: Maybe<Scalars['String']>;
  /** When true the content is considered new by published at or created at */
  isNew?: Maybe<Scalars['Boolean']>;
  /** The language of this content */
  language?: Maybe<Scalars['String']>;
  /** The language of this content in full text e.g. English */
  languageFullText?: Maybe<Scalars['String']>;
  /** The path part of a url which matches this content. Return path as relative or full URL. */
  path?: Maybe<Scalars['String']>;
  /** The path redirect by source linked to this content by path */
  pathRedirectBySource?: Maybe<PathRedirect>;
  /** PM people list */
  peopleListId?: Maybe<Scalars['String']>;
  /** The requesting user playlist items for this content */
  playlistItems?: Maybe<Array<Maybe<PlaylistItem>>>;
  /** The preview media for this content */
  previewMedia?: Maybe<Media>;
  /** The foreign key to the media table to the preview media */
  previewMediaId?: Maybe<Scalars['ID']>;
  /** The language of content that was used to create all of the translations */
  primaryLanguage?: Maybe<Scalars['String']>;
  /** The name of producer of the video */
  producer?: Maybe<Scalars['String']>;
  /** The product type identifier in UI rendering */
  productType?: Maybe<Scalars['String']>;
  /** The production status */
  productionStatus?: Maybe<Scalars['String']>;
  /**
   * Published state of the content. IMPORTANT: Content that is not published (published=false) should NEVER be accessible to end users.
   *
   * Published State Meanings:
   * - published=false: Content is NOT published and should NEVER be accessible. This content is hidden from all public access.
   * - published=true + publishedAtDate is in the future: Content is published but NOT YET playable. It can be discovered in search/browse but cannot be played until publishedAtDate is reached.
   * - published=true + publishedAtDate is now or in the past: Content is published AND playable (PUBLISHED_NOW state). This is the only state where content can be fully accessed and played.
   *
   * Use publishedState filter (PUBLISHED_NOW) to get only playable content, or published=true to get all discoverable content (including future-dated).
   */
  published?: Maybe<Scalars['Boolean']>;
  /**
   * The date and time when the content becomes playable. Used in combination with published field:
   * - If published=true and publishedAtDate is in the future: Content is discoverable but not playable
   * - If published=true and publishedAtDate is now or in the past: Content is playable (PUBLISHED_NOW)
   * - If published=false: Content is not accessible regardless of publishedAtDate
   */
  publishedAtDate?: Maybe<Scalars['DateTime']>;
  /** When performing a search query the relevance score */
  queryRelevanceScore?: Maybe<Scalars['Float']>;
  /** The content references linked from this content which is useful in an apps when displaying categories, tags, topics, etc. */
  references?: Maybe<Array<Maybe<ContentReference>>>;
  /** The content references linked from this content which are considered tags useful in an apps when displaying tags */
  referencesByTypeTag?: Maybe<Array<Maybe<ContentReference>>>;
  /**
   * Chunk-level document embeddings for this content (direct or feature media): vectors + `documentText` for semantic retrieval and RAG.
   *
   * Pass **`query`** to rank chunks by cosine similarity; omit it to list related chunks without query scoring. Pair with `ContentRelatedDocumentEmbeddings.summarizationText` for an on-the-fly narrative, or use `documentAbstractList` for offline pooled vectors over chunks (`sumEmbedding` / `averageEmbedding`).
   */
  relatedDocumentEmbeddings?: Maybe<ContentRelatedDocumentEmbeddings>;
  /** The series season number */
  seasonNumber?: Maybe<Scalars['Int']>;
  /** Get a count of all seasons linked to this content */
  seasonsCount?: Maybe<Scalars['Int']>;
  /** The SEO canonical url */
  seoCanonicalUrl?: Maybe<Scalars['String']>;
  /** The SEO short description in the given language */
  seoDescription?: Maybe<Scalars['String']>;
  /** The SEO keywords in the given language */
  seoKeywords?: Maybe<Scalars['String']>;
  /** The SEO no follow attribute */
  seoRobotsNoFollow?: Maybe<Scalars['Boolean']>;
  /** The SEO no index attribute */
  seoRobotsNoIndex?: Maybe<Scalars['Boolean']>;
  /** The SEO title of this video in the given language */
  seoTitle?: Maybe<Scalars['String']>;
  /** The share URL for this content, constructed based on content policy shareAllowed setting */
  shareUrl?: Maybe<Scalars['String']>;
  /** The short description in the given language */
  shortDescription?: Maybe<Scalars['String']>;
  /** The format of the long description (null = plain text) */
  shortDescriptionFormat?: Maybe<Scalars['String']>;
  /** The studio where the video was filmed */
  studio?: Maybe<Scalars['String']>;
  /** The content sub type used by apps for rendering (not useful in other contexts) */
  subType?: Maybe<Scalars['String']>;
  /** The third party description in the given language */
  thirdPartyDescription?: Maybe<Scalars['String']>;
  /** The title of this video in the given language */
  title?: Maybe<Scalars['String']>;
  /**
   * A human-readable identifier that groups all translations of the same content together.
   * Format: "{contentId}-{contentType}" (e.g., "123-video").
   * All language versions of the same content share the same titleGroupId.
   * Use this field to query for all translations of a piece of content or to group content by title.
   */
  titleGroupId?: Maybe<Scalars['String']>;
  /**
   * A human-readable identifier that uniquely identifies a specific language version of content.
   * Format: "{contentId}-{contentType}-{language}" (e.g., "123-video-en").
   * This is globally unique across all content - each language version has a unique titleId.
   *
   * NOTE: contentId is PREFERRED over titleId for querying and programmatic access.
   * Use contentId + contentType + language instead when possible.
   */
  titleId?: Maybe<Scalars['String']>;
  /** The date the content was unpublished (when published was changed from true to false) */
  unpublishedAt?: Maybe<Scalars['DateTime']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The requesting user latest vote for this content */
  vote?: Maybe<Vote>;
  /** The weight when ordering in lists */
  weight?: Maybe<Scalars['Int']>;
  /** The name of the video */
  writer?: Maybe<Scalars['String']>;
};


/** Content entity from federated content service */
export type ContentContentAssetReferencesArgs = {
  contentAssetReferences?: InputMaybe<Array<InputMaybe<ContentAssetReferenceFilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Content entity from federated content service */
export type ContentContentClipsArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Content entity from federated content service */
export type ContentContentCoursesArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Content entity from federated content service */
export type ContentContentEpisodesArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  seasonNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


/** Content entity from federated content service */
export type ContentContentFeaturedArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Content entity from federated content service */
export type ContentContentReferencesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Content entity from federated content service */
export type ContentContentReferencesFromArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Content entity from federated content service */
export type ContentContentReferencesToArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Content entity from federated content service */
export type ContentContentRelatedArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<ContentRelatedType>;
};


/** Content entity from federated content service */
export type ContentContentSeriesArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Content entity from federated content service */
export type ContentContentVideoArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Content entity from federated content service */
export type ContentCourseItemProgressArgs = {
  courseTitleGroupId: Scalars['String'];
};


/** Content entity from federated content service */
export type ContentCourseModuleProgressArgs = {
  courseTitleGroupId: Scalars['String'];
};


/** Content entity from federated content service */
export type ContentDescriptionArgs = {
  format?: InputMaybe<ContentTextFormat>;
  truncate?: InputMaybe<Scalars['Int']>;
};


/** Content entity from federated content service */
export type ContentEpisodesCountArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seasonNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


/** Content entity from federated content service */
export type ContentImageContentRelationshipsArgs = {
  imageContentRelationships?: InputMaybe<Array<InputMaybe<ContentImageContentRelationshipsFilterInput>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Content entity from federated content service */
export type ContentPathArgs = {
  format?: InputMaybe<ContentPathFormat>;
};


/** Content entity from federated content service */
export type ContentReferencesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typesByTypeTag?: InputMaybe<Scalars['Boolean']>;
};


/** Content entity from federated content service */
export type ContentRelatedDocumentEmbeddingsArgs = {
  embeddingConfigKey?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


/** Content entity from federated content service */
export type ContentSeasonsCountArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Content entity from federated content service */
export type ContentShortDescriptionArgs = {
  format?: InputMaybe<ContentTextFormat>;
  truncate?: InputMaybe<Scalars['Int']>;
};

/** AI-assessed learner level from summary validator (score, level, reasoning). */
export type ContentAiLearnerLevel = {
  __typename?: 'ContentAILearnerLevel';
  /** Validator-assigned learner level (e.g. beginner, intermediate). */
  level?: Maybe<Scalars['String']>;
  /** Validator reasoning for the assigned level. */
  reasoning?: Maybe<Scalars['String']>;
  /** Validator score for the learner level. */
  score?: Maybe<Scalars['Int']>;
};

/** Look up AI metadata by either mediaId (feature media id) or contentId; language is required. */
export type ContentAiMetadataInput = {
  /** Content identifier (use when you have the content id). */
  contentId?: InputMaybe<Scalars['ID']>;
  /** Language/locale for the metadata (e.g. en, es). */
  language: Scalars['String'];
  /** Feature media identifier (use when you have the media id). */
  mediaId?: InputMaybe<Scalars['ID']>;
};

/** Content analytic */
export type ContentAnalytic = {
  __typename?: 'ContentAnalytic';
  /** The total number of comments for this content */
  commentsCountTotal?: Maybe<Scalars['Int']>;
  /** The content linked to this content analytic */
  content?: Maybe<Array<Maybe<Content>>>;
  /** The content id for the content this analytics row */
  contentId?: Maybe<Scalars['Int']>;
  /** The content type for the content this analytics row */
  contentType?: Maybe<Scalars['String']>;
  /** One day video play count for the content */
  count1Day?: Maybe<Scalars['Int']>;
  /** Three day video play count for the content */
  count3Day?: Maybe<Scalars['Int']>;
  /** seven day video play count for the content */
  count7Day?: Maybe<Scalars['Int']>;
  /** 7 day share count for German content */
  countShares7dDe?: Maybe<Scalars['Int']>;
  /** 7 day share count for English content */
  countShares7dEn?: Maybe<Scalars['Int']>;
  /** 7 day share count for Spanish content */
  countShares7dEs?: Maybe<Scalars['Int']>;
  /** 7 day share count for French content */
  countShares7dFr?: Maybe<Scalars['Int']>;
  /** rolling 7 day share count for German content */
  countSharesDailyDe?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** rolling 7 day share count for English content */
  countSharesDailyEn?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** rolling 7 day share count for Spanish content */
  countSharesDailyEs?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** rolling 7 day share count for French content */
  countSharesDailyFr?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** forever video play count for the content */
  countTotal?: Maybe<Scalars['Int']>;
  /** Three day video play count for German content */
  count_3d_de?: Maybe<Scalars['Int']>;
  /** Three day video play count for English content */
  count_3d_en?: Maybe<Scalars['Int']>;
  /** Three day video play count for Spanish content */
  count_3d_es?: Maybe<Scalars['Int']>;
  /** Three day video play count for French content */
  count_3d_fr?: Maybe<Scalars['Int']>;
  /** Seven day video play count for German content */
  count_7d_de?: Maybe<Scalars['Int']>;
  /** Seven day video play count for English content */
  count_7d_en?: Maybe<Scalars['Int']>;
  /** Seven day video play count for Spanish content */
  count_7d_es?: Maybe<Scalars['Int']>;
  /** Seven day video play count for French content */
  count_7d_fr?: Maybe<Scalars['Int']>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** daily counts for all languages (plus combined 'all') */
  languageCounts?: Maybe<Scalars['JSON']>;
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: Maybe<Scalars['String']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The total number of votes for this content */
  votesCountTotal?: Maybe<Scalars['Int']>;
  /** The total number of up votes for this content */
  votesUpCountTotal?: Maybe<Scalars['Int']>;
};

/** Content analytic where id input type */
export type ContentAnalyticWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Content analytic where conditions to filter rows */
export type ContentAnalyticWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<ContentAnalyticWhereIdInput>;
  /** The title group id field where clause */
  titleGroupId?: InputMaybe<ContentAnalyticWhereTitleGroupIdInput>;
};

/** Content analytic where title group id input type */
export type ContentAnalyticWhereTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Content analytic list response */
export type ContentAnalyticsListResponse = {
  __typename?: 'ContentAnalyticsListResponse';
  /** A list of Content analytic */
  contentAnalytics?: Maybe<Array<Maybe<ContentAnalytic>>>;
};

/** Anonymous description data for a content row (1:1 with Content by content.id) */
export type ContentAnon = {
  __typename?: 'ContentAnon';
  /** The Content row primary key (Content.id) this anon row belongs to. Not the content group id (Content.contentId). */
  contentId?: Maybe<Scalars['ID']>;
  /** The description (optional format and truncate as on Content.description) */
  description?: Maybe<Scalars['String']>;
  /** The format of the long description (null = plain text) */
  descriptionFormat?: Maybe<Scalars['String']>;
  /** The short description (optional format and truncate as on Content.shortDescription) */
  shortDescription?: Maybe<Scalars['String']>;
  /** The format of the short description (null = plain text) */
  shortDescriptionFormat?: Maybe<Scalars['String']>;
};


/** Anonymous description data for a content row (1:1 with Content by content.id) */
export type ContentAnonDescriptionArgs = {
  format?: InputMaybe<ContentTextFormat>;
  truncate?: InputMaybe<Scalars['Int']>;
};


/** Anonymous description data for a content row (1:1 with Content by content.id) */
export type ContentAnonShortDescriptionArgs = {
  format?: InputMaybe<ContentTextFormat>;
  truncate?: InputMaybe<Scalars['Int']>;
};

/** Input for creating content anon (1:1 with Content by content.id) */
export type ContentAnonCreateInput = {
  /** Content row primary key (Content.id) this anon row belongs to */
  contentId: Scalars['ID'];
  /** Description (long) */
  description?: InputMaybe<Scalars['String']>;
  /** Format of description (null = plain text) */
  descriptionFormat?: InputMaybe<Scalars['String']>;
  /** Short description */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Format of short description (null = plain text); same values as ContentTextFormat stored value */
  shortDescriptionFormat?: InputMaybe<Scalars['String']>;
};

/** Response for contentAnon create mutation */
export type ContentAnonCreateResponse = {
  __typename?: 'ContentAnonCreateResponse';
  /** The created content anon */
  contentAnon?: Maybe<ContentAnon>;
};

/** Input for deleting content anon by content id */
export type ContentAnonDeleteInput = {
  /** Content row primary key (Content.id) */
  contentId: Scalars['ID'];
};

/** Response for contentAnon delete mutation */
export type ContentAnonDeleteResponse = {
  __typename?: 'ContentAnonDeleteResponse';
  /** The deleted content anon */
  contentAnon?: Maybe<ContentAnon>;
};

/** Input for updating content anon by content id */
export type ContentAnonUpdateInput = {
  /** Content row primary key (Content.id) */
  contentId: Scalars['ID'];
  /** Description (long) */
  description?: InputMaybe<Scalars['String']>;
  /** Format of description (null = plain text) */
  descriptionFormat?: InputMaybe<Scalars['String']>;
  /** Short description */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Format of short description (null = plain text) */
  shortDescriptionFormat?: InputMaybe<Scalars['String']>;
};

/** Response for contentAnon update mutation */
export type ContentAnonUpdateResponse = {
  __typename?: 'ContentAnonUpdateResponse';
  /** The updated content anon */
  contentAnon?: Maybe<ContentAnon>;
};

/** ContentAssetReference */
export type ContentAssetReference = {
  __typename?: 'ContentAssetReference';
  /** The asset linked to the content asset reference */
  asset?: Maybe<Asset>;
  /** The asset id foreign key */
  assetsId?: Maybe<Scalars['ID']>;
  /** The content list linked to the content asset reference */
  content?: Maybe<Array<Maybe<Content>>>;
  /** The content asset reference type directly linked to this content asset reference */
  contentAssetReferenceType?: Maybe<ContentAssetReferenceType>;
  /** The content asset reference types id foreign key */
  contentAssetReferenceTypesId?: Maybe<Scalars['ID']>;
  /** The content contentTitleGroupId foreign key */
  contentTitleGroupId?: Maybe<Scalars['String']>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/** ContentAssetReference */
export type ContentAssetReferenceAssetArgs = {
  filter?: InputMaybe<AssetFilterInput>;
};


/** ContentAssetReference */
export type ContentAssetReferenceContentArgs = {
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>;
};

/** Input type for creating a new content asset reference */
export type ContentAssetReferenceCreateInput = {
  /** The assets_id of the asset */
  assetsId: Scalars['ID'];
  /** The content_asset_reference_types_id of the content asset reference type */
  contentAssetReferenceTypesId: Scalars['ID'];
  /** The content_title_group_id of the content title group */
  contentTitleGroupId: Scalars['ID'];
  /** The primary key (optional) */
  id?: InputMaybe<Scalars['ID']>;
};

/** Input type for deleting an existing content asset reference */
export type ContentAssetReferenceDeleteInput = {
  /** The primary key of the content asset reference to delete */
  id: Scalars['ID'];
};

export type ContentAssetReferenceFilterInput = {
  /** The content asset reference types id foreign key */
  contentAssetReferenceTypesId?: InputMaybe<Scalars['ID']>;
  /** The content contentTitleGroupId foreign key */
  contentTitleGroupId?: InputMaybe<Scalars['String']>;
  /** The content asset reference type */
  type?: InputMaybe<Scalars['String']>;
};

/** Response object containing a boolean property of success and the created/deleted content asset reference */
export type ContentAssetReferenceMutationResponse = {
  __typename?: 'ContentAssetReferenceMutationResponse';
  /** The created or deleted content asset reference */
  contentAssetReference?: Maybe<ContentAssetReference>;
  /** A boolean property of success indicating whether the operation was successful */
  success: Scalars['Boolean'];
};

/** ContentAssetReferenceType */
export type ContentAssetReferenceType = {
  __typename?: 'ContentAssetReferenceType';
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** The content asset reference type */
  type?: Maybe<Scalars['ID']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** ContentAssetReferenceType where id input */
export type ContentAssetReferenceTypeWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** ContentAssetReferenceType where input */
export type ContentAssetReferenceTypeWhereInput = {
  /** ContentAssetReferenceType where id clause */
  id?: InputMaybe<ContentAssetReferenceTypeWhereIdInput>;
};

/** ContentAssetReferenceTypes list response */
export type ContentAssetReferenceTypesListResponse = {
  __typename?: 'ContentAssetReferenceTypesListResponse';
  /** A list of assets */
  contentAssetReferenceTypes?: Maybe<Array<Maybe<ContentAssetReferenceType>>>;
};

/** ContentAssetReference where id input */
export type ContentAssetReferenceWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** ContentAssetReference where input */
export type ContentAssetReferenceWhereInput = {
  /** ContentAssetReference where id clause */
  id?: InputMaybe<ContentAssetReferenceWhereIdInput>;
};

/** ContentAssetReferences list response */
export type ContentAssetReferencesListResponse = {
  __typename?: 'ContentAssetReferencesListResponse';
  /** A list of assets */
  contentAssetReferences?: Maybe<Array<Maybe<ContentAssetReference>>>;
};

/** Content content provider filter input */
export type ContentContentProviderFilterInput = {
  /** The content provider */
  provider?: InputMaybe<ContentProviderProviders>;
  /** The content provider key for this content */
  providerKey?: InputMaybe<Scalars['String']>;
};

/** Content content references from filter input */
export type ContentContentReferencesFromFilterInput = {
  /** The content id */
  contentId?: InputMaybe<Scalars['Int']>;
  /** The content type */
  contentType?: InputMaybe<Scalars['String']>;
  /** The content reference type */
  type?: InputMaybe<Scalars['String']>;
};

/** Content content references to filter input */
export type ContentContentReferencesToFilterInput = {
  /** The content id */
  contentId?: InputMaybe<Scalars['Int']>;
  /** The content type */
  contentType?: InputMaybe<Scalars['String']>;
  /** The content reference type */
  type?: InputMaybe<Scalars['String']>;
};

/** Return type for content create */
export type ContentCreateResponse = {
  __typename?: 'ContentCreateResponse';
  /** The newly created content */
  content?: Maybe<Content>;
};

/**
 * **`content_documents` join row:** pairs one **`Content`** (`contentId`) with one **`documents`** row (`documentsId`). This is the **primary** way a catalog title becomes “the document” for chunk indexing when the pipeline is content-driven: the worker builds **`document_embeddings`** from that title’s text (and related media), and **`Document.documentContent`** / the **`Document.content`** list resolve through this link.
 *
 * **Contrast with `media_asset_documents`:** If the document is instead linked **only** to a **`MediaAsset`**, there is no `content_documents` row; **`Document.documentContent`** is `null` while **`Document.content`** may still list titles discovered via **`featureMediaId`**. See **`Document`** type docs for resolver precedence between content-linked and media-linked paths.
 *
 * **Embeddings / abstract:** Chunks remain on **`Document.documentEmbeddings`**; whole-title synopsis and pooled chunk vectors are on **`Document.documentAbstract`** / **`documentAbstractList`** (`document_abstracts`).
 */
export type ContentDocument = {
  __typename?: 'ContentDocument';
  /** The **`Content`** row for this join (catalog metadata: title, episode, path, etc.). */
  content?: Maybe<Content>;
  /** `Content` primary key participating in this link. */
  contentId?: Maybe<Scalars['ID']>;
  /** Join row creation time. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The **`Document`** row used for embeddings and worker processing for this title. */
  document?: Maybe<Document>;
  /** `documents.id` participating in this link. */
  documentsId?: Maybe<Scalars['ID']>;
  /** Join row last update time. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Content featured */
export type ContentFeatured = {
  __typename?: 'ContentFeatured';
  /** The featured content */
  content?: Maybe<Content>;
  /** The featured type indicating the user's progress: first (no progress), next (in progress), last (final video to watch), continue (resume watching), latest (all complete, active production) */
  featuredType?: Maybe<Scalars['String']>;
};

/** Content filter */
export type ContentFilter = {
  __typename?: 'ContentFilter';
  content?: Maybe<Array<Maybe<Content>>>;
  /** The content filter set linked to this content filter */
  contentFilterSet?: Maybe<ContentFilterSet>;
  /** The content_id field on the content table */
  contentId?: Maybe<Scalars['String']>;
  /** The content reference type */
  contentReferenceType?: Maybe<ContentReferenceType>;
  /** A foreign key to the content_reference_types which defines the relationship between the parent and the child content */
  contentReferenceTypesId?: Maybe<Scalars['ID']>;
  /** The content_type field on the content table */
  contentType?: Maybe<Scalars['String']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The filter set to which this filter belongs */
  filterSet?: Maybe<Scalars['String']>;
  /** The filter type to which this filter belongs */
  filterType?: Maybe<Scalars['String']>;
  /** The primary key for this record */
  id?: Maybe<Scalars['ID']>;
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: Maybe<Scalars['String']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/** Content filter */
export type ContentFilterContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * The content filter for associated content.
 *
 * IMPORTANT: Published state filtering:
 * - published=true: Returns content that is discoverable (may include future-dated content that's not yet playable)
 * - published=false: Should NEVER be used in production queries - unpublished content should never be accessible
 * - publishedState=PUBLISHED_NOW: Returns only playable content (published=true AND publishedAtDate is now or in past)
 * - publishedState=PUBLISHED: Returns all discoverable content (published=true, regardless of publishedAtDate)
 *
 * For playable content, always use publishedState=PUBLISHED_NOW or ensure published=true AND publishedAtDate is in the past.
 */
export type ContentFilterInput = {
  /** The content content id */
  contentId?: InputMaybe<Scalars['Int']>;
  /** The content content type */
  contentType?: InputMaybe<Scalars['String']>;
  /** The content language */
  language?: InputMaybe<Scalars['String']>;
  /**
   * The content published state (does not consider published at date - see publishedState for date-aware filtering).
   * WARNING: published=false should NEVER be accessible to end users. Use publishedState filter instead.
   */
  published?: InputMaybe<Scalars['Boolean']>;
  /**
   * Alias for various content published states that considers both published flag and publishedAtDate.
   * Use PUBLISHED_NOW to get only playable content, or PUBLISHED to get all discoverable content (including future-dated).
   */
  publishedState?: InputMaybe<ContentFilterPublishedState>;
  /** The content title group id */
  titleGroupId?: InputMaybe<Scalars['String']>;
};

/** Content filter list response */
export type ContentFilterListResponse = {
  __typename?: 'ContentFilterListResponse';
  /** A list of content reference */
  contentFilters?: Maybe<Array<Maybe<ContentFilter>>>;
};

/**
 * Content filter types for various content published states.
 *
 * Published State Meanings:
 * - PUBLISHED: Content where published=true (regardless of publishedAtDate). This includes:
 *   * Content that is discoverable but not yet playable (publishedAtDate in future)
 *   * Content that is playable (publishedAtDate is now or in past)
 *   Use this to get all discoverable content, including future-dated content.
 *
 * - PUBLISHED_NOW: Content where published=true AND publishedAtDate is now or in the past.
 *   This is the ONLY state where content is playable. Use this filter to get only content
 *   that can actually be played by users.
 *
 * IMPORTANT: Content with published=false should NEVER be accessible, regardless of publishedAtDate.
 */
export enum ContentFilterPublishedState {
  /**
   * The content published is true (does not consider published at date).
   * Includes both playable content and future-dated discoverable content.
   */
  Published = 'PUBLISHED',
  /**
   * The content published is true and published at date is now or in the past.
   * This is the ONLY state where content is playable. Use this to filter for content
   * that users can actually access and play.
   */
  PublishedNow = 'PUBLISHED_NOW'
}

/** Content filter set */
export type ContentFilterSet = {
  __typename?: 'ContentFilterSet';
  content?: Maybe<Array<Maybe<Content>>>;
  /** The content filters in this content filter set */
  contentFilters?: Maybe<Array<Maybe<ContentFilter>>>;
  /** The content_id field on the content table */
  contentId?: Maybe<Scalars['Int']>;
  /** The content reference type */
  contentReferenceType?: Maybe<ContentReferenceType>;
  /** A foreign key to the content_reference_types which defines the relationship between the parent and the child content */
  contentReferenceTypesId?: Maybe<Scalars['ID']>;
  /** The content_type field on the content table */
  contentType?: Maybe<Scalars['String']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** A list of content_filter types in display order from left to right */
  filterTypeOrder?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The primary key for this record */
  id?: Maybe<Scalars['ID']>;
  /** The filter set to which this filter belongs */
  name?: Maybe<Scalars['String']>;
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: Maybe<Scalars['String']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/** Content filter set */
export type ContentFilterSetContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Content filter set list response */
export type ContentFilterSetListResponse = {
  __typename?: 'ContentFilterSetListResponse';
  /** A list of content reference */
  contentFilterSets?: Maybe<Array<Maybe<ContentFilterSet>>>;
};

/** Content path redirect type where input type */
export type ContentFilterSetWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Content filter set where conditions to filter rows */
export type ContentFilterSetWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<ContentFilterSetWhereIdInput>;
  /** The name field where clause */
  name?: InputMaybe<ContentFilterSetWhereNameInput>;
};

/** Content filter set filter type where input type */
export type ContentFilterSetWhereNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Content filter filter set where input type */
export type ContentFilterWhereFilterSetInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Content filter filter type where input type */
export type ContentFilterWhereFilterTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Content path redirect type where input type */
export type ContentFilterWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Content filter where conditions to filter rows */
export type ContentFilterWhereInput = {
  /** The filterSet field where clause */
  filterSet?: InputMaybe<ContentFilterWhereFilterSetInput>;
  /** The filterSet field where clause */
  filterType?: InputMaybe<ContentFilterWhereFilterTypeInput>;
  /** The id field where clause */
  id?: InputMaybe<ContentFilterWhereIdInput>;
};

/** The content filter for associated imageContentRelationships */
export type ContentImageContentRelationshipsFilterInput = {
  /** The image content relationship language */
  language?: InputMaybe<Scalars['String']>;
  /** The image content relationship type */
  type?: InputMaybe<Scalars['String']>;
};

/** Single piece of content as input */
export type ContentInput = {
  /** The assets description */
  assetsDescription?: InputMaybe<Scalars['String']>;
  /** The assets label */
  assetsLabel?: InputMaybe<Scalars['String']>;
  /** Bundle for a tag, (d6 vocabulary vid) */
  bundle?: InputMaybe<Scalars['String']>;
  /** The cast in the video */
  cast?: InputMaybe<Scalars['String']>;
  /** D6 nid also the content group id i.e. all translations of this content share the same content_id */
  contentId?: InputMaybe<Scalars['Int']>;
  /** A reference to the content policy */
  contentPolicyPolicyId?: InputMaybe<Scalars['Int']>;
  /** When true the content will be visible in content search */
  contentSearchNoIndex?: InputMaybe<Scalars['Boolean']>;
  /** The content type which can be expanded in the future i.e. video or series */
  contentType?: InputMaybe<Scalars['String']>;
  /** The copyright date as text */
  copyright?: InputMaybe<Scalars['String']>;
  /** The date the row was created */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** the deeplink path on the gaia app where the promoted item lives */
  ctaDeeplinkPath?: InputMaybe<Scalars['String']>;
  /** the call to action label */
  ctaLabel?: InputMaybe<Scalars['String']>;
  /** the path on the gaia web app where the promoted item lives */
  ctaPath?: InputMaybe<Scalars['String']>;
  /** The URL to purchase the product */
  ctaProductUrl?: InputMaybe<Scalars['String']>;
  /** The day number */
  dayNumber?: InputMaybe<Scalars['Int']>;
  /** The description in the given language */
  description?: InputMaybe<Scalars['String']>;
  /** The format of the long description (null = plain text) */
  descriptionFormat?: InputMaybe<Scalars['String']>;
  /** The directions description */
  directionsDescription?: InputMaybe<Scalars['String']>;
  /** The directions label */
  directionsLabel?: InputMaybe<Scalars['String']>;
  /** The name of the directory of the video */
  director?: InputMaybe<Scalars['String']>;
  /** The display type to be used in UI rendering */
  displayType?: InputMaybe<Scalars['String']>;
  /** The series season episode number */
  episodeNumber?: InputMaybe<Scalars['Int']>;
  /** When true the content will be excluded from recommendations */
  excludeFromRecommendations?: InputMaybe<Scalars['Boolean']>;
  /** If true the content is family friendly */
  familyFriendly?: InputMaybe<Scalars['Boolean']>;
  /** The foreign key to the media table to the feature media */
  featureMediaId?: InputMaybe<Scalars['ID']>;
  /** Optional filter type to include this content as a filter option */
  filterType?: InputMaybe<Scalars['String']>;
  /** The primary identifier for this record */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the instructor in the video */
  instructor?: InputMaybe<Scalars['String']>;
  /** The language of this content */
  language?: InputMaybe<Scalars['String']>;
  /** The path part of a url which matches this content */
  path?: InputMaybe<Scalars['String']>;
  /** PM people list */
  peopleListId?: InputMaybe<Scalars['String']>;
  /** The foreign key to the media table to the preview media */
  previewMediaId?: InputMaybe<Scalars['ID']>;
  /** The language of content that was used to create all of the translations */
  primaryLanguage?: InputMaybe<Scalars['String']>;
  /** The name of producer of the video */
  producer?: InputMaybe<Scalars['String']>;
  /** The product type identifier in UI rendering */
  productType?: InputMaybe<Scalars['String']>;
  /** The production status */
  productionStatus?: InputMaybe<Scalars['String']>;
  /** True if the video is published */
  published?: InputMaybe<Scalars['Boolean']>;
  /** The date the content was published to allow sorting by language */
  publishedAtDate?: InputMaybe<Scalars['DateTime']>;
  /** The series season number */
  seasonNumber?: InputMaybe<Scalars['Int']>;
  /** The SEO canonical url */
  seoCanonicalUrl?: InputMaybe<Scalars['String']>;
  /** The SEO short description in the given language */
  seoDescription?: InputMaybe<Scalars['String']>;
  /** The SEO keywords in the given language */
  seoKeywords?: InputMaybe<Scalars['String']>;
  /** The SEO no follow attribute */
  seoRobotsNoFollow?: InputMaybe<Scalars['Boolean']>;
  /** The SEO no index attribute */
  seoRobotsNoIndex?: InputMaybe<Scalars['Boolean']>;
  /** The SEO title of this video in the given language */
  seoTitle?: InputMaybe<Scalars['String']>;
  /** The share URL for this content, constructed based on content policy shareAllowed setting */
  shareUrl?: InputMaybe<Scalars['String']>;
  /** The short description in the given language */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** The format of the long description (null = plain text) */
  shortDescriptionFormat?: InputMaybe<Scalars['String']>;
  /** The studio where the video was filmed */
  studio?: InputMaybe<Scalars['String']>;
  /** The third party description in the given language */
  thirdPartyDescription?: InputMaybe<Scalars['String']>;
  /** The title of this video in the given language */
  title?: InputMaybe<Scalars['String']>;
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: InputMaybe<Scalars['String']>;
  /** A human readable id that is unique for all content */
  titleId?: InputMaybe<Scalars['String']>;
  /** The date the content was unpublished */
  unpublishedAt?: InputMaybe<Scalars['DateTime']>;
  /** The date the row was last updated */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** The weight when ordering in lists */
  weight?: InputMaybe<Scalars['Int']>;
  /** The name of the video */
  writer?: InputMaybe<Scalars['String']>;
};

/** Content link payload for component rendering. */
export type ContentLinkDocument = {
  __typename?: 'ContentLinkDocument';
  contentId: Scalars['Int'];
  contentType: Scalars['String'];
  path: Scalars['String'];
  title: Scalars['String'];
};

/** Content list criteria */
export type ContentListCriteria = {
  __typename?: 'ContentListCriteria';
  /** The content linked to this content list criteria */
  content?: Maybe<Array<Maybe<Content>>>;
  /** The content filter set linked to this content list criteria */
  contentFilterSet?: Maybe<ContentFilterSet>;
  /** The content content id i.e. all translations of this content share the same content.content_id */
  contentId?: Maybe<Scalars['Int']>;
  /** The content content type i.e. video, series, etc. */
  contentType?: Maybe<Scalars['String']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** How content list should be filtered by the content set */
  criteria?: Maybe<ContentListCriteriaCriteria>;
  /** The primary key for this record */
  id?: Maybe<Scalars['ID']>;
  /** The language for to match for the criteria */
  language?: Maybe<Scalars['String']>;
  /** How should the content be sorted */
  sort?: Maybe<Scalars['String']>;
  /** A human readable id that is identifies the content in a title group e.g. content.titleGroupId */
  titleGroupId?: Maybe<Scalars['String']>;
  /** A human readable id that is unique for all content e.g. content.titleId */
  titleId?: Maybe<Scalars['String']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/** Content list criteria */
export type ContentListCriteriaContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** One content list criteria row as input */
export type ContentListCriteriaCreateInput = {
  /** The content content id i.e. all translations of this content share the same content.content_id */
  contentId?: InputMaybe<Scalars['Int']>;
  /** The content content type i.e. video, series, etc. */
  contentType?: InputMaybe<Scalars['String']>;
  /** When the row was created */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** How content list should be filtered by the content set */
  criteria?: InputMaybe<ContentListCriteriaCriteriaInput>;
  /** The primary key for this record */
  id?: InputMaybe<Scalars['ID']>;
  /** The language for to match for the criteria */
  language?: InputMaybe<Scalars['String']>;
  /** How should the content be sorted */
  sort?: InputMaybe<Scalars['String']>;
  /** A human readable id that is identifies the content in a title group e.g. content.titleGroupId */
  titleGroupId?: InputMaybe<Scalars['String']>;
  /** A human readable id that is unique for all content e.g. content.titleId */
  titleId?: InputMaybe<Scalars['String']>;
  /** When the row was last updated */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Content list criteria criteria to be applied to content when filtering */
export type ContentListCriteriaCriteria = {
  __typename?: 'ContentListCriteriaCriteria';
  /** Criteria to apply when there are no content filters are specified with the content filter set */
  all?: Maybe<Array<Maybe<ContentListCriteriaCriteriaItem>>>;
  /** Criteria to apply when any content filters are specified with the content filter set */
  filtered?: Maybe<Array<Maybe<ContentListCriteriaCriteriaItem>>>;
};

/** One Content list criteria criteria */
export type ContentListCriteriaCriteriaInput = {
  /** Criteria to apply when there are no content filters are specified with the content filter set */
  all?: InputMaybe<Array<InputMaybe<ContentListCriteriaCriteriaItemInput>>>;
  /** Criteria to apply when any content filters are specified with the content filter set */
  filtered?: InputMaybe<Array<InputMaybe<ContentListCriteriaCriteriaItemInput>>>;
};

/** Content list criteria criteria item to be applied to content when filtering */
export type ContentListCriteriaCriteriaItem = {
  __typename?: 'ContentListCriteriaCriteriaItem';
  /** The content content type i.e. video, series, etc. */
  contentType?: Maybe<Scalars['String']>;
  /** The content product type i.e. episode, segment, single, etc. */
  productType?: Maybe<Scalars['String']>;
};

/** One content list criteria criteria item */
export type ContentListCriteriaCriteriaItemInput = {
  /** The content content type i.e. video, series, etc. */
  contentType?: InputMaybe<Scalars['String']>;
  /** The content product type i.e. episode, segment, single, etc. */
  productType?: InputMaybe<Scalars['String']>;
};

/** One content list criteria row as input */
export type ContentListCriteriaDeleteInput = {
  /** The primary key for this record */
  id?: InputMaybe<Scalars['ID']>;
};

/** Content list criteria list response */
export type ContentListCriteriaListResponse = {
  __typename?: 'ContentListCriteriaListResponse';
  /** A list of content list criteria */
  contentListCriteria?: Maybe<Array<Maybe<ContentListCriteria>>>;
};

/** Mutation response for a content list mutation */
export type ContentListCriteriaMutationResponse = {
  __typename?: 'ContentListCriteriaMutationResponse';
  /** The content list criteria that was mutated */
  contentListCriteria?: Maybe<ContentListCriteria>;
};

/** Content list criteria id where input type */
export type ContentListCriteriaWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** Content list criteria where conditions to filter rows */
export type ContentListCriteriaWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<ContentListCriteriaWhereIdInput>;
  /** The id field where clause */
  titleGroupId?: InputMaybe<ContentListCriteriaWhereTitleGroupIdInput>;
};

/** Content list criteria title group id where input type */
export type ContentListCriteriaWhereTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Content list response */
export type ContentListResponse = {
  __typename?: 'ContentListResponse';
  /** A list of content */
  content?: Maybe<Array<Maybe<Content>>>;
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** Debug information from the resolver */
  debug?: Maybe<Scalars['JSON']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
  /** Get a overview text of the content list */
  overview?: Maybe<DocumentAnswer>;
};


/** Content list response */
export type ContentListResponseOverviewArgs = {
  context?: InputMaybe<ContentOverviewContext>;
  format?: InputMaybe<ContentTextFormat>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ContentNotFilterInput = {
  /** The content id to exclude */
  contentId?: InputMaybe<Scalars['Int']>;
  /** The content type to exclude */
  contentType?: InputMaybe<Scalars['String']>;
};

/** The type of summarization to perform which determines the text summarization style */
export enum ContentOverviewContext {
  /** The default summarization style */
  Default = 'DEFAULT',
  /** The summarization style for a user search query */
  UserSearchQuery = 'USER_SEARCH_QUERY'
}

/** Format for the content path: relative path only or full URL including domain */
export enum ContentPathFormat {
  /** The full URL including domain (e.g. servers.webapp + path) */
  Full = 'FULL',
  /** The path segment only (e.g. video/slug). Default. */
  Relative = 'RELATIVE'
}

/** A playlist entry in a content-to-playlist mapping */
export type ContentPlaylistEntry = {
  __typename?: 'ContentPlaylistEntry';
  /** Total number of items in the playlist */
  itemCount?: Maybe<Scalars['Int']>;
  /** The playlist UUID */
  playlistId: Scalars['ID'];
  /** The playlist name */
  playlistName?: Maybe<Scalars['String']>;
};

/** Mapping of a content item to the playlists that contain it */
export type ContentPlaylistMapping = {
  __typename?: 'ContentPlaylistMapping';
  /** The content ID */
  contentId: Scalars['Int'];
  /** Playlists containing this content (public/anonymous only, excludes system playlists) */
  playlists: Array<ContentPlaylistEntry>;
};

/**
 * Content policy defines comprehensive access control, sharing permissions, and availability rules for content.
 *
 * Content policies are the central mechanism for controlling who can access content and under what conditions.
 * Each content item is linked to a content policy via the contentPolicyPolicyId field.
 *
 * ACCESS CONTROL RULES (evaluated in order of precedence):
 *
 * 1. User Role Access (HIGHEST PRECEDENCE):
 *    - If userRoleAllowed is true, the user has access regardless of all other rules
 *    - Roles like EDITOR, SITE_ADMIN, CUSTOMER_SERVICE bypass all other restrictions
 *    - This takes precedence over subscriptions, countries, and all other checks
 *
 * 2. Country/Geographic Restrictions:
 *    - availability field controls geographic access:
 *      * Worldwide: Content available everywhere
 *      * Only In: Content only available in countries list
 *      * Blocked: Content blocked in countries list
 *    - countryAllowed indicates if user's country (from authentication or request) is allowed
 *    - Uses user's authenticated country if available, otherwise falls back to request country
 *
 * 3. Client Attributes:
 *    - availabilityClientAttributes controls client-based restrictions:
 *      * No restrictions: All clients can access
 *      * Only with: Only clients with attributes in clientAttributes list can access
 *      * Blocked with: Clients with attributes in clientAttributes list are blocked
 *    - clientAttributesAllowed indicates if user's client attributes are allowed
 *
 * 4. Subscription Plans:
 *    - optionIds contains the list of subscription plan IDs that allow access
 *    - subscriptionsAllowed indicates if user's active subscriptions match any allowed plan
 *    - Users must have at least one matching subscription to access (unless content is free)
 *
 * 5. Ecommerce Entitlements:
 *    - ecommercePurchaseAllowed indicates if user has purchased this specific content
 *    - Can be used for pay-per-view or one-time purchase content
 *
 * 6. Free Content:
 *    - isFreeAllowed indicates if content is free (no subscription required)
 *    - Free content is accessible to all users (subject to country/client restrictions)
 *
 * FINAL ACCESS DECISION:
 * - allowed: True when user has access based on ALL applicable rules
 * - allowedWithEntitlementsMatch: True when ecommercePurchaseAllowed OR subscriptionsAllowed is true
 * - User role access (userRoleAllowed) takes precedence over all other checks
 *
 * SHARING:
 * - shareAllowed: Whether the content can be shared via shareUrl
 * - Controls if content can be shared on social media or via direct links
 *
 * Use the accessCheck field to evaluate access for the current request. The check considers all rules
 * and returns detailed information about which checks passed or failed.
 *
 * AUTHENTICATION-BASED CONTENT FILTERING:
 * When querying content with applyContentPolicy=true, the following authentication properties are used
 * to automatically filter content based on content policy rules:
 *
 * 1. authentication.country (or request country if not authenticated):
 *    - Matched against policy.availability and policy.countries
 *    - Filters out content not available in user's country
 *    - Used to enforce geographic restrictions
 *
 * 2. authentication.clientAttributes:
 *    - Matched against policy.availabilityClientAttributes and policy.clientAttributes
 *    - Filters content based on client device/platform restrictions
 *    - Used to restrict content to specific client types
 *
 * 3. authentication.subscriptions:
 *    - Matched against policy.optionIds
 *    - Filters content to only show what user's subscription allows
 *    - Free content (optionIds includes 0) is shown to all users
 *
 * 4. authentication.roles:
 *    - Checked for special privileges (EDITOR, SITE_ADMIN, etc.)
 *    - Users with privileged roles bypass all other restrictions
 *    - Used to allow staff/admin access to all content
 *
 * These authentication properties are automatically extracted from the request and applied when
 * applyContentPolicy=true is used in content queries (contentList, contentSeries, contentEpisodes, etc.).
 */
export type ContentPolicy = {
  __typename?: 'ContentPolicy';
  /** Access check for the current request against this content policy */
  accessCheck?: Maybe<ContentPolicyAccessCheck>;
  /** Content policy availability of countries such as worldwide, only in or blocked */
  availability?: Maybe<Scalars['Int']>;
  /** Content policy availability of client attributes such as no restrictions, only with or blocked with */
  availabilityClientAttributes?: Maybe<Scalars['Int']>;
  /** The client attributes to apply in combination with availability_client_attributes ordered ASC */
  clientAttributes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The content associated with this content policy */
  content?: Maybe<Array<Maybe<Content>>>;
  /** The countries to apply in combination with availability ordered ASC */
  countries?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Name of the policy group */
  name?: Maybe<Scalars['String']>;
  /** The subscriptions which are allowed for this content policy ordered ASC */
  optionIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** The id for this content policy group */
  policyId?: Maybe<Scalars['ID']>;
  /** True if this content policy allows sharing */
  shareAllowed?: Maybe<Scalars['Boolean']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * Access check results for the current request against a content policy.
 *
 * This type provides detailed information about whether a user can access content based on
 * the content policy rules. Use this to determine access, display appropriate UI, and
 * understand why access was granted or denied.
 *
 * EVALUATION ORDER (precedence matters):
 * 1. userRoleAllowed (HIGHEST) - If true, user has access regardless of all other checks
 * 2. countryAllowed - Geographic restrictions
 * 3. clientAttributesAllowed - Client-based restrictions
 * 4. subscriptionsAllowed - Subscription plan matching
 * 5. ecommercePurchaseAllowed - One-time purchase entitlements
 * 6. isFreeAllowed - Free content access
 *
 * FINAL DECISION:
 * - allowed: True when user passes ALL applicable checks (or userRoleAllowed is true)
 * - allowedWithEntitlementsMatch: True when user has either subscription OR purchase entitlement
 */
export type ContentPolicyAccessCheck = {
  __typename?: 'ContentPolicyAccessCheck';
  /**
   * True when the request is allowed access by the content policy checks applied using all rules.
   * This is the primary field to check for access. If true, the user can access the content.
   * If false, check the individual allowed fields to understand which restriction applies.
   *
   * NOTE: userRoleAllowed=true will make this true regardless of other checks.
   */
  allowed?: Maybe<Scalars['Boolean']>;
  /**
   * True when either ecommercePurchaseAllowed OR subscriptionsAllowed is true.
   * Useful for determining if user has any form of entitlement (subscription or purchase).
   */
  allowedWithEntitlementsMatch?: Maybe<Scalars['Boolean']>;
  /**
   * True when the user's client attributes match the content policy requirements.
   * Based on availabilityClientAttributes and clientAttributes fields in the policy.
   */
  clientAttributesAllowed?: Maybe<Scalars['Boolean']>;
  /**
   * True when the user's country is allowed by the content policy.
   * Uses authenticated country if available, otherwise request country.
   * Based on availability and countries fields in the policy.
   */
  countryAllowed?: Maybe<Scalars['Boolean']>;
  /**
   * True when the user has purchased this specific content via ecommerce.
   * Used for pay-per-view or one-time purchase content.
   */
  ecommercePurchaseAllowed?: Maybe<Scalars['Boolean']>;
  /**
   * True when the content policy indicates the content is free (no subscription required).
   * Free content is accessible to all users (subject to country/client restrictions).
   */
  isFreeAllowed?: Maybe<Scalars['Boolean']>;
  /**
   * True when the user's active subscriptions match any of the allowed subscription plans.
   * Based on optionIds field in the policy. User must have at least one matching subscription.
   */
  subscriptionsAllowed?: Maybe<Scalars['Boolean']>;
  /**
   * True when the user's role allows access to the policy.
   * THIS TAKES PRECEDENCE OVER ALL OTHER CHECKS.
   * If true, the user has access regardless of subscriptions, countries, or other restrictions.
   * Roles like EDITOR, SITE_ADMIN, CUSTOMER_SERVICE typically have this privilege.
   */
  userRoleAllowed?: Maybe<Scalars['Boolean']>;
  /**
   * The values used for the access check evaluation.
   * Contains the actual country, subscriptions, client attributes, and roles that were evaluated.
   */
  values?: Maybe<ContentPolicyAccessCheckValues>;
};

/**
 * Access check values to evaluate rules.
 *
 * These values come from the request authentication and are used to evaluate content policy access.
 * The authentication properties are automatically extracted from the request and used to filter content
 * when applyContentPolicy is true on content queries.
 *
 * AUTHENTICATION PROPERTIES USED FOR FILTERING:
 * - country: User's country code (from authentication, falls back to request country if not authenticated)
 * - clientAttributes: Array of client attributes (e.g., device type, platform) from authentication
 * - subscriptions: Array of subscription plan IDs the user is subscribed to
 * - roles: Array of user role IDs (e.g., EDITOR, SITE_ADMIN) that may bypass restrictions
 *
 * These properties are used to match against content policy rules:
 * - country is matched against policy.availability and policy.countries
 * - clientAttributes are matched against policy.availabilityClientAttributes and policy.clientAttributes
 * - subscriptions are matched against policy.optionIds
 * - roles are checked for special access privileges
 */
export type ContentPolicyAccessCheckValues = {
  __typename?: 'ContentPolicyAccessCheckValues';
  /**
   * The user authentication client attributes (takes precedence for clientAttributesAllowed check).
   * Used to filter content based on client-based restrictions in the content policy.
   */
  clientAttributes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * The user authentication country (takes precedence for countryAllowed check).
   * Used to filter content based on geographic restrictions in the content policy.
   * Falls back to requestCountry if not available from authentication.
   */
  country?: Maybe<Scalars['String']>;
  /**
   * The request country used if user authentication country is undefined.
   * Used as a fallback when determining geographic access restrictions.
   */
  requestCountry?: Maybe<Scalars['String']>;
  /**
   * The user authentication roles (takes precedence for userRoleAllowed check).
   * Used to determine if user has special access privileges that bypass other restrictions.
   */
  roles?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /**
   * The user authentication subscriptions (takes precedence for subscriptionsAllowed check).
   * Used to filter content based on subscription plan requirements in the content policy.
   */
  subscriptions?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

/** Content policy list response */
export type ContentPolicyListResponse = {
  __typename?: 'ContentPolicyListResponse';
  /** A list of content reference */
  contentPolicies?: Maybe<Array<Maybe<ContentPolicy>>>;
  /** Total number of rows of content policies found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
};

/** Content content id where input type */
export type ContentPolicyWhereContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['Int']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Content id where input type */
export type ContentPolicyWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Content policy where conditions to filter rows */
export type ContentPolicyWhereInput = {
  /** The id field where clause */
  policyId?: InputMaybe<ContentPolicyWherePolicyIdInput>;
};

/** Content content policy type where input type */
export type ContentPolicyWherePolicyIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Content provider */
export type ContentProvider = {
  __typename?: 'ContentProvider';
  /** The content associated with this content provider */
  content?: Maybe<Content>;
  /** The id for this content provider content.id */
  contentId?: Maybe<Scalars['ID']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Metadata specifically for the content provider, generally data that does not fit the content model, but is used by the provider */
  metadata?: Maybe<Scalars['JSON']>;
  /** The content provider */
  provider?: Maybe<ContentProviderProviders>;
  /** The provider hash value of the data on the provider */
  providerHash?: Maybe<Scalars['String']>;
  /** The provider hash algorithm used to produce the hash value */
  providerHashType?: Maybe<ContentProviderHashType>;
  /** The content provider key for this content */
  providerKey?: Maybe<Scalars['String']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/** Content provider */
export type ContentProviderContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Content provider create */
export type ContentProviderCreateByContentIdInput = {
  /** The id for this content provider */
  contentId?: InputMaybe<Scalars['ID']>;
  /** Metadata specifically for the content provider, generally data that does not fit the content model, but is used by the provider the mutation will full replace the current value if defined */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** The content provider */
  provider?: InputMaybe<ContentProviderProviders>;
  /** The provider hash value of the data on the provider */
  providerHash?: InputMaybe<Scalars['String']>;
  /** The provider hash algorithm used to produce the hash value */
  providerHashType?: InputMaybe<ContentProviderHashType>;
  /** The content provider key for this content */
  providerKey?: InputMaybe<Scalars['String']>;
};

/** Content delete provider delete by content id */
export type ContentProviderDeleteByContentIdInput = {
  /** The id for this content provider */
  contentId?: InputMaybe<Scalars['ID']>;
};

/** Content provider providers */
export enum ContentProviderHashType {
  /** MD5 */
  Md5 = 'MD5'
}

/** Content provider list response */
export type ContentProviderListResponse = {
  __typename?: 'ContentProviderListResponse';
  /** A list of content reference */
  contentProviders?: Maybe<Array<Maybe<ContentProvider>>>;
};

/** Content provider mutation response */
export type ContentProviderMutationResponse = {
  __typename?: 'ContentProviderMutationResponse';
  /** The content provider which was mutated */
  contentProvider?: Maybe<ContentProvider>;
};

/** Content provider providers */
export enum ContentProviderProviders {
  /** Brightcove AI Content Multiplier clip metadata */
  BrightcoveAiContentMultiplier = 'BRIGHTCOVE_AI_CONTENT_MULTIPLIER',
  /** Gaia Bonus */
  GaiaBonus = 'GAIA_BONUS',
  /** Gaia Worpress */
  GaiaWordpress = 'GAIA_WORDPRESS',
  /** Shopify */
  Shopify = 'SHOPIFY',
  /** Yoga International */
  YogaInternational = 'YOGA_INTERNATIONAL'
}

/** Content delete provider update by content id */
export type ContentProviderUpdateByContentIdInput = {
  /** The id for this content provider */
  contentId?: InputMaybe<Scalars['ID']>;
  /** Metadata specifically for the content provider, generally data that does not fit the content model, but is used by the provider the mutation will full replace the current value if defined */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** The content provider */
  provider?: InputMaybe<ContentProviderProviders>;
  /** The provider hash value of the data on the provider */
  providerHash?: InputMaybe<Scalars['String']>;
  /** The provider hash algorithm used to produce the hash value */
  providerHashType?: InputMaybe<ContentProviderHashType>;
  /** The content provider key for this content */
  providerKey?: InputMaybe<Scalars['String']>;
};

/** Content provider where conditions to filter rows */
export type ContentProviderWhereInput = {
  /** The content id field where clause */
  contentId?: InputMaybe<ContentProvidersWhereContentIdInput>;
  /** Metadata JSON input */
  metadata?: InputMaybe<ContentProvidersWhereMetadataInput>;
  /** The provider field where clause */
  provider?: InputMaybe<ContentProvidersWhereProviderInput>;
  /** The provider key field where clause */
  providerKey?: InputMaybe<ContentProvidersWhereProviderKeyInput>;
};

/** Content id where input type */
export type ContentProvidersWhereContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Content provider where input type */
export type ContentProvidersWhereMetadataInput = {
  /** Does the field contain the values */
  contains?: InputMaybe<Scalars['JSON']>;
};

/** Content provider where input type */
export type ContentProvidersWhereProviderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Content provider where input type */
export type ContentProvidersWhereProviderKeyInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Content reference */
export type ContentReference = {
  __typename?: 'ContentReference';
  /** The content linked from this content reference */
  contentFrom?: Maybe<Array<Maybe<Content>>>;
  /** The content reference type */
  contentReferenceType?: Maybe<ContentReferenceType>;
  /** A foreign key to the content_reference_types which defines the relationship between the parent and the child content */
  contentReferenceTypesId?: Maybe<Scalars['ID']>;
  /** The content linked to this content reference */
  contentTo?: Maybe<Array<Maybe<Content>>>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The content_id field on the content table where the reference originates */
  fromContentContentId?: Maybe<Scalars['Int']>;
  /** The content_type field on the content table where the reference originates */
  fromContentContentType?: Maybe<Scalars['String']>;
  /** A human readable id that is identifies the content in a title group for the from content */
  fromTitleGroupId?: Maybe<Scalars['String']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** The label for this content reference in the requested language (only applicable to course-module-practice and course-module-other types) */
  label?: Maybe<Scalars['String']>;
  /** The field to sort by */
  sortKey?: Maybe<Scalars['Int']>;
  /** The content_type field on the content table where the reference points */
  toContentContentId?: Maybe<Scalars['Int']>;
  /** The content_type field on the content table where the reference points */
  toContentContentType?: Maybe<Scalars['String']>;
  /** A human readable id that is identifies the content in a title group for the to content */
  toTitleGroupId?: Maybe<Scalars['String']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/** Content reference */
export type ContentReferenceContentFromArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Content reference */
export type ContentReferenceContentToArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Content reference */
export type ContentReferenceLabelArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Content references allowed row */
export type ContentReferenceAllowed = {
  __typename?: 'ContentReferenceAllowed';
  /** The content id field on the content table */
  contentId?: Maybe<Scalars['Int']>;
  /** The content reference type associated with this row */
  contentReferenceType?: Maybe<ContentReferenceType>;
  /** The content reference types id field on the content table where the reference points */
  contentReferenceTypesId?: Maybe<Scalars['Int']>;
  /** The content type field on the content table */
  contentType?: Maybe<Scalars['String']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
};

/** Single content reference as create input */
export type ContentReferenceCreateInput = {
  /** The from_content_content_id field */
  fromContentContentId: Scalars['Int'];
  /** The from_content_content_type field */
  fromContentContentType: Scalars['String'];
  /** The field to sort by */
  sortKey?: InputMaybe<Scalars['Int']>;
  /** The to_content_content_id field */
  toContentContentId: Scalars['Int'];
  /** The to_content_content_type field */
  toContentContentType: Scalars['String'];
  /** The content_reference_types.type field */
  type: Scalars['String'];
};

/** Return type for content reference create many. */
export type ContentReferenceCreateManyResponse = {
  __typename?: 'ContentReferenceCreateManyResponse';
  /** The content references that were updated */
  contentReferences?: Maybe<Array<Maybe<ContentReference>>>;
};

/** Return type for content reference create. */
export type ContentReferenceCreateResponse = {
  __typename?: 'ContentReferenceCreateResponse';
  /** The content reference that was updated */
  contentReference?: Maybe<ContentReference>;
};

/** Single content reference as delete input */
export type ContentReferenceDeleteInput = {
  /** The id of the content reference to delete */
  id: Scalars['ID'];
};

/** Return type for content reference delete. */
export type ContentReferenceDeleteResponse = {
  __typename?: 'ContentReferenceDeleteResponse';
  /** The content reference that was deleted */
  contentReference?: Maybe<ContentReference>;
};

/** Content reference type */
export type ContentReferenceType = {
  __typename?: 'ContentReferenceType';
  /** The date and time the record was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** The type of the reference between the content */
  type?: Maybe<Scalars['String']>;
  /** The date and time the record was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Content reference types list response */
export type ContentReferenceTypesListResponse = {
  __typename?: 'ContentReferenceTypesListResponse';
  /** A list of content reference types */
  contentReferenceTypes?: Maybe<Array<Maybe<ContentReferenceType>>>;
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
};

/** Content reference where input type */
export type ContentReferenceTypesWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Content reference types where conditions to filter rows */
export type ContentReferenceTypesWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<ContentReferenceTypesWhereIdInput>;
};

/** Content reference where fromContentContentId input type */
export type ContentReferenceWhereFromContentContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Content reference where fromContentContentType input type */
export type ContentReferenceWhereFromContentContentTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Content reference where fromTitleGroupId input type */
export type ContentReferenceWhereFromTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Content reference where id input type */
export type ContentReferenceWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Content reference where toContentContentId input type */
export type ContentReferenceWhereToContentContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Content reference where toContentContentType input type */
export type ContentReferenceWhereToContentContentTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Content reference where toTitleGroupId input type */
export type ContentReferenceWhereToTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Content list response */
export type ContentReferencesAllowedResponse = {
  __typename?: 'ContentReferencesAllowedResponse';
  /** A list of content reference */
  contentReferencesAllowed?: Maybe<Array<Maybe<ContentReferenceAllowed>>>;
};

export type ContentReferencesAllowedWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Content references allowed where input */
export type ContentReferencesAllowedWhereInput = {
  /** Filter rows by id */
  id?: InputMaybe<ContentReferencesAllowedWhereIdInput>;
};

/** Content reference list response */
export type ContentReferencesListResponse = {
  __typename?: 'ContentReferencesListResponse';
  /** A list of content reference */
  contentReferences?: Maybe<Array<Maybe<ContentReference>>>;
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
};

/** Content reference where conditions to filter rows */
export type ContentReferencesWhereInput = {
  /** The fromContentContentId field where clause */
  fromContentContentId?: InputMaybe<ContentReferenceWhereFromContentContentIdInput>;
  /** The fromContentContentType field where clause */
  fromContentContentType?: InputMaybe<ContentReferenceWhereFromContentContentTypeInput>;
  /** The fromTitleGroupId field where clause */
  fromTitleGroupId?: InputMaybe<ContentReferenceWhereFromTitleGroupIdInput>;
  /** The id field where clause */
  id?: InputMaybe<ContentReferenceWhereIdInput>;
  /** The toContentId field where clause */
  toContentContentId?: InputMaybe<ContentReferenceWhereToContentContentIdInput>;
  /** The toContentType field where clause */
  toContentContentType?: InputMaybe<ContentReferenceWhereToContentContentTypeInput>;
  /** The toTitleGroupId field where clause */
  toTitleGroupId?: InputMaybe<ContentReferenceWhereToTitleGroupIdInput>;
};

/**
 * Embeddings tied to this content (direct link or feature media): chunk-level `documentText` plus vectors for retrieval.
 *
 * **When to use this shape:** Semantic search over passages, RAG with citations, or generating a **fresh** overview via `summarizationText` (on-demand LLM over the loaded chunks—not the same as title-level pooled vectors from `documentAbstractList` / `document_abstracts`, which hold offline sums/averages of chunk embeddings).
 *
 * **Typical flow:** Load `documentEmbeddings` (optionally with `query` to rank by relevance), then optionally request `summarizationText` for a condensed narrative of those chunks.
 */
export type ContentRelatedDocumentEmbeddings = {
  __typename?: 'ContentRelatedDocumentEmbeddings';
  /** Chunk-level rows: text spans, embedding vectors, optional cue timing (`positionStart`/`positionEnd`), and metadata for provenance. Use for quoting sources, similarity search, or feeding `summarizationText`. */
  documentEmbeddings?: Maybe<Array<Maybe<DocumentEmbedding>>>;
  /**
   * On-demand LLM summary of the `documentEmbeddings` returned alongside it (map–reduce style over chunk text). Requires server `googleGenAiApiKey` for the summarization model.
   *
   * **Contrast:** For a **persisted**, worker-built synopsis and embedding per **document**, query `documentAbstractList` (`document_abstracts`) instead of this on-demand field.
   */
  summarizationText?: Maybe<Scalars['String']>;
};

/** Content related type */
export enum ContentRelatedType {
  /** Content that is linked using content references types for similar */
  References = 'REFERENCES',
  /** Content that is similar across mutliple data points */
  Similar = 'SIMILAR'
}

/** Get the GraphQL Types  */
export type ContentSearch = {
  __typename?: 'ContentSearch';
  /** D6 nid also the content group id i.e. all translations of this content share the same content_id */
  contentId?: Maybe<Scalars['Int']>;
  /** type of content (i.e. series, video, etc.) */
  contentType?: Maybe<Scalars['String']>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The description fuzzy search text */
  fuzzyDesc?: Maybe<Scalars['String']>;
  /** The words fuzzy search text */
  fuzzyWords?: Maybe<Scalars['String']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** The language associated with the search content */
  language?: Maybe<Scalars['String']>;
  /** The metaphone text to search for this content ID (typically used for names) */
  metaphoneText?: Maybe<Scalars['String']>;
  /** The (non-metaphone) text to search for this content ID, weighted by search params */
  searchText?: Maybe<Scalars['String']>;
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: Maybe<Scalars['String']>;
  /** The title of this video in the given language with NO accented chars */
  titleUnaccented?: Maybe<Scalars['String']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Natural-language search sub-pipeline legs for `contentList` (omit or empty = run all). */
export enum ContentSearchLeg {
  /** PostgreSQL full-text hits used to bump ranks for rows already in the merged result set. */
  Fts = 'FTS',
  /** Fuzzy SQL match on content fields for broader lexical recall. */
  Fuzzy = 'FUZZY',
  /** Fuzzy match on titles only (small capped set of title variants). */
  FuzzyTitle = 'FUZZY_TITLE',
  /** Chunk-level embedding similarity over document embeddings (semantic transcript-like match). */
  Nls = 'NLS',
  /** Embedding similarity over document abstracts / summaries. */
  Summary = 'SUMMARY',
  /** Case-insensitive exact match on the unaccented title (high-precision direct hits). */
  Title = 'TITLE'
}

/** Media asset response */
export type ContentSearchListResponse = {
  __typename?: 'ContentSearchListResponse';
  /** A list of media */
  contentSearch?: Maybe<Array<Maybe<ContentSearch>>>;
};

/** GraphQL content server where input  */
export type ContentSearchWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** The where conditions to filter rows */
export type ContentSearchWhereInput = {
  id?: InputMaybe<ContentSearchWhereIdInput>;
};

/** User entitlment */
export type ContentSet = {
  __typename?: 'ContentSet';
  /** The content set id */
  contentSetId?: Maybe<Scalars['ID']>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** When true this is the default content set */
  defaultContentSet?: Maybe<Scalars['Boolean']>;
  /** Description of this content set */
  description?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['ID']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** User info policy list response */
export type ContentSetListResponse = {
  __typename?: 'ContentSetListResponse';
  /** A list of userInfo reference */
  contentSets?: Maybe<Array<Maybe<ContentSet>>>;
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
};

/** Content set id where input type */
export type ContentSetListWhereContentSetIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** Content set id where input type */
export type ContentSetListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** User info policy where conditions to filter rows */
export type ContentSetListWhereInput = {
  /** The conten set id field where clause */
  contentSetId?: InputMaybe<ContentSetListWhereContentSetIdInput>;
  /** The id field where clause */
  id?: InputMaybe<ContentSetListWhereIdInput>;
};

/** Content text format options */
export enum ContentTextFormat {
  /** Format the text as HTML */
  Html = 'HTML',
  /** Format the text as markdown */
  Markdown = 'MARKDOWN',
  /** Format the text as plain text */
  PlainText = 'PLAIN_TEXT'
}

/** Return type for content update */
export type ContentUpdateResponse = {
  __typename?: 'ContentUpdateResponse';
  /** The content that was updated */
  content?: Maybe<Content>;
};

/** Content bundle where input type */
export type ContentWhereBundleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Is one of the values equal to the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Content content id where input type */
export type ContentWhereContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['Int']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Content Policy Policy Id where input type */
export type ContentWhereContentPolicyPolicyIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Is one of the values equal to the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Content content type where input type */
export type ContentWhereContentTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Content filter type where input type */
export type ContentWhereFilterTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Is the value a substring of the field */
  like?: InputMaybe<Scalars['String']>;
};

/** Content id where input type */
export type ContentWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Content where conditions to filter rows */
export type ContentWhereInput = {
  /** The content bundle */
  bundle?: InputMaybe<ContentWhereBundleInput>;
  /** The content content id field where clause */
  contentId?: InputMaybe<ContentWhereContentIdInput>;
  /** The Content Policy Policy Id of the content */
  contentPolicyPolicyId?: InputMaybe<ContentWhereContentPolicyPolicyIdInput>;
  /** The content content type field where clause */
  contentType?: InputMaybe<ContentWhereContentTypeInput>;
  /** The content filter type(s) using 'like' */
  filterType?: InputMaybe<ContentWhereFilterTypeInput>;
  /** The id field where clause */
  id?: InputMaybe<ContentWhereIdInput>;
  /** The requested language of the content */
  language?: InputMaybe<ContentWhereLanguageInput>;
  /** The content path */
  path?: InputMaybe<ContentWherePathInput>;
  /** The content is published */
  published?: InputMaybe<ContentWherePublishedInput>;
  /** The date the content was published */
  publishedAtDate?: InputMaybe<ContentWherePublishedAtDateInput>;
  /**
   * A query to filter content using search, use this with queryType to determine the type of search.
   * Search will consider the request authentication properties (country, clientAttributes, subscriptions)
   * to determine which content is available based on the content policy,
   * but does not filter based on the entire content policy which requires the applyContentPolicy flag to be true.
   */
  query?: InputMaybe<Scalars['String']>;
  /** Which search type to perform on the query. */
  queryType?: InputMaybe<ContentWhereQueryType>;
  /** The content title */
  title?: InputMaybe<ContentWhereTitleInput>;
  /** The content title group id field where clause */
  titleGroupId?: InputMaybe<ContentWhereTitleGroupIdInput>;
  /** The date the content was last updated */
  updatedAt?: InputMaybe<ContentWhereUpdatedAtInput>;
};

/** Content content language where input type */
export type ContentWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Content content path where input type */
export type ContentWherePathInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Is the value a case-insensitive substring of the field */
  ilike?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ContentWherePublishedAtDateInput = {
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']>;
};

export type ContentWherePublishedInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** The type of search to perform with the query */
export enum ContentWhereQueryType {
  /**
   * Run a full text search query
   * @deprecated Removed from contentList; use NATURAL_LANGUAGE_SEARCH. Sending this value returns a validation error.
   */
  FullTextSearch = 'FULL_TEXT_SEARCH',
  /** Run a natural language search query */
  NaturalLanguageSearch = 'NATURAL_LANGUAGE_SEARCH',
  /** Get recommended content for a user */
  RecommendedContent = 'RECOMMENDED_CONTENT'
}

/** Content content title group id where input type */
export type ContentWhereTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Content title where input type */
export type ContentWhereTitleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Is the value a case-insensitive substring of the field */
  ilike?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Is the value a substring of the field */
  like?: InputMaybe<Scalars['String']>;
};

/** Content updated at where input type */
export type ContentWhereUpdatedAtInput = {
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']>;
};

export type ConversationSearchResponse = {
  __typename?: 'ConversationSearchResponse';
  conversations: Array<ConversationSearchResult>;
  totalConversations: Scalars['Int'];
};

export type ConversationSearchResult = {
  __typename?: 'ConversationSearchResult';
  conversationId: Scalars['ID'];
  conversationTitle: Scalars['String'];
  highlightedTitle?: Maybe<Scalars['String']>;
  matchCount: Scalars['Int'];
  matchedMessages: Array<MessagePairSearchResult>;
};

export type CreateApiKeyInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  roleIds: Array<Scalars['Int']>;
  scope?: InputMaybe<Scalars['String']>;
  /** Target user (UUID). Omitted = current user. Admins may set any user. */
  userInfoUuid?: InputMaybe<Scalars['ID']>;
};

/** Create billing discount input */
export type CreateBillingDiscountInput = {
  /** The billing discount allowed for plan change */
  allowedForPlanChange?: InputMaybe<Scalars['Boolean']>;
  /** The billing discount amount discount */
  amountDiscount?: InputMaybe<Scalars['JSON']>;
  /** The billing discount available count */
  availableCount?: InputMaybe<Scalars['Int']>;
  /** The billing discount billing cycles */
  billingCycles?: InputMaybe<Scalars['Int']>;
  /** The billing discount code */
  code?: InputMaybe<Scalars['String']>;
  /** The billing discount countries */
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing discount countries operator */
  countriesOperator?: InputMaybe<InNotInOperator>;
  /** The billing discount currencies */
  currencies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing discount currencies operator */
  currenciesOperator?: InputMaybe<InNotInOperator>;
  /** Human-readable description for admins */
  description?: InputMaybe<Scalars['String']>;
  /** The billing discount ecommerce SKUs */
  ecommerceSkus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing discount ecommerce SKUs operator */
  ecommerceSkusOperator?: InputMaybe<InNotInOperator>;
  /** The billing discount enabled */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** The billing discount end date */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** The billing discount languages */
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing discount languages operator */
  languagesOperator?: InputMaybe<InNotInOperator>;
  /** The billing discount minimum price */
  minimumPrice?: InputMaybe<Scalars['JSON']>;
  /** The billing discount minimum trial segment price */
  minimumTrialSegmentPrice?: InputMaybe<Scalars['JSON']>;
  /** The billing discount percentage discount */
  percentageDiscount?: InputMaybe<Scalars['Float']>;
  /** The billing discount plan categories */
  planCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing discount plan categories operator */
  planCategoriesOperator?: InputMaybe<InNotInOperator>;
  /** The billing discount redemptions per user */
  redemptionsPerUser?: InputMaybe<Scalars['Int']>;
  /** The billing discount redemptions per user months */
  redemptionsPerUserMonths?: InputMaybe<Scalars['Int']>;
  /** The billing discount SKUs */
  skus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing discount SKUs operator */
  skusOperator?: InputMaybe<InNotInOperator>;
  /** The billing discount start date */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** When set, only these user_info.uid values may redeem the discount */
  uids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Create input for Billing Plan Grid */
export type CreateBillingPlanGridInput = {
  /** The billing plan grid billing product id in */
  billingProductIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** The billing plan grid billing product id not in */
  billingProductIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** The billing plan grid billing provider product id in */
  billingProviderProductIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** The billing plan grid billing provider product id not in */
  billingProviderProductIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** The billing plan grid country in */
  countryIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing plan grid country not in */
  countryNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing plan grid currency in */
  currencyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing plan grid currency not in */
  currencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether this plan grid is the default for the given page */
  defaultPageGrid: Scalars['Boolean'];
  /** The billing plan grid device type in */
  deviceTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing plan grid device type not in */
  deviceTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether the billing plan grid is enabled */
  enabled: Scalars['Boolean'];
  /** The billing plan grid end date */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** The best value plan in the plan grid for existing members */
  existingMemberBestValueBillingProviderProductId?: InputMaybe<Scalars['Int']>;
  /** The first plan in the plan grid for existing members */
  existingMemberBillingProviderProductId1: Scalars['Int'];
  /** The second plan in the plan grid for existing members */
  existingMemberBillingProviderProductId2?: InputMaybe<Scalars['Int']>;
  /** The third plan in the plan grid for existing members */
  existingMemberBillingProviderProductId3?: InputMaybe<Scalars['Int']>;
  /** The fourth plan in the plan grid for existing members */
  existingMemberBillingProviderProductId4?: InputMaybe<Scalars['Int']>;
  /** The billing plan grid language in */
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing plan grid language not in */
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The best value plan in the plan grid for new members */
  newMemberBestValueBillingProviderProductId?: InputMaybe<Scalars['Int']>;
  /** The first plan in the plan grid for new members */
  newMemberBillingProviderProductId1: Scalars['Int'];
  /** The second plan in the plan grid for new members */
  newMemberBillingProviderProductId2?: InputMaybe<Scalars['Int']>;
  /** The third plan in the plan grid for new members */
  newMemberBillingProviderProductId3?: InputMaybe<Scalars['Int']>;
  /** The fourth plan in the plan grid for new members */
  newMemberBillingProviderProductId4?: InputMaybe<Scalars['Int']>;
  /** The billing plan grid page */
  page: Scalars['String'];
  /** The billing plan grid priority */
  priority: Scalars['Int'];
  /** The billing plan grid start date */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** The billing plan grid variant name */
  variantName?: InputMaybe<Scalars['String']>;
};

/** Input for creating an eligibility rule */
export type CreateBillingProviderProductEligibilityInput = {
  billingProviderProductId: Scalars['ID'];
  /** Required when ruleType is Country */
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Required when ruleType is Country */
  countryOperator?: InputMaybe<PlanEligibilityCountryOperator>;
  ecommerceSkus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  lifetimeValue?: InputMaybe<Scalars['Float']>;
  lifetimeValueOperator?: InputMaybe<PlanEligibilityNumericOperator>;
  maxPurchases?: InputMaybe<Scalars['Int']>;
  monthsSinceLastPurchase?: InputMaybe<Scalars['Int']>;
  planCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  planSkus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ruleType: PlanEligibilityRuleType;
  scope: PlanEligibilityScope;
  skuCheckType?: InputMaybe<SkuCheckType>;
  skuOperator?: InputMaybe<SkuOperator>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  tenure?: InputMaybe<Scalars['Int']>;
  tenureOperator?: InputMaybe<PlanEligibilityNumericOperator>;
};

/** Input for creating a new event */
export type CreateCommunityEventInput = {
  /** Maximum attendees (null = unlimited) */
  capacity?: InputMaybe<Scalars['Int']>;
  /** Event description */
  content: Scalars['String'];
  /** Event end date and time */
  endTime: Scalars['DateTime'];
  /** Event locations */
  locations?: InputMaybe<Array<CommunityEventLocationInput>>;
  /** Reminder settings */
  reminderSettings?: InputMaybe<CommunityEventReminderSettingsInput>;
  /** Event start date and time */
  startTime: Scalars['DateTime'];
  /** Initial status (defaults to PUBLISHED) */
  status?: InputMaybe<CommunityEventStatus>;
  /** IANA timezone */
  timeZone: Scalars['String'];
  /** Event title */
  title: Scalars['String'];
};

/** Input for creating a custom emoji */
export type CreateCustomEmojiInput = {
  /** Base64-encoded image file */
  fileData: Scalars['String'];
  /** The unique key for the emoji (alphanumeric, hyphens, underscores only) */
  key: Scalars['String'];
  /** MIME type of the image (e.g., 'image/png') */
  mimeType: Scalars['String'];
  /** The display name of the emoji */
  name: Scalars['String'];
};

/** A custom emoji for use in the community */
export type CustomEmoji = {
  __typename?: 'CustomEmoji';
  /** Whether the emoji is active and available for use */
  active: Scalars['Boolean'];
  /** When the emoji was created */
  createdAt: Scalars['DateTime'];
  /** The unique ID of the custom emoji */
  id: Scalars['ID'];
  /** The unique key/identifier for the emoji (e.g., 'love', 'fire') */
  key: Scalars['String'];
  /** The display name of the emoji */
  name: Scalars['String'];
  /** URL to access the emoji image */
  url: Scalars['String'];
};

/** Custom reaction configuration (admin-configured, feed-wide) */
export type CustomReaction = {
  __typename?: 'CustomReaction';
  /** Active color (hex code) */
  activeColor?: Maybe<Scalars['String']>;
  /** Icon URL when active/selected */
  activeIconUrl?: Maybe<Scalars['String']>;
  /** Default color (hex code) */
  color?: Maybe<Scalars['String']>;
  /** Icon URL (default state) */
  iconUrl: Scalars['String'];
  /** Unique key for this custom reaction (e.g., 'gaia_earth') */
  key: Scalars['String'];
  /** Display name (e.g., 'Gaia Earth') */
  name: Scalars['String'];
};

/** Response from deleting a banner image */
export type DeleteBannerImageResponse = {
  __typename?: 'DeleteBannerImageResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** Delete input for Billing Plan Grid */
export type DeleteBillingPlanGridInput = {
  /** The billing plan grid id */
  id: Scalars['ID'];
};

/** Delete response for Billing Plan Grid */
export type DeleteBillingPlanGridResponse = {
  __typename?: 'DeleteBillingPlanGridResponse';
  /** Whether the delete was successful */
  success?: Maybe<Scalars['Boolean']>;
};

/** Response from deleting a playlist cover photo */
export type DeletePlaylistCoverPhotoResponse = {
  __typename?: 'DeletePlaylistCoverPhotoResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** Response from deleting a profile picture */
export type DeleteProfilePictureResponse = {
  __typename?: 'DeleteProfilePictureResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** Deleted Billing Provider Product Pricing type */
export type DeletedBillingProviderProductPricing = {
  __typename?: 'DeletedBillingProviderProductPricing';
  /** The billing provider product id of the billing provider product pricing */
  billingProviderProductId?: Maybe<Scalars['ID']>;
  /** Billing Provider Product SKU */
  billingProviderProductSku?: Maybe<Scalars['String']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The billing provider product pricing currency */
  currency?: Maybe<Scalars['String']>;
  /** The id of the billing provider product pricing */
  id?: Maybe<Scalars['ID']>;
  /** The billing provider product pricing price */
  price?: Maybe<Scalars['Float']>;
  /** The billing provider product trial segment price */
  trialSegmentPrice?: Maybe<Scalars['Float']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The UUID of the billing provider product pricing */
  uuid?: Maybe<Scalars['ID']>;
};

/** Name value pair for demographic data */
export type DemographicsNameValuePair = {
  __typename?: 'DemographicsNameValuePair';
  /** The name of the demographic field */
  name?: Maybe<Scalars['String']>;
  /** The value of the demographic field */
  value?: Maybe<Scalars['String']>;
};

/** Demographics response containing email and data */
export type DemographicsResponse = {
  __typename?: 'DemographicsResponse';
  /** The demographic data as name/value pairs */
  data?: Maybe<Array<Maybe<DemographicsNameValuePair>>>;
  /** The email address that was queried */
  email?: Maybe<Scalars['String']>;
};

/** Discount code object */
export type DiscountCode = {
  __typename?: 'DiscountCode';
  /** The discount code string */
  code?: Maybe<Scalars['String']>;
  /** The end date of the discount code */
  endsAt?: Maybe<Scalars['DateTime']>;
  /** The discount code ID from Shopify */
  id?: Maybe<Scalars['ID']>;
  /** The start date of the discount code */
  startsAt?: Maybe<Scalars['DateTime']>;
  /** The discount code title */
  title?: Maybe<Scalars['String']>;
};

/** Discount code create input */
export type DiscountCodeCreateInput = {
  /** The amount off for the discount code */
  amountOff: Scalars['Float'];
  /** The discount code */
  code: Scalars['String'];
  /** The end date of the discount code */
  endsAt: Scalars['DateTime'];
  /** The minimum subtotal for the discount code */
  minimumSubtotal: Scalars['Float'];
  /** The start date of the discount code */
  startsAt: Scalars['DateTime'];
};

/** Discount code create response */
export type DiscountCodeCreateResponse = {
  __typename?: 'DiscountCodeCreateResponse';
  /** The created discount code */
  discountCode?: Maybe<DiscountCode>;
  /** Error message if the mutation failed */
  errorMessage?: Maybe<Scalars['String']>;
  /** When true mutation was successful */
  success?: Maybe<Scalars['Boolean']>;
};

/** Divination collection (deck, rune set, etc.) */
export type DivinationCollection = {
  __typename?: 'DivinationCollection';
  backImageUrl?: Maybe<Scalars['String']>;
  collectionKey: Scalars['String'];
  id: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

/** Bundled divination feature state for oracle cards, tarot, and horoscope. */
export type DivinationFeatureStates = {
  __typename?: 'DivinationFeatureStates';
  horoscopeState: HoroscopeFeatureState;
  oracleState: OracleCardsFeatureState;
  tarotState: TarotFeatureState;
};

/** Divination object (card, rune, etc.) */
export type DivinationObject = {
  __typename?: 'DivinationObject';
  collectionId: Scalars['ID'];
  displayName: Scalars['String'];
  family?: Maybe<Scalars['String']>;
  frontImageUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['JSON']>;
  objectKey: Scalars['String'];
  rank?: Maybe<Scalars['Int']>;
  semanticClass?: Maybe<Scalars['String']>;
};

/** Poster grid URL and context for divination pull history (not a live reading pull). */
export type DivinationPullHistoryDocument = {
  __typename?: 'DivinationPullHistoryDocument';
  /** Resolved deck / collection key (same rules as starting a reading). */
  collectionKey?: Maybe<Scalars['String']>;
  /** Media path type segment (e.g. tarot, oracle) for poster URL. */
  mediaTypeSegment?: Maybe<Scalars['String']>;
  /** GET URL for /api/media/images/poster/... with reveal= query params. */
  posterUrl: Scalars['String'];
  /** Backend reading type: tarot or oracle_cards. */
  sourceReadingType: Scalars['String'];
  /** Number of distinct pulled card image keys in this history list. */
  uniqueCardCount: Scalars['Int'];
};

/** Oracle AI: Which divination reading stream to use when listing unique pulled card image keys (tarot vs oracle cards). */
export enum DivinationUniqueDrawReadingType {
  Oracle = 'ORACLE',
  Tarot = 'TAROT'
}

/**
 * **`documents` row:** hub for **chunk-level** vectors (`document_embeddings`), **optional explicit** links to catalog `Content` / `MediaAsset` via join tables, and **optional** offline whole-title text + vector in **`document_abstracts`**.
 *
 * **Content vs media — how fields differ (resolver behavior):**
 * - **Join tables:** `content_documents` links one **primary** `Content` (`contentId` ↔ `documentsId`). `media_asset_documents` links one **primary** `MediaAsset` (`mediaAssetsId` ↔ `documentsId`). A document may have either, both, or neither; list vs singular fields use **different precedence** (below).
 * - **`documentContent` / `documentMediaAsset` (singular):** Each reads **only** its join table. `documentContent` → `Content` from `content_documents` if the row exists, else `null`. `documentMediaAsset` → `MediaAsset` from `media_asset_documents` if the row exists, else `null`. They do **not** infer the other side from feature media alone.
 * - **`content` (list):** If `content_documents` exists → that linked `Content`. Else if only `media_asset_documents` exists → every `Content` whose **`featureMediaId`** equals the linked media asset’s **`mediaId`**. Else → `[]`.
 * - **`mediaAssets` (list):** If `media_asset_documents` exists → that linked `MediaAsset` only. Else if `content_documents` exists → the **feature** `MediaAsset` for that `Content` when `featureMediaId` is set. Else → `[]`.
 *
 * **Chunks vs abstract (`document_embeddings` vs `document_abstracts`):**
 * - **`documentEmbeddings`:** Many **`DocumentEmbedding`** rows — **chunked** text, **one vector per chunk**, **`metadata`** provenance. For **passages**, RAG, captions; not a single title summary.
 * - **Whole-title synopsis:** **`document_abstracts`** holds at most **one** **`DocumentAbstract`** per document — **`summaryText`**, **`summaryEmbedding`**, **`sumEmbedding`**, **`averageEmbedding`**. Resolve **`documentAbstract`** on **`Document`** (same **`documentAbstractList`** loader family as **`documentAbstractList`** query), or list/filter via **`documentAbstractList`**.
 *
 * **Related:** Title-scoped search often uses **`Content.relatedDocumentEmbeddings`**. For a one-paragraph synopsis use **`documentAbstract`** or **`documentAbstractList`**; for “which passage answers this?” use chunks / **`documentEmbeddings`**.
 */
export type Document = {
  __typename?: 'Document';
  /** **Expanded** `Content` list (see type doc): `content_documents` first; else content rows tied via linked media **`mediaId`** / **`featureMediaId`**. Not the same as **`documentContent`** (join-table–only). */
  content?: Maybe<Array<Maybe<Content>>>;
  /** Row creation time. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** At most **one** row from **`document_abstracts`**: LLM **`summaryText`**, **`summaryEmbedding`**, and pooled **`sumEmbedding`** / **`averageEmbedding`**. Loaded via the same **`documentAbstractList`** data loader keyed by this document’s **`id`** (`documentsId`). **`null`** until the worker has produced an abstract. */
  documentAbstract?: Maybe<DocumentAbstract>;
  /** **Direct** link: `Content` from **`content_documents`**, or `null` if none. Does not resolve media-first documents (use **`content`**). */
  documentContent?: Maybe<Content>;
  /** All **`document_embeddings`** chunk rows for this document: **`documentText`** + per-chunk **`embedding`**, optional **`queryRelevance`** when fetched with a query vector, and **`metadata`** (including **`documentSource`** for content vs media provenance). Optional `documentEmbeddings` argument filters by JSON **`metadata`**. For the offline title synopsis + pooled vectors, use **`documentAbstract`** (or **`documentAbstractList`**). For ranked, content-scoped retrieval prefer **`Content.relatedDocumentEmbeddings`**. */
  documentEmbeddings?: Maybe<Array<Maybe<DocumentEmbedding>>>;
  /** **Direct** link: `MediaAsset` from **`media_asset_documents`**, or `null` if none. Does not resolve content-only documents (use **`mediaAssets`**). */
  documentMediaAsset?: Maybe<MediaAsset>;
  /** Target chunk size when source text was split into `document_embeddings` rows. */
  embeddingChunks?: Maybe<Scalars['Int']>;
  /** Overlap between consecutive chunks (per worker configuration). */
  embeddingChunksOverlap?: Maybe<Scalars['Int']>;
  /** Content hash of source material last used when chunk embeddings were successfully written (worker bookkeeping). */
  embeddingDocumentHash?: Maybe<Scalars['String']>;
  /** Embedding model id stored on the document (e.g. text-embedding-ada-002); aligns with `embedding_config` for chunk indexing. */
  embeddingModel?: Maybe<Scalars['String']>;
  /** Primary key (`documents.id`); referenced as `documentsId` on `document_embeddings` and `document_abstracts`. */
  id?: Maybe<Scalars['ID']>;
  /** **Expanded** `MediaAsset` list (see type doc): `media_asset_documents` first; else feature media from linked content. Not the same as **`documentMediaAsset`** (join-table–only). */
  mediaAssets?: Maybe<Array<Maybe<MediaAsset>>>;
  /** Row last update time. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/**
 * **`documents` row:** hub for **chunk-level** vectors (`document_embeddings`), **optional explicit** links to catalog `Content` / `MediaAsset` via join tables, and **optional** offline whole-title text + vector in **`document_abstracts`**.
 *
 * **Content vs media — how fields differ (resolver behavior):**
 * - **Join tables:** `content_documents` links one **primary** `Content` (`contentId` ↔ `documentsId`). `media_asset_documents` links one **primary** `MediaAsset` (`mediaAssetsId` ↔ `documentsId`). A document may have either, both, or neither; list vs singular fields use **different precedence** (below).
 * - **`documentContent` / `documentMediaAsset` (singular):** Each reads **only** its join table. `documentContent` → `Content` from `content_documents` if the row exists, else `null`. `documentMediaAsset` → `MediaAsset` from `media_asset_documents` if the row exists, else `null`. They do **not** infer the other side from feature media alone.
 * - **`content` (list):** If `content_documents` exists → that linked `Content`. Else if only `media_asset_documents` exists → every `Content` whose **`featureMediaId`** equals the linked media asset’s **`mediaId`**. Else → `[]`.
 * - **`mediaAssets` (list):** If `media_asset_documents` exists → that linked `MediaAsset` only. Else if `content_documents` exists → the **feature** `MediaAsset` for that `Content` when `featureMediaId` is set. Else → `[]`.
 *
 * **Chunks vs abstract (`document_embeddings` vs `document_abstracts`):**
 * - **`documentEmbeddings`:** Many **`DocumentEmbedding`** rows — **chunked** text, **one vector per chunk**, **`metadata`** provenance. For **passages**, RAG, captions; not a single title summary.
 * - **Whole-title synopsis:** **`document_abstracts`** holds at most **one** **`DocumentAbstract`** per document — **`summaryText`**, **`summaryEmbedding`**, **`sumEmbedding`**, **`averageEmbedding`**. Resolve **`documentAbstract`** on **`Document`** (same **`documentAbstractList`** loader family as **`documentAbstractList`** query), or list/filter via **`documentAbstractList`**.
 *
 * **Related:** Title-scoped search often uses **`Content.relatedDocumentEmbeddings`**. For a one-paragraph synopsis use **`documentAbstract`** or **`documentAbstractList`**; for “which passage answers this?” use chunks / **`documentEmbeddings`**.
 */
export type DocumentDocumentEmbeddingsArgs = {
  documentEmbeddings?: InputMaybe<Array<InputMaybe<DocumentEmbeddingFilterInput>>>;
};

/**
 * **`document_abstracts`:** exactly **one row per `documents` row** — primary key **`documents_id`** (FK to **`documents.id`**). Populated by the **documents worker** using the same **rebuild → promote** pattern as other embedding tables (`document_abstracts_rebuild` → swap to live **`document_abstracts`**).
 *
 * **`summary_text` / `summary_embedding`:** The worker loads all **`document_embeddings`** rows for that document, builds text from chunk **`documentText`**, and runs **map-reduce summarization** (batched “map” over large concatenated text with configurable chunk size/overlap, then “reduce” into one synopsis). The synopsis is embedded into **`summary_embedding`** for cosine search.
 *
 * **`sum_embedding` / `average_embedding`:** Computed in the same worker pass as the summary: element-wise sum and per-dimension mean over all chunk **`embedding`** rows for this **`documents_id`** (offline pooled vectors for title-level similarity).
 *
 * **Relationship to chunks:** **`DocumentEmbedding`** rows are passage-level; this type is **one** offline title-level synopsis + **one** summary vector, plus **pooled** sum/average chunk vectors for title-level similarity without the LLM synopsis.
 *
 * **API:** Use **`documentAbstractList`** (Knex-backed loaders + optional text **`query`** for cosine-ranked results via `documentQueryEmbedding`), or **`Document.documentAbstract`** (batched via **`documentAbstractList`** loader by **`documentsId`**).
 */
export type DocumentAbstract = {
  __typename?: 'DocumentAbstract';
  /** Per-dimension average of chunk embeddings for this document. */
  averageEmbedding?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** When this row was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Parent **`Document`** (same id as **`documentsId`**). */
  document?: Maybe<Document>;
  /** Primary key: `documents_id` = `documents.id` (one abstract per document). */
  documentsId: Scalars['ID'];
  /** Element-wise sum of all chunk **`document_embeddings.embedding`** vectors for this document. */
  sumEmbedding?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Embedding of **`summaryText`** (`summary_embedding`); ranked against a search string via **`query`** on **`documentAbstractList`** (same embedding config family as this column). */
  summaryEmbedding?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** LLM synopsis produced by the worker from aggregated **`document_embeddings`** text (map-reduce; not raw chunk concatenation in the DB). */
  summaryText?: Maybe<Scalars['String']>;
  /** When **`summary_text`** / **`summary_embedding`** were last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Document abstract list response */
export type DocumentAbstractListResponse = {
  __typename?: 'DocumentAbstractListResponse';
  /** Total number of rows matching filters (computed when the selection set requests `count`) */
  count?: Maybe<Scalars['Int']>;
  /** Rows from `document_abstracts` matching the query */
  documentAbstracts?: Maybe<Array<Maybe<DocumentAbstract>>>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
};

/** Document abstract timestamp where input */
export type DocumentAbstractWhereDateTimeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['DateTime']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']>;
};

/** Document abstract primary key / documents id where input */
export type DocumentAbstractWhereDocumentsIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** Document abstract where conditions to filter rows (`document_abstracts`) */
export type DocumentAbstractWhereInput = {
  /** Filter by `created_at` */
  createdAt?: InputMaybe<DocumentAbstractWhereDateTimeInput>;
  /** Filter by `documents_id` (same as `Document.id`) */
  documentsId?: InputMaybe<DocumentAbstractWhereDocumentsIdInput>;
  /** Filter by `summary_text` */
  summaryText?: InputMaybe<DocumentAbstractWhereSummaryTextInput>;
  /** Filter by `updated_at` */
  updatedAt?: InputMaybe<DocumentAbstractWhereDateTimeInput>;
};

/** Document abstract summary text where input */
export type DocumentAbstractWhereSummaryTextInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Is the value a case-insensitive substring of the field */
  ilike?: InputMaybe<Scalars['String']>;
  /** Is the value a substring of the field */
  like?: InputMaybe<Scalars['String']>;
  /** Is the value not equal to the field */
  ne?: InputMaybe<Scalars['String']>;
};

/** The output from an LLM chain */
export type DocumentAnswer = {
  __typename?: 'DocumentAnswer';
  /** The answer text */
  text?: Maybe<Scalars['String']>;
};

/** Document call chain response */
export type DocumentCallChainResponse = {
  __typename?: 'DocumentCallChainResponse';
  /** The answer for this chain step */
  answer?: Maybe<DocumentAnswer>;
  /** A list of document embeddings returned from the search query in this chain step */
  documentEmbeddings?: Maybe<Array<Maybe<DocumentEmbedding>>>;
};

/** A chain to call against the supplied templates and search results */
export type DocumentCallChainStepInput = {
  /** The chain to run */
  chain?: InputMaybe<DocumentChain>;
  /** The context to load and use in the chain step */
  contextSource?: InputMaybe<DocumentContextSource>;
  /** The llm to use in the chain */
  llm?: InputMaybe<DocumentLlm>;
  /** The step search options */
  search?: InputMaybe<DocumentCallChainStepSearchInput>;
  /** The llm temperature where higher is more creative (0.9) and lower is less creative (0.0) only used when chain is DocumentChain.PROMPT */
  temperature?: InputMaybe<Scalars['Float']>;
  /** The call prompt template only used when chain is DocumentChain.PROMPT */
  template?: InputMaybe<Scalars['String']>;
};

/** Document call chain step search input to filter search results */
export type DocumentCallChainStepSearchInput = {
  /** `embedding_config.key` for query embedding model (must match document embeddings store) */
  embeddingConfigKey?: InputMaybe<Scalars['String']>;
  /** The limit to the number of rows */
  limit?: InputMaybe<Scalars['Int']>;
  /** Metadata to match document embedding using a contains operator */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** The offset for the rows */
  offset?: InputMaybe<Scalars['Int']>;
  /** The search query */
  query?: InputMaybe<Scalars['String']>;
  /** The where conditions to filter search rows */
  where?: InputMaybe<DocumentCallPromptChainStepSearchWhere>;
};

/** GraphQL document chain where input */
export type DocumentCallPromptChainStepSearchWhere = {
  /** Filter based on query relevance values */
  queryRelevance?: InputMaybe<DocumentCallPromptChainStepSearchWhereQueryRelevanceInput>;
};

/** GraphQL document chain where input */
export type DocumentCallPromptChainStepSearchWhereQueryRelevanceInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Float']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['Float']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Float']>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['Float']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Float']>;
};

/** The available chains */
export enum DocumentChain {
  /** Run a LLM prompt */
  Prompt = 'PROMPT',
  /** Run Q&A using a query */
  RetrievalQa = 'RETRIEVAL_QA',
  /** Run Q&A using multi query generate from the query */
  RetrievalQaMultiQuery = 'RETRIEVAL_QA_MULTI_QUERY',
  /** Run a summarization */
  Summarization = 'SUMMARIZATION'
}

/** The source for the context e.g. the content data media assets data or the document embedding text */
export enum DocumentContextSource {
  /** The source document content */
  Content = 'CONTENT',
  /** The document embedding text */
  DocumentText = 'DOCUMENT_TEXT',
  /** The document embedding text and any metadata which can be loaded for the relationship */
  DocumentTextAndMetadata = 'DOCUMENT_TEXT_AND_METADATA',
  /** The source document media asset provider e.g. the entire text track (closed caption) */
  MediaAssetProvider = 'MEDIA_ASSET_PROVIDER'
}

/**
 * A single **chunk** of indexed text (and its vector) for a document: the atomic unit for semantic search, RAG citations, and transcript/caption-aligned lookups. Rows live in **`document_embeddings`** and are siblings under the same **`Document`** as other chunks.
 *
 * **Versus `document_abstracts`:** Chunks carry **passage** text (`documentText`) and **per-chunk** vectors. **`DocumentAbstract`** rows (`document_abstracts`) hold **one** LLM **summary** and **one** **`summaryEmbedding`** per document — use chunks for evidence spans; use **`Query.documentAbstractList`** for a compact overview or title-level vector similarity.
 *
 * **MCP / tool selection:** Use **`documentText` + `embedding`** for passage retrieval; use **`metadata.documentSource`** to explain provenance (content vs media asset vs related rows); use **`positionStart`/`positionEnd`/`positionUnit`** when the source is time-based (e.g. captions). **`queryRelevance`** appears when the parent query embedded a user question (e.g. `Content.relatedDocumentEmbeddings(query: ...)`). For title-level pooled vectors and the offline LLM synopsis, query **`documentAbstractList`** (e.g. `where: { documentsId: { eq: … } }`).
 */
export type DocumentEmbedding = {
  __typename?: 'DocumentEmbedding';
  /** Row creation time. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Parent **`Document`** (`documents.id` = `documentsId`): holds chunking settings and join-table links to **`Content`** / **`MediaAsset`**. From **`Document`**, **`documentEmbeddings`** lists all chunks including this row; the separate **`document_abstracts`** summary + **`summaryEmbedding`** are exposed via **`documentAbstractList`**, not on **`Document`**. */
  document?: Maybe<Document>;
  /** Ordinal chunk index within the parent document (ordering of text segments after splitting). */
  documentNumber?: Maybe<Scalars['Int']>;
  /** Resolved content row for the primary source content in metadata, when present. */
  documentSourceContent?: Maybe<Content>;
  /** Featured content linked as context for this chunk (e.g. hero episode), when encoded in metadata. */
  documentSourceContentFeatured?: Maybe<Content>;
  /** Series-level featured content for this chunk when encoded in metadata. */
  documentSourceContentFeaturedSeries?: Maybe<Content>;
  /** Resolved media asset when this chunk came from a media-backed source in metadata. */
  documentSourceMediaAsset?: Maybe<MediaAsset>;
  /** Raw passage text embedded in `embedding`. Use for display, quoting, and LLM context; this is not the offline whole-title pooled vectors on `document_abstracts` (see `documentAbstractList`). */
  documentText?: Maybe<Scalars['String']>;
  /** Parent document id in the `documents` table; pairs with `documentNumber` as the composite key. */
  documentsId?: Maybe<Scalars['ID']>;
  /** Dense vector for this chunk’s `documentText`, comparable via cosine similarity to query embeddings. Dimensions follow the active `embedding_config` for `document_embeddings`. */
  embedding?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** BCP-47 style language code for this chunk row (partitions indexes and aggregates). */
  language?: Maybe<Scalars['String']>;
  /** Structured provenance and linkage: source content/media, related content rows, and language. Use to filter or explain *why* a chunk matched—not a substitute for title-level pooled vectors or per-document summaries from `documentAbstractList` (`document_abstracts`). */
  metadata?: Maybe<DocumentEmbeddingMetadata>;
  /** End of source span when applicable (e.g. WebVTT cue), expressed in `positionUnit`. */
  positionEnd?: Maybe<Scalars['Float']>;
  /** Start of source span when applicable (e.g. WebVTT cue), expressed in `positionUnit`. */
  positionStart?: Maybe<Scalars['Float']>;
  /** Unit for `positionStart`/`positionEnd` (e.g. `seconds` for timed captions). */
  positionUnit?: Maybe<Scalars['String']>;
  /** Relevance score when this row was retrieved with a query embedding (higher = closer match). Omitted or null when no query was used. */
  queryRelevance?: Maybe<Scalars['Float']>;
  /** Additional related content rows linked through metadata `relatedContent`. */
  relatedContent?: Maybe<Array<Maybe<Content>>>;
  /** Additional related media assets linked through metadata `relatedMediaAssets`. */
  relatedMediaAssets?: Maybe<Array<Maybe<MediaAsset>>>;
  /** Nearest chunks by cosine similarity in vector space—useful for "more like this passage" exploration. Prefer query-based retrieval on `Content.relatedDocumentEmbeddings` when you have a natural-language question. */
  similarDocumentEmbeddings?: Maybe<Array<Maybe<DocumentEmbedding>>>;
  /** Row last update time. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/**
 * A single **chunk** of indexed text (and its vector) for a document: the atomic unit for semantic search, RAG citations, and transcript/caption-aligned lookups. Rows live in **`document_embeddings`** and are siblings under the same **`Document`** as other chunks.
 *
 * **Versus `document_abstracts`:** Chunks carry **passage** text (`documentText`) and **per-chunk** vectors. **`DocumentAbstract`** rows (`document_abstracts`) hold **one** LLM **summary** and **one** **`summaryEmbedding`** per document — use chunks for evidence spans; use **`Query.documentAbstractList`** for a compact overview or title-level vector similarity.
 *
 * **MCP / tool selection:** Use **`documentText` + `embedding`** for passage retrieval; use **`metadata.documentSource`** to explain provenance (content vs media asset vs related rows); use **`positionStart`/`positionEnd`/`positionUnit`** when the source is time-based (e.g. captions). **`queryRelevance`** appears when the parent query embedded a user question (e.g. `Content.relatedDocumentEmbeddings(query: ...)`). For title-level pooled vectors and the offline LLM synopsis, query **`documentAbstractList`** (e.g. `where: { documentsId: { eq: … } }`).
 */
export type DocumentEmbeddingSimilarDocumentEmbeddingsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Document embedding filtering */
export type DocumentEmbeddingFilterInput = {
  /** Document embedding filtering */
  metadata?: InputMaybe<Scalars['JSON']>;
};

/** JSON-backed provenance for a chunk: which content/media rows produced it, optional related links, and language. Filterable via `documentEmbeddingsList(where: { metadata: ... })` for operators; use resolved `documentSource*` fields on `DocumentEmbedding` for navigation in GraphQL. */
export type DocumentEmbeddingMetadata = {
  __typename?: 'DocumentEmbeddingMetadata';
  /** Structured source pointers (content, media, related tables) for this chunk. */
  documentSource?: Maybe<DocumentEmbeddingMetadataDocumentSource>;
  /** Language hint stored in metadata (may align with the row’s `language`). */
  language?: Maybe<Scalars['String']>;
};

/** Document embedding row metadata document source data */
export type DocumentEmbeddingMetadataDocumentSource = {
  __typename?: 'DocumentEmbeddingMetadataDocumentSource';
  /** The column in the datastore */
  column?: Maybe<Scalars['String']>;
  /** The content which the document embedding was created from */
  content?: Maybe<DocumentEmbeddingMetadataDocumentSourceContent>;
  /** The content that is the feature media for this document embedding */
  contentFeatured?: Maybe<DocumentEmbeddingMetadataDocumentSourceContent>;
  /** The content of type series that is the feature media for this document embedding */
  contentFeaturedSeries?: Maybe<DocumentEmbeddingMetadataDocumentSourceContent>;
  /** The datastore */
  datastore?: Maybe<DocumentEmbeddingMetadataDocumentSourceDatastore>;
  /** The content which the document embedding was created from */
  mediaAsset?: Maybe<DocumentEmbeddingMetadataDocumentSourceMediaAsset>;
  /** Related datastore data */
  related?: Maybe<Array<Maybe<DocumentEmbeddingMetadataDocumentSourceRelated>>>;
  /** Related content */
  relatedContent?: Maybe<Array<Maybe<DocumentEmbeddingMetadataDocumentSourceContent>>>;
  /** Related media assets */
  relatedMediaAssets?: Maybe<Array<Maybe<DocumentEmbeddingMetadataDocumentSourceMediaAsset>>>;
  /** The table name in the datastore */
  table?: Maybe<DocumentEmbeddingMetadataDocumentSourceTable>;
  /** The column value in the datastore */
  value?: Maybe<Scalars['String']>;
};

/** Document embedding row metadata document source content */
export type DocumentEmbeddingMetadataDocumentSourceContent = {
  __typename?: 'DocumentEmbeddingMetadataDocumentSourceContent';
  /** The content content id */
  contentId?: Maybe<Scalars['String']>;
  /** The content content type */
  contentType?: Maybe<Scalars['String']>;
  /** The content day number */
  dayNumber?: Maybe<Scalars['String']>;
  /** The content episode number */
  episodeNumber?: Maybe<Scalars['String']>;
  /** The content id */
  id?: Maybe<Scalars['ID']>;
  /** The content language */
  language?: Maybe<Scalars['String']>;
  /** The content path */
  path?: Maybe<Scalars['String']>;
  /** The content published at date */
  publishedAtDate?: Maybe<Scalars['DateTime']>;
  /** The content season number */
  seasonNumber?: Maybe<Scalars['String']>;
  /** The content title group id */
  titleGroupId?: Maybe<Scalars['String']>;
};

/** Document embedding row metadata document source content input */
export type DocumentEmbeddingMetadataDocumentSourceContentInput = {
  /** The content content id */
  contentId?: InputMaybe<Scalars['String']>;
  /** The content content type */
  contentType?: InputMaybe<Scalars['String']>;
  /** The content day number */
  dayNumber?: InputMaybe<Scalars['String']>;
  /** The content episode number */
  episodeNumber?: InputMaybe<Scalars['String']>;
  /** The content id */
  id?: InputMaybe<Scalars['ID']>;
  /** The content language */
  language?: InputMaybe<Scalars['String']>;
  /** The content path */
  path?: InputMaybe<Scalars['String']>;
  /** The content published at date */
  publishedAtDate?: InputMaybe<Scalars['DateTime']>;
  /** The content season number */
  seasonNumber?: InputMaybe<Scalars['String']>;
  /** The content title group id */
  titleGroupId?: InputMaybe<Scalars['String']>;
};

/** Document embedding row metadata document source datastore */
export enum DocumentEmbeddingMetadataDocumentSourceDatastore {
  Database = 'DATABASE'
}

/** Document embedding row metadata document source data */
export type DocumentEmbeddingMetadataDocumentSourceInput = {
  /** The content which the document embedding was created from */
  content?: InputMaybe<DocumentEmbeddingMetadataDocumentSourceContentInput>;
  /** The content which the document embedding was created from */
  mediaAsset?: InputMaybe<DocumentEmbeddingMetadataDocumentSourceMediaAssetInput>;
  /** Related */
  related?: InputMaybe<Array<InputMaybe<DocumentEmbeddingMetadataDocumentSourceRelatedInput>>>;
  /** Related content */
  relatedContent?: InputMaybe<Array<InputMaybe<DocumentEmbeddingMetadataDocumentSourceContentInput>>>;
  /** Related media assets */
  relatedMediaAssets?: InputMaybe<Array<InputMaybe<DocumentEmbeddingMetadataDocumentSourceMediaAssetInput>>>;
};

/** Document embedding row metadata document source media asset */
export type DocumentEmbeddingMetadataDocumentSourceMediaAsset = {
  __typename?: 'DocumentEmbeddingMetadataDocumentSourceMediaAsset';
  /** The media asset duration */
  duation?: Maybe<Scalars['String']>;
  /** The media asset id */
  id?: Maybe<Scalars['ID']>;
  /** The media asset language */
  language?: Maybe<Scalars['String']>;
  /** The media id id */
  mediaId?: Maybe<Scalars['ID']>;
  /** The media reference type for this media asset */
  mediaReferenceType?: Maybe<Scalars['String']>;
};

/** Document embedding row metadata document source media asset input */
export type DocumentEmbeddingMetadataDocumentSourceMediaAssetInput = {
  /** The media asset duration */
  duation?: InputMaybe<Scalars['String']>;
  /** The media asset id */
  id?: InputMaybe<Scalars['ID']>;
  /** The media asset language */
  language?: InputMaybe<Scalars['String']>;
  /** The media id id */
  mediaId?: InputMaybe<Scalars['ID']>;
  /** The media reference type for this media asset */
  mediaReferenceType?: InputMaybe<Scalars['String']>;
};

/** Document embedding row metadata document source related */
export type DocumentEmbeddingMetadataDocumentSourceRelated = {
  __typename?: 'DocumentEmbeddingMetadataDocumentSourceRelated';
  /** The column in the datastore */
  column?: Maybe<Scalars['String']>;
  /** The datastore */
  datastore?: Maybe<DocumentEmbeddingMetadataDocumentSourceDatastore>;
  /** The table name in the datastore */
  table?: Maybe<DocumentEmbeddingMetadataDocumentSourceTable>;
  /** The column value in the datastore */
  value?: Maybe<Scalars['String']>;
};

/** Document embedding row metadata document source related input */
export type DocumentEmbeddingMetadataDocumentSourceRelatedInput = {
  /** The column in the datastore */
  column?: InputMaybe<Scalars['String']>;
  /** The datastore */
  datastore?: InputMaybe<DocumentEmbeddingMetadataDocumentSourceDatastore>;
  /** The table name in the datastore */
  table?: InputMaybe<DocumentEmbeddingMetadataDocumentSourceTable>;
  /** The column value in the datastore */
  value?: InputMaybe<Scalars['String']>;
};

/** Document embedding row metadata document source datastore */
export enum DocumentEmbeddingMetadataDocumentSourceTable {
  Content = 'CONTENT',
  Media = 'MEDIA',
  MediaAssets = 'MEDIA_ASSETS'
}

/** Document embedding row metadata input */
export type DocumentEmbeddingMetadataInput = {
  /** The document source for the metadata */
  documentSource?: InputMaybe<DocumentEmbeddingMetadataDocumentSourceInput>;
  /** The document embedding text language */
  language?: InputMaybe<Scalars['String']>;
};

/** Document embedding where id input */
export type DocumentEmbeddingWhereDocumentNumberInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Is the value in the list of values */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** Document embedding where id input */
export type DocumentEmbeddingWhereDocumentsIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Is the value in the list of values */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** The document emebdding where input */
export type DocumentEmbeddingWhereInput = {
  /** The document number field where clause */
  documentNumber?: InputMaybe<DocumentEmbeddingWhereDocumentNumberInput>;
  /** The documents id field where clause */
  documentsId?: InputMaybe<DocumentEmbeddingWhereDocumentsIdInput>;
  /** The document embedding language */
  language?: InputMaybe<DocumentEmbeddingWhereLanguageInput>;
  /** The metadata field where clause */
  metadata?: InputMaybe<DocumentEmbeddingWhereMetadataInput>;
};

/** Document embedding where id input */
export type DocumentEmbeddingWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value in the list of values */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** GraphQL document embedding metadata where input */
export type DocumentEmbeddingWhereMetadataInput = {
  /** The field contains the value */
  contains?: InputMaybe<DocumentEmbeddingMetadataInput>;
};

/** Paged list of chunk rows from `document_embeddings` for admin-style filtering (metadata, language, ids)—not the same as relevance-ranked `Content.relatedDocumentEmbeddings`. */
export type DocumentEmbeddingsListResponse = {
  __typename?: 'DocumentEmbeddingsListResponse';
  /** Total rows matching `where` (uses a slower COUNT when requested). */
  count?: Maybe<Scalars['Int']>;
  /** Matching chunk rows. */
  documentEmbeddings?: Maybe<Array<Maybe<DocumentEmbedding>>>;
  /** Limit applied to this response. */
  limit?: Maybe<Scalars['Int']>;
  /** Offset applied to this response. */
  offset?: Maybe<Scalars['Int']>;
};

/** The available LLMs for use in a chain */
export enum DocumentLlm {
  /** The OpenAI LLM */
  Openai = 'OPENAI'
}

/** Document multi query response */
export type DocumentMultiQueryResponse = {
  __typename?: 'DocumentMultiQueryResponse';
  /** Alternative queries to the provide query */
  query?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** An emedding generate using a query */
export type DocumentQueryEmbeddingResponse = {
  __typename?: 'DocumentQueryEmbeddingResponse';
  queryEmbedding?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export enum DocumentSemanticSearchCurationMode {
  /** Closest transcript matches in retrieval order. */
  BestMatches = 'BEST_MATCHES',
  /** Tight thematic focus on the prompt. */
  DeepDive = 'DEEP_DIVE',
  /** Foundational-to-advanced learning arc across topics. */
  LearningPath = 'LEARNING_PATH',
  /** Diverse selection ordered as a narrative journey. */
  SurveyJourney = 'SURVEY_JOURNEY',
  /** Diverse selection tightened to thematic core. API/QA only — not exposed in member UI. */
  VariedFocus = 'VARIED_FOCUS',
  /** Diverse clip selection while staying on topic. */
  WideLens = 'WIDE_LENS'
}

export type DocumentSemanticSearchFilter = {
  /** Restrict to content in a content center (the center tag's numeric content_id). Matched via content_reference_types.type = 'centers'. */
  centerContentId?: InputMaybe<Scalars['Int']>;
  /** Restrict to a single video (its numeric content_id). */
  contentId?: InputMaybe<Scalars['Int']>;
  /** Restrict to content published within a rolling window. Omit or use ANY for no date restriction. */
  publishedAge?: InputMaybe<DocumentSemanticSearchPublishedAge>;
  /** Used with seriesContentId: restrict to a specific season number. */
  seasonNumber?: InputMaybe<Scalars['Int']>;
  /** Restrict to episodes in a series (the series' numeric content_id). Matched via content_reference_types.type = 'series'. */
  seriesContentId?: InputMaybe<Scalars['Int']>;
  /** Restrict to content tagged with a conscious topic (the topic tag's numeric content_id). Matched via content_reference_types.type = 'conscious-topic'. */
  topicContentId?: InputMaybe<Scalars['Int']>;
};

export type DocumentSemanticSearchInput = {
  /** How clips are curated before stitching (maps to internal ranking + coherence). Default: BEST_MATCHES. */
  curationMode?: DocumentSemanticSearchCurationMode;
  /**
   * Optional scope filter. All set fields are ANDed. At most one scope field (contentId, seriesContentId,
   * topicContentId, centerContentId) may be set at a time. Licensed content is always excluded regardless
   * of this filter. Omitting the filter (or setting publishedAge to ANY with no scope) runs the
   * full-corpus HNSW search.
   */
  filter?: InputMaybe<DocumentSemanticSearchFilter>;
  /** When true, intro / between-clip / conclusion transition clips (from server config) are spliced into the stitched manifest. */
  includeTransitions?: InputMaybe<Scalars['Boolean']>;
  /** Language for matching `document_embeddings.language` (en, es, de, fr). */
  language: DocumentSemanticSearchLanguage;
  /** How many hits to return (1–100 in the API; capped to 10 server-side for stitch cost). */
  maxResults?: Scalars['Int'];
  /** Natural-language query. */
  prompt: Scalars['String'];
  /** Default: only timed WebVTT-style chunk rows; use ALL_CHUNKS to search all document chunks for the language. */
  scope?: DocumentSemanticSearchScope;
};

export enum DocumentSemanticSearchLanguage {
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Fr = 'FR'
}

export enum DocumentSemanticSearchPublishedAge {
  /** No date restriction — search all content (default). */
  Any = 'ANY',
  /** Content published in the past 2 years. */
  Past_2Years = 'PAST_2_YEARS',
  /** Content published in the past 90 days. */
  Past_3Months = 'PAST_3_MONTHS',
  /** Content published in the past 3 years. */
  Past_3Years = 'PAST_3_YEARS',
  /** Content published in the past 5 years. */
  Past_5Years = 'PAST_5_YEARS',
  /** Content published in the past 180 days. */
  Past_6Months = 'PAST_6_MONTHS',
  /** Content published in the past 30 days. */
  PastMonth = 'PAST_MONTH',
  /** Content published in the past 365 days. */
  PastYear = 'PAST_YEAR'
}

export type DocumentSemanticSearchResult = {
  __typename?: 'DocumentSemanticSearchResult';
  /**
   * Top relevance-ranked article Content (deduped by content). Resolved from `document_embeddings` rows whose
   * `metadata.documentSource.content.contentType` is `article`, using the same query embedding as `spans`.
   * Empty array unless the client selects this field — the resolver short-circuits when it's not in the selection.
   */
  articles: Array<Content>;
  language: DocumentSemanticSearchLanguage;
  /**
   * Top relevance-ranked product Content (deduped by content). Resolved from `document_embeddings` rows whose
   * `metadata.documentSource.content.contentType` is `product`, using the same query embedding as `spans`.
   * Empty array unless the client selects this field — the resolver short-circuits when it's not in the selection.
   */
  products: Array<Content>;
  resultId: Scalars['ID'];
  spans: Array<TranscriptSpan>;
  stitchedPlayback: StitchedPlayback;
  /**
   * LLM-generated summary (2–4 sentences) synthesizing the retrieved transcript spans.
   * Null unless the client explicitly selects this field — the resolver short-circuits when it is absent
   * (same opt-in pattern as `products` and `articles`). The summary is tailored to the `curationMode`
   * preset used in the search and is generated in the same language as the search.
   */
  summary?: Maybe<Scalars['String']>;
};

export enum DocumentSemanticSearchScope {
  /** All `document_embeddings` for the given language (broader; may include non-VTT chunks). */
  AllChunks = 'ALL_CHUNKS',
  /** Only rows with timed transcript spans (WebVTT seconds — default). */
  TranscriptTimed = 'TRANSCRIPT_TIMED'
}

/** GraphQL document chain where input */
export type DocumentWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** The document where input */
export type DocumentWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<DocumentWhereIdInput>;
};

/** Documents list response */
export type DocumentsListResponse = {
  __typename?: 'DocumentsListResponse';
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** Documents */
  documents?: Maybe<Array<Maybe<Document>>>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
};

/** Documents worker reset response */
export type DocumentsWorkerResetResponse = {
  __typename?: 'DocumentsWorkerResetResponse';
  /** Will be true if reset was successful */
  success?: Maybe<Scalars['Boolean']>;
  /** The worker that was reset */
  worker?: Maybe<Worker>;
};

/** A single block in a dynamic page layout */
export type DynamicLayoutBlock = {
  __typename?: 'DynamicLayoutBlock';
  /** Block-specific props as JSON */
  props?: Maybe<Scalars['JSON']>;
  /** Block type from the registry (e.g. 'for-you-hero', 'topic-section') */
  type: Scalars['String'];
};

/** Response from the dynamicLayout query */
export type DynamicLayoutResponse = {
  __typename?: 'DynamicLayoutResponse';
  /** Ordered list of blocks to render */
  blocks: Array<DynamicLayoutBlock>;
  /** Unique ID for analytics attribution */
  layoutId: Scalars['ID'];
  /** How this layout was produced: 'llm', 'cache', 'default' */
  source: Scalars['String'];
  /** Schema version */
  version: Scalars['Int'];
};

/** Ecommerce Sku Mapping */
export type EcommerceSkuMapping = {
  __typename?: 'EcommerceSkuMapping';
  /** The content provider that represents the ecommerce sku primary language. It contains the content data for the sku itself. */
  contentProvider?: Maybe<ContentProvider>;
  /** The contentProviderKey that maps to the content provider table record that represents this sku */
  contentProviderKey?: Maybe<Scalars['String']>;
  /** The content providers that represent the ecommerce sku across all languages. */
  contentProviders?: Maybe<Array<Maybe<ContentProvider>>>;
  /** The content relating to the contentTitleGroupIds. Episodes may be nested in series. Empty when contentTitleGroupIds is empty. */
  contentRelated?: Maybe<Array<Maybe<Content>>>;
  /** Subscription length in seconds from the start date */
  contentSetDurationSeconds?: Maybe<Scalars['Int']>;
  /** Subscription end date cap. When both duration and end date are set, the earlier of the two limits the entitlement. */
  contentSetEndDate?: Maybe<Scalars['DateTime']>;
  /** Content set id for subscription access */
  contentSetId?: Maybe<Scalars['Int']>;
  /** Subscription start date */
  contentSetStartDate?: Maybe<Scalars['DateTime']>;
  /** Title group ids for alacarte content access. Empty array when this SKU grants subscription access only. */
  contentTitleGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Whether to not entitle this sku to users. For example, if the sku is a tshirt, we do not want to entitle it to users. Default is false. */
  doNotEntitle?: Maybe<Scalars['Boolean']>;
  /** The unique sku for the given provider */
  ecommerceSku?: Maybe<Scalars['ID']>;
  /** The ecommerce sku mapping bonus eligibilities related to this item */
  ecommerceSkuMappingBonusEligibilities?: Maybe<Array<Maybe<EcommerceSkuMappingBonusEligibility>>>;
  /** Whether this SKU mapping is enabled and available for use. Default is true. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Entitlement duration in seconds for alacarte content (content set 222) */
  entitlementDurationSeconds?: Maybe<Scalars['Int']>;
  /** The ecommerce provider */
  provider?: Maybe<Scalars['ID']>;
  /** The title of the variant */
  title?: Maybe<Scalars['String']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/** Ecommerce Sku Mapping */
export type EcommerceSkuMappingContentRelatedArgs = {
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Ecommerce Sku Mapping */
export type EcommerceSkuMappingEcommerceSkuMappingBonusEligibilitiesArgs = {
  userCurrent?: InputMaybe<Scalars['Boolean']>;
};

/** Ecommerce Sku Mappings list response */
export type EcommerceSkuMappingBonusEligibilitiesListResponse = {
  __typename?: 'EcommerceSkuMappingBonusEligibilitiesListResponse';
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** A list of ecommerce sku mappings */
  ecommerceSkuMappingBonusEligibilities?: Maybe<Array<Maybe<EcommerceSkuMappingBonusEligibility>>>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
};

/** Ecommerce Sku Mapping Bonus Eligibility where Ecommerce Sku input type */
export type EcommerceSkuMappingBonusEligibilitiesWhereEcommerceSkuInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Ecommerce Sku Mapping Bonus Eligibility where End Date input type */
export type EcommerceSkuMappingBonusEligibilitiesWhereEndDateInput = {
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']>;
};

/** Ecommerce Sku Mapping Bonus Eligibility where conditions to filter rows */
export type EcommerceSkuMappingBonusEligibilitiesWhereInput = {
  /** The ecommerceSku bonus eligibilities field where clause */
  ecommerceSku?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereEcommerceSkuInput>;
  endDate?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereEndDateInput>;
  languages?: InputMaybe<EcommerceSkuMappingBonusEligibilityWhereLanguagesInput>;
  planSku?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWherePlanSkuInput>;
  provider?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereProviderInput>;
  retainOnPlanChange?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereRetainOnPlanChangeInput>;
  startDate?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereStartDateInput>;
};

/** Ecommerce Sku Mapping Bonus Eligibility where PlanSku input type */
export type EcommerceSkuMappingBonusEligibilitiesWherePlanSkuInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Ecommerce Sku Mapping Bonus Eligibility where Provider input type */
export type EcommerceSkuMappingBonusEligibilitiesWhereProviderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Ecommerce Sku Mapping Bonus Eligibility where Retain On Plan Change input type */
export type EcommerceSkuMappingBonusEligibilitiesWhereRetainOnPlanChangeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** Ecommerce Sku Mapping Bonus Eligibility where Start Date input type */
export type EcommerceSkuMappingBonusEligibilitiesWhereStartDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** Ecommerce SKU Mapping Bonus Eligibility */
export type EcommerceSkuMappingBonusEligibility = {
  __typename?: 'EcommerceSkuMappingBonusEligibility';
  /** The BillingProviderProduct that bestows this ecommerce sku */
  billingProviderProduct?: Maybe<BillingProviderProduct>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The description of the eligibility */
  description?: Maybe<Scalars['String']>;
  /** The ecommerce sku */
  ecommerceSku?: Maybe<Scalars['String']>;
  /** The ecommerce sku mapping for this record */
  ecommerceSkuMapping?: Maybe<EcommerceSkuMapping>;
  /** The end date when eligibility ends */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The id of the ecommerce sku mapping bonus eligibility */
  id?: Maybe<Scalars['ID']>;
  /** A list of languages for this item */
  languages: Array<Language>;
  /** An optional coupon code or gift card code to grant for marketplace */
  marketplaceCouponCode?: Maybe<Scalars['String']>;
  /** An optional coupon code or gift card expiration to grant for marketplace */
  marketplaceCouponCodeExpiration?: Maybe<Scalars['DateTime']>;
  /** The plan sku that bestows this ecommerce sku */
  planSku?: Maybe<Scalars['String']>;
  /** The ecommerce provider */
  provider?: Maybe<Scalars['String']>;
  /** Whether to retain the bonus eligibilities when the user changes plan */
  retainOnPlanChange?: Maybe<Scalars['Boolean']>;
  /** The start date when eligibility begins */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The users who have this eligibility */
  userEcommerceSkuMappingBonusEligibilities?: Maybe<Array<Maybe<UserEcommerceSkuMappingBonusEligibility>>>;
};


/** Ecommerce SKU Mapping Bonus Eligibility */
export type EcommerceSkuMappingBonusEligibilityUserEcommerceSkuMappingBonusEligibilitiesArgs = {
  userCurrent?: InputMaybe<Scalars['Boolean']>;
};

/** Ecommerce Sku Mapping Bonus Eligibility create */
export type EcommerceSkuMappingBonusEligibilityCreateInput = {
  /** Description */
  description?: InputMaybe<Scalars['String']>;
  /** Ecommerce Sku */
  ecommerceSku?: InputMaybe<Scalars['String']>;
  /** End Date */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** A list of languages for this item */
  languages: Array<Language>;
  /** An optional coupon code or gift card code to grant for marketplace */
  marketplaceCouponCode?: InputMaybe<Scalars['String']>;
  /** An optional coupon code or gift card code expiration to grant for marketplace */
  marketplaceCouponCodeExpiration?: InputMaybe<Scalars['DateTime']>;
  /** Plan Sku */
  planSku?: InputMaybe<Scalars['String']>;
  /** Ecommerce Sku Provider */
  provider?: InputMaybe<Scalars['String']>;
  /** Whether to retain the bonus eligibilities when the user changes plan */
  retainOnPlanChange?: InputMaybe<Scalars['Boolean']>;
  /** Start Date */
  startDate: Scalars['DateTime'];
};

/** Ecommerce Sku Mapping Bonus Eligibility delete */
export type EcommerceSkuMappingBonusEligibilityDeleteByIdInput = {
  /** id required to delete */
  id: Scalars['ID'];
};

/** Ecommerce Sku Mapping Bonus Eligibility update */
export type EcommerceSkuMappingBonusEligibilityUpdateByIdInput = {
  /** Description */
  description?: InputMaybe<Scalars['String']>;
  /** End Date */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** id required to update */
  id: Scalars['ID'];
  /** A list of languages for this item */
  languages?: InputMaybe<Array<Language>>;
  /** An optional coupon code or gift card code to grant for marketplace */
  marketplaceCouponCode?: InputMaybe<Scalars['String']>;
  /** An optional coupon code or gift card code expiration to grant for marketplace */
  marketplaceCouponCodeExpiration?: InputMaybe<Scalars['DateTime']>;
  /** Plan Sku */
  planSku?: InputMaybe<Scalars['String']>;
  /** Whether to retain the bonus eligibilities when the user changes plan */
  retainOnPlanChange?: InputMaybe<Scalars['Boolean']>;
  /** Start Date */
  startDate?: InputMaybe<Scalars['DateTime']>;
};

/** Ecommerce Sku Mapping Bonus Eligibility where Language Ids input type */
export type EcommerceSkuMappingBonusEligibilityWhereLanguagesInput = {
  /** Includes any of the values in the field */
  overlap?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Input for creating a GAIA_BONUS ecommerce SKU mapping (ecommerceSkuMappingCreate). Each SKU must grant at least one entitlement target unless doNotEntitle is true: alacarte content (non-empty contentTitleGroupIds), subscription access (contentSetId with timing fields), or both. Purchasers always receive content set 222; admins may attach additional content later and retroactively grant other content sets. Subscription-only example: contentTitleGroupIds: [], contentSetId, and contentSetDurationSeconds and/or contentSetEndDate. */
export type EcommerceSkuMappingCreateInput = {
  /** The contentProviderKey that maps to the content provider table record that represents this sku - this is immutable once created and will populate with a uuid if left out */
  contentProviderKey?: InputMaybe<Scalars['String']>;
  /** Subscription length in seconds from the start date. Required on create when contentSetId is set unless contentSetEndDate is provided. */
  contentSetDurationSeconds?: InputMaybe<Scalars['Int']>;
  /** Subscription end date cap. Required on create when contentSetId is set unless contentSetDurationSeconds is provided. When both duration and end date are set, the earlier of the two limits the entitlement. */
  contentSetEndDate?: InputMaybe<Scalars['DateTime']>;
  /** Content set id for subscription access. Required for subscription-only SKUs (use with contentTitleGroupIds: []). When set, contentSetDurationSeconds and/or contentSetEndDate is required unless doNotEntitle is true. */
  contentSetId?: InputMaybe<Scalars['Int']>;
  /** Optional subscription start date. Defaults to grant time when omitted. */
  contentSetStartDate?: InputMaybe<Scalars['DateTime']>;
  /** Required. Title group ids for alacarte video/content access. Pass [] for subscription-only SKUs. Content set 222 is always granted on purchase or bonus grant. Pass one or more ids for alacarte-only or combined alacarte + subscription SKUs. */
  contentTitleGroupIds: Array<InputMaybe<Scalars['String']>>;
  /** Whether to not entitle this sku to users. For example, if the sku is a tshirt, we do not want to entitle it to users. */
  doNotEntitle?: InputMaybe<Scalars['Boolean']>;
  /** Ecommerce Sku */
  ecommerceSku: Scalars['String'];
  /** Whether this SKU mapping is enabled and available for use */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Optional entitlement duration in seconds for content set 222 */
  entitlementDurationSeconds?: InputMaybe<Scalars['Int']>;
  /** The languages of the content that represents this sku. If not provided, the primary language will be used. */
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The primaryLanguage of the content that represents this sku - this is immutable once created */
  primaryLanguage: Scalars['String'];
  /** Ecommerce Sku Provider */
  provider: Scalars['String'];
  /** The title of the ecommmerce sku */
  title: Scalars['String'];
};

/** Input for updating a GAIA_BONUS ecommerce SKU mapping (ecommerceSkuMappingUpdateByProviderAndEcommerceSku). Omitted fields are unchanged. After the update, the mapping must still grant at least one entitlement target unless doNotEntitle is true. To make a SKU subscription-only, set contentTitleGroupIds: [] and provide contentSetId with subscription timing fields. */
export type EcommerceSkuMappingUpdateByProviderAndEcommerceSkuInput = {
  /** Subscription length in seconds from the start date */
  contentSetDurationSeconds?: InputMaybe<Scalars['Int']>;
  /** Subscription end date cap (must be after contentSetStartDate when both are set). When both duration and end date are set, the earlier of the two limits the entitlement. */
  contentSetEndDate?: InputMaybe<Scalars['DateTime']>;
  /** Content set id for subscription access. When set, contentSetDurationSeconds and/or contentSetEndDate is required on the resulting mapping unless doNotEntitle is true. */
  contentSetId?: InputMaybe<Scalars['Int']>;
  /** Optional subscription start date */
  contentSetStartDate?: InputMaybe<Scalars['DateTime']>;
  /** Title group ids for alacarte content access. Pass [] to remove alacarte access (requires contentSetId on the resulting mapping unless doNotEntitle is true). */
  contentTitleGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to not entitle this sku to users. For example, if the sku is a tshirt, we do not want to entitle it to users. */
  doNotEntitle?: InputMaybe<Scalars['Boolean']>;
  /** Ecommerce Sku required to update */
  ecommerceSku: Scalars['String'];
  /** Whether this SKU mapping is enabled and available for use */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Entitlement duration in seconds for alacarte content (content set 222). Used when contentTitleGroupIds is non-empty. */
  entitlementDurationSeconds?: InputMaybe<Scalars['Int']>;
  /** Additional languages of the content that represents this sku. If languages already exist but are not provided, they will not be removed. */
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Ecommerce Sku Provider required to update */
  provider: Scalars['String'];
  /** The title of the ecommmerce sku */
  title?: InputMaybe<Scalars['String']>;
};

/** Ecommerce Sku Mappings list response */
export type EcommerceSkuMappingsListResponse = {
  __typename?: 'EcommerceSkuMappingsListResponse';
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** A list of ecommerce sku mappings */
  ecommerceSkuMappings?: Maybe<Array<Maybe<EcommerceSkuMapping>>>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
};

/** Ecommerce Sku Mapping where Content Title Group Ids input type */
export type EcommerceSkuMappingsWhereContentTitleGroupIdsInput = {
  /** Are the values in the field */
  overlap?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Ecommerce Sku Mapping where Do Not Entitle input type */
export type EcommerceSkuMappingsWhereDoNotEntitleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** Ecommerce Sku Mapping where Ecommerce Sku input type */
export type EcommerceSkuMappingsWhereEcommerceSkuInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value a case-insensitive substring of the field */
  ilike?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Ecommerce Sku Mapping where Enabled input type */
export type EcommerceSkuMappingsWhereEnabledInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** Ecommerce Sku Mappings where conditions to filter rows */
export type EcommerceSkuMappingsWhereInput = {
  contentTitleGroupIds?: InputMaybe<EcommerceSkuMappingsWhereContentTitleGroupIdsInput>;
  doNotEntitle?: InputMaybe<EcommerceSkuMappingsWhereDoNotEntitleInput>;
  /** The ecommerceSku field where clause */
  ecommerceSku?: InputMaybe<EcommerceSkuMappingsWhereEcommerceSkuInput>;
  enabled?: InputMaybe<EcommerceSkuMappingsWhereEnabledInput>;
  provider?: InputMaybe<EcommerceSkuMappingsWhereProviderInput>;
};

/** Ecommerce Sku Mapping where Provider input type */
export type EcommerceSkuMappingsWhereProviderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Embedding parameters aligned with a target database table (key = Sequelize tableName) */
export type EmbeddingConfig = {
  __typename?: 'EmbeddingConfig';
  /** Created at */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Provider embedding model identifier */
  embeddingModel: Scalars['String'];
  /** Primary key */
  id: Scalars['ID'];
  /** Target table name this configuration applies to */
  key: Scalars['String'];
  /** Embedding API provider */
  provider: EmbeddingProvider;
  /** Updated at */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Vector column dimension count (e.g. for pgvector) */
  vectorDimensions: Scalars['Int'];
};

/** Create a new embedding configuration row */
export type EmbeddingConfigCreateInput = {
  embeddingModel: Scalars['String'];
  /** Target Sequelize table name (unique) */
  key: Scalars['String'];
  provider: EmbeddingProvider;
  vectorDimensions: Scalars['Int'];
};

/** Result of embedding_config create, update, or delete mutations */
export type EmbeddingConfigMutationPayload = {
  __typename?: 'EmbeddingConfigMutationPayload';
  /** The affected row (null when success is false, e.g. not found) */
  embeddingConfig?: Maybe<EmbeddingConfig>;
  /** Whether the mutation completed successfully */
  success: Scalars['Boolean'];
};

/** Update an existing embedding configuration row */
export type EmbeddingConfigUpdateInput = {
  embeddingModel?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  key?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<EmbeddingProvider>;
  vectorDimensions?: InputMaybe<Scalars['Int']>;
};

/** Where clause for embedding_config.embedding_model */
export type EmbeddingConfigWhereEmbeddingModelInput = {
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Where clause for embedding_config.id */
export type EmbeddingConfigWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** Where clause for embedding_config.key */
export type EmbeddingConfigWhereKeyInput = {
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Where clause for embedding_config.provider (DB values: openai, google) */
export type EmbeddingConfigWhereProviderInput = {
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Where clause for embedding_config.vector_dimensions */
export type EmbeddingConfigWhereVectorDimensionsInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
};

/** List response for embedding configuration rows */
export type EmbeddingConfigsListResponse = {
  __typename?: 'EmbeddingConfigsListResponse';
  /** Total row count (only when requested in the query) */
  count?: Maybe<Scalars['Int']>;
  /** Matching rows */
  embeddingConfigs?: Maybe<Array<Maybe<EmbeddingConfig>>>;
  /** Limit applied */
  limit?: Maybe<Scalars['Int']>;
  /** Offset applied */
  offset?: Maybe<Scalars['Int']>;
};

/** Filter for embeddingConfigsList */
export type EmbeddingConfigsWhereInput = {
  embeddingModel?: InputMaybe<EmbeddingConfigWhereEmbeddingModelInput>;
  id?: InputMaybe<EmbeddingConfigWhereIdInput>;
  key?: InputMaybe<EmbeddingConfigWhereKeyInput>;
  provider?: InputMaybe<EmbeddingConfigWhereProviderInput>;
  vectorDimensions?: InputMaybe<EmbeddingConfigWhereVectorDimensionsInput>;
};

/** Vendor that supplies text embeddings */
export enum EmbeddingProvider {
  Google = 'GOOGLE',
  Openai = 'OPENAI'
}

export type EntityRecognitionResult = {
  __typename?: 'EntityRecognitionResult';
  adjacency: Array<AdjacentCenter>;
  entities: Array<RecognizedEntity>;
  intentSignal: IntentSignal;
};

/** Event-specific data fields */
export type EventDataInput = {
  /** Date after trial start (e.g. for SubscriptionSignup) */
  afterTrialStartDate?: InputMaybe<Scalars['String']>;
  /** AI persona identifier */
  aiPersona?: InputMaybe<Scalars['String']>;
  /** AI session identifier (required for AI events) */
  aiSessionId?: InputMaybe<Scalars['String']>;
  /** Collated test assignments (optional, may be JSON string) */
  allTestsCollated?: InputMaybe<Scalars['String']>;
  /** Application name (required for some events). Valid values validated via Joi: android, android-app, ios-app, web-app, roku-app, wordpress-app, tvos-app, androidtv-app, firetv-app, ai-app. */
  appName?: InputMaybe<Scalars['String']>;
  /** Application version (required for some events) */
  appVersion?: InputMaybe<Scalars['String']>;
  /** User reached 5min threshold */
  at5Minutes?: InputMaybe<Scalars['Boolean']>;
  /** User at end (e.g. watch time > duration-15s or position >= 90%) */
  atEnd?: InputMaybe<Scalars['Boolean']>;
  /** User reached 25% engaged threshold */
  atEngaged?: InputMaybe<Scalars['Boolean']>;
  /** User reached 2min interested threshold */
  atInterested?: InputMaybe<Scalars['Boolean']>;
  /** User reached 15s qualified threshold */
  atQualified?: InputMaybe<Scalars['Boolean']>;
  /** Attempt number (e.g. for PaymentRecovered) */
  attemptNumber?: InputMaybe<Scalars['Int']>;
  /** Billing cycle days remaining (e.g. for CancelFlowStarted) */
  billingCycleDaysRemaining?: InputMaybe<Scalars['Int']>;
  /** Cancel reason (e.g. for CancelReasonSelected, CancelSaveOfferShown) */
  cancelReason?: InputMaybe<Scalars['String']>;
  /** Number of complimentary days (e.g. for SubscriptionComped) */
  compedDays?: InputMaybe<Scalars['Int']>;
  /** Content (video) ID */
  contentId?: InputMaybe<Scalars['Int']>;
  /** Array of content IDs for view content events */
  contentIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Content name for view content events */
  contentName?: InputMaybe<Scalars['String']>;
  /** Content identifier for detail page clicks */
  contentTitleGroupId?: InputMaybe<Scalars['String']>;
  /** Content type for view content events */
  contentType?: InputMaybe<Scalars['String']>;
  /** Conversation ID (UUID) */
  conversationId?: InputMaybe<Scalars['String']>;
  /** Conversation title */
  conversationTitle?: InputMaybe<Scalars['String']>;
  /** Country (e.g. for UserLead) */
  country?: InputMaybe<Scalars['String']>;
  /** Acquisition or signup source tag (Braze profile creation_source) */
  creationSource?: InputMaybe<Scalars['String']>;
  /** Currency code (e.g., 'USD', 'EUR') */
  currency?: InputMaybe<Scalars['String']>;
  /** Date of birth in YYYY-MM-DD format (e.g. for UserAttributesUpdate) */
  dateOfBirth?: InputMaybe<Scalars['String']>;
  /** Days since failure (e.g. for SubscriptionSuspended) */
  daysSinceFailure?: InputMaybe<Scalars['Float']>;
  /** Days since lapsed (e.g. for SubscriptionReactivated) */
  daysSinceLapsed?: InputMaybe<Scalars['Float']>;
  /** Days to recovery (e.g. for PaymentRecovered) */
  daysToRecovery?: InputMaybe<Scalars['Int']>;
  /** Total media duration in seconds */
  duration?: InputMaybe<Scalars['Int']>;
  /** Effective date (e.g. for PlanChanged) */
  effectiveDate?: InputMaybe<Scalars['String']>;
  /** Email address for lead events */
  email?: InputMaybe<Scalars['String']>;
  /** Braze email_subscribe: unsubscribed | subscribed | opted-in (validated by Joi) */
  emailSubscribe?: InputMaybe<Scalars['String']>;
  /** Error type */
  errorType?: InputMaybe<Scalars['String']>;
  /** Event number in sequence */
  eventNumber?: InputMaybe<Scalars['Int']>;
  /** External identifier */
  externalId?: InputMaybe<Scalars['String']>;
  /** Failure reason (e.g. for PaymentFailed) */
  failureReason?: InputMaybe<Scalars['String']>;
  /** Facebook click ID */
  fbc?: InputMaybe<Scalars['String']>;
  /** Facebook browser ID */
  fbp?: InputMaybe<Scalars['String']>;
  /** Feedback type (e.g. refresh, copy) */
  feedbackType?: InputMaybe<Scalars['String']>;
  /** First name (e.g. for UserStartedCart) */
  firstName?: InputMaybe<Scalars['String']>;
  /** Form name (e.g. for UserLead) */
  formName?: InputMaybe<Scalars['String']>;
  /** Gaia product SKU */
  gaiaProductSku?: InputMaybe<Scalars['String']>;
  /** Google Ads app click ID (gbraid). Mutually exclusive with gclid and wbraid for uploads. */
  gbraid?: InputMaybe<Scalars['String']>;
  /** Google Ads click ID (gclid). At most one of gclid, wbraid, gbraid should be set per event. */
  gclid?: InputMaybe<Scalars['String']>;
  /** Recipient email for gift subscription (e.g. for GiftSubscriptionPurchased). Optional. */
  giftSubscriptionPurchasedForEmail?: InputMaybe<Scalars['String']>;
  /** Guest phase identifier (required for some events) */
  guestPhase?: InputMaybe<Scalars['Boolean']>;
  /** Input method (e.g. Text, Speech, Toggle) */
  inputMethod?: InputMaybe<Scalars['String']>;
  /** Whether plan change is downgrade (e.g. for PlanChanged) */
  isDowngrade?: InputMaybe<Scalars['Boolean']>;
  /** Whether content is featured (optional) */
  isFeaturedMedia?: InputMaybe<Scalars['Boolean']>;
  /** Whether subscription is trial (e.g. for SubscriptionSignup) */
  isTrial?: InputMaybe<Scalars['Boolean']>;
  /** Whether plan change is upgrade (e.g. for PlanChanged) */
  isUpgrade?: InputMaybe<Scalars['Boolean']>;
  /** Last name (e.g. for UserStartedCart) */
  lastName?: InputMaybe<Scalars['String']>;
  /** Media ID */
  mediaId?: InputMaybe<Scalars['String']>;
  /** Media language (optional) */
  mediaLanguage?: InputMaybe<Scalars['String']>;
  /** User membership status (required for some events) */
  membershipStatus?: InputMaybe<Scalars['String']>;
  /** Message length in characters (e.g. for ai_message_received) */
  messageLength?: InputMaybe<Scalars['Int']>;
  /** Microsoft Advertising Click ID (msclkid) for Bing offline conversion attribution. */
  msclkid?: InputMaybe<Scalars['String']>;
  /** Next bill amount (Braze profile next_bill_amount) */
  nextBillAmount?: InputMaybe<Scalars['Float']>;
  /** Offer type (e.g. for CancelSaveOfferShown) */
  offerType?: InputMaybe<Scalars['String']>;
  /** Offer value (e.g. for CancelSaveOfferShown) */
  offerValue?: InputMaybe<Scalars['String']>;
  /** Order identifier for purchase events */
  orderId?: InputMaybe<Scalars['String']>;
  /** Page location identifier (optional) */
  pageLocation?: InputMaybe<Scalars['String']>;
  /** Paid-through date string (Braze profile paid_through_date) */
  paidThroughDate?: InputMaybe<Scalars['String']>;
  /** Parent series ID */
  parentSeriesId?: InputMaybe<Scalars['String']>;
  /** Parent series name (e.g. for recommendation events) */
  parentSeriesName?: InputMaybe<Scalars['String']>;
  /** Payment provider identifier (e.g. stripe, paypal) */
  paymentProvider?: InputMaybe<Scalars['String']>;
  /** Phone number (validated and standardized to E.164 via libphonenumber-js) */
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** Plan display name (Braze profile plan_name) */
  planName?: InputMaybe<Scalars['String']>;
  /** Playlist name */
  playlistName?: InputMaybe<Scalars['String']>;
  /** Playlist type */
  playlistType?: InputMaybe<Scalars['String']>;
  /** Play position in seconds */
  position?: InputMaybe<Scalars['Int']>;
  /** Price amount for purchase events */
  price?: InputMaybe<Scalars['Float']>;
  /** Content rating (0: Dislike, 1: Like, 2: Love) */
  rating?: InputMaybe<Scalars['Int']>;
  /** Recommendation ID for Recombee events */
  recommId?: InputMaybe<Scalars['String']>;
  /** Response type (e.g. text) */
  responseType?: InputMaybe<Scalars['String']>;
  /** Retention Period (1M, 3M, 6M, 12M, etc) */
  retentionPeriod?: InputMaybe<Scalars['String']>;
  /** Row name identifier (optional) */
  rowName?: InputMaybe<Scalars['String']>;
  /** Row placement identifier (optional) */
  rowPlacement?: InputMaybe<Scalars['Int']>;
  /** Search query text (e.g. for SearchPerformed) */
  searchQuery?: InputMaybe<Scalars['String']>;
  /** Source (e.g. for SubscriptionReactivated) */
  source?: InputMaybe<Scalars['String']>;
  /** Subscription tier */
  subscriptionTier?: InputMaybe<Scalars['String']>;
  /** Suspension reason (e.g. for SubscriptionSuspended) */
  suspensionReason?: InputMaybe<Scalars['String']>;
  /** Tile position number (optional) */
  tileNumber?: InputMaybe<Scalars['Int']>;
  /** Topic identifier (e.g. for TopicClicked) */
  topicId?: InputMaybe<Scalars['String']>;
  /** Topic name (e.g. for TopicClicked) */
  topicName?: InputMaybe<Scalars['String']>;
  /** Total time watched in seconds */
  totalTimeWatched?: InputMaybe<Scalars['Int']>;
  /** Whether a trial period applies (e.g. for SubscriptionSignup) */
  trialPeriod?: InputMaybe<Scalars['Boolean']>;
  /** TikTok Click ID (ttclid) for TikTok Events API offline conversion attribution. */
  ttclid?: InputMaybe<Scalars['String']>;
  /** TikTok Cookie ID (ttp) for TikTok Events API attribution. */
  ttp?: InputMaybe<Scalars['String']>;
  /** UI element identifier (optional) */
  uiElement?: InputMaybe<Scalars['String']>;
  /** UI location identifier (optional) */
  uiLocation?: InputMaybe<Scalars['String']>;
  /** User test assignment (optional) */
  userInTest?: InputMaybe<Scalars['Boolean']>;
  /** User language preference (required for some events); synced to Braze profile registration_language when present */
  userLanguage?: InputMaybe<Scalars['String']>;
  /** Lifetime Value - total amount paid over the lifetime of the user */
  userLifetimeValue?: InputMaybe<Scalars['Float']>;
  /** Player/device type (e.g. device_type from player stats) */
  vaPlayerName?: InputMaybe<Scalars['String']>;
  /** Video analytics session ID (e.g. user history row uuid) */
  vaSessionId?: InputMaybe<Scalars['String']>;
  /** Google Ads web-to-app click ID (wbraid). Mutually exclusive with gclid and gbraid for uploads. */
  wbraid?: InputMaybe<Scalars['String']>;
  /** Winback status */
  winback?: InputMaybe<Scalars['Boolean']>;
};

/** Filters for listing events */
export type EventListFilterInput = {
  /** End time range */
  endTimeAfter?: InputMaybe<Scalars['DateTime']>;
  endTimeBefore?: InputMaybe<Scalars['DateTime']>;
  /** Only past events (endTime < now) */
  pastOnly?: InputMaybe<Scalars['Boolean']>;
  /** Start time range */
  startTimeAfter?: InputMaybe<Scalars['DateTime']>;
  startTimeBefore?: InputMaybe<Scalars['DateTime']>;
  /** Event status filter */
  status?: InputMaybe<CommunityEventStatus>;
  /** Only upcoming events (startTime > now) */
  upcomingOnly?: InputMaybe<Scalars['Boolean']>;
};

export enum EventLocationType {
  Physical = 'PHYSICAL',
  Virtual = 'VIRTUAL'
}

/** Event log input */
export type EventLogInput = {
  /** Action source (e.g., 'website') */
  actionSource?: InputMaybe<Scalars['String']>;
  /** Event-specific data with typed fields */
  data?: InputMaybe<EventDataInput>;
  /** Optional event ID for tracking and deduplication (auto-generated if not provided) */
  eventId?: InputMaybe<Scalars['String']>;
  /** The event name */
  eventName: EventName;
  /** Source URL where the event originated (optional, derived from referer if not provided) */
  eventSourceUrl?: InputMaybe<Scalars['String']>;
  /** Event timestamp (optional, defaults to now) */
  eventTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional test ID for testing environments */
  testId?: InputMaybe<Scalars['String']>;
};

/** Event log response */
export type EventLogResponse = {
  __typename?: 'EventLogResponse';
  /** Response message */
  message?: Maybe<Scalars['String']>;
  /** Whether the event was logged successfully */
  success: Scalars['Boolean'];
};

/** Event name for user interaction events (used by Facebook, Recombee, or Braze) */
export enum EventName {
  /** User clicks add to playlist in the AI Chat */
  AiAddToPlaylist = 'AiAddToPlaylist',
  /** User clicks on a conversation in sidebar */
  AiConversationOpened = 'AiConversationOpened',
  /** Fires when the user makes the first post of a session on a previously exiting thread from the full page experience */
  AiConversationResumed = 'AiConversationResumed',
  /** User clicks New Conversation button, submits text in the empty state of chat home, selects a pre prompt from AI home, submits text from the MH module, or selects a pre prompt from MH module */
  AiConversationStarted = 'AiConversationStarted',
  /** AI returns a message */
  AiMessageReceived = 'AiMessageReceived',
  /** User types a message to AI from empty screen, in existing conversation, in MH module, selects a pre prompt from empty AI home or MH module, or is in voice mode and sends something that the AI responds to */
  AiMessageSent = 'AiMessageSent',
  /** User clicks on AI Member Home module item */
  AiModuleClicked = 'AiModuleClicked',
  /** User dismisses AI Video Player module */
  AiModuleClosed = 'AiModuleClosed',
  /** User populates AI Video Player module */
  AiModuleOpened = 'AiModuleOpened',
  /** User pins the AI Video Player module */
  AiModulePinned = 'AiModulePinned',
  /** The AI module becomes visible in the users viewport */
  AiModuleViewed = 'AiModuleViewed',
  /** User clicks on AI navigation item */
  AiNavigationClicked = 'AiNavigationClicked',
  /** User clicks on the AI video player icon */
  AiPlayerNavClicked = 'AiPlayerNavClicked',
  /** User disables AI Video Guide in the Settings page */
  AiVideoguideDisabled = 'AiVideoguideDisabled',
  /** User enables AI Video Guide in the Settings page */
  AiVideoguideEnabled = 'AiVideoguideEnabled',
  /** User connected via AirPlay */
  AirplayConnected = 'AirplayConnected',
  /** User experienced an app error */
  AppErrorExperienced = 'AppErrorExperienced',
  /** Member clicks Cancel Plan / Manage Subscription */
  CancelFlowStarted = 'CancelFlowStarted',
  /** Member accepts pause or hold option in cancel flow */
  CancelPauseAccepted = 'CancelPauseAccepted',
  /** Member declines pause or hold option in cancel flow */
  CancelPauseDeclined = 'CancelPauseDeclined',
  /** Pause / hold option shown */
  CancelPauseShown = 'CancelPauseShown',
  /** Member selects reason in Step 1 of flow */
  CancelReasonSelected = 'CancelReasonSelected',
  /** Member accepts save offer in cancel flow */
  CancelSaveOfferAccepted = 'CancelSaveOfferAccepted',
  /** Member declines save offer in cancel flow */
  CancelSaveOfferDeclined = 'CancelSaveOfferDeclined',
  /** Save offer is displayed to member in Step 3 */
  CancelSaveOfferShown = 'CancelSaveOfferShown',
  /** User connected via Chromecast */
  ChromecastConnected = 'ChromecastConnected',
  /** User clicks the Thumbs Up or Thumbs Down button */
  ContentRated = 'ContentRated',
  /** User viewed content (e.g. marketing site page with content id, type, and title). SNS uses snake_case content_viewed (e.g. Braze). Meta still receives standard ViewContent. */
  ContentViewed = 'ContentViewed',
  /** User clicks the Video or Series Title in Spotlight on the Member Home page, clicks the Title or Thumbnail on a Tile, clicks Video or Series Title in Jumbotron on Series | Episode Detail page, or clicks a Video Title in the Episode List, Related Tab, Recommended Next Video Tile, Just Finished Video, Notifications Menu, or Notifications page */
  DetailPageClicked = 'DetailPageClicked',
  /** User deleted a download */
  DownloadDeleted = 'DownloadDeleted',
  /** User purchases a gift subscription (use giftSubscriptionPurchasedForEmail for recipient) */
  GiftSubscriptionPurchased = 'GiftSubscriptionPurchased',
  /** Recipient redeems a gift subscription */
  GiftSubscriptionRedeemed = 'GiftSubscriptionRedeemed',
  /** User clicked an in-app message */
  InAppMessageClicked = 'InAppMessageClicked',
  /** User hits button to download a video to their device */
  OfflineDownloadStarted = 'OfflineDownloadStarted',
  /** User completed onboarding */
  OnboardingCompleted = 'OnboardingCompleted',
  /** User started onboarding */
  OnboardingStarted = 'OnboardingStarted',
  /** User views a page */
  PageViewed = 'PageViewed',
  /** Renewal charge fails (card decline, expired, etc.) */
  PaymentFailed = 'PaymentFailed',
  /** Failed payment subsequently succeeds */
  PaymentRecovered = 'PaymentRecovered',
  /** Member changes subscription plan (upgrade or downgrade) */
  PlanChanged = 'PlanChanged',
  /** User clicks Play button from Spotlight, Tile, Detail page, Video Player, Watch Later | Favorites | Watch History, Custom Playlist, Topic page, All Series page, Recently Added page, Films & Docs page, Recipes page, Yoga & Meditation page, All Yoga | All Meditations page, Person page, Programs | Lifestyle | Pilates & More, Search page, Episode List, Related tab, Recommended Next Tile on Video End Screen, or Video Autoplay on the Recommended Next Tile. User clicks Watch Now button in Jumbotron, for a Video in the Notifications Menu, or for a Video in the Notifications List page */
  PlayClick = 'PlayClick',
  /** User created a playlist */
  PlaylistCreated = 'PlaylistCreated',
  /** User deleted a playlist */
  PlaylistDeleted = 'PlaylistDeleted',
  /** Fires when API request to add a video or series to a playlist is fired. User clicks Add to Playlist button from Spotlight, Tile, Detail Page or Video Player and checks a Checkbox for a Playlist */
  PlaylistItemAdded = 'PlaylistItemAdded',
  /** Fires when API request to remove a video or series from a playlist is fired. User clicks Add to Playlist button from Spotlight, Tile, Detail Page or Video Player and unchecks a Checkbox for the Playlist the video is in. User selects any Playlist on the My Library page, clicks the Edit button, clicks the Red X Button on any number of Tiles, then clicks Done */
  PlaylistItemRemoved = 'PlaylistItemRemoved',
  /** User shared a playlist */
  PlaylistShared = 'PlaylistShared',
  /** User played a preview (requires mediaLanguage, mediaId, contentTitleGroupId) */
  PreviewPlayed = 'PreviewPlayed',
  /** Refund has been completed */
  RefundCompleted = 'RefundCompleted',
  /** Member or system requests a refund */
  RefundRequested = 'RefundRequested',
  /** User loads a Row on Member Home page or clicks an Arrow button for a Row on Member Home page */
  RowImpression = 'RowImpression',
  /** User performs a search (e.g. in-app search) */
  SearchPerformed = 'SearchPerformed',
  /** User follows a series (notification subscription) */
  SeriesFollowed = 'SeriesFollowed',
  /** User unfollows a series (notification subscription) */
  SeriesUnfollowed = 'SeriesUnfollowed',
  /** User initiated a share */
  ShareInitiated = 'ShareInitiated',
  /** Member cancels subscription */
  SubscriptionCanceled = 'SubscriptionCanceled',
  /** Subscription is comped (complimentary) */
  SubscriptionComped = 'SubscriptionComped',
  /** Member pauses or holds subscription */
  SubscriptionPaused = 'SubscriptionPaused',
  /** Suspended or cancelled member reactivates */
  SubscriptionReactivated = 'SubscriptionReactivated',
  /** Subscription renews at end of billing period */
  SubscriptionRenewed = 'SubscriptionRenewed',
  /** User signs up for a new subscription */
  SubscriptionSignup = 'SubscriptionSignup',
  /** Account moves to suspended state (payment failure grace period expired) */
  SubscriptionSuspended = 'SubscriptionSuspended',
  /** User follows a term/topic (notification subscription) */
  TermFollowed = 'TermFollowed',
  /** User unfollows a term/topic (notification subscription) */
  TermUnfollowed = 'TermUnfollowed',
  /** User clicks a sub or super topic on the browse All Topics page or clicks a Topic or Sub-topic from Topics Page */
  TopicClicked = 'TopicClicked',
  /** Updates one or more user profile attributes in downstream systems (e.g. Braze) */
  UserAttributesUpdate = 'UserAttributesUpdate',
  /** User Became Member */
  UserBecameMember = 'UserBecameMember',
  /** User posted a comment on content */
  UserComment = 'UserComment',
  /** Member converts from trial to paid or first recurring paid invoice (server-side); Meta maps to Convert_to_Paid */
  UserConvertedToPaid = 'UserConvertedToPaid',
  /** User changes their currency preference */
  UserCurrencyChanged = 'UserCurrencyChanged',
  /** User initiates checkout (e.g. See Plans button on Plan Selection page) */
  UserInitiatedCheckout = 'UserInitiatedCheckout',
  /** New prospect lead captured */
  UserLead = 'UserLead',
  /** User enters Credit Card / Paypal and clicks the Start Membership button on Payment page */
  UserPurchase = 'UserPurchase',
  /** User purchases a plan directly to paid */
  UserPurchasedDirectToPaid = 'UserPurchasedDirectToPaid',
  /** User purchased a free trial; Facebook displays as Free Trial Start - Purchase */
  UserPurchasedFreeTrial = 'UserPurchasedFreeTrial',
  /** User enters name, email, password and clicks Continue button on Account Creation page */
  UserRegistered = 'UserRegistered',
  /** User retained event */
  UserRetained = 'UserRetained',
  /** User began the cart process */
  UserStartedCart = 'UserStartedCart',
  /** Video analytics: user reached 5min threshold */
  Video5MinutesView = 'Video5MinutesView',
  /** Video buffering occurred */
  VideoBufferingEvent = 'VideoBufferingEvent',
  /** Video analytics: user reached end (e.g. watch time > duration-15s or position >= 90%) */
  VideoEndView = 'VideoEndView',
  /** Video analytics: video plays for 25% of the total duration. */
  VideoEngagedView = 'VideoEngagedView',
  /** Video analytics: user reached 2min interested threshold */
  VideoInterestedView = 'VideoInterestedView',
  /** User opened the video player (requires mediaLanguage, mediaId, contentTitleGroupId) */
  VideoPlayerOpened = 'VideoPlayerOpened',
  /** Video analytics: user reached 15s qualified threshold */
  VideoQualifiedView = 'VideoQualifiedView'
}

/** Feed image type enum */
export enum FeedImageType {
  /** Banner/cover image */
  Banner = 'banner',
  /** Profile/avatar image */
  Profile = 'profile'
}

/** Result of feed image upload */
export type FeedImageUploadResult = {
  __typename?: 'FeedImageUploadResult';
  /** The feed ID */
  feedId: Scalars['ID'];
  /** The image type */
  imageType: FeedImageType;
  /** The URL to render the image */
  url: Scalars['String'];
};

/** Feed role type enum */
export enum FeedRoleType {
  /** Admin role with full permissions */
  Admin = 'ADMIN',
  /** Member role with standard permissions */
  Member = 'MEMBER'
}

/** Feed visibility level */
export enum FeedVisibility {
  /** Private feed - visible only to members, admin adds members */
  Private = 'PRIVATE',
  /** Public feed - visible to all, anyone can join */
  Public = 'PUBLIC'
}

/** Field-level visibility */
export enum FieldVisibility {
  Private = 'private',
  Public = 'public'
}

/** Response for flagWatchedVideo mutation */
export type FlagWatchedVideoResponse = {
  __typename?: 'FlagWatchedVideoResponse';
  /** Whether the mutation succeeded */
  success: Scalars['Boolean'];
};

/** A foreign exchange rate between two currencies */
export type ForexRate = {
  __typename?: 'ForexRate';
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The destination currency */
  destinationCurrency: Scalars['String'];
  /** The exchange rate */
  exchangeRate: Scalars['Float'];
  /** The primary key for this record */
  id?: Maybe<Scalars['Int']>;
  /** The source currency */
  sourceCurrency: Scalars['String'];
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Input for a currency pair lookup */
export type ForexRatePairInput = {
  /** The destination currency */
  destinationCurrency: Scalars['String'];
  /** The source currency */
  sourceCurrency: Scalars['String'];
};

/** Remaining balance on a Shopify gift card */
export type GiftCardBalance = {
  __typename?: 'GiftCardBalance';
  /** Amount as a decimal string (Shopify MoneyV2) */
  amount: Scalars['String'];
  /** ISO 4217 currency code */
  currencyCode: Scalars['String'];
};

/** Result of consuming the full balance of a Shopify gift card by code */
export type GiftCardConsumePayload = {
  __typename?: 'GiftCardConsumePayload';
  /** Amount debited as a decimal string; null when lookup or debit failed before consumption */
  amountConsumed?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Result of debiting a Shopify gift card */
export type GiftCardDebitPayload = {
  __typename?: 'GiftCardDebitPayload';
  errorMessage?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Shopify gift card resolved by code (Admin API) */
export type GiftCardDetails = {
  __typename?: 'GiftCardDetails';
  balance: GiftCardBalance;
  /** Whether the card can be used */
  enabled: Scalars['Boolean'];
  /** Shopify GiftCard GID */
  giftCardId: Scalars['ID'];
};

/** Horoscope document payload for component rendering. */
export type HoroscopeCardDocument = {
  __typename?: 'HoroscopeCardDocument';
  /** Resolve the back image URL for the referenced collection. */
  backImageUrl?: Maybe<Scalars['String']>;
  collectionId?: Maybe<Scalars['ID']>;
  collectionKey?: Maybe<Scalars['String']>;
  horoscopeText: Scalars['String'];
  isFallbackGenerated?: Maybe<Scalars['Boolean']>;
  localDate: Scalars['String'];
  objects: Array<OracleDocumentObject>;
  provider?: Maybe<Scalars['String']>;
  pullId: Scalars['ID'];
  pulledAt?: Maybe<Scalars['String']>;
  readingId: Scalars['ID'];
  zodiacSign: Scalars['String'];
};

/** Horoscope state for daily-sign exposure UI decisions. */
export type HoroscopeFeatureState = {
  __typename?: 'HoroscopeFeatureState';
  chatSessionId?: Maybe<Scalars['ID']>;
  dailySignExposure: Scalars['JSON'];
  hasSession: Scalars['Boolean'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  lastUsedSessionId?: Maybe<Scalars['ID']>;
};

/**
 * Image represents an image file that can be associated with content.
 *
 * IMPORTANT: Assets are PREFERRED over Images for accessing content-related images.
 * - Assets have a deterministic relationship to content through ContentAssetReference, providing
 *   a clear, predictable way to associate files with content.
 * - Images have a non-deterministic relationship to content through ImageContentRelationship,
 *   making them unsuitable for programmatic access where consistency is required.
 *
 * Images will continue to be supported for backward compatibility, but Assets should always
 * be preferred when possible. Use contentAssetReferences on Content to access images via Assets
 * instead of using imageContentRelationships.
 *
 * The Image type may link to an Asset via the asset field, but this relationship is non-deterministic.
 */
export type Image = {
  __typename?: 'Image';
  /**
   * The asset associated with this image (if one exists).
   * NOTE: Assets are preferred over Images. Assets have a deterministic relationship to content, while Images have a non-deterministic relationship.
   * Use Assets via contentAssetReferences on Content instead.
   */
  asset?: Maybe<Asset>;
  /** The asset associated with this image */
  assetsId?: Maybe<Scalars['Int']>;
  /** Image Content Relationship primay key */
  contentRelationshipId?: Maybe<Scalars['ID']>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The file extension */
  fileExtension?: Maybe<Scalars['String']>;
  /** The file size in bytes */
  fileSize?: Maybe<Scalars['Int']>;
  /** The key for the image on the file system */
  fileSystemKey?: Maybe<Scalars['String']>;
  /** The hash of the image file */
  hash?: Maybe<Scalars['String']>;
  /** The height of the image in pixels */
  height?: Maybe<Scalars['String']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** Image content relationship linked to this image */
  imageContentRelationship?: Maybe<ImageContentRelationship>;
  /** The file mime type */
  mimeType?: Maybe<Scalars['String']>;
  /** The original file name that was uploaded for this image */
  originalFileName?: Maybe<Scalars['String']>;
  /** The provider of this image */
  provider?: Maybe<Scalars['String']>;
  /** The key used to access this image using the provider interface */
  providerKey?: Maybe<Scalars['String']>;
  /** The render provider e.g. the render url which is returned to the apps */
  renderUrlProvider?: Maybe<Scalars['String']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The image render url to be used when displaying an image */
  url?: Maybe<Scalars['String']>;
  /** The width of the image in pixels */
  width?: Maybe<Scalars['String']>;
};

/** Image content relationship */
export type ImageContentRelationship = {
  __typename?: 'ImageContentRelationship';
  /** The content title_group_id column linking from this image relationship to content */
  contentTitleGroupId?: Maybe<Scalars['String']>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The Drupal 6 Content Type which is combined with d6Id for Drupal look ups */
  d6ContentType?: Maybe<Scalars['String']>;
  /** The Drupal 6 Id which is combined with d6ContentType for Drupal look ups */
  d6Id?: Maybe<Scalars['Int']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** The image linked from this image content relationship */
  image?: Maybe<Image>;
  /** The this is the default image for the content i.e. the source image */
  isSource?: Maybe<Scalars['Boolean']>;
  /** The language this image is meant to statisfy in the relationship */
  language?: Maybe<Scalars['String']>;
  /** The type of relationship between the image and content */
  type?: Maybe<Scalars['String']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Image content relationship by content input */
export type ImageContentRelationshipByContentInput = {
  /** The content content id */
  contentId?: InputMaybe<Scalars['Int']>;
  /** The content content type */
  contentType?: InputMaybe<Scalars['String']>;
  /** The image content relationship types */
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Image content relationship where contentTitleGroupId input */
export type ImageContentRelationshipWhereContentTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Image content relationship where d6ContentType input */
export type ImageContentRelationshipWhereD6ContentTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Image content relationship where d6Id input */
export type ImageContentRelationshipWhereD6IdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Int']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Is the value less than the field */
  let?: InputMaybe<Scalars['Int']>;
};

/** Image content relationship where id input */
export type ImageContentRelationshipWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Image content relationship where input */
export type ImageContentRelationshipWhereInput = {
  /** Image content relationship where content title group id clause */
  contentTitleGroupId?: InputMaybe<ImageContentRelationshipWhereContentTitleGroupIdInput>;
  /** Image content relationship where d6 id clause */
  d6ContentType?: InputMaybe<ImageContentRelationshipWhereD6ContentTypeInput>;
  /** Image content relationship where d6 id clause */
  d6Id?: InputMaybe<ImageContentRelationshipWhereD6IdInput>;
  /** Image content relationship where id clause */
  id?: InputMaybe<ImageContentRelationshipWhereIdInput>;
  /** Image content relationship where language clause */
  language?: InputMaybe<ImageContentRelationshipWhereLanguageInput>;
  /** Image content relationship where type clause */
  type?: InputMaybe<ImageContentRelationshipWhereTypeInput>;
};

/** Image content relationship where language input */
export type ImageContentRelationshipWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Image content relationship where type input */
export type ImageContentRelationshipWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Image content relationship response */
export type ImageContentRelationshipsListResponse = {
  __typename?: 'ImageContentRelationshipsListResponse';
  /** A list of image content relationships */
  imageContentRelationships?: Maybe<Array<Maybe<ImageContentRelationship>>>;
};

/** Image providers */
export enum ImageProviders {
  /** AWS S3 */
  AwsS3 = 'AWS_S3',
  /** The imgIX image service */
  Imgix = 'IMGIX'
}

/** Image where id input */
export type ImageWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Image where input */
export type ImageWhereInput = {
  /** Image where id clause */
  id?: InputMaybe<ImageWhereIdInput>;
};

/** Images list response */
export type ImagesListResponse = {
  __typename?: 'ImagesListResponse';
  /** A list of images */
  images?: Maybe<Array<Maybe<Image>>>;
};

/** In or not-in list match */
export enum InNotInOperator {
  /** In list */
  In = 'IN',
  /** Not in list */
  NotIn = 'NOT_IN'
}

export type IntentSignal = {
  __typename?: 'IntentSignal';
  classification: Scalars['String'];
  reason: Scalars['String'];
  requiresLlm: Scalars['Boolean'];
};

export type InterestTopicOption = {
  __typename?: 'InterestTopicOption';
  /** Stable interest topic identifier */
  key: Scalars['String'];
  /** Display label for the topic */
  label: Scalars['String'];
};

export type InterestingAnswers = {
  __typename?: 'InterestingAnswers';
  /** Have you had an alien encounter? */
  alienEncounter?: Maybe<Scalars['Boolean']>;
  /** Do you think we're alone in the universe? */
  aloneInUniverse?: Maybe<Scalars['Boolean']>;
  /** If a spacecraft landed in front of you, would you approach it? */
  approachSpacecraft?: Maybe<Scalars['Boolean']>;
  /** Do you think deja vu is a clue or a glitch? (true=yes) */
  dejaVuBelief?: Maybe<Scalars['Boolean']>;
  /** Would you describe yourself as intuitive? */
  isIntuitive?: Maybe<Scalars['Boolean']>;
};

export enum Language {
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr'
}

export enum LeaderboardTimeWindow {
  AllTime = 'ALL_TIME',
  Month = 'MONTH',
  Week = 'WEEK'
}

/** Live Access session row (event or track schedule); mirrors REST spotlight session objects */
export type LiveAccessSpotlightSessionSummary = {
  __typename?: 'LiveAccessSpotlightSessionSummary';
  allowAnon?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  /** Session end (ISO 8601 or as returned by REST) */
  endDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isFree?: Maybe<Scalars['Boolean']>;
  isLiveStream?: Maybe<Scalars['Boolean']>;
  linkUrl?: Maybe<Scalars['String']>;
  localeLongDay?: Maybe<Scalars['String']>;
  localeShortDay?: Maybe<Scalars['String']>;
  sessionTime?: Maybe<Scalars['String']>;
  speakerName?: Maybe<Scalars['String']>;
  /** Session start (ISO 8601 or as returned by REST) */
  startDate?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** The input for a login / renew cookie argument */
export type LoginRenewCookieInput = {
  /** The domain for the cookie where it is valid */
  domain?: InputMaybe<Scalars['String']>;
  /** When true include cookie information the the token data that is returned */
  include?: InputMaybe<Scalars['Boolean']>;
  /** When true the cookie is considered secure */
  secure?: InputMaybe<Scalars['Boolean']>;
  /** When true call express cookie function to send the cookie header */
  send?: InputMaybe<Scalars['Boolean']>;
};

export type LoginRenewResponse = {
  __typename?: 'LoginRenewResponse';
  /** The current user authentication group, authentication tokens with values less than the current value are invalid */
  authenticationGroupId?: Maybe<Scalars['Int']>;
  /** The client attributes for the authentication token */
  clientAttributes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The codes for the login result */
  codes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The user country based on the request */
  country?: Maybe<Scalars['String']>;
  /** The user display name */
  displayName?: Maybe<Scalars['String']>;
  /** The user email address */
  email?: Maybe<Scalars['String']>;
  /** The date when the token expires */
  idExpires?: Maybe<Scalars['DateTime']>;
  /** The idToken to use in API requests */
  idToken?: Maybe<Scalars['String']>;
  /** A JWT token to use in authentication requests */
  jwt?: Maybe<Scalars['ID']>;
  /** The user languages */
  language?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The date of the last billing event which can be used to by an application to determine if new billing data should be fetched */
  lastBillingEvent?: Maybe<Scalars['DateTime']>;
  /** The messages for the login result */
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of user roles ids */
  roleIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** The google subscription status */
  subscriptionStatus?: Maybe<Scalars['String']>;
  /** A list of user subcription ids */
  subscriptions?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** When true login was successful */
  success?: Maybe<Scalars['Boolean']>;
  /** The user uid */
  uid?: Maybe<Scalars['ID']>;
  /** The current user account authentication group, authentication tokens with values less than the current value are invalid */
  userAccountAuthenticationGroupId?: Maybe<Scalars['Int']>;
  /** The user account id */
  userAccountId?: Maybe<Scalars['ID']>;
  /** The user username */
  username?: Maybe<Scalars['String']>;
  /** The user uuid */
  uuid?: Maybe<Scalars['ID']>;
};

export enum MatchSourceType {
  Agent = 'AGENT',
  User = 'USER'
}

/**
 * Media represents playable media content (video/audio streams) and associated metadata.
 *
 * Media is linked to Content and contains the actual playable streams and text tracks.
 * To get the actual media files (streams, subtitles, etc.), use the mediaAssets field to get
 * MediaAsset objects, then access their url fields via HTTP requests for the most efficient access.
 */
export type Media = {
  __typename?: 'Media';
  /** Media aspect ratio */
  aspectRatio?: Maybe<Scalars['String']>;
  /** Media colorspace value */
  colorspace?: Maybe<Scalars['String']>;
  /** All of the content where this media appears as the feature */
  contentFeatured?: Maybe<Array<Maybe<Content>>>;
  /** A fully qualified string identifier for the media (not content.contentId) */
  contentId?: Maybe<Scalars['String']>;
  /** The content policy linked to this media */
  contentPolicy?: Maybe<ContentPolicy>;
  /** All of the content where this media appears as the preview */
  contentPreview?: Maybe<Array<Maybe<Content>>>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The media duration derived from playable media asset of media reference type 'ms' */
  duration?: Maybe<Scalars['Int']>;
  /** Filename of input media file */
  filename?: Maybe<Scalars['String']>;
  /** Media framerate */
  framerate?: Maybe<Scalars['Int']>;
  /** A flag indicating the media has been published */
  isPublished?: Maybe<Scalars['Boolean']>;
  /** A list of linked media assets */
  mediaAssets?: Maybe<Array<Maybe<MediaAsset>>>;
  /** Video playback data for the media asset of type media stream (ms) */
  mediaAssetsVideoPlayback?: Maybe<Array<Maybe<MediaAssetVideoPlayback>>>;
  /** The primary key */
  mediaId?: Maybe<Scalars['ID']>;
  /** Media maestro ID */
  mediaMaestroTitleCode?: Maybe<Scalars['String']>;
  /** Media motion type */
  motionType?: Maybe<Scalars['String']>;
  /** viewing policy which can yield arrays of country codes allowed/denied */
  policyId?: Maybe<Scalars['Int']>;
  /** Media type */
  subtype?: Maybe<Scalars['String']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Media use (feature/trailer) */
  use?: Maybe<Scalars['Int']>;
  /** The user media position for the current position on this media */
  userMediaPosition?: Maybe<UserMediaPosition>;
  /** Size of Video (1080, 720, etc.) */
  videoSize?: Maybe<Scalars['Int']>;
};


/**
 * Media represents playable media content (video/audio streams) and associated metadata.
 *
 * Media is linked to Content and contains the actual playable streams and text tracks.
 * To get the actual media files (streams, subtitles, etc.), use the mediaAssets field to get
 * MediaAsset objects, then access their url fields via HTTP requests for the most efficient access.
 */
export type MediaContentFeaturedArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Media represents playable media content (video/audio streams) and associated metadata.
 *
 * Media is linked to Content and contains the actual playable streams and text tracks.
 * To get the actual media files (streams, subtitles, etc.), use the mediaAssets field to get
 * MediaAsset objects, then access their url fields via HTTP requests for the most efficient access.
 */
export type MediaContentPreviewArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Media represents playable media content (video/audio streams) and associated metadata.
 *
 * Media is linked to Content and contains the actual playable streams and text tracks.
 * To get the actual media files (streams, subtitles, etc.), use the mediaAssets field to get
 * MediaAsset objects, then access their url fields via HTTP requests for the most efficient access.
 */
export type MediaMediaAssetsArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageMatchType?: InputMaybe<MediaMediaAssetsLanguageMatchType>;
  mediaAssets?: InputMaybe<Array<InputMaybe<MediaMediaAssetsInput>>>;
};


/**
 * Media represents playable media content (video/audio streams) and associated metadata.
 *
 * Media is linked to Content and contains the actual playable streams and text tracks.
 * To get the actual media files (streams, subtitles, etc.), use the mediaAssets field to get
 * MediaAsset objects, then access their url fields via HTTP requests for the most efficient access.
 */
export type MediaMediaAssetsVideoPlaybackArgs = {
  deliveryRule?: InputMaybe<MediaAssetVideoPlaybackDeliverRule>;
  hlsVersion?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageMatchType?: InputMaybe<MediaMediaAssetsLanguageMatchType>;
};

/**
 * Media asset represents a file associated with media (video streams, subtitles, closed captions, chapters).
 *
 * Media assets are the actual files that make up playable media content:
 * - MEDIA_STREAM: Playable video/audio streams (HLS, DASH)
 * - CLOSED_CAPTION: Closed caption text tracks (VTT format)
 * - SUBTITLE: Subtitle text tracks (VTT format)
 * - CHAPTER: Chapter marker text tracks (VTT format)
 *
 * Important Usage Notes:
 * - To get the actual media asset file, use the url field and make an HTTP GET request to that URL.
 *   This is the most efficient way to retrieve media asset data, as it leverages CDN caching and
 *   direct file access rather than going through GraphQL.
 *
 * - For text tracks (subtitles, closed captions, chapters): If you only need the raw VTT file data,
 *   it is more efficient to access the url directly via REST/HTTP rather than using GraphQL.
 *   GraphQL is better when you need parsed metadata (via providerData) or relationships, but for
 * raw file content, direct URL access is preferred.
 */
export type MediaAsset = {
  __typename?: 'MediaAsset';
  /**
   * AI-authored metadata for this media asset, resolved by the AI service.
   * Returns null when no metadata is available.
   */
  aiMetadata?: Maybe<MediaAssetAiMetadata>;
  /** The content policy linked to this media asset by the media */
  contentPolicy?: Maybe<ContentPolicy>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** An optional duration */
  duration?: Maybe<Scalars['Int']>;
  /** An optional height */
  height?: Maybe<Scalars['Int']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** The status of ingest for the provider asset */
  ingestStatus?: Maybe<Scalars['String']>;
  /** The language of asset that was used to create all of the translations */
  language?: Maybe<Scalars['String']>;
  /** The media associated with this media asset */
  media?: Maybe<Media>;
  /** The media asset document linked to this media asset */
  mediaAssetDocument?: Maybe<MediaAssetDocument>;
  /** The media id on the media table */
  mediaId?: Maybe<Scalars['ID']>;
  /** A string that describes the relationship between the asset and media e.g. cc */
  mediaReferenceType?: Maybe<Scalars['String']>;
  /** The mime type of the asset */
  mimeType?: Maybe<Scalars['String']>;
  /** The original name of the file for the asset */
  originalFileName?: Maybe<Scalars['String']>;
  /** The provider where the asset is stored e.g. AWS_S3 */
  provider?: Maybe<Scalars['String']>;
  /**
   * The media assets provider specific data (e.g., parsed VTT data).
   * This field provides structured access to parsed content like VTT cues for text tracks.
   * If you only need raw file data, use the url field with direct HTTP access instead.
   */
  providerData?: Maybe<MediaAssetProviderData>;
  /** The unique key for the asset on providers system e.g. on S3 it would be file key or it might be a url for an external provider */
  providerKey?: Maybe<Scalars['String']>;
  /** The when true the media asset is publically available */
  published?: Maybe<Scalars['Boolean']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /**
   * The URL to retrieve the media asset file.
   * This is the most efficient way to get the actual media asset - make an HTTP GET request to this URL.
   * For text tracks (subtitles, closed captions, chapters), accessing this URL directly via REST
   * is preferred over GraphQL if you only need the raw VTT file data.
   */
  url?: Maybe<Scalars['String']>;
  /** The public primary identifier for this record */
  uuid?: Maybe<Scalars['String']>;
  /** Video playback data for media streams */
  videoPlayback?: Maybe<MediaAssetVideoPlayback>;
  /** An optional width */
  width?: Maybe<Scalars['Int']>;
};


/**
 * Media asset represents a file associated with media (video streams, subtitles, closed captions, chapters).
 *
 * Media assets are the actual files that make up playable media content:
 * - MEDIA_STREAM: Playable video/audio streams (HLS, DASH)
 * - CLOSED_CAPTION: Closed caption text tracks (VTT format)
 * - SUBTITLE: Subtitle text tracks (VTT format)
 * - CHAPTER: Chapter marker text tracks (VTT format)
 *
 * Important Usage Notes:
 * - To get the actual media asset file, use the url field and make an HTTP GET request to that URL.
 *   This is the most efficient way to retrieve media asset data, as it leverages CDN caching and
 *   direct file access rather than going through GraphQL.
 *
 * - For text tracks (subtitles, closed captions, chapters): If you only need the raw VTT file data,
 *   it is more efficient to access the url directly via REST/HTTP rather than using GraphQL.
 *   GraphQL is better when you need parsed metadata (via providerData) or relationships, but for
 * raw file content, direct URL access is preferred.
 */
export type MediaAssetAiMetadataArgs = {
  language?: InputMaybe<Scalars['String']>;
};


/**
 * Media asset represents a file associated with media (video streams, subtitles, closed captions, chapters).
 *
 * Media assets are the actual files that make up playable media content:
 * - MEDIA_STREAM: Playable video/audio streams (HLS, DASH)
 * - CLOSED_CAPTION: Closed caption text tracks (VTT format)
 * - SUBTITLE: Subtitle text tracks (VTT format)
 * - CHAPTER: Chapter marker text tracks (VTT format)
 *
 * Important Usage Notes:
 * - To get the actual media asset file, use the url field and make an HTTP GET request to that URL.
 *   This is the most efficient way to retrieve media asset data, as it leverages CDN caching and
 *   direct file access rather than going through GraphQL.
 *
 * - For text tracks (subtitles, closed captions, chapters): If you only need the raw VTT file data,
 *   it is more efficient to access the url directly via REST/HTTP rather than using GraphQL.
 *   GraphQL is better when you need parsed metadata (via providerData) or relationships, but for
 * raw file content, direct URL access is preferred.
 */
export type MediaAssetVideoPlaybackArgs = {
  deliveryRule?: InputMaybe<MediaAssetVideoPlaybackDeliverRule>;
  hlsVersion?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** AI-authored metadata for a media asset resolved by the AI service. */
export type MediaAssetAiMetadata = {
  __typename?: 'MediaAssetAiMetadata';
  /** Language/locale for the metadata payload. */
  language: Scalars['String'];
  /** AI-assessed learner level from summary validator (level, reasoning, score). */
  learnerLevel?: Maybe<ContentAiLearnerLevel>;
  /** Parent media identifier. */
  mediaId: Scalars['ID'];
  /** AI-generated summary text, or null when unavailable. */
  summary?: Maybe<Scalars['String']>;
  /** Pre-processed transcript text, or null when unavailable. */
  transcript?: Maybe<Scalars['String']>;
};

/**
 * **`media_asset_documents` join row:** pairs one **`MediaAsset`** (`mediaAssetsId`) with one **`documents`** row (`documentsId`). This is the **primary** link when indexing is driven from a concrete media asset (e.g. captions/transcripts) without a **`content_documents`** row first.
 *
 * **Resolver interaction:** When this row exists, **`Document.documentMediaAsset`** and **`Document.mediaAssets`** resolve to this asset; **`Document.documentContent`** is `null` unless a separate **`content_documents`** row also exists. **`Document.content`** may still list **`Content`** rows whose **`featureMediaId`** matches the linked media’s **`mediaId`**. See **`Document`** for full precedence between content-linked and media-linked paths.
 *
 * **Embeddings:** Chunk rows on **`Document.documentEmbeddings`** carry **`metadata`** pointing back to source content/media; offline title-level summary + vector live in **`document_abstracts`** and are read via **`documentAbstractList`**.
 */
export type MediaAssetDocument = {
  __typename?: 'MediaAssetDocument';
  /** Join row creation time. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The **`Document`** row used for embeddings and worker processing for this asset. */
  document?: Maybe<Document>;
  /** `documents.id` participating in this link. */
  documentsId?: Maybe<Scalars['ID']>;
  /** The **`MediaAsset`** row (tracks, duration, language, etc.) for this join. */
  mediaAsset?: Maybe<MediaAsset>;
  /** `MediaAsset` primary key participating in this link. */
  mediaAssetsId?: Maybe<Scalars['ID']>;
  /** Join row last update time. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Media asset response */
export type MediaAssetListResponse = {
  __typename?: 'MediaAssetListResponse';
  /** A list of media */
  mediaAssets?: Maybe<Array<Maybe<MediaAsset>>>;
};

export enum MediaAssetMediaReferenceTypes {
  /** The asset represents a chapter marker */
  Chapter = 'CHAPTER',
  /** The asset represents a closed caption */
  ClosedCaption = 'CLOSED_CAPTION',
  /** The asset represents a playable media stream i.e. hls */
  MediaStream = 'MEDIA_STREAM',
  /** The asset represents a subtitle */
  Subtitle = 'SUBTITLE'
}

/** The provider specific data for the media asset e.g. parsed VTT data */
export type MediaAssetProviderData = {
  __typename?: 'MediaAssetProviderData';
  /** The provider data as text if supported */
  text?: Maybe<Scalars['String']>;
  /** Parsed vtt data */
  vtt?: Maybe<MediaAssetProviderDataVtt>;
};

/** Parsed vtt data */
export type MediaAssetProviderDataVtt = {
  __typename?: 'MediaAssetProviderDataVtt';
  /** The parsed VTT data cues */
  cues?: Maybe<Array<Maybe<MediaAssetProviderDataVttQues>>>;
};

/** The parsed VTT data cues */
export type MediaAssetProviderDataVttQues = {
  __typename?: 'MediaAssetProviderDataVttQues';
  alignment?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lineAlign?: Maybe<Scalars['String']>;
  linePosition?: Maybe<Scalars['String']>;
  pauseOnExit?: Maybe<Scalars['String']>;
  positionAlign?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  snapToLines?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  textPosition?: Maybe<Scalars['String']>;
};

/** The video playback information for media assets of type media stream */
export type MediaAssetVideoPlayback = {
  __typename?: 'MediaAssetVideoPlayback';
  /** The provider DASH url */
  dashUrl?: Maybe<Scalars['String']>;
  /** The provider HLS url */
  hlsUrl?: Maybe<Scalars['String']>;
  /** The HLS stream version */
  hlsVersion?: Maybe<Scalars['String']>;
  /** The media asset id */
  id?: Maybe<Scalars['ID']>;
  /** The media asset language */
  language?: Maybe<Scalars['String']>;
  /** The video thumbnail url */
  thumbnailUrl?: Maybe<Scalars['String']>;
};

/** The video playback delivery rules */
export enum MediaAssetVideoPlaybackDeliverRule {
  /** Apply the byte range delivery rule */
  ByteRange = 'BYTE_RANGE'
}

/** The video playback delivery rules */
export enum MediaAssetVideoPlaybackHlsVersions {
  /** HLS version 3 */
  V3 = 'v3',
  /** HLS version 4 */
  V4 = 'v4',
  /** HLS version 7 */
  V7 = 'v7'
}

/** The where clause for a media asset id field */
export type MediaAssetWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** Media asset where input */
export type MediaAssetWhereInput = {
  /** Media asset where id clause */
  id?: InputMaybe<MediaAssetWhereIdInput>;
  /** Media asset where mediaId clause */
  mediaId?: InputMaybe<MediaAssetWhereMediaIdInput>;
  /** Media asset where mediaReferenceType clause */
  mediaReferenceType?: InputMaybe<MediaAssetWhereMediaReferenceTypenput>;
};

/** The where clause for a media asset id field */
export type MediaAssetWhereMediaIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** The where clause for a media asset media reference type field */
export type MediaAssetWhereMediaReferenceTypenput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Return type for media create */
export type MediaCreateResponse = {
  __typename?: 'MediaCreateResponse';
  /** The newly created media */
  media?: Maybe<Media>;
};

/** Media input for create/update operations */
export type MediaInput = {
  /** Media aspect ratio */
  aspectRatio?: InputMaybe<Scalars['String']>;
  /** Brightcove data array (optional) */
  brightcove?: InputMaybe<Array<InputMaybe<BrightcoveInput>>>;
  /** Media colorspace value */
  colorspace?: InputMaybe<Scalars['String']>;
  /** A fully qualified string identifier for the media (required) */
  contentId: Scalars['String'];
  /** Filename of input media file */
  filename?: InputMaybe<Scalars['String']>;
  /** Media framerate */
  framerate?: InputMaybe<Scalars['Int']>;
  /** A flag indicating the media has been published */
  isPublished?: InputMaybe<Scalars['Boolean']>;
  /** The primary key (optional for create, auto-generated if not provided) */
  mediaId?: InputMaybe<Scalars['ID']>;
  /** Media maestro ID */
  mediaMaestroTitleCode?: InputMaybe<Scalars['String']>;
  /** Media motion type */
  motionType?: InputMaybe<Scalars['String']>;
  /** viewing policy which can yield arrays of country codes allowed/denied */
  policyId?: InputMaybe<Scalars['Int']>;
  /** Media type */
  subtype?: InputMaybe<Scalars['String']>;
  /** Media use (feature/trailer) */
  use?: InputMaybe<Scalars['Int']>;
  /** Size of Video (1080, 720, etc.) */
  videoSize?: InputMaybe<Scalars['Int']>;
};

/** Media asset response */
export type MediaListResponse = {
  __typename?: 'MediaListResponse';
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** A list of media */
  media?: Maybe<Array<Maybe<Media>>>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
};

/** Media filter for media assets */
export type MediaMediaAssetsInput = {
  /** The media asset language */
  language?: InputMaybe<Scalars['String']>;
  /** The media asset media reference type */
  mediaReferenceType?: InputMaybe<Scalars['String']>;
};

/** The media media assets association language match type */
export enum MediaMediaAssetsLanguageMatchType {
  /** Match any of the languages */
  Any = 'ANY'
}

/** The where conditions to filter rows */
export type MediaWhereInput = {
  /** The media content id (not content.id or content.content_id) */
  contentId?: InputMaybe<MediaWhereMediaContentIdInput>;
  /** The media id */
  mediaId?: InputMaybe<MediaWhereMediaIdInput>;
};

/** The where clause for a media content id field */
export type MediaWhereMediaContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value a case-insensitive substring of the field */
  ilike?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** The where clause for a media id field */
export type MediaWhereMediaIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

export type MessagePairSearchResult = {
  __typename?: 'MessagePairSearchResult';
  createdAt: Scalars['DateTime'];
  matchSource: MatchSourceType;
  messageIndexInConversation: Scalars['Int'];
  messagePairId: Scalars['ID'];
  searchRank: Scalars['Float'];
  snippet: Scalars['String'];
};

export enum ModerationAction {
  Approve = 'APPROVE',
  BanUser = 'BAN_USER',
  Reject = 'REJECT',
  Remove = 'REMOVE'
}

export enum ModerationStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Removed = 'REMOVED'
}

/** Oracle AI: Root mutation operations */
export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']>;
  /** Add a member to a community feed (admin only) */
  addCommunityFeedMember?: Maybe<CommunityFeed>;
  ambassadorLeadsUploadNdJsonToS3: AmbassadorLeadsUploadFileToS3Response;
  /** Assign a user as a moderator of a feed (admin only) */
  assignFeedModerator?: Maybe<Scalars['Boolean']>;
  /** Fetch playlist from Brightcove CMS and attach WebVTT captions to existing Gaia clips only (does not create clips) */
  attachClipCaptionsFromBrightcovePlaylist?: Maybe<AttachClipCaptionsFromBrightcovePlaylistResponse>;
  /** Creates a new auth role */
  authRoleCreate: AuthRoleMutationResponse;
  /** Deletes an existing auth role */
  authRoleDelete: AuthRoleMutationResponse;
  /** Updates an existing auth role */
  authRoleUpdate: AuthRoleMutationResponse;
  authScopeCreate: AuthScopeMutationResponse;
  authScopeDelete: AuthScopeMutationResponse;
  authScopeUpdate: AuthScopeMutationResponse;
  /** Create a billing events */
  billingCreateEvent?: Maybe<BillingEvent>;
  /** Update a billing events */
  billingUpdateEvent?: Maybe<BillingEvent>;
  /** Cancel RSVP to an event */
  cancelRsvpToCommunityEvent?: Maybe<CommunityEventRegistrationSummary>;
  /** Oracle AI: Create a channel prompt set */
  channelPromptSetCreate: ChannelPromptSetMutationResponse;
  /** Oracle AI: Delete channel prompt set */
  channelPromptSetDelete: ChannelPromptSetDeleteResponse;
  /** Oracle AI: Replace sections for a channel prompt set */
  channelPromptSetReplaceSections: ChannelPromptSetMutationResponse;
  /** Oracle AI: Update channel prompt set status */
  channelPromptSetUpdateStatus: ChannelPromptSetMutationResponse;
  /** Create a chat history */
  chatHistoryCreate?: Maybe<ChatHistoryMutationResponse>;
  /** Delete a chat history */
  chatHistoryDelete?: Maybe<ChatHistoryMutationResponse>;
  /** Update a chat history */
  chatHistoryUpdate?: Maybe<ChatHistoryMutationResponse>;
  /** Create a chat session */
  chatSessionCreate?: Maybe<ChatSessionMutationResponse>;
  /** Delete a chat session */
  chatSessionDelete?: Maybe<ChatSessionMutationResponse>;
  /** Update a chat session */
  chatSessionUpdate?: Maybe<ChatSessionMutationResponse>;
  /** Create a vertical clip with ms_clip media, clip-vert reference to parent, and optional AI multiplier metadata */
  clipCreate?: Maybe<ClipCreateResponse>;
  /** Import clips from a Brightcove CMS playlist. Parent Gaia video per row: Brightcove clip_source_video_id or clip_source as ms stream provider key, else perVideoParentOverrides entry. */
  clipImportFromBrightcovePlaylist?: Maybe<ClipImportFromBrightcovePlaylistResponse>;
  /** Create a new comment on content */
  commentCreate: CommentMutationResponse;
  /** Report a comment for review */
  commentReport: CommentMutationResponse;
  /** Edit an existing comment (must be own comment) */
  commentUpdate: CommentMutationResponse;
  /** Confirm a banner image upload after the client PUTs the image */
  confirmBannerImageUpload: BannerImageUploadResponse;
  /** Confirm a playlist cover photo upload after the client PUTs the image */
  confirmPlaylistCoverPhotoUpload: PlaylistCoverPhotoUploadResponse;
  /** Confirm a profile picture upload after the client PUTs the image */
  confirmProfilePictureUpload: ProfilePictureUploadResponse;
  /** Record a discount redemption for a user (admin). Persists a billing_discount_redemption row. */
  consumeDiscount: BillingDiscountRedemption;
  /** Create a content anon row for the given content (Content.id). Fails if one already exists. */
  contentAnonCreate?: Maybe<ContentAnonCreateResponse>;
  /** Delete the content anon row for the given content (Content.id). EDITOR cannot delete; EDITOR_PLUS and above only. */
  contentAnonDelete?: Maybe<ContentAnonDeleteResponse>;
  /** Update the content anon row for the given content (Content.id). */
  contentAnonUpdate?: Maybe<ContentAnonUpdateResponse>;
  /** Creates a new content asset reference */
  contentAssetReferenceCreate: ContentAssetReferenceMutationResponse;
  /** Deletes an existing content asset reference */
  contentAssetReferenceDelete: ContentAssetReferenceMutationResponse;
  /** Create a new piece of content */
  contentCreate?: Maybe<ContentCreateResponse>;
  /** Create one content list criteria */
  contentListCriteriaCreate?: Maybe<ContentListCriteriaMutationResponse>;
  /** Delete one content list criteria */
  contentListCriteriaDelete?: Maybe<ContentListCriteriaMutationResponse>;
  /** Create one content provider */
  contentProviderCreateByContentId?: Maybe<ContentProviderMutationResponse>;
  /** Delete one content provider */
  contentProviderDeleteByContentId?: Maybe<ContentProviderMutationResponse>;
  /** Update one content provider */
  contentProviderUpdateByContentId?: Maybe<ContentProviderMutationResponse>;
  /** Create a content reference */
  contentReferenceCreate: ContentReferenceCreateResponse;
  /**
   * Create many content references
   * - Does not error if references already exist
   */
  contentReferenceCreateMany: ContentReferenceCreateManyResponse;
  /** Delete a content reference */
  contentReferenceDelete: ContentReferenceDeleteResponse;
  /** Update a single piece of content */
  contentUpdate?: Maybe<ContentUpdateResponse>;
  /** Mark an entire course as complete */
  courseMarkComplete: UserStateProgressCourse;
  /** Mark a course module as complete */
  courseModuleMarkComplete: UserStateProgressCourseModule;
  /** Reset a course (removes all progress, preserves completion count) */
  courseReset: UserStateProgressCourse;
  /** Start a course (marks first video as in progress) */
  courseStart: UserStateProgressCourse;
  createApiKey: ApiKeyMutationResponse;
  /** Create a billing account */
  createBillingAccount: BillingAccount;
  /** Create a billing discount */
  createBillingDiscount?: Maybe<BillingDiscount>;
  /** Create a billingInvoice */
  createBillingInvoice?: Maybe<BillingInvoice>;
  /** Create a billingOneTimePurchase */
  createBillingOneTimePurchase?: Maybe<BillingOneTimePurchase>;
  /** Create a billingPayment */
  createBillingPayment?: Maybe<BillingPayment>;
  /** Create a billingPaymentMethod */
  createBillingPaymentMethod?: Maybe<BillingPaymentMethod>;
  /** Create a billing plan grid */
  createBillingPlanGrid?: Maybe<BillingPlanGrid>;
  /** Create billingProduct */
  createBillingProduct?: Maybe<BillingProduct>;
  /** Create a billingProductChangeLog */
  createBillingProductChangeLog?: Maybe<BillingProductChangeLog>;
  /** Create billingProvider */
  createBillingProvider?: Maybe<BillingProvider>;
  /** Create billingProviderCurrency */
  createBillingProviderCurrency?: Maybe<BillingProviderCurrency>;
  /** Create billingProviderProduct */
  createBillingProviderProduct?: Maybe<BillingProviderProduct>;
  /** Create a plan eligibility rule */
  createBillingProviderProductEligibility?: Maybe<BillingProviderProductEligibility>;
  /** Create a billingProviderProductPricing */
  createBillingProviderProductPrice?: Maybe<BillingProviderProductPricing>;
  /** Create a billingProviderProductText */
  createBillingProviderProductText?: Maybe<BillingProviderProductText>;
  /** Create a billingRefund */
  createBillingRefund?: Maybe<BillingRefund>;
  /** Create a billingSubscription */
  createBillingSubscription?: Maybe<BillingSubscription>;
  /** Create a billingSubscriptionOrder */
  createBillingSubscriptionOrder?: Maybe<BillingSubscriptionOrder>;
  /** Create a BillingSubscriptionOrderPlan */
  createBillingSubscriptionOrderPlan?: Maybe<BillingSubscriptionOrderPlan>;
  /** Create a billingSubscriptionPlan */
  createBillingSubscriptionPlan?: Maybe<BillingSubscriptionPlan>;
  /** Create a new event in a feed (admin only) */
  createCommunityEvent?: Maybe<CommunityEvent>;
  /** Create a community feed (admin only) */
  createCommunityFeed?: Maybe<CommunityFeed>;
  /** Create a community post or comment */
  createCommunityPost?: Maybe<CommunityPost>;
  /** Create a community reaction */
  createCommunityReaction?: Maybe<Scalars['Boolean']>;
  /** Create a new custom emoji (Admin only) */
  createCustomEmoji: CustomEmoji;
  /** Create a transactions */
  createTransaction?: Maybe<Transaction>;
  /** Create a userAuditLog */
  createUserAuditLog?: Maybe<UserAuditLog>;
  /**
   * Create a user entitlement. Typically used by administrators or customer service to manually
   * grant access. In normal operation, entitlements are created automatically when billing events
   * are processed. Requires elevated role access.
   */
  createUserEntitlement?: Maybe<UserEntitlement>;
  /** Delete the current user's banner image */
  deleteBannerImage: DeleteBannerImageResponse;
  /** Delete a billing plan grid */
  deleteBillingPlanGrid?: Maybe<DeleteBillingPlanGridResponse>;
  /** Delete a plan eligibility rule */
  deleteBillingProviderProductEligibility?: Maybe<BillingProviderProductEligibilityDeleteResponse>;
  /** Delete a billingProviderProductPricing */
  deleteBillingProviderProductPrice?: Maybe<BillingProviderProductPricingDeleteResponse>;
  /** Delete a billingProviderProductText */
  deleteBillingProviderProductText?: Maybe<BillingProviderProductTextDeleteResponse>;
  /** Delete an event (admin only) */
  deleteCommunityEvent?: Maybe<Scalars['Boolean']>;
  /** Delete a community feed (admin only) */
  deleteCommunityFeed?: Maybe<Scalars['Boolean']>;
  /** Delete a community post or comment */
  deleteCommunityPost?: Maybe<Scalars['Boolean']>;
  /** Delete a community reaction */
  deleteCommunityReaction?: Maybe<Scalars['Boolean']>;
  /** Delete a custom emoji (Admin only) */
  deleteCustomEmoji: Scalars['Boolean'];
  /** Delete a feed image (admin only) */
  deleteFeedImage: Scalars['Boolean'];
  /** Delete a playlist's cover photo */
  deletePlaylistCoverPhoto: DeletePlaylistCoverPhotoResponse;
  /** Delete the current user's profile picture */
  deleteProfilePicture: DeleteProfilePictureResponse;
  /** Create a discount code in Shopify */
  discountCodeCreate?: Maybe<DiscountCodeCreateResponse>;
  /** Reset the document embeddings worker: clear worker data; in one transaction drop rebuild tables if present and recreate empty rebuild tables from embedding_config */
  documentsWorkerReset?: Maybe<DocumentsWorkerResetResponse>;
  /** Create one ecommerce sku mapping bonus eligibility */
  ecommerceSkuMappingBonusEligibilityCreate?: Maybe<EcommerceSkuMappingBonusEligibilityCreateResponse>;
  /** Delete one ecommerce sku mapping bonus eligibility */
  ecommerceSkuMappingBonusEligibilityDeleteById?: Maybe<EcommerceSkuMappingBonusEligibilityDeleteByIdResponse>;
  /** Update one ecommerce sku mapping bonus eligibility */
  ecommerceSkuMappingBonusEligibilityUpdateById?: Maybe<EcommerceSkuMappingBonusEligibilityUpdateByIdResponse>;
  /** Create one GAIA_BONUS ecommerce sku mapping. See EcommerceSkuMappingCreateInput for entitlement configuration. Purchasers always receive content set 222; subscription-only SKUs require contentTitleGroupIds: [] plus contentSetId and subscription timing fields. */
  ecommerceSkuMappingCreate?: Maybe<EcommerceSkuMappingCreateResponse>;
  /** Update one GAIA_BONUS ecommerce sku mapping. See EcommerceSkuMappingUpdateByProviderAndEcommerceSkuInput for entitlement configuration. */
  ecommerceSkuMappingUpdateByProviderAndEcommerceSku?: Maybe<EcommerceSkuMappingUpdateByProviderAndEcommerceSkuResponse>;
  /** Insert an embedding_config row (site admin only) */
  embeddingConfigCreate?: Maybe<EmbeddingConfigMutationPayload>;
  /** Delete an embedding_config row by id (site admin only) */
  embeddingConfigDelete?: Maybe<EmbeddingConfigMutationPayload>;
  /** Update an embedding_config row (site admin only) */
  embeddingConfigUpdate?: Maybe<EmbeddingConfigMutationPayload>;
  /** Log a user interaction event */
  eventLog: EventLogResponse;
  /** Flag content for moderation */
  flagCommunityContent?: Maybe<Scalars['Boolean']>;
  /** Hide or unhide a video from the user's watch history */
  flagWatchedVideo: FlagWatchedVideoResponse;
  /** Follow a playlist */
  followPlaylist?: Maybe<Playlist>;
  /** Look up a Shopify gift card by code and debit its full remaining balance */
  giftCardConsume?: Maybe<GiftCardConsumePayload>;
  /** Debit an amount from a Shopify gift card by id */
  giftCardDebit?: Maybe<GiftCardDebitPayload>;
  /** Join a community feed */
  joinCommunityFeed?: Maybe<CommunityFeed>;
  /** Leave a community feed */
  leaveCommunityFeed?: Maybe<CommunityFeed>;
  /** Login a user */
  login?: Maybe<LoginRenewResponse>;
  /** Create a new media item */
  mediaCreate?: Maybe<MediaCreateResponse>;
  /** Oracle AI: Update onboarding settings for the current user */
  onboardingSettingsUpdate: OnboardingSettingsUpdateResponse;
  /** Oracle AI: Submit an onboarding step and advance the flow */
  onboardingSubmit: OnboardingSubmitResponse;
  /** Oracle AI: Send a message to the AI agent with tool access */
  oracleAgentChat: OracleAgentChatPayload;
  /** Oracle AI: Create a new chat session */
  oracleChatSessionCreate: OracleChatSessionCreateResponse;
  /** Oracle AI: Delete a chat session */
  oracleChatSessionDelete: OracleChatSessionDeleteResponse;
  /** Oracle AI: Update a chat session's favorite status */
  oracleChatSessionFavorite: OracleChatSessionFavoriteResponse;
  /** Oracle AI: Rename a chat session */
  oracleChatSessionRename: OracleChatSessionRenameResponse;
  /** Oracle AI: Update an existing chat session */
  oracleChatSessionUpdate: OracleChatSessionUpdateResponse;
  /** Oracle AI: Generate identity vibe line options from user profile data */
  oracleIdentityVibeGenerate: OracleIdentityVibeGenerateResponse;
  /** Oracle AI: Select and save an identity vibe line to the user's profile */
  oracleIdentityVibeSelect: OracleIdentityVibeSelectResponse;
  /** Oracle AI: Create or update a scoped LLM config set */
  oracleLlmConfigSetUpsert: OracleLlmConfigSetUpsertResponse;
  /** Oracle AI: Create a new individual message */
  oracleMessageCreate: OracleMessageCreateResponse;
  /** Oracle AI: Create a new message pair */
  oracleMessagePairCreate: OracleMessagePairCreateResponse;
  /** Oracle AI: Delete a message pair */
  oracleMessagePairDelete: OracleMessagePairDeleteResponse;
  /** Oracle AI: Regenerate the assistant response for the last turn */
  oracleMessagePairRegenerateLast: OracleMessagePairRegenerateLastResponse;
  /** Oracle AI: Create a share ID for a message pair snapshot */
  oracleMessagePairShare: OracleMessagePairShareResponse;
  /** Oracle AI: Update an existing message pair */
  oracleMessagePairUpdate: OracleMessagePairUpdateResponse;
  /** Oracle AI: Update the mode of an existing message pair */
  oracleMessagePairUpdateMode: OracleMessagePairUpdateResponse;
  /** Oracle AI: Select active assistant variant for a message pair */
  oracleMessagePairVariantSelect: OracleMessagePairVariantSelectResponse;
  /** Oracle AI: Create a new personality */
  oraclePersonalityCreate: OraclePersonalityCreateResponse;
  /** Oracle AI: Delete a personality */
  oraclePersonalityDelete: OraclePersonalityDeleteResponse;
  /** Oracle AI: Update an existing personality */
  oraclePersonalityUpdate: OraclePersonalityUpdateResponse;
  /** Oracle AI: Save a playlist directly (no agent loop) */
  oraclePlaylistSave: OraclePlaylistSaveResponse;
  /** Oracle AI: Submit thumbs up/down feedback for a search result turn */
  oracleSearchFeedback: OracleSearchFeedbackResponse;
  /** Pin a post to the top of its feed (admin or feed moderator) */
  pinCommunityPost?: Maybe<CommunityPost>;
  /** Create one playlist */
  playlistCreate?: Maybe<PlaylistCreateResponse>;
  /** Create one playlist item */
  playlistCreatePlaylistItem?: Maybe<PlaylistCreatePlaylistItemResponse>;
  /** Create a playlist with items in a single operation */
  playlistCreateWithItems?: Maybe<PlaylistCreateWithItemsResponse>;
  /** Delete one playlist */
  playlistDelete?: Maybe<PlaylistDeleteResponse>;
  /** Delete one playlist item */
  playlistDeletePlaylistItem?: Maybe<PlaylistDeletePlaylistItemResponse>;
  /** Update one playlist item */
  playlistUpdatePlaylistItem?: Maybe<PlaylistUpdatePlaylistItemResponse>;
  /** Create a new PM Screen */
  pmScreenCreate: PmScreenCreateResponse;
  /** Delete a PM Screen */
  pmScreenDelete: PmScreenDeleteResponse;
  /** Update an existing PM Screen */
  pmScreenUpdate: PmScreenUpdateResponse;
  /** Create a new PM Section */
  pmSectionCreate: PmSectionCreateResponse;
  /** Delete a PM Section */
  pmSectionDelete: PmSectionDeleteResponse;
  /** Update an existing PM Section */
  pmSectionUpdate: PmSectionUpdateResponse;
  /** Remove a member from a community feed (admin only) */
  removeCommunityFeedMember?: Maybe<CommunityFeed>;
  /** Remove a user's moderator role from a feed (admin only) */
  removeFeedModerator?: Maybe<Scalars['Boolean']>;
  /** Renew a user authorization token provided using authorization header */
  renew?: Maybe<LoginRenewResponse>;
  /** Request AI moderation analysis on content (admin or feed moderator) */
  requestAiModeration?: Maybe<Scalars['Boolean']>;
  /** Request a presigned URL for uploading a profile banner image */
  requestBannerImageUpload: BannerImageUploadRequest;
  /** Request a presigned URL for uploading a playlist cover photo */
  requestPlaylistCoverPhotoUpload: PlaylistCoverPhotoUploadRequest;
  /** Request a presigned URL for uploading a profile picture */
  requestProfilePictureUpload: ProfilePictureUploadRequest;
  /** Resolve a moderation report (admin or feed moderator) */
  resolveCommunityModeration?: Maybe<CommunityModerationReport>;
  revokeApiKey: ApiKeyMutationResponse;
  /** RSVP to an event */
  rsvpToCommunityEvent?: Maybe<CommunityEventRegistrationSummary>;
  s3UpsertNdjson?: Maybe<S3UpsertNdjsonResult>;
  /** Oracle AI: Create a new seed question */
  seedQuestionCreate: SeedQuestionCreateResponse;
  /** Oracle AI: Delete a seed question */
  seedQuestionDelete: SeedQuestionDeleteResponse;
  /** Oracle AI: Update an existing seed question */
  seedQuestionUpdate: SeedQuestionUpdateResponse;
  /** Sync billingProviderProducts with source system */
  syncBillingProviderProducts?: Maybe<SyncBillingProviderProductsResponse>;
  /** Unfollow a playlist */
  unfollowPlaylist?: Maybe<Playlist>;
  /** Unpin a post from its feed (admin or feed moderator) */
  unpinCommunityPost?: Maybe<CommunityPost>;
  /** Update a billing account */
  updateBillingAccount: BillingAccount;
  /** Update a billing discount */
  updateBillingDiscount?: Maybe<BillingDiscount>;
  /** Update a billingInvoice */
  updateBillingInvoice?: Maybe<BillingInvoice>;
  /** Update a billingOneTimePurchase */
  updateBillingOneTimePurchase?: Maybe<BillingOneTimePurchase>;
  /** Update a billingPayment */
  updateBillingPayment?: Maybe<BillingPayment>;
  /** Update a billingPaymentMethod */
  updateBillingPaymentMethod?: Maybe<BillingPaymentMethod>;
  /** Update a billing plan grid */
  updateBillingPlanGrid?: Maybe<BillingPlanGrid>;
  /** Update billingProduct */
  updateBillingProduct?: Maybe<BillingProduct>;
  /** Update billingProvider */
  updateBillingProvider?: Maybe<BillingProvider>;
  /** Update billingProviderCurrency */
  updateBillingProviderCurrency?: Maybe<BillingProviderCurrency>;
  /** Update billingProviderProduct */
  updateBillingProviderProduct?: Maybe<BillingProviderProduct>;
  /** Update a plan eligibility rule */
  updateBillingProviderProductEligibility?: Maybe<BillingProviderProductEligibility>;
  /** Update a billingProviderProductPricing */
  updateBillingProviderProductPrice?: Maybe<BillingProviderProductPricing>;
  /** Update a billingProviderProductText */
  updateBillingProviderProductText?: Maybe<BillingProviderProductText>;
  /** Update a billingRefund */
  updateBillingRefund?: Maybe<BillingRefund>;
  /** Update a billingSubscription */
  updateBillingSubscription?: Maybe<BillingSubscription>;
  /** Update a billingSubscriptionOrder */
  updateBillingSubscriptionOrder?: Maybe<BillingSubscriptionOrder>;
  /** Update a BillingSubscriptionOrderPlan */
  updateBillingSubscriptionOrderPlan?: Maybe<BillingSubscriptionOrderPlan>;
  /** Update a billingSubscriptionPlan */
  updateBillingSubscriptionPlan?: Maybe<BillingSubscriptionPlan>;
  /** Update an existing event (admin only) */
  updateCommunityEvent?: Maybe<CommunityEvent>;
  /** Update a community feed (admin only) */
  updateCommunityFeed?: Maybe<CommunityFeed>;
  /** Update a member's role in a community feed (admin only) */
  updateCommunityFeedMemberRole?: Maybe<Scalars['Boolean']>;
  /** Update a community post or comment */
  updateCommunityPost?: Maybe<CommunityPost>;
  /** Update network-wide allowed reactions (admin only) */
  updateCommunityReactionSettings?: Maybe<Scalars['Boolean']>;
  /** Update a custom emoji (Admin only) */
  updateCustomEmoji: CustomEmoji;
  /** Update allowed reactions for a specific feed (admin only) */
  updateFeedAllowedReactions?: Maybe<CommunityFeed>;
  /** Update a playlist's name and/or description */
  updatePlaylist?: Maybe<PlaylistUpdateResponse>;
  /** Update the visibility of a playlist */
  updatePlaylistVisibility?: Maybe<PlaylistUpdateVisibilityResponse>;
  /** Update a raw event */
  updateRawEvent?: Maybe<RawEvent>;
  /** Update a transactions */
  updateTransaction?: Maybe<Transaction>;
  /** Update a userAuditLog */
  updateUserAuditLog?: Maybe<UserAuditLog>;
  /**
   * Update a user entitlement. Can modify start/end dates, content set, or other fields.
   * Used for extending access, changing content sets, or correcting entitlement data.
   * Requires elevated role access.
   */
  updateUserEntitlement?: Maybe<UserEntitlement>;
  /** Upload or update a feed image (admin only) */
  uploadFeedImage: FeedImageUploadResult;
  /** Update the current user's profile info (username, names, name visibility) */
  userInfoUpdate: UserInfoUpdateResponse;
  /** Update a profile's first and last name (account owner only) */
  userInfoUpdateProfile: UserInfoUpdateResponse;
  /** Creates or updates learner level rows. Any authenticated user may call; rows are keyed to the JWT user unless an elevated role supplies uid on each input item. */
  userLearnerLevelCreateOrUpdate: UserLearnerLevelMutationResult;
  userLearnerLevelDelete: UserLearnerLevelDeleteResult;
  /** Create or update user metadata entries */
  userMetadataCreateOrUpdate: UserMetadataMutationResult;
  /** Admin: update any user's profile by UID */
  userProfileAdminUpdate?: Maybe<UserProfileUpdateResponse>;
  /** Follow a user */
  userProfileFollow?: Maybe<UserProfileFollowResponse>;
  /** Unfollow a user */
  userProfileUnfollow?: Maybe<UserProfileFollowResponse>;
  /** Update the current user's profile (creates on first use) */
  userProfileUpdate?: Maybe<UserProfileUpdateResponse>;
  /** Create or update user state entries */
  userStateCreateOrUpdate: Array<UserState>;
  /** Delete a user state entry */
  userStateDelete: Scalars['Boolean'];
  /** Create one worker */
  workerCreate: WorkerMutationResponse;
  /** Delete one worker the id or name in the input is used to select the worker */
  workerDelete: WorkerMutationResponse;
  /** Update one worker */
  workerUpdate: WorkerMutationResponse;
};


/** Oracle AI: Root mutation operations */
export type MutationAddCommunityFeedMemberArgs = {
  feedId: Scalars['ID'];
  userId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationAmbassadorLeadsUploadNdJsonToS3Args = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  s3Params: AmbassadorLeadsS3Input;
  where?: InputMaybe<AmbassadorLeadsWhereInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationAssignFeedModeratorArgs = {
  feedId: Scalars['ID'];
  userId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationAttachClipCaptionsFromBrightcovePlaylistArgs = {
  defaults: ClipImportSharedDefaultsInput;
  playlistId: Scalars['String'];
};


/** Oracle AI: Root mutation operations */
export type MutationAuthRoleCreateArgs = {
  authRole: AuthRoleCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationAuthRoleDeleteArgs = {
  authRole: AuthRoleDeleteInput;
};


/** Oracle AI: Root mutation operations */
export type MutationAuthRoleUpdateArgs = {
  authRole: AuthRoleUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationAuthScopeCreateArgs = {
  authScope: AuthScopeCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationAuthScopeDeleteArgs = {
  authScope: AuthScopeDeleteInput;
};


/** Oracle AI: Root mutation operations */
export type MutationAuthScopeUpdateArgs = {
  authScope: AuthScopeUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationBillingCreateEventArgs = {
  input: BillingEventCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationBillingUpdateEventArgs = {
  input: BillingEventUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCancelRsvpToCommunityEventArgs = {
  eventId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationChannelPromptSetCreateArgs = {
  input: ChannelPromptSetCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationChannelPromptSetDeleteArgs = {
  id: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationChannelPromptSetReplaceSectionsArgs = {
  input: ChannelPromptSetReplaceSectionsInput;
};


/** Oracle AI: Root mutation operations */
export type MutationChannelPromptSetUpdateStatusArgs = {
  input: ChannelPromptSetStatusInput;
};


/** Oracle AI: Root mutation operations */
export type MutationChatHistoryCreateArgs = {
  chatHistory?: InputMaybe<ChatHistoryCreateInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationChatHistoryDeleteArgs = {
  chatHistory?: InputMaybe<ChatHistoryDeleteInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationChatHistoryUpdateArgs = {
  chatHistory?: InputMaybe<ChatHistoryUpdateInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationChatSessionCreateArgs = {
  chatSession?: InputMaybe<ChatSessionCreateInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationChatSessionDeleteArgs = {
  chatSession?: InputMaybe<ChatSessionDeleteInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationChatSessionUpdateArgs = {
  chatSession?: InputMaybe<ChatSessionUpdateInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationClipCreateArgs = {
  clip: ClipCreateInput;
  generatePath?: InputMaybe<Scalars['Boolean']>;
};


/** Oracle AI: Root mutation operations */
export type MutationClipImportFromBrightcovePlaylistArgs = {
  defaults: ClipImportSharedDefaultsInput;
  generatePath?: InputMaybe<Scalars['Boolean']>;
  importTextTracks?: InputMaybe<Scalars['Boolean']>;
  perVideoParentOverrides?: InputMaybe<Array<ClipImportPerVideoParentInput>>;
  playlistId: Scalars['String'];
};


/** Oracle AI: Root mutation operations */
export type MutationCommentCreateArgs = {
  input: CommentCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCommentReportArgs = {
  id: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationCommentUpdateArgs = {
  input: CommentUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationConfirmBannerImageUploadArgs = {
  imageExtension: Scalars['String'];
  imageUuid: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationConfirmPlaylistCoverPhotoUploadArgs = {
  imageExtension: Scalars['String'];
  imageUuid: Scalars['ID'];
  playlistId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationConfirmProfilePictureUploadArgs = {
  imageExtension: Scalars['String'];
  imageUuid: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationConsumeDiscountArgs = {
  input: ConsumeDiscountInput;
};


/** Oracle AI: Root mutation operations */
export type MutationContentAnonCreateArgs = {
  input: ContentAnonCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationContentAnonDeleteArgs = {
  input: ContentAnonDeleteInput;
};


/** Oracle AI: Root mutation operations */
export type MutationContentAnonUpdateArgs = {
  input: ContentAnonUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationContentAssetReferenceCreateArgs = {
  contentAssetReference: ContentAssetReferenceCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationContentAssetReferenceDeleteArgs = {
  contentAssetReference: ContentAssetReferenceDeleteInput;
};


/** Oracle AI: Root mutation operations */
export type MutationContentCreateArgs = {
  content: ContentInput;
  generatePath?: InputMaybe<Scalars['Boolean']>;
};


/** Oracle AI: Root mutation operations */
export type MutationContentListCriteriaCreateArgs = {
  contentListCriteria?: InputMaybe<ContentListCriteriaCreateInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationContentListCriteriaDeleteArgs = {
  contentListCriteria?: InputMaybe<ContentListCriteriaDeleteInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationContentProviderCreateByContentIdArgs = {
  contentProvider?: InputMaybe<ContentProviderCreateByContentIdInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationContentProviderDeleteByContentIdArgs = {
  contentProvider?: InputMaybe<ContentProviderDeleteByContentIdInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationContentProviderUpdateByContentIdArgs = {
  contentProvider?: InputMaybe<ContentProviderUpdateByContentIdInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationContentReferenceCreateArgs = {
  contentReference?: InputMaybe<ContentReferenceCreateInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationContentReferenceCreateManyArgs = {
  contentReferences: Array<ContentReferenceCreateInput>;
  deleteOmittedReferences?: InputMaybe<Scalars['Boolean']>;
};


/** Oracle AI: Root mutation operations */
export type MutationContentReferenceDeleteArgs = {
  contentReference?: InputMaybe<ContentReferenceDeleteInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationContentUpdateArgs = {
  content?: InputMaybe<ContentInput>;
  generatePath?: InputMaybe<Scalars['Boolean']>;
};


/** Oracle AI: Root mutation operations */
export type MutationCourseMarkCompleteArgs = {
  courseTitleGroupId: Scalars['String'];
};


/** Oracle AI: Root mutation operations */
export type MutationCourseModuleMarkCompleteArgs = {
  courseModuleTitleGroupId: Scalars['String'];
  courseTitleGroupId: Scalars['String'];
};


/** Oracle AI: Root mutation operations */
export type MutationCourseResetArgs = {
  courseTitleGroupId: Scalars['String'];
};


/** Oracle AI: Root mutation operations */
export type MutationCourseStartArgs = {
  courseTitleGroupId: Scalars['String'];
};


/** Oracle AI: Root mutation operations */
export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingAccountArgs = {
  input?: InputMaybe<BillingAccountCreateInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingDiscountArgs = {
  input: CreateBillingDiscountInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingInvoiceArgs = {
  input: BillingInvoiceCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingOneTimePurchaseArgs = {
  input: BillingOneTimePurchaseCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingPaymentArgs = {
  input: BillingPaymentCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingPaymentMethodArgs = {
  input: BillingPaymentMethodCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingPlanGridArgs = {
  input?: InputMaybe<CreateBillingPlanGridInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProductArgs = {
  input: CreateBillingProductInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProductChangeLogArgs = {
  input: BillingProductChangeLogInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProviderArgs = {
  input: CreateBillingProviderInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProviderCurrencyArgs = {
  billingProviderCurrency: BillingProviderCurrencyInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProviderProductArgs = {
  billingProviderProduct: BillingProviderProductInput;
  billingProviderProductPrices?: InputMaybe<Array<InputMaybe<BillingProviderProductPriceInput>>>;
  billingProviderProductText?: InputMaybe<Array<InputMaybe<BillingProviderProductTextInput>>>;
  updateProvider?: InputMaybe<Scalars['Boolean']>;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProviderProductEligibilityArgs = {
  input: CreateBillingProviderProductEligibilityInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProviderProductPriceArgs = {
  input: BillingProviderProductPricingCreateInput;
  updateProvider?: InputMaybe<Scalars['Boolean']>;
  updateRelatedBillingProviderProducts?: InputMaybe<Scalars['Boolean']>;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProviderProductTextArgs = {
  input: BillingProviderProductTextCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingRefundArgs = {
  input: BillingRefundCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingSubscriptionArgs = {
  input: BillingSubscriptionCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingSubscriptionOrderArgs = {
  input: BillingSubscriptionOrderCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingSubscriptionOrderPlanArgs = {
  input: BillingSubscriptionOrderPlanCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateBillingSubscriptionPlanArgs = {
  input: BillingSubscriptionPlanCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateCommunityEventArgs = {
  feedId: Scalars['ID'];
  input: CreateCommunityEventInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateCommunityFeedArgs = {
  description?: InputMaybe<Scalars['String']>;
  feedType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  topicContentId?: InputMaybe<Scalars['Int']>;
  visibility?: InputMaybe<FeedVisibility>;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateCommunityPostArgs = {
  content: Scalars['String'];
  feedId: Scalars['ID'];
  parentId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateCommunityReactionArgs = {
  postId: Scalars['ID'];
  reaction: Scalars['String'];
};


/** Oracle AI: Root mutation operations */
export type MutationCreateCustomEmojiArgs = {
  input: CreateCustomEmojiInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateTransactionArgs = {
  input: TransactionCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateUserAuditLogArgs = {
  input: UserAuditLogCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationCreateUserEntitlementArgs = {
  input: UserEntitlementCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationDeleteBillingPlanGridArgs = {
  input?: InputMaybe<DeleteBillingPlanGridInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationDeleteBillingProviderProductEligibilityArgs = {
  id: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationDeleteBillingProviderProductPriceArgs = {
  id: Scalars['ID'];
  updateProvider?: InputMaybe<Scalars['Boolean']>;
  updateRelatedBillingProviderProducts?: InputMaybe<Scalars['Boolean']>;
};


/** Oracle AI: Root mutation operations */
export type MutationDeleteBillingProviderProductTextArgs = {
  id: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationDeleteCommunityEventArgs = {
  eventId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationDeleteCommunityFeedArgs = {
  id: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationDeleteCommunityPostArgs = {
  id: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationDeleteCommunityReactionArgs = {
  postId: Scalars['ID'];
  reaction: Scalars['String'];
};


/** Oracle AI: Root mutation operations */
export type MutationDeleteCustomEmojiArgs = {
  id: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationDeleteFeedImageArgs = {
  feedId: Scalars['ID'];
  imageType: FeedImageType;
};


/** Oracle AI: Root mutation operations */
export type MutationDeletePlaylistCoverPhotoArgs = {
  playlistId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationDiscountCodeCreateArgs = {
  input: DiscountCodeCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationEcommerceSkuMappingBonusEligibilityCreateArgs = {
  ecommerceSkuMappingBonusEligibility?: InputMaybe<EcommerceSkuMappingBonusEligibilityCreateInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationEcommerceSkuMappingBonusEligibilityDeleteByIdArgs = {
  ecommerceSkuMappingBonusEligibility?: InputMaybe<EcommerceSkuMappingBonusEligibilityDeleteByIdInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationEcommerceSkuMappingBonusEligibilityUpdateByIdArgs = {
  ecommerceSkuMappingBonusEligibility?: InputMaybe<EcommerceSkuMappingBonusEligibilityUpdateByIdInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationEcommerceSkuMappingCreateArgs = {
  ecommerceSkuMapping?: InputMaybe<EcommerceSkuMappingCreateInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationEcommerceSkuMappingUpdateByProviderAndEcommerceSkuArgs = {
  ecommerceSkuMapping?: InputMaybe<EcommerceSkuMappingUpdateByProviderAndEcommerceSkuInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationEmbeddingConfigCreateArgs = {
  input: EmbeddingConfigCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationEmbeddingConfigDeleteArgs = {
  id: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationEmbeddingConfigUpdateArgs = {
  input: EmbeddingConfigUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationEventLogArgs = {
  input: EventLogInput;
};


/** Oracle AI: Root mutation operations */
export type MutationFlagCommunityContentArgs = {
  contentId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};


/** Oracle AI: Root mutation operations */
export type MutationFlagWatchedVideoArgs = {
  hiddenByUser: Scalars['Boolean'];
  videoId: Scalars['Int'];
};


/** Oracle AI: Root mutation operations */
export type MutationFollowPlaylistArgs = {
  playlistId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationGiftCardConsumeArgs = {
  giftCardCode: Scalars['String'];
};


/** Oracle AI: Root mutation operations */
export type MutationGiftCardDebitArgs = {
  amount: Scalars['String'];
  giftCardId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationJoinCommunityFeedArgs = {
  feedId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationLeaveCommunityFeedArgs = {
  feedId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationLoginArgs = {
  clientAttributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cookie?: InputMaybe<LoginRenewCookieInput>;
  device?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  password?: InputMaybe<Scalars['String']>;
  useMaster?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
};


/** Oracle AI: Root mutation operations */
export type MutationMediaCreateArgs = {
  media: MediaInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOnboardingSettingsUpdateArgs = {
  input: OnboardingSettingsUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOnboardingSubmitArgs = {
  input: OnboardingSubmitInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOracleAgentChatArgs = {
  input: OracleAgentChatInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOracleChatSessionCreateArgs = {
  input: OracleChatSessionCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOracleChatSessionDeleteArgs = {
  id: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationOracleChatSessionFavoriteArgs = {
  input: OracleChatSessionFavoriteInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOracleChatSessionRenameArgs = {
  input: OracleChatSessionRenameInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOracleChatSessionUpdateArgs = {
  input: OracleChatSessionUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOracleIdentityVibeGenerateArgs = {
  input?: InputMaybe<OracleIdentityVibeGenerateInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationOracleIdentityVibeSelectArgs = {
  input: OracleIdentityVibeSelectInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOracleLlmConfigSetUpsertArgs = {
  input: OracleLlmConfigSetUpsertInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOracleMessageCreateArgs = {
  input: OracleMessageCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairCreateArgs = {
  input: OracleMessagePairCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairDeleteArgs = {
  id: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairRegenerateLastArgs = {
  input: OracleMessagePairRegenerateLastInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairShareArgs = {
  input: OracleMessagePairShareInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairUpdateArgs = {
  id: Scalars['ID'];
  input: OracleMessagePairUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairUpdateModeArgs = {
  id: Scalars['ID'];
  mode: Scalars['String'];
};


/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairVariantSelectArgs = {
  input: OracleMessagePairVariantSelectInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOraclePersonalityCreateArgs = {
  input: OraclePersonalityCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOraclePersonalityDeleteArgs = {
  id: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationOraclePersonalityUpdateArgs = {
  input: OraclePersonalityUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOraclePlaylistSaveArgs = {
  input: OraclePlaylistSaveInput;
};


/** Oracle AI: Root mutation operations */
export type MutationOracleSearchFeedbackArgs = {
  input: OracleSearchFeedbackInput;
};


/** Oracle AI: Root mutation operations */
export type MutationPinCommunityPostArgs = {
  postId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationPlaylistCreateArgs = {
  playlist?: InputMaybe<PlaylistCreatePlaylistInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationPlaylistCreatePlaylistItemArgs = {
  createPlaylistIfNotExist?: InputMaybe<Scalars['Boolean']>;
  playlist?: InputMaybe<PlaylistCreatePlaylistItemPlaylistInput>;
  playlistItem?: InputMaybe<PlaylistCreatePlaylistItemPlaylistItemInput>;
  reorderPlaylist?: InputMaybe<Scalars['Boolean']>;
};


/** Oracle AI: Root mutation operations */
export type MutationPlaylistCreateWithItemsArgs = {
  items: Array<PlaylistCreateWithItemsItemInput>;
  playlist?: InputMaybe<PlaylistCreatePlaylistInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationPlaylistDeleteArgs = {
  playlist?: InputMaybe<PlaylistDeletePlaylistInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationPlaylistDeletePlaylistItemArgs = {
  playlist?: InputMaybe<PlaylistDeletePlaylistItemPlaylistInput>;
  playlistItem?: InputMaybe<PlaylistDeletePlaylistItemPlaylistItemInput>;
  reorderPlaylist?: InputMaybe<Scalars['Boolean']>;
};


/** Oracle AI: Root mutation operations */
export type MutationPlaylistUpdatePlaylistItemArgs = {
  playlist?: InputMaybe<PlaylistUpdatePlaylistItemPlaylistInput>;
  playlistItem?: InputMaybe<PlaylistUpdatePlaylistItemPlaylistItemInput>;
  reorderPlaylist?: InputMaybe<Scalars['Boolean']>;
};


/** Oracle AI: Root mutation operations */
export type MutationPmScreenCreateArgs = {
  pmScreen: PmScreenCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationPmScreenDeleteArgs = {
  id: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationPmScreenUpdateArgs = {
  pmScreen: PmScreenUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationPmSectionCreateArgs = {
  pmSection: PmSectionCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationPmSectionDeleteArgs = {
  id: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationPmSectionUpdateArgs = {
  pmSection: PmSectionUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationRemoveCommunityFeedMemberArgs = {
  feedId: Scalars['ID'];
  userId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationRemoveFeedModeratorArgs = {
  feedId: Scalars['ID'];
  userId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationRenewArgs = {
  clientAttributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cookie?: InputMaybe<LoginRenewCookieInput>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logUserAccountOutOfAllDevices?: InputMaybe<Scalars['Boolean']>;
  logUserOutOfAllDevices?: InputMaybe<Scalars['Boolean']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  useMaster?: InputMaybe<Scalars['Boolean']>;
};


/** Oracle AI: Root mutation operations */
export type MutationRequestAiModerationArgs = {
  contentId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationRequestBannerImageUploadArgs = {
  fileExtension: Scalars['String'];
};


/** Oracle AI: Root mutation operations */
export type MutationRequestPlaylistCoverPhotoUploadArgs = {
  fileExtension: Scalars['String'];
  playlistId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationRequestProfilePictureUploadArgs = {
  fileExtension: Scalars['String'];
};


/** Oracle AI: Root mutation operations */
export type MutationResolveCommunityModerationArgs = {
  action: ModerationAction;
  note?: InputMaybe<Scalars['String']>;
  reportId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationRevokeApiKeyArgs = {
  id: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationRsvpToCommunityEventArgs = {
  eventId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationS3UpsertNdjsonArgs = {
  s3UpsertNdjsonInput: S3UpsertNdjsonInput;
};


/** Oracle AI: Root mutation operations */
export type MutationSeedQuestionCreateArgs = {
  input: SeedQuestionCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationSeedQuestionDeleteArgs = {
  id: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationSeedQuestionUpdateArgs = {
  input: SeedQuestionUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUnfollowPlaylistArgs = {
  playlistId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationUnpinCommunityPostArgs = {
  postId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingAccountArgs = {
  input?: InputMaybe<BillingAccountUpdateInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingDiscountArgs = {
  input: UpdateBillingDiscountInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingInvoiceArgs = {
  input: BillingInvoiceUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingOneTimePurchaseArgs = {
  input: BillingOneTimePurchaseUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingPaymentArgs = {
  input: BillingPaymentUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingPaymentMethodArgs = {
  input: BillingPaymentMethodUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingPlanGridArgs = {
  input?: InputMaybe<UpdateBillingPlanGridInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProductArgs = {
  input: UpdateBillingProductInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProviderArgs = {
  input: UpdateBillingProviderInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProviderCurrencyArgs = {
  input: BillingProviderCurrencyUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProviderProductArgs = {
  createBillingProviderProductPrices?: InputMaybe<Array<InputMaybe<BillingProviderProductPricingCreateInput>>>;
  createBillingProviderProductText?: InputMaybe<Array<InputMaybe<BillingProviderProductTextCreateInput>>>;
  deleteBillingProviderProductPrices?: InputMaybe<Array<InputMaybe<BillingProviderProductDeleteByIdInput>>>;
  deleteBillingProviderProductText?: InputMaybe<Array<InputMaybe<BillingProviderProductDeleteByIdInput>>>;
  input: BillingProviderProductUpdateInput;
  skipProviderSync?: InputMaybe<Scalars['Boolean']>;
  updateBillingProviderProductPrices?: InputMaybe<Array<InputMaybe<BillingProviderProductPricingUpdateInput>>>;
  updateBillingProviderProductText?: InputMaybe<Array<InputMaybe<BillingProviderProductTextUpdateInput>>>;
  updateProvider?: InputMaybe<Scalars['Boolean']>;
  updateRelatedBillingProviderProducts?: InputMaybe<Scalars['Boolean']>;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProviderProductEligibilityArgs = {
  input: UpdateBillingProviderProductEligibilityInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProviderProductPriceArgs = {
  input: BillingProviderProductPricingUpdateInput;
  updateProvider?: InputMaybe<Scalars['Boolean']>;
  updateRelatedBillingProviderProducts?: InputMaybe<Scalars['Boolean']>;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProviderProductTextArgs = {
  input: BillingProviderProductTextUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingRefundArgs = {
  input: BillingRefundUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingSubscriptionArgs = {
  input: BillingSubscriptionUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingSubscriptionOrderArgs = {
  input: BillingSubscriptionOrderUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingSubscriptionOrderPlanArgs = {
  input: BillingSubscriptionOrderPlanUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingSubscriptionPlanArgs = {
  input: BillingSubscriptionPlanUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateCommunityEventArgs = {
  eventId: Scalars['ID'];
  input: UpdateCommunityEventInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateCommunityFeedArgs = {
  description?: InputMaybe<Scalars['String']>;
  feedType?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<FeedVisibility>;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateCommunityFeedMemberRoleArgs = {
  feedId: Scalars['ID'];
  roleType: FeedRoleType;
  userId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateCommunityPostArgs = {
  content?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateCommunityReactionSettingsArgs = {
  allowedReactions: Array<Scalars['String']>;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateCustomEmojiArgs = {
  input: UpdateCustomEmojiInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateFeedAllowedReactionsArgs = {
  allowedReactions: Array<Scalars['String']>;
  feedId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationUpdatePlaylistArgs = {
  input: PlaylistUpdateInput;
  playlistId: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationUpdatePlaylistVisibilityArgs = {
  playlistId: Scalars['ID'];
  visibility: PlaylistVisibility;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateRawEventArgs = {
  input: RawEventUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateTransactionArgs = {
  input: TransactionUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateUserAuditLogArgs = {
  input: UserAuditLogUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUpdateUserEntitlementArgs = {
  input: UserEntitlementUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUploadFeedImageArgs = {
  input: UploadFeedImageInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUserInfoUpdateArgs = {
  input: UserInfoUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUserInfoUpdateProfileArgs = {
  input: UserInfoUpdateProfileInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUserLearnerLevelCreateOrUpdateArgs = {
  input: Array<UserLearnerLevelInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationUserLearnerLevelDeleteArgs = {
  tagContentContentId: Scalars['Int'];
  uid: Scalars['Int'];
};


/** Oracle AI: Root mutation operations */
export type MutationUserMetadataCreateOrUpdateArgs = {
  input: Array<UserMetadataInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationUserProfileAdminUpdateArgs = {
  input: UserProfileUpdateInput;
  uid: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationUserProfileFollowArgs = {
  uid: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationUserProfileUnfollowArgs = {
  uid: Scalars['ID'];
};


/** Oracle AI: Root mutation operations */
export type MutationUserProfileUpdateArgs = {
  input: UserProfileUpdateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationUserStateCreateOrUpdateArgs = {
  input: Array<UserStateInput>;
};


/** Oracle AI: Root mutation operations */
export type MutationUserStateDeleteArgs = {
  parentContentTitleGroupId: Scalars['String'];
  progressItemId: Scalars['String'];
  progressItemType: UserStateProgressItemType;
  userUid?: InputMaybe<Scalars['Int']>;
};


/** Oracle AI: Root mutation operations */
export type MutationWorkerCreateArgs = {
  worker: WorkerCreateInput;
};


/** Oracle AI: Root mutation operations */
export type MutationWorkerDeleteArgs = {
  worker: WorkerDeleteInput;
};


/** Oracle AI: Root mutation operations */
export type MutationWorkerUpdateArgs = {
  create?: InputMaybe<Scalars['Boolean']>;
  worker: WorkerUpdateInput;
};

/** Oracle AI: Input for nudge and suggestion search */
export type NudgeAndSuggestionInput = {
  lowWeightCategories: Array<Scalars['String']>;
  queries: Array<Scalars['String']>;
  userFeedIds: Array<Scalars['String']>;
};

/** Oracle AI: Nudge and suggestion result */
export type NudgeAndSuggestionResult = {
  __typename?: 'NudgeAndSuggestionResult';
  nudgePost?: Maybe<NudgePost>;
  pickedPost?: Maybe<PickedPost>;
  suggestedFeed?: Maybe<SuggestedFeed>;
};

/** Oracle AI: A post from an unjoined feed for nudging */
export type NudgePost = {
  __typename?: 'NudgePost';
  feedId: Scalars['String'];
  feedName: Scalars['String'];
  feedSlug: Scalars['String'];
  headline: Scalars['String'];
  postId: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

/** OAuth2/OIDC client */
export type OAuthClient = {
  __typename?: 'OAuthClient';
  /** Unique OAuth2 client identifier */
  clientId?: Maybe<Scalars['String']>;
  /** Human-readable client name */
  clientName?: Maybe<Scalars['String']>;
  /** Client homepage URL */
  clientUri?: Maybe<Scalars['String']>;
  /** Array of contact email addresses */
  contacts?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Array of supported grant types */
  grantTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The primary identifier for this record (UUID v4) */
  id?: Maybe<Scalars['ID']>;
  /** Client logo URL */
  logoUri?: Maybe<Scalars['String']>;
  /** Privacy policy URI */
  policyUri?: Maybe<Scalars['String']>;
  /** Array of allowed redirect URIs */
  redirectUris?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Array of supported response types */
  responseTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Default scopes for the client */
  scope?: Maybe<Scalars['String']>;
  /** Authentication method for token endpoint */
  tokenEndpointAuthMethod?: Maybe<Scalars['String']>;
  /** Terms of service URI */
  tosUri?: Maybe<Scalars['String']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** OAuth client list response */
export type OAuthClientListResponse = {
  __typename?: 'OAuthClientListResponse';
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** A list of OAuth clients */
  oauthClients?: Maybe<Array<Maybe<OAuthClient>>>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
};

/** OAuth client clientId type where input type */
export type OAuthClientListWhereClientIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** OAuth client id type where input type */
export type OAuthClientListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** OAuth client where conditions to filter rows */
export type OAuthClientListWhereInput = {
  /** The clientId field where clause */
  clientId?: InputMaybe<OAuthClientListWhereClientIdInput>;
  /** The id field where clause */
  id?: InputMaybe<OAuthClientListWhereIdInput>;
};

export type OnboardingSettings = {
  __typename?: 'OnboardingSettings';
  /** Birth city */
  birthCity?: Maybe<Scalars['String']>;
  /** Birth date (MM/DD/YYYY) */
  birthDate?: Maybe<Scalars['String']>;
  /** Birth state */
  birthState?: Maybe<Scalars['String']>;
  /** Birth time (24hr HH:MM) */
  birthTime?: Maybe<Scalars['String']>;
  /** Interest topic keys */
  interestTopics?: Maybe<Array<Scalars['String']>>;
  /** Answers for 'make it interesting' section */
  interestingAnswers?: Maybe<InterestingAnswers>;
  /** Life goals */
  lifeGoals?: Maybe<Scalars['String']>;
  /** Life journey */
  lifeJourney?: Maybe<Scalars['String']>;
  /** Preferred response style */
  responseStyle?: Maybe<Scalars['String']>;
  /** Return to last conversation when true */
  returnLastConversation: Scalars['Boolean'];
  /** Freeform text the user wants to share */
  shareAnything?: Maybe<Scalars['String']>;
};

export type OnboardingSettingsUpdateInput = {
  /** Have you had an alien encounter? */
  alienEncounter?: InputMaybe<Scalars['Boolean']>;
  /** Do you think we're alone in the universe? */
  aloneInUniverse?: InputMaybe<Scalars['Boolean']>;
  /** If a spacecraft landed in front of you, would you approach it? */
  approachSpacecraft?: InputMaybe<Scalars['Boolean']>;
  /** Birth city */
  birthCity?: InputMaybe<Scalars['String']>;
  /** Birth date (MM/DD/YYYY) */
  birthDate?: InputMaybe<Scalars['String']>;
  /** Birth state */
  birthState?: InputMaybe<Scalars['String']>;
  /** Birth time (24hr HH:MM) */
  birthTime?: InputMaybe<Scalars['String']>;
  /** Do you think deja vu is a clue or a glitch? (true=yes) */
  dejaVuBelief?: InputMaybe<Scalars['Boolean']>;
  /** Interest topic keys */
  interestTopics?: InputMaybe<Array<Scalars['String']>>;
  /** Would you describe yourself as intuitive? */
  isIntuitive?: InputMaybe<Scalars['Boolean']>;
  /** Life goals */
  lifeGoals?: InputMaybe<Scalars['String']>;
  /** Life journey */
  lifeJourney?: InputMaybe<Scalars['String']>;
  /** Preferred response style */
  responseStyle?: InputMaybe<Scalars['String']>;
  /** Return to last conversation when true */
  returnLastConversation?: InputMaybe<Scalars['Boolean']>;
  /** Freeform text the user wants to share */
  shareAnything?: InputMaybe<Scalars['String']>;
};

export type OnboardingSettingsUpdateResponse = {
  __typename?: 'OnboardingSettingsUpdateResponse';
  /** Errors, if any */
  errors: Array<Scalars['String']>;
  /** Whether the update succeeded */
  success: Scalars['Boolean'];
};

export type OnboardingState = {
  __typename?: 'OnboardingState';
  /** Whether onboarding is active for this request */
  active: Scalars['Boolean'];
  /** Whether the user can skip onboarding at this step */
  allowSkip: Scalars['Boolean'];
  /** Optional choices */
  choices?: Maybe<Array<Scalars['String']>>;
  /** Whether onboarding is completed for the user */
  completed: Scalars['Boolean'];
  /** Question to ask */
  question?: Maybe<Scalars['String']>;
  /** Current onboarding step */
  step?: Maybe<Scalars['Int']>;
};

export type OnboardingSubmitInput = {
  /** Chat session id for the onboarding session */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /** Step 4: interest topics */
  interestTopics?: InputMaybe<Array<Scalars['String']>>;
  /** Step 2: preferred name */
  preferredName?: InputMaybe<Scalars['String']>;
  /** Step 3: preferred response style */
  responseStyle?: InputMaybe<Scalars['String']>;
  /** Skip onboarding and proceed to normal chat */
  skip?: Scalars['Boolean'];
  /** Step 1 choice: start onboarding (true) or skip (false) */
  startOnboarding?: InputMaybe<Scalars['Boolean']>;
  /** Current onboarding step being submitted */
  step: Scalars['Int'];
  /** Step 2: confirm existing name */
  useExistingName?: InputMaybe<Scalars['Boolean']>;
};

export type OnboardingSubmitResponse = {
  __typename?: 'OnboardingSubmitResponse';
  /** Errors, if any */
  errors: Array<Scalars['String']>;
  /** Updated onboarding state */
  state?: Maybe<OnboardingState>;
  /** Whether the update succeeded */
  success: Scalars['Boolean'];
};

export type OracleAgentChatHistoryInput = {
  /** Maximum number of message pairs to include in chat history (0-30) */
  limit?: Scalars['Int'];
};

export type OracleAgentChatInput = {
  /** Channel hint used to select policy/tooling and enforce role-gated access. Examples: 'default', 'video_guide', 'internal', 'search'. If omitted, defaults to 'default'.  */
  chatChannel?: InputMaybe<Scalars['String']>;
  /** ID of the chat session to continue, if any */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /** The content ID this session is associated with (null for regular conversations) */
  contentId?: InputMaybe<Scalars['String']>;
  /** The current playback time in seconds when the message was sent. */
  currentTimeSeconds?: InputMaybe<Scalars['Float']>;
  /** If true, ask LLM to generate gaia:// deep links for native apps */
  deepLinks?: InputMaybe<Scalars['Boolean']>;
  /** The feature media ID this session is associated with (null for regular conversations) */
  featureMediaId?: InputMaybe<Scalars['String']>;
  /** Chat history configuration */
  history?: InputMaybe<OracleAgentChatHistoryInput>;
  /** Whether the video is currently paused when the message was sent. */
  isPaused?: InputMaybe<Scalars['Boolean']>;
  /** Preferred response language (supported: en, fr, de, es) */
  language?: InputMaybe<Scalars['String']>;
  /** The temperature for the language model (default: 0.7) */
  llmTemperature?: InputMaybe<Scalars['Float']>;
  /** Long-term memory for the agent */
  longTermMemory?: InputMaybe<Scalars['String']>;
  /** The maximum number of context documents to use */
  maxContextDocs?: InputMaybe<Scalars['Int']>;
  /** The maximum number of iterations for the agent */
  maxIterations?: InputMaybe<Scalars['Int']>;
  /** The user's message to the agent */
  message: Scalars['String'];
  /** Communication mode ('text' or 'voice') */
  mode?: InputMaybe<Scalars['String']>;
  /** The name of the language model to use */
  modelName?: InputMaybe<Scalars['String']>;
  /** ID of the personality to use for the chat */
  personalityId: Scalars['ID'];
  /** User's timezone for rate limit calculations */
  timezone?: InputMaybe<Scalars['String']>;
};

export type OracleAgentChatPayload = {
  __typename?: 'OracleAgentChatPayload';
  /** The normalized channel actually used by the backend */
  chatChannel?: Maybe<Scalars['String']>;
  /** The ID of the chat session */
  chatSessionId?: Maybe<Scalars['ID']>;
  /** Generic signals for frontend workflow decisions */
  clientSignals?: Maybe<Array<ClientSignal>>;
  /** A list of documents retrieved by the agent */
  documents: Array<OracleDocument>;
  /** Any error message that occurred */
  error?: Maybe<Scalars['String']>;
  /** A list of structured errors. */
  errorInfo: Array<AppError>;
  /** A list of any errors that occurred */
  errors: Array<Scalars['String']>;
  /** The total execution time of the agent chat */
  executionTime: Scalars['Float'];
  /** Current rate limit status for the user */
  rateLimitStatus?: Maybe<RateLimitInfo>;
  /** Section-level success/failure metadata for response modules. */
  sectionStatus?: Maybe<Scalars['JSON']>;
  /** The generated title for the chat session */
  sessionTitle?: Maybe<Scalars['String']>;
  /** Whether the agent chat was successful */
  success: Scalars['Boolean'];
  /** The agent's response text */
  text: Scalars['String'];
};

export type OracleAgentChatSubscriptionPayload = {
  __typename?: 'OracleAgentChatSubscriptionPayload';
  /** The normalized channel actually used by the backend (sent with final message). */
  chatChannel?: Maybe<Scalars['String']>;
  /** The session ID for the chat. */
  chatSessionId?: Maybe<Scalars['ID']>;
  /** Generic signals for frontend workflow decisions (sent with final message). */
  clientSignals?: Maybe<Array<ClientSignal>>;
  /** Documents retrieved by the agent. */
  documents?: Maybe<Array<OracleDocument>>;
  /** An error message if something went wrong. */
  error?: Maybe<Scalars['String']>;
  /** A list of structured errors. */
  errorInfo: Array<AppError>;
  /** A list of error messages. */
  errors: Array<Scalars['String']>;
  /** Total execution time (sent with final message). */
  executionTime?: Maybe<Scalars['Float']>;
  /** Flag to indicate the final message in the stream. */
  isFinal: Scalars['Boolean'];
  /** The message pair ID for this interaction. */
  messagePairId?: Maybe<Scalars['ID']>;
  /** Current rate limit status for the user (sent with final message). */
  rateLimitStatus?: Maybe<RateLimitInfo>;
  /** Section-level success/failure metadata for response modules. */
  sectionStatus?: Maybe<Scalars['JSON']>;
  /** The generated title for the session (sent with final message). */
  sessionTitle?: Maybe<Scalars['String']>;
  /** Indicates if the event was successful. */
  success: Scalars['Boolean'];
  /** A chunk of the agent's response text. */
  textChunk?: Maybe<Scalars['String']>;
};

/** Oracle AI: Standard operators for boolean filtering */
export type OracleBooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** Oracle document payload for component rendering. */
export type OracleCardDocument = {
  __typename?: 'OracleCardDocument';
  /** Resolve the back image URL for the referenced collection. */
  backImageUrl?: Maybe<Scalars['String']>;
  collectionId?: Maybe<Scalars['ID']>;
  collectionKey?: Maybe<Scalars['String']>;
  objects: Array<OracleDocumentObject>;
  pullId: Scalars['ID'];
  pulledAt?: Maybe<Scalars['String']>;
  readingId: Scalars['ID'];
};

/** Session-scoped oracle cards state for UI decisions. */
export type OracleCardsFeatureState = {
  __typename?: 'OracleCardsFeatureState';
  activeReadingHasPull: Scalars['Boolean'];
  activeReadingId?: Maybe<Scalars['ID']>;
  canPullCard: Scalars['Boolean'];
  canStartReading: Scalars['Boolean'];
  chatSessionId?: Maybe<Scalars['ID']>;
  hasActiveReading: Scalars['Boolean'];
  hasSession: Scalars['Boolean'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  lastUsedSessionId?: Maybe<Scalars['ID']>;
};

/** Oracle AI: A chat session between user and AI */
export type OracleChatSession = {
  __typename?: 'OracleChatSession';
  /** Frontend chat channel label. Backed by the chat session's session_type column (for example: default, oracle_cards, onboarding). */
  chatChannel: Scalars['String'];
  /** The content ID this session is associated with (null for regular conversations) */
  contentId?: Maybe<Scalars['String']>;
  /** Timestamp of when the chat session was created */
  createdAt: Scalars['DateTime'];
  /** Auto-incrementing unique identifier for export operations */
  exportIndex: Scalars['Int'];
  /** Whether the user has marked this chat session as a favorite. */
  favorite: Scalars['Boolean'];
  /** Timestamp when the favorite status was last updated */
  favoriteUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** The feature media ID this session is associated with (null for regular conversations) */
  featureMediaId?: Maybe<Scalars['String']>;
  /** Unique identifier for the chat session */
  id: Scalars['ID'];
  /** Whether this chat session is the onboarding session */
  isOnboarding: Scalars['Boolean'];
  /** Month scoping key for channel sessions (for example divination); null for regular chat sessions. */
  monthKey?: Maybe<Scalars['String']>;
  /** The name (LLM-defined or user-defined) for the chat session */
  name: Scalars['String'];
  /** The personalities FK for this session */
  personalityId: Scalars['ID'];
  /** Timestamp of when the chat session was last updated */
  updatedAt: Scalars['DateTime'];
  /** User information for this chat session */
  userInfo: UserInfo;
  /** The user info UUID */
  userInfoUuid: Scalars['ID'];
};

/** Oracle AI: Input for creating a new chat session */
export type OracleChatSessionCreateInput = {
  /** The name for the chat session */
  name: Scalars['String'];
  /** The personality ID to use for this session */
  personalityId: Scalars['ID'];
};

/** Oracle AI: Response envelope for chat session creation */
export type OracleChatSessionCreateResponse = {
  __typename?: 'OracleChatSessionCreateResponse';
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']>;
  /** The created chat session, if successful */
  oracleChatSession?: Maybe<OracleChatSession>;
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean'];
};

/** Oracle AI: Response envelope for chat session deletion */
export type OracleChatSessionDeleteResponse = {
  __typename?: 'OracleChatSessionDeleteResponse';
  /** True if the deletion was successful, otherwise False */
  deleted?: Maybe<Scalars['Boolean']>;
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']>;
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean'];
};

/** Oracle AI: Input for updating chat session favorite status */
export type OracleChatSessionFavoriteInput = {
  /** The new favorite status for the chat session */
  favorite: Scalars['Boolean'];
  /** The ID of the chat session to update */
  id: Scalars['ID'];
};

/** Oracle AI: Response envelope for chat session favorite update */
export type OracleChatSessionFavoriteResponse = {
  __typename?: 'OracleChatSessionFavoriteResponse';
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']>;
  /** The updated chat session, if successful */
  oracleChatSession?: Maybe<OracleChatSession>;
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean'];
};

/** Oracle AI: Chat session list response */
export type OracleChatSessionListResponse = {
  __typename?: 'OracleChatSessionListResponse';
  /** The total number of chat sessions available. */
  count: Scalars['Int'];
  /** The number of chat sessions returned in this response. */
  limit: Scalars['Int'];
  /** The starting point of the returned chat sessions. */
  offset: Scalars['Int'];
  /** A list of chat sessions. */
  oracleChatSessions: Array<OracleChatSession>;
};

/** Oracle AI: Filtering options for chat session lists */
export type OracleChatSessionListWhere = {
  /** Filter by content ID */
  contentId?: InputMaybe<OracleStringFilterInput>;
  /** Filter by creation timestamp */
  createdAt?: InputMaybe<OracleDateTimeFilterInput>;
  /** Filter by favorite status */
  favorite?: InputMaybe<OracleBooleanFilterInput>;
  /** Filter by feature media ID */
  featureMediaId?: InputMaybe<OracleStringFilterInput>;
  /** Filter by chat session ID */
  id?: InputMaybe<OracleUuidFilterInput>;
  /** Filter by chat session name */
  name?: InputMaybe<OracleStringFilterInput>;
  /** Filter by personality ID */
  personalityId?: InputMaybe<OracleIntFilterInput>;
  /** Filter by session type / chat channel (e.g. default, playlist_generator) */
  sessionType?: InputMaybe<OracleStringFilterInput>;
  /** Filter by update timestamp */
  updatedAt?: InputMaybe<OracleDateTimeFilterInput>;
  /** Filter by user info UUID */
  userInfoUuid?: InputMaybe<OracleUuidFilterInput>;
};

/** Oracle AI: Input for renaming a chat session */
export type OracleChatSessionRenameInput = {
  /** The ID of the chat session to rename */
  id: Scalars['ID'];
  /** The new name/title for the chat session */
  name: Scalars['String'];
};

/** Oracle AI: Response envelope for chat session rename */
export type OracleChatSessionRenameResponse = {
  __typename?: 'OracleChatSessionRenameResponse';
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']>;
  /** The updated chat session, if successful */
  oracleChatSession?: Maybe<OracleChatSession>;
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean'];
};

/** Oracle AI: Input for updating an existing chat session */
export type OracleChatSessionUpdateInput = {
  /** The ID of the chat session to update */
  id: Scalars['ID'];
  /** The new user message to append to the session */
  userMessage: Scalars['String'];
};

/** Oracle AI: Response envelope for chat session update */
export type OracleChatSessionUpdateResponse = {
  __typename?: 'OracleChatSessionUpdateResponse';
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']>;
  /** The updated chat session, if successful */
  oracleChatSession?: Maybe<OracleChatSession>;
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean'];
};

/** Oracle AI: Input for transcript chunk semantic search */
export type OracleChunkSemanticSearchInput = {
  /** Candidate pool size before MMR rerank. Required ≥ limit when rankingMode is MMR; if omitted, defaults to max(20, limit * 5). */
  fetchK?: InputMaybe<Scalars['Int']>;
  languageCode: OracleChunkSemanticSearchLanguageCode;
  limit?: Scalars['Int'];
  /** MMR lambda (relevance vs diversity). Used when rankingMode is MMR; defaults to 0.5. */
  mmrLambda?: InputMaybe<Scalars['Float']>;
  prompt: Scalars['String'];
  rankingMode?: OracleChunkSemanticSearchRankingMode;
};

/** Oracle AI: Supported language codes for chunk vector tables */
export enum OracleChunkSemanticSearchLanguageCode {
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Fr = 'FR'
}

/** Oracle AI: Chunk search ranking strategy */
export enum OracleChunkSemanticSearchRankingMode {
  Mmr = 'MMR',
  Similarity = 'SIMILARITY'
}

/** Oracle AI: A video content result with federation resolver */
export type OracleContentResult = {
  __typename?: 'OracleContentResult';
  /** Brooklyn Content primary key (federation key) */
  brooklynId: Scalars['Int'];
  /** Federated Content entity from Brooklyn */
  content: Content;
  /** Brooklyn contentId (D6 nid) */
  contentId: Scalars['Int'];
  /** Content type (video for v1) */
  contentType: Scalars['String'];
  /** Relevance score */
  score: Scalars['Float'];
  /** Content title */
  title: Scalars['String'];
};

/** Oracle AI: Standard operators for datetime filtering */
export type OracleDateTimeFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
};

/** Schema for document containing text content and metadata */
export type OracleDocument = {
  __typename?: 'OracleDocument';
  /** Sequential id for recommendation component tags */
  componentId: Scalars['String'];
  /** Component type for rich rendering */
  componentType: Scalars['String'];
  /** Reference to the federated Content entity for accessing thumbnails and media */
  content?: Maybe<Content>;
  /** Content ID (not unique). Tarot components use sentinel 0. */
  contentId: Scalars['Int'];
  contentLink?: Maybe<ContentLinkDocument>;
  contentType: Scalars['String'];
  /** Off-session pull history gallery (poster); not used for active reading flows. */
  divinationPullHistory?: Maybe<DivinationPullHistoryDocument>;
  documentText: Scalars['String'];
  /** Primary key for federation with Content service */
  documentsId: Scalars['String'];
  embedding: Array<Scalars['Float']>;
  horoscope?: Maybe<HoroscopeCardDocument>;
  language: Scalars['String'];
  link: Scalars['String'];
  oracle?: Maybe<OracleCardDocument>;
  path: Scalars['String'];
  /** Reference to the federated Playlist entity for accessing playlist data */
  playlist?: Maybe<Playlist>;
  /** Brooklyn playlist ID for federated Playlist resolution */
  playlistId?: Maybe<Scalars['String']>;
  score: Scalars['Float'];
  seriesTitle: Scalars['String'];
  tarot?: Maybe<TarotDocument>;
  tarotSummary?: Maybe<TarotSummaryDocument>;
  title: Scalars['String'];
  writer: Scalars['String'];
};

/** Divination object reference in an oracle document. */
export type OracleDocumentObject = {
  __typename?: 'OracleDocumentObject';
  displayName?: Maybe<Scalars['String']>;
  /** Resolve the front image URL for this divination object. */
  frontImageUrl?: Maybe<Scalars['String']>;
  insight: Scalars['String'];
  invite: Scalars['String'];
  objectId: Scalars['ID'];
  objectKey?: Maybe<Scalars['String']>;
  position: Scalars['String'];
};

export type OracleHealth = {
  __typename?: 'OracleHealth';
  success: Scalars['Boolean'];
};

export type OracleHealthResponse = {
  __typename?: 'OracleHealthResponse';
  errors: Array<Scalars['String']>;
  health?: Maybe<OracleHealth>;
  success: Scalars['Boolean'];
};

/** Oracle AI: Standard operators for ID filtering */
export type OracleIdFilterInput = {
  eq?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
};

/** Oracle AI: AI-generated identity vibe */
export type OracleIdentityVibe = {
  __typename?: 'OracleIdentityVibe';
  /** Description of this vibe */
  description?: Maybe<Scalars['String']>;
  /** When this vibe was assigned to the user */
  generatedAt: Scalars['DateTime'];
  /** Vibe catalog ID */
  id: Scalars['ID'];
  /** The identity vibe line sentence */
  vibe: Scalars['String'];
};

/** Oracle AI: Optional input for identity vibe generation */
export type OracleIdentityVibeGenerateInput = {
  /** Up to 5 prior lines to treat as forbidden when regenerating (max 60 characters each) */
  previousVibeLines?: InputMaybe<Array<Scalars['String']>>;
  /** Optional vibe quiz answers from the profile flow (energy, feels true, shaping) */
  vibeQuiz?: InputMaybe<OracleVibeQuizInput>;
};

/** Oracle AI: Response from identity vibe line generation */
export type OracleIdentityVibeGenerateResponse = {
  __typename?: 'OracleIdentityVibeGenerateResponse';
  errors?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
  /** Generated vibe line options */
  vibeLines: Array<Scalars['String']>;
};

/** Oracle AI: Input for selecting an identity vibe line */
export type OracleIdentityVibeSelectInput = {
  /** The selected vibe line text */
  vibeLine: Scalars['String'];
};

/** Oracle AI: Response from selecting an identity vibe line */
export type OracleIdentityVibeSelectResponse = {
  __typename?: 'OracleIdentityVibeSelectResponse';
  errors?: Maybe<Array<Scalars['String']>>;
  oracleIdentityVibe?: Maybe<OracleIdentityVibe>;
  success: Scalars['Boolean'];
};

/** Oracle AI: Standard operators for integer filtering */
export type OracleIntFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
};

export type OracleLlmConfigSet = {
  __typename?: 'OracleLLMConfigSet';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
  useCaseConfigs: Array<OracleLlmUseCaseConfig>;
};

export type OracleLlmConfigSetListResponse = {
  __typename?: 'OracleLLMConfigSetListResponse';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  llmConfigSets: Array<OracleLlmConfigSet>;
  offset: Scalars['Int'];
};

export type OracleLlmConfigSetUpsertInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  key: Scalars['String'];
  name: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  useCaseConfigs?: Array<OracleLlmUseCaseConfigInput>;
};

export type OracleLlmConfigSetUpsertResponse = {
  __typename?: 'OracleLLMConfigSetUpsertResponse';
  errors: Array<Scalars['String']>;
  llmConfigSet?: Maybe<OracleLlmConfigSet>;
  success: Scalars['Boolean'];
};

export type OracleLlmUseCaseConfig = {
  __typename?: 'OracleLLMUseCaseConfig';
  frequencyPenalty?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  maxTokens?: Maybe<Scalars['Int']>;
  modelName: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  temperature?: Maybe<Scalars['Float']>;
  useCase: Scalars['String'];
};

export type OracleLlmUseCaseConfigInput = {
  frequencyPenalty?: InputMaybe<Scalars['Float']>;
  maxTokens?: InputMaybe<Scalars['Int']>;
  modelName: Scalars['String'];
  provider?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Scalars['Float']>;
  useCase: Scalars['String'];
};

/** Oracle AI: Individual message in a conversation */
export type OracleMessage = {
  __typename?: 'OracleMessage';
  /** The parent chat session ID for this message */
  chatSessionId: Scalars['ID'];
  /** The actual text content of the message */
  content: Scalars['String'];
  /** Timestamp of when the message was created */
  createdAt: Scalars['DateTime'];
  /** Derived unique identifier for the message (since they don't have separate DB IDs) */
  id: Scalars['String'];
  /** The role of the message author, e.g., "user" or "assistant" */
  role: Scalars['String'];
  /** The user ID for user messages, null for assistant messages */
  userId?: Maybe<Scalars['ID']>;
};

/** Oracle AI: Input for creating a new message */
export type OracleMessageCreateInput = {
  /** The chat session ID to which this message belongs */
  chatSessionId: Scalars['ID'];
  /** The text content of the message */
  content: Scalars['String'];
  /** The role of the message author, e.g., "user" or "assistant" */
  role: Scalars['String'];
  /** The user ID for the message, if applicable */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Oracle AI: Response envelope for message creation */
export type OracleMessageCreateResponse = {
  __typename?: 'OracleMessageCreateResponse';
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']>;
  /** The created message, if successful */
  oracleMessage?: Maybe<OracleMessage>;
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean'];
};

/** Oracle AI: Message list response */
export type OracleMessageListResponse = {
  __typename?: 'OracleMessageListResponse';
  /** The total number of messages available. */
  count: Scalars['Int'];
  /** The number of messages returned in this response. */
  limit: Scalars['Int'];
  /** The starting point of the returned messages. */
  offset: Scalars['Int'];
  /** A list of messages. */
  oracleMessages: Array<OracleMessage>;
};

/** Oracle AI: Filtering options for message lists */
export type OracleMessageListWhere = {
  /** Filter by chat session ID */
  chatSessionId?: InputMaybe<OracleUuidFilterInput>;
  /** Filter by creation timestamp */
  createdAt?: InputMaybe<OracleDateTimeFilterInput>;
  /** Filter by message role */
  role?: InputMaybe<OracleStringFilterInput>;
  /** Filter by user ID */
  userId?: InputMaybe<OracleUuidFilterInput>;
};

/** Oracle AI: A pair of user and assistant messages */
export type OracleMessagePair = {
  __typename?: 'OracleMessagePair';
  /** Active assistant response variant id */
  activeVariantId?: Maybe<Scalars['ID']>;
  /** The chat_sessions FK for this message pair */
  chatSessionId: Scalars['ID'];
  /** Timestamp of when the message pair was created */
  createdAt: Scalars['DateTime'];
  /** Document metadata used to render links/components */
  documentMetadata?: Maybe<Scalars['JSON']>;
  /** Documents referenced by this assistant message */
  documents: Array<OracleDocument>;
  /** Auto-incrementing unique identifier for export operations */
  exportIndex: Scalars['Int'];
  /** Unique identifier for the message pair */
  id: Scalars['ID'];
  /** The LLM used to generate the oracle response */
  llmName: Scalars['String'];
  /** The sentiment of the message */
  messageSentiment?: Maybe<Scalars['String']>;
  /** The topic of the message */
  messageTopic?: Maybe<Scalars['String']>;
  /** Communication mode ('text' or 'voice') */
  mode: Scalars['String'];
  /** The assistant's message in the pair */
  oracleMessage: OracleMessage;
  /** User's thumbs up/down rating of the oracle response ('up', 'down', or 'none') */
  thumbsValue: Scalars['String'];
  /** Stable 0-based turn index within the chat session */
  turnIndex: Scalars['Int'];
  /** Timestamp of when the message pair was last updated */
  updatedAt: Scalars['DateTime'];
  /** The user info UUID */
  userInfoUuid: Scalars['ID'];
  /** The user's message in the pair */
  userMessage: OracleMessage;
};

/** Oracle AI: Input for creating a new message pair */
export type OracleMessagePairCreateInput = {
  /** The chat session ID for this message pair */
  chatSessionId: Scalars['ID'];
  /** The name of the LLM that generated the response */
  llmName: Scalars['String'];
  /** The sentiment of the message */
  messageSentiment?: InputMaybe<Scalars['String']>;
  /** The topic of the message */
  messageTopic?: InputMaybe<Scalars['String']>;
  /** Communication mode ('text' or 'voice') */
  mode?: InputMaybe<Scalars['String']>;
  /** The assistant's response text */
  oracleMessage: Scalars['String'];
  /** The user info UUID for the user message */
  userInfoUuid: Scalars['ID'];
  /** The user's message text */
  userMessage: Scalars['String'];
};

/** Oracle AI: Response envelope for message pair creation */
export type OracleMessagePairCreateResponse = {
  __typename?: 'OracleMessagePairCreateResponse';
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']>;
  /** The created message pair, if successful */
  oracleMessagePair?: Maybe<OracleMessagePair>;
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean'];
};

/** Oracle AI: Response envelope for message pair deletion */
export type OracleMessagePairDeleteResponse = {
  __typename?: 'OracleMessagePairDeleteResponse';
  /** True if the deletion was successful, otherwise False */
  deleted?: Maybe<Scalars['Boolean']>;
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']>;
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean'];
};

/** Oracle AI: Message pair list response */
export type OracleMessagePairListResponse = {
  __typename?: 'OracleMessagePairListResponse';
  /** The total number of message pairs available. */
  count: Scalars['Int'];
  /** The number of message pairs returned in this response. */
  limit: Scalars['Int'];
  /** The starting point of the returned message pairs. */
  offset: Scalars['Int'];
  /** A list of message pairs. */
  oracleMessagePairs: Array<OracleMessagePair>;
};

/** Oracle AI: Filtering options for message pair lists */
export type OracleMessagePairListWhere = {
  /** Filter by creation timestamp */
  createdAt?: InputMaybe<OracleDateTimeFilterInput>;
  /** Filter by message pair ID */
  id?: InputMaybe<OracleUuidFilterInput>;
  /** Filter by LLM name */
  llmName?: InputMaybe<OracleStringFilterInput>;
  /** Filter by communication mode ('text' or 'voice') */
  mode?: InputMaybe<OracleStringFilterInput>;
  /** Filter by update timestamp */
  updatedAt?: InputMaybe<OracleDateTimeFilterInput>;
};

/** Oracle AI: Input for regenerating the last message pair turn */
export type OracleMessagePairRegenerateLastInput = {
  /** Optional context document cap for regeneration */
  maxContextDocs?: InputMaybe<Scalars['Int']>;
  /** Optional max iterations for regeneration */
  maxIterations?: InputMaybe<Scalars['Int']>;
  /** Message pair ID to regenerate (must be the current last turn) */
  messagePairId: Scalars['ID'];
  /** Optional mode override ('text' or 'voice') */
  mode?: InputMaybe<Scalars['String']>;
  /** Optional model override for regeneration */
  modelName?: InputMaybe<Scalars['String']>;
};

/** Oracle AI: Response envelope for last-turn regenerate mutation */
export type OracleMessagePairRegenerateLastResponse = {
  __typename?: 'OracleMessagePairRegenerateLastResponse';
  /** Active variant selected after regeneration */
  activeVariant?: Maybe<OracleMessagePairVariant>;
  /** List of mutation errors */
  errors: Array<Scalars['String']>;
  /** Updated message pair with active regenerated response */
  oracleMessagePair?: Maybe<OracleMessagePair>;
  /** Indicates mutation success */
  success: Scalars['Boolean'];
};

/** Oracle AI: Input for creating a message-pair share link */
export type OracleMessagePairShareInput = {
  /** The message pair ID to snapshot and share */
  messagePairId: Scalars['ID'];
};

/** Oracle AI: Envelope response for message-pair sharing */
export type OracleMessagePairShareResponse = {
  __typename?: 'OracleMessagePairShareResponse';
  /** Errors from share creation */
  errors: Array<Scalars['String']>;
  /** Public share ID for this message pair */
  shareId?: Maybe<Scalars['ID']>;
  /** Whether share creation succeeded */
  success: Scalars['Boolean'];
};

/** Oracle AI: Input for updating an existing message pair */
export type OracleMessagePairUpdateInput = {
  /** The updated LLM name */
  llmName?: InputMaybe<Scalars['String']>;
  /** The updated message sentiment */
  messageSentiment?: InputMaybe<Scalars['String']>;
  /** The updated message topic */
  messageTopic?: InputMaybe<Scalars['String']>;
  /** The updated communication mode ('text' or 'voice') */
  mode?: InputMaybe<Scalars['String']>;
  /** The updated assistant message text */
  oracleMessage?: InputMaybe<Scalars['String']>;
  /** The updated thumbs up/down value ('up', 'down', or 'none') */
  thumbsValue?: InputMaybe<Scalars['String']>;
  /** The updated user message text */
  userMessage?: InputMaybe<Scalars['String']>;
};

/** Oracle AI: Response envelope for message pair update */
export type OracleMessagePairUpdateResponse = {
  __typename?: 'OracleMessagePairUpdateResponse';
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']>;
  /** The updated message pair, if successful */
  oracleMessagePair?: Maybe<OracleMessagePair>;
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean'];
};

/** Oracle AI: Assistant response variant for a message pair */
export type OracleMessagePairVariant = {
  __typename?: 'OracleMessagePairVariant';
  /** Creation time for this variant */
  createdAt: Scalars['DateTime'];
  /** Variant identifier */
  id: Scalars['ID'];
  /** True when this is the active variant */
  isActive: Scalars['Boolean'];
  /** LLM used to generate this variant */
  llmName: Scalars['String'];
  /** Parent message pair identifier */
  messagePairId: Scalars['ID'];
  /** Assistant response for this variant */
  oracleMessage: OracleMessage;
  /** Updated time for this variant */
  updatedAt: Scalars['DateTime'];
  /** 0-based variant index for this message pair */
  variantIndex: Scalars['Int'];
};

/** Oracle AI: Input for selecting the active assistant response variant */
export type OracleMessagePairVariantSelectInput = {
  /** Parent message pair identifier */
  messagePairId: Scalars['ID'];
  /** Variant to set active */
  variantId: Scalars['ID'];
};

/** Oracle AI: Response envelope for variant selection mutation */
export type OracleMessagePairVariantSelectResponse = {
  __typename?: 'OracleMessagePairVariantSelectResponse';
  /** Variant now active for this message pair */
  activeVariant?: Maybe<OracleMessagePairVariant>;
  /** List of mutation errors */
  errors: Array<Scalars['String']>;
  /** Updated message pair after active variant switch */
  oracleMessagePair?: Maybe<OracleMessagePair>;
  /** Indicates mutation success */
  success: Scalars['Boolean'];
};

/** Oracle AI: AI personality configuration */
export type OraclePersonality = {
  __typename?: 'OraclePersonality';
  /** Timestamp of when the personality was created */
  createdAt: Scalars['DateTime'];
  /** Display name for the personality shown on the frontend */
  displayName?: Maybe<Scalars['String']>;
  /** Whether this personality is enabled and available for use */
  enabled: Scalars['Boolean'];
  /** List of enabled tools for the personality */
  enabledTools: Array<Scalars['String']>;
  /** Custom prompt for history summarization (Phase 0.5) */
  historySummarizationPrompt?: Maybe<Scalars['String']>;
  /** Unique identifier for the personality */
  id: Scalars['ID'];
  /** Whether this is the default personality */
  isDefault: Scalars['Boolean'];
  /** Short string key for the personality (e.g., wisdom-keeper) */
  key: Scalars['String'];
  /** Scoped LLM config bindings for this personality */
  llmConfigBindings: Array<OraclePersonalityLlmConfigBinding>;
  /** ID of active default scoped LLM config set for this personality */
  llmDefaultConfigSetId?: Maybe<Scalars['ID']>;
  /** Frequency penalty for LLM token generation */
  llmFrequencyPenalty?: Maybe<Scalars['Float']>;
  /** Maximum tokens for LLM responses */
  llmMaxTokens?: Maybe<Scalars['Int']>;
  /** LLM model name for this personality */
  llmModel: Scalars['String'];
  /** Provider-specific parameters for LLM configuration (JSON object) */
  llmProviderKwargs?: Maybe<Scalars['JSON']>;
  /** LLM temperature setting (0.0 to 1.0) */
  llmTemperature: Scalars['Float'];
  /** Soft reference to another personality by ID that serves as its parent */
  parentId?: Maybe<Scalars['ID']>;
  /** Frequency penalty for the planner phase LLM token generation */
  plannerLlmFrequencyPenalty?: Maybe<Scalars['Float']>;
  /** Reserved model name for future orchestration phase (currently unused). */
  plannerLlmModel?: Maybe<Scalars['String']>;
  /** LLM temperature setting for the planner phase (0.0 to 1.0) */
  plannerLlmTemperature?: Maybe<Scalars['Float']>;
  /** Custom system prompt for the planner phase (Phase 1.5) */
  plannerSystemPrompt?: Maybe<Scalars['String']>;
  /** System message that defines the personality's behavior */
  systemMessage: Scalars['String'];
  /** Timestamp of when the personality was last updated */
  updatedAt: Scalars['DateTime'];
  /** Whether to emit component markdown tags instead of links */
  useComponentMarkdown: Scalars['Boolean'];
  /** Reserved toggle for future multi-phase orchestration (currently unused). */
  usePlannerWriter: Scalars['Boolean'];
  /** Frequency penalty for the writer phase LLM token generation */
  writerLlmFrequencyPenalty?: Maybe<Scalars['Float']>;
  /** Reserved model name for future response phase (currently unused). */
  writerLlmModel?: Maybe<Scalars['String']>;
  /** LLM temperature setting for the writer phase (0.0 to 1.0) */
  writerLlmTemperature?: Maybe<Scalars['Float']>;
  /** Custom system prompt for the writer phase (Phase 2) */
  writerSystemPrompt?: Maybe<Scalars['String']>;
};

/** Oracle AI: Input for creating a new personality */
export type OraclePersonalityCreateInput = {
  /** Display name for the personality shown on the frontend */
  displayName?: InputMaybe<Scalars['String']>;
  /** Whether this personality is enabled and available for use */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** List of enabled tools for the personality */
  enabledTools?: Array<Scalars['String']>;
  /** Custom prompt for history summarization (Phase 0.5) */
  historySummarizationPrompt?: InputMaybe<Scalars['String']>;
  /** Set as the default personality. Setting this to true will automatically unset any existing default personality. */
  isDefault?: InputMaybe<Scalars['Boolean']>;
  /** Short string key for the personality (e.g., wisdom-keeper) */
  key: Scalars['String'];
  /** Optional channel-specific LLM config set bindings */
  llmChannelConfigSetBindings?: InputMaybe<Array<OraclePersonalityLlmChannelBindingInput>>;
  /** When true, removes the default scoped LLM config binding for this personality */
  llmClearDefaultConfigBinding?: InputMaybe<Scalars['Boolean']>;
  /** Optional LLM config set ID to bind as default for this personality */
  llmDefaultConfigSetId?: InputMaybe<Scalars['ID']>;
  /** Frequency penalty for LLM token generation */
  llmFrequencyPenalty?: InputMaybe<Scalars['Float']>;
  /** Maximum tokens for LLM responses */
  llmMaxTokens?: InputMaybe<Scalars['Int']>;
  /** LLM model name for this personality */
  llmModel?: InputMaybe<Scalars['String']>;
  /** Provider-specific parameters for LLM configuration (JSON object) */
  llmProviderKwargs?: InputMaybe<Scalars['JSON']>;
  /** LLM temperature setting (0.0 to 1.0) */
  llmTemperature?: InputMaybe<Scalars['Float']>;
  /** Soft reference to another personality by ID that serves as its parent */
  parentId?: InputMaybe<Scalars['ID']>;
  /** Frequency penalty for the planner phase LLM token generation */
  plannerLlmFrequencyPenalty?: InputMaybe<Scalars['Float']>;
  /** Reserved model name for future orchestration phase (currently unused). */
  plannerLlmModel?: InputMaybe<Scalars['String']>;
  /** LLM temperature setting for the planner phase (0.0 to 1.0) */
  plannerLlmTemperature?: InputMaybe<Scalars['Float']>;
  /** Custom system prompt for the planner phase (Phase 1.5) */
  plannerSystemPrompt?: InputMaybe<Scalars['String']>;
  /** System message that defines the personalities behavior */
  systemMessage: Scalars['String'];
  /** Whether to emit component markdown tags instead of links */
  useComponentMarkdown?: InputMaybe<Scalars['Boolean']>;
  /** Reserved toggle for future multi-phase orchestration (currently unused). */
  usePlannerWriter?: InputMaybe<Scalars['Boolean']>;
  /** Frequency penalty for the writer phase LLM token generation */
  writerLlmFrequencyPenalty?: InputMaybe<Scalars['Float']>;
  /** Reserved model name for future response phase (currently unused). */
  writerLlmModel?: InputMaybe<Scalars['String']>;
  /** LLM temperature setting for the writer phase (0.0 to 1.0) */
  writerLlmTemperature?: InputMaybe<Scalars['Float']>;
  /** Custom system prompt for the writer phase (Phase 2) */
  writerSystemPrompt?: InputMaybe<Scalars['String']>;
};

/** Oracle AI: Response envelope for personality creation */
export type OraclePersonalityCreateResponse = {
  __typename?: 'OraclePersonalityCreateResponse';
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']>;
  /** The created personality, if successful */
  oraclePersonality?: Maybe<OraclePersonality>;
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean'];
};

/** Oracle AI: Response envelope for personality deletion */
export type OraclePersonalityDeleteResponse = {
  __typename?: 'OraclePersonalityDeleteResponse';
  /** True if the deletion was successful, otherwise False */
  deleted?: Maybe<Scalars['Boolean']>;
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']>;
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean'];
};

export type OraclePersonalityLlmChannelBindingInput = {
  channel: Scalars['String'];
  configSetId: Scalars['ID'];
  enabled?: Scalars['Boolean'];
  priority?: Scalars['Int'];
};

export type OraclePersonalityLlmConfigBinding = {
  __typename?: 'OraclePersonalityLLMConfigBinding';
  configSetId: Scalars['ID'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  priority: Scalars['Int'];
  scopeKey?: Maybe<Scalars['String']>;
  scopeType: Scalars['String'];
};

/** Oracle AI: Personality list response */
export type OraclePersonalityListResponse = {
  __typename?: 'OraclePersonalityListResponse';
  /** The total number of personalities available. */
  count: Scalars['Int'];
  /** The number of personalities returned in this response. */
  limit: Scalars['Int'];
  /** The starting point of the returned personalities. */
  offset: Scalars['Int'];
  /** A list of personalities. */
  oraclePersonalities: Array<OraclePersonality>;
};

/** Oracle AI: Filtering options for personality lists */
export type OraclePersonalityListWhere = {
  /** Filter by creation timestamp */
  createdAt?: InputMaybe<OracleDateTimeFilterInput>;
  /** Filter by enabled status */
  enabled?: InputMaybe<OracleBooleanFilterInput>;
  /** Filter by enabled tools */
  enabledTools?: InputMaybe<OracleStringFilterInput>;
  /** Filter by personality ID */
  id?: InputMaybe<OracleIntFilterInput>;
  /** Filter by default status */
  isDefault?: InputMaybe<OracleBooleanFilterInput>;
  /** Filter by personality key */
  key?: InputMaybe<OracleStringFilterInput>;
  /** Filter by parent personality ID */
  parentId?: InputMaybe<OracleIntFilterInput>;
  /** Filter by update timestamp */
  updatedAt?: InputMaybe<OracleDateTimeFilterInput>;
};

/** Oracle AI: Input for updating an existing personality */
export type OraclePersonalityUpdateInput = {
  /** New display name for the personality shown on the frontend */
  displayName?: InputMaybe<Scalars['String']>;
  /** Whether this personality is enabled and available for use */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** New list of enabled tools for the personality */
  enabledTools?: InputMaybe<Array<Scalars['String']>>;
  /** New custom prompt for history summarization (Phase 0.5) */
  historySummarizationPrompt?: InputMaybe<Scalars['String']>;
  /** ID of the personality to update */
  id: Scalars['ID'];
  /** Set as the default personality. Setting this to true will automatically unset any existing default personality. */
  isDefault?: InputMaybe<Scalars['Boolean']>;
  /** New key for the personality */
  key?: InputMaybe<Scalars['String']>;
  /** Optional channel-scoped LLM config set binding updates */
  llmChannelConfigSetBindings?: InputMaybe<Array<OraclePersonalityLlmChannelBindingInput>>;
  /** When true, removes the default scoped LLM config binding for this personality */
  llmClearDefaultConfigBinding?: InputMaybe<Scalars['Boolean']>;
  /** Optional default LLM config set ID for this personality */
  llmDefaultConfigSetId?: InputMaybe<Scalars['ID']>;
  /** New frequency penalty for LLM token generation */
  llmFrequencyPenalty?: InputMaybe<Scalars['Float']>;
  /** New maximum tokens for LLM responses */
  llmMaxTokens?: InputMaybe<Scalars['Int']>;
  /** New LLM model name for this personality */
  llmModel?: InputMaybe<Scalars['String']>;
  /** New provider-specific parameters for LLM configuration (JSON object) */
  llmProviderKwargs?: InputMaybe<Scalars['JSON']>;
  /** New LLM temperature setting (0.0 to 1.0) */
  llmTemperature?: InputMaybe<Scalars['Float']>;
  /** New parent ID for the personality */
  parentId?: InputMaybe<Scalars['ID']>;
  /** New frequency penalty for the planner phase LLM token generation */
  plannerLlmFrequencyPenalty?: InputMaybe<Scalars['Float']>;
  /** Reserved model name for future orchestration phase (currently unused). */
  plannerLlmModel?: InputMaybe<Scalars['String']>;
  /** New LLM temperature setting for the planner phase (0.0 to 1.0) */
  plannerLlmTemperature?: InputMaybe<Scalars['Float']>;
  /** New custom system prompt for the planner phase (Phase 1.5) */
  plannerSystemPrompt?: InputMaybe<Scalars['String']>;
  /** New system message for the personality */
  systemMessage?: InputMaybe<Scalars['String']>;
  /** Whether to emit component markdown tags instead of links */
  useComponentMarkdown?: InputMaybe<Scalars['Boolean']>;
  /** Reserved toggle for future multi-phase orchestration (currently unused). */
  usePlannerWriter?: InputMaybe<Scalars['Boolean']>;
  /** New frequency penalty for the writer phase LLM token generation */
  writerLlmFrequencyPenalty?: InputMaybe<Scalars['Float']>;
  /** Reserved model name for future response phase (currently unused). */
  writerLlmModel?: InputMaybe<Scalars['String']>;
  /** New LLM temperature setting for the writer phase (0.0 to 1.0) */
  writerLlmTemperature?: InputMaybe<Scalars['Float']>;
  /** New custom system prompt for the writer phase (Phase 2) */
  writerSystemPrompt?: InputMaybe<Scalars['String']>;
};

/** Oracle AI: Response envelope for personality update */
export type OraclePersonalityUpdateResponse = {
  __typename?: 'OraclePersonalityUpdateResponse';
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']>;
  /** The updated personality, if successful */
  oraclePersonality?: Maybe<OraclePersonality>;
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean'];
};

/** Oracle AI: Input for generating a playlist */
export type OraclePlaylistGenerateInput = {
  /** Viewing intent */
  intent?: Scalars['String'];
  /** Language code (e.g. en, de, es) */
  language?: Scalars['String'];
  /** User mood */
  mood?: Scalars['String'];
};

/** Oracle AI: Result of playlist generation */
export type OraclePlaylistGenerateResult = {
  __typename?: 'OraclePlaylistGenerateResult';
  /** Video recommendations */
  documents: Array<OracleDocument>;
  errors: Array<Scalars['String']>;
  /** Seconds */
  executionTime: Scalars['Float'];
  success: Scalars['Boolean'];
  /** AI-generated narrative text */
  text: Scalars['String'];
};

/** Oracle AI: A playlist result with federation resolver */
export type OraclePlaylistResult = {
  __typename?: 'OraclePlaylistResult';
  /** Brooklyn playlist UUID */
  id: Scalars['String'];
  /** Federated Playlist entity from Brooklyn */
  playlist: Playlist;
  /** Relevance score */
  score: Scalars['Float'];
  /** Playlist title */
  title: Scalars['String'];
};

/** Oracle AI: Input for saving a playlist */
export type OraclePlaylistSaveInput = {
  /** Ordered list of content IDs to add */
  contentIds: Array<Scalars['Int']>;
  /** Content type (default: video) */
  contentType?: Scalars['String'];
  /** A short description capturing the playlist's mood, theme, or intent */
  description?: Scalars['String'];
  /** Name for the new playlist */
  playlistName: Scalars['String'];
};

/** Oracle AI: Response for playlist save */
export type OraclePlaylistSaveResponse = {
  __typename?: 'OraclePlaylistSaveResponse';
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']>;
  /** Number of items successfully added to the playlist */
  itemsAdded: Scalars['Int'];
  /** The ID of the created playlist */
  playlistId?: Maybe<Scalars['String']>;
  /** The name of the created playlist */
  playlistName?: Maybe<Scalars['String']>;
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean'];
};

/** Oracle AI: A member profile result with federation resolver */
export type OracleProfileResult = {
  __typename?: 'OracleProfileResult';
  /** User bio */
  bio: Scalars['String'];
  /** User interest labels */
  interests: Array<Scalars['String']>;
  /** Federated UserProfile entity from Brooklyn */
  profile: UserProfile;
  /** Relevance score */
  score: Scalars['Float'];
  /** User UID */
  uid: Scalars['String'];
  /** Username */
  username: Scalars['String'];
};

/** Oracle AI: Input for search feedback (thumbs up/down) */
export type OracleSearchFeedbackInput = {
  /** Feedback value: 'up', 'down', or 'none' */
  thumbsValue: Scalars['String'];
  /** Turn ID from the streaming search payload */
  turnId: Scalars['ID'];
};

/** Oracle AI: Response for search feedback mutation */
export type OracleSearchFeedbackResponse = {
  __typename?: 'OracleSearchFeedbackResponse';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  thumbsValue?: Maybe<Scalars['String']>;
};

/** Oracle AI: Input for agent-powered oracle search */
export type OracleSearchInput = {
  /** Language preference */
  language?: Scalars['String'];
  /** Max results per type */
  limit?: Scalars['Int'];
  /** Personality to use (Sage default) */
  personalityId?: Scalars['Int'];
  /** Previous AI text for refinement context */
  previousResponse?: InputMaybe<Scalars['String']>;
  query: Scalars['String'];
  /** Optional follow-up refinement */
  refinement?: InputMaybe<Scalars['String']>;
  /** What to search: 'playlist', 'content', 'profile', etc. */
  types?: Array<Scalars['String']>;
};

/** Oracle AI: Agent-powered search result */
export type OracleSearchResult = {
  __typename?: 'OracleSearchResult';
  /** Video content results */
  content: Array<OracleContentResult>;
  /** AI message for the content/videos tab */
  contentText: Scalars['String'];
  errors: Array<Scalars['String']>;
  /** Total search execution time in seconds */
  executionTime: Scalars['Float'];
  /** AI message for the playlists tab */
  playlistText: Scalars['String'];
  /** Playlist results */
  playlists: Array<OraclePlaylistResult>;
  /** AI message for the profiles/authors tab */
  profileText: Scalars['String'];
  /** Member profile results */
  profiles: Array<OracleProfileResult>;
  success: Scalars['Boolean'];
  /** AI-generated recommendation text (generic fallback) */
  text: Scalars['String'];
};

/** Oracle AI: Input for streaming search */
export type OracleSearchStreamInput = {
  /** Session ID from previous search for refinement. Omit for fresh search. */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /** Language preference */
  language?: Scalars['String'];
  /** Max results per type */
  limit?: Scalars['Int'];
  /** Personality to use (Sage default) */
  personalityId?: Scalars['Int'];
  query: Scalars['String'];
  /** What to search: 'playlist', 'content', 'profile', etc. */
  types?: Array<Scalars['String']>;
};

/** Oracle AI: Streaming search subscription payload */
export type OracleSearchSubscriptionPayload = {
  __typename?: 'OracleSearchSubscriptionPayload';
  /** Search session ID for refinement and feedback */
  chatSessionId?: Maybe<Scalars['ID']>;
  contentResults?: Maybe<Array<OracleContentResult>>;
  errors: Array<Scalars['String']>;
  executionTime?: Maybe<Scalars['Float']>;
  isFinal: Scalars['Boolean'];
  playlistResults?: Maybe<Array<OraclePlaylistResult>>;
  profileResults?: Maybe<Array<OracleProfileResult>>;
  refinementSuggestions?: Maybe<Array<Scalars['String']>>;
  /** Oracle AI: Status key for stage-based loading feedback (e.g. 'searching', 'generating') */
  statusText?: Maybe<Scalars['String']>;
  /** Oracle AI: Typed refinement suggestions with classification and structured attributes */
  structuredRefinements?: Maybe<Array<RefinementSuggestion>>;
  success: Scalars['Boolean'];
  textChunk?: Maybe<Scalars['String']>;
  /** Turn ID for submitting feedback via oracleSearchFeedback mutation */
  turnId?: Maybe<Scalars['ID']>;
};

/** Oracle AI: Public shared assistant message */
export type OracleSharedAssistantMessage = {
  __typename?: 'OracleSharedAssistantMessage';
  /** Snapshot of the assistant message */
  content: Scalars['String'];
};

/** Oracle AI: Public shared document */
export type OracleSharedDocument = {
  __typename?: 'OracleSharedDocument';
  contentType?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** Oracle AI: Public shared message pair snapshot */
export type OracleSharedMessagePair = {
  __typename?: 'OracleSharedMessagePair';
  createdAt: Scalars['DateTime'];
  documents: Array<OracleSharedDocument>;
  oracleMessage: OracleSharedAssistantMessage;
  personalityDisplayName?: Maybe<Scalars['String']>;
  personalityKey: Scalars['String'];
  userMessage: OracleSharedUserMessage;
};

/** Oracle AI: Public shared user message */
export type OracleSharedUserMessage = {
  __typename?: 'OracleSharedUserMessage';
  /** Snapshot of the user's message */
  content: Scalars['String'];
};

/** Oracle AI: Standard operators for string filtering */
export type OracleStringFilterInput = {
  eq?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
};

/** Oracle AI: Standard operators for tags filtering */
export type OracleTagsFilterInput = {
  /** Filter questions that contain all of the specified tags */
  contains?: InputMaybe<Array<Scalars['String']>>;
  /** Filter questions that contain any of the specified tags */
  overlap?: InputMaybe<Array<Scalars['String']>>;
};

/** Oracle AI: A transcript segment hit from chunk semantic search */
export type OracleTranscriptChunk = {
  __typename?: 'OracleTranscriptChunk';
  contentId: Scalars['String'];
  endTimecode: Scalars['String'];
  featureMediaId: Scalars['String'];
  startTimecode: Scalars['String'];
};

/** Oracle AI: Standard operators for UUID filtering */
export type OracleUuidFilterInput = {
  eq?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<Scalars['UUID']>>;
};

/** Oracle AI: Vibe quiz selections (canonical English strings from the client) */
export type OracleVibeQuizInput = {
  /** Up to 2 energy adjectives (e.g. Grounded, Curious); max 160 characters per value */
  energy?: InputMaybe<Array<Scalars['String']>>;
  /** Up to 2 'feels true' phrases; max 160 characters per value */
  feelsTrue?: InputMaybe<Array<Scalars['String']>>;
  /** Up to 2 shaping-day activity labels; max 160 characters per value */
  shapingDays?: InputMaybe<Array<Scalars['String']>>;
};

/** Oracle AI: Curated list of visualizers for site admins. */
export type OracleVisualizerCatalog = {
  __typename?: 'OracleVisualizerCatalog';
  /** Ordered visualizer entries. */
  entries: Array<OracleVisualizerCatalogEntry>;
};

/** Oracle AI: A single entry in the admin visualizer catalog. */
export type OracleVisualizerCatalogEntry = {
  __typename?: 'OracleVisualizerCatalogEntry';
  /** Optional longer description or tooltip copy. */
  description: Scalars['String'];
  /** Stable identifier for menus and analytics. */
  id: Scalars['ID'];
  /** Which visualizer family this entry belongs to. */
  kind: OracleVisualizerKind;
  /** Path relative to the Oracle origin (e.g. /api/visualizer/plotly/...); combine with the service base URL to open a new tab. */
  launchPath: Scalars['String'];
  /** Short label for submenu UI. */
  title: Scalars['String'];
};

/** Oracle AI: Kind of curated visualizer entry. */
export enum OracleVisualizerKind {
  Dash = 'DASH',
  EmbeddingProjector = 'EMBEDDING_PROJECTOR',
  Plotly = 'PLOTLY'
}

/** PM List - A curated list of content items (videos, series, people, tags, etc.) that can be associated with PM Sections. Lists are used primarily in 'content-list' section types where each list becomes a tab. Lists contain ordered content items that are displayed together. */
export type PmList = {
  __typename?: 'PMList';
  /** Administrative title used in admin interfaces to identify this list. Not displayed to end users. */
  adminTitle: Scalars['String'];
  /** The date the row was created */
  createdAt: Scalars['DateTime'];
  /** Description displayed to end users. User-facing description explaining what the list contains. Used for additional context when displaying the list. */
  description?: Maybe<Scalars['String']>;
  /** The primary identifier for this record */
  id: Scalars['ID'];
  /** Two letter language code (e.g., 'en', 'es', 'fr') for the list's language */
  language: Scalars['String'];
  /** Array of content type/content id objects that make up this list. Each item specifies a content type (e.g., 'video', 'series', 'person') and content ID. Items are displayed in the order they appear in this array. Example: [{type: 'series', id: '123'}, {type: 'video', id: '456'}] represents a list with one series followed by one video. */
  listItems: Array<PmListItem>;
  /** Title displayed to end users. User-facing title for the list (e.g., 'Featured Videos', 'Popular Series'). Used when the list is displayed as a tab or section header. */
  title?: Maybe<Scalars['String']>;
  /** List type string constant that determines what kind of content the list contains. Valid types: 'content' (mix of videos and series from content model), 'content-people' (people/instructors from content model), 'content-tags' (tags from content model), 'portals' (user portals), 'people' (legacy people list type). The type affects how listItems are resolved and displayed. */
  type: Scalars['String'];
  /** The date the row was last updated */
  updatedAt: Scalars['DateTime'];
};

/** PM List Item */
export type PmListItem = {
  __typename?: 'PMListItem';
  /** The asset linked to this list item (resolved from image.asset) */
  asset?: Maybe<Asset>;
  /** The child list id */
  childListId?: Maybe<Scalars['String']>;
  /** The content id */
  id?: Maybe<Scalars['String']>;
  /** The image linked to this list item (resolved from imageId) */
  image?: Maybe<Image>;
  /**
   * The image id (for legacy people lists). Deprecated: use asset field instead.
   * @deprecated Use asset field instead
   */
  imageId?: Maybe<Scalars['String']>;
  /**
   * The image URL (computed). Deprecated: use asset.renderUrl instead.
   * @deprecated Use asset.renderUrl instead
   */
  imageUrl?: Maybe<Scalars['String']>;
  /** The content title (computed) */
  title?: Maybe<Scalars['String']>;
  /** The content type */
  type?: Maybe<Scalars['String']>;
};

/** PM List list response */
export type PmListListResponse = {
  __typename?: 'PMListListResponse';
  /** The total number of PM Lists matching the query */
  count?: Maybe<Scalars['Int']>;
  /** The limit used in the query */
  limit: Scalars['Int'];
  /** The offset used in the query */
  offset: Scalars['Int'];
  /** A list of PM List */
  pmLists: Array<PmList>;
};

/** PM List where admin title input type */
export type PmListWhereAdminTitleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** PM List where id input type */
export type PmListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** PM List where conditions to filter rows */
export type PmListWhereInput = {
  /** The admin title field where clause */
  adminTitle?: InputMaybe<PmListWhereAdminTitleInput>;
  /** The id field where clause */
  id?: InputMaybe<PmListWhereIdInput>;
  /** The language field where clause */
  language?: InputMaybe<PmListWhereLanguageInput>;
  /** The type field where clause */
  type?: InputMaybe<PmListWhereTypeInput>;
};

/** PM List where language input type */
export type PmListWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** PM List where type input type */
export type PmListWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** PM Screen - A screen/page in the application that contains multiple PM Sections. Screens define the overall page structure (e.g., member home page, centers page). Each screen has multiple sections that are displayed in order. Examples: 'member-home' (main member landing page), 'member-home-v2'/'member-home-v4' (updated versions), 'centers' (centers/communities page). */
export type PmScreen = {
  __typename?: 'PMScreen';
  /** The date the row was created */
  createdAt: Scalars['DateTime'];
  /** The primary identifier for this record */
  id: Scalars['ID'];
  /** Two letter language code (e.g., 'en', 'es', 'fr') for the screen's language */
  language: Scalars['String'];
  /**
   * PM Sections which are children of this PM Screen. Returns all sections belonging to this screen.
   * Sections can be personalized based on user context, filtered by content properties, and filtered by enabled status.
   * The hierarchy is: PMScreen → PMSection → PMList.
   * @see pmScreenPersonalized resolver for more details
   */
  pmSections: Array<PmSection>;
  /** Screen type string constant that identifies the screen/page. Common types: 'member-home' (main member landing page, automatically upgraded to v2), 'member-home-v2' (member home version 2), 'member-home-v4' (member home version 4 with experiments), 'centers' (centers/communities page). Used to fetch the correct screen configuration for a given page in the app. */
  screenType: Scalars['String'];
  /** The date the row was last updated */
  updatedAt: Scalars['DateTime'];
};


/** PM Screen - A screen/page in the application that contains multiple PM Sections. Screens define the overall page structure (e.g., member home page, centers page). Each screen has multiple sections that are displayed in order. Examples: 'member-home' (main member landing page), 'member-home-v2'/'member-home-v4' (updated versions), 'centers' (centers/communities page). */
export type PmScreenPmSectionsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
};

/** PM Screen create input */
export type PmScreenCreateInput = {
  /** Two letter language code */
  language: Scalars['String'];
  /** Screen type string constant */
  screenType: Scalars['String'];
};

/** PM Screen create response */
export type PmScreenCreateResponse = {
  __typename?: 'PMScreenCreateResponse';
  /** The created PM Screen */
  pmScreen: PmScreen;
  /** Whether the creation was successful */
  success: Scalars['Boolean'];
};

/** PM Screen delete response */
export type PmScreenDeleteResponse = {
  __typename?: 'PMScreenDeleteResponse';
  /** The deleted PM Screen */
  pmScreen: PmScreen;
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** PM Screen list response */
export type PmScreenListResponse = {
  __typename?: 'PMScreenListResponse';
  /** The total number of PM Screens matching the query */
  count?: Maybe<Scalars['Int']>;
  /** The limit used in the query */
  limit: Scalars['Int'];
  /** The offset used in the query */
  offset: Scalars['Int'];
  /** A list of PM Screen */
  pmScreens: Array<PmScreen>;
};

/** PM Screen personalized response */
export type PmScreenPersonalizedResponse = {
  __typename?: 'PMScreenPersonalizedResponse';
  /** The personalized PM Screen null when the screen is not found */
  pmScreen?: Maybe<PmScreen>;
  /**
   * The screen type for the personalized screen, this is infered screen type from the requested args
   * e.g. the value used to get the pmScreen
   */
  screenType: Scalars['String'];
};

/** PM Screen update input */
export type PmScreenUpdateInput = {
  /** The primary identifier for this record */
  id: Scalars['ID'];
  /** Two letter language code */
  language?: InputMaybe<Scalars['String']>;
  /** Screen type string constant */
  screenType?: InputMaybe<Scalars['String']>;
};

/** PM Screen update response */
export type PmScreenUpdateResponse = {
  __typename?: 'PMScreenUpdateResponse';
  /** The updated PM Screen */
  pmScreen: PmScreen;
  /** Whether the update was successful */
  success: Scalars['Boolean'];
};

/** PM Screen where id input type */
export type PmScreenWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** PM Screen where conditions to filter rows */
export type PmScreenWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<PmScreenWhereIdInput>;
  /** The language field where clause */
  language?: InputMaybe<PmScreenWhereLanguageInput>;
  /** The screen type field where clause */
  screenType?: InputMaybe<PmScreenWhereScreenTypeInput>;
};

/** PM Screen where language input type */
export type PmScreenWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** PM Screen where screen type input type */
export type PmScreenWhereScreenTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** PM Section - A content section that appears on a PM Screen. Sections define what content is displayed and how it's organized. Examples: content-list sections display curated lists of videos/series, continue-watching sections show user's watch history, placement sections show personalized recommendations. */
export type PmSection = {
  __typename?: 'PMSection';
  /** Administrative title used in admin interfaces to identify this section. Not displayed to end users. */
  adminTitle: Scalars['String'];
  /** The personalized and rendered version of this section for use in applications. This includes processed data with tabs, personalization, and all computed fields from getSection. */
  app?: Maybe<PmSectionApp>;
  /** PM section availability of client attributes. Integer value: 1 = ALLOW_WITH (section only visible if request has matching client attributes), 2 = BLOCKED_WITH (section hidden if request has matching client attributes), 3 = NO_RESTRICTIONS (default, no client attribute filtering). Works in combination with clientAttributes array. */
  availabilityClientAttributes: Scalars['Int'];
  /** The client attributes to apply in combination with availability_client_attributes ordered ASC. Client attributes identify the app/platform making the request (e.g., 'app-provider-gaia', 'app-web', 'app-tv-android', 'app-mobile-ios'). Used to restrict section visibility to specific platforms. Must be ordered alphabetically. */
  clientAttributes: Array<Scalars['String']>;
  /** The date the row was created */
  createdAt: Scalars['DateTime'];
  /** Section is hidden when not enabled. When false, the section will not appear on the screen even if it exists. */
  enabled: Scalars['Boolean'];
  /** The primary identifier for this record */
  id: Scalars['ID'];
  /** Two letter language code (e.g., 'en', 'es', 'fr') for the section's language */
  language: Scalars['String'];
  /** Section placement order within a screen. Lower numbers appear first. Sections are sorted by this field when displayed. Used to control the vertical order of sections on a screen (e.g., header section might be order 1, featured content order 2, etc.). */
  order?: Maybe<Scalars['Int']>;
  /** PM Lists associated with this section. Used primarily by 'content-list' section types where each list becomes a tab. Lists are linked to sections through the pm_section_pm_list join table. Returns curated lists of content items (videos, series, people, tags, etc.) that belong to this section. */
  pmList: Array<PmList>;
  /** The PM Screen that is the parent for this section. Resolves to the full PMScreen object containing this section. */
  pmScreen?: Maybe<PmScreen>;
  /** The Screen this Section belongs to. Foreign key reference to the PMScreen that contains this section. */
  pmScreenId?: Maybe<Scalars['ID']>;
  /** The provider for the data of this section. Used when section content comes from external recommendation systems. Valid values: 'personalize' (AWS Personalize recommendations), 'pine' (Pine/SLR recommendation system). When null, section uses static or computed content. */
  provider?: Maybe<Scalars['String']>;
  /** The key that can be used to access the data for this provider. This is a provider-specific identifier used to fetch recommendations. For 'personalize' provider, this might be a campaign ID. For 'pine' provider, this might be a placement key. Used in combination with the provider field. */
  providerKey?: Maybe<Scalars['String']>;
  /** Section type string constant that determines the section's behavior and data structure. Common types: 'content-list' (curated lists with tabs), 'continue-watching' (user watch history), 'placement' (personalized recommendations), 'header' (screen header with image), 'recommended-content' (AI recommendations), 'most-popular' (popular content), 'courses' (course listings). See types.js for complete list. */
  type: Scalars['String'];
  /** The date the row was last updated */
  updatedAt: Scalars['DateTime'];
  /** Array of visibility rule objects that control when this section is shown to users. Rules can check user login status, subscriptions, content watched, test groups, etc. Sections are only visible if all rules pass (or are inverted). */
  visibility?: Maybe<Array<PmSectionVisibilityRule>>;
};


/** PM Section - A content section that appears on a PM Screen. Sections define what content is displayed and how it's organized. Examples: content-list sections display curated lists of videos/series, continue-watching sections show user's watch history, placement sections show personalized recommendations. */
export type PmSectionAppArgs = {
  LASpotlightOption?: InputMaybe<Scalars['Boolean']>;
  LASpotlightTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>;
  contentNot?: InputMaybe<Array<InputMaybe<ContentNotFilterInput>>>;
  disableMerchImpressionCount?: InputMaybe<Scalars['Boolean']>;
  usePGV?: InputMaybe<Scalars['Boolean']>;
  useRandom?: InputMaybe<Scalars['Boolean']>;
};


/** PM Section - A content section that appears on a PM Screen. Sections define what content is displayed and how it's organized. Examples: content-list sections display curated lists of videos/series, continue-watching sections show user's watch history, placement sections show personalized recommendations. */
export type PmSectionPmListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
};

/** PM Section App - A personalized and rendered version of a PM Section for use in applications. This includes processed data with tabs, personalization, and all computed fields from getSection. */
export type PmSectionApp = {
  __typename?: 'PMSectionApp';
  /** Administrative title used in admin interfaces to identify this section. Not displayed to end users. */
  adminTitle: Scalars['String'];
  /** PM section availability of client attributes */
  availabilityClientAttributes: Scalars['Int'];
  /** The client attributes to apply in combination with availability_client_attributes ordered ASC */
  clientAttributes: Array<Scalars['String']>;
  /** The date the row was created */
  createdAt: Scalars['DateTime'];
  /** Section-specific app data object with personalization and computed fields. The structure varies by section type. */
  data?: Maybe<PmSectionAppData>;
  /** Section is hidden when not enabled */
  enabled: Scalars['Boolean'];
  /** The primary identifier for this record */
  id: Scalars['ID'];
  /** Two letter language code (e.g., 'en', 'es', 'fr') for the section's language */
  language: Scalars['String'];
  /** Section placement order within a screen */
  order?: Maybe<Scalars['Int']>;
  /** The Screen this Section belongs to */
  pmScreenId?: Maybe<Scalars['ID']>;
  /** The base PM Section model data for this app-rendered section */
  pmSection?: Maybe<PmSection>;
  /** The provider for the data of this section */
  provider?: Maybe<Scalars['String']>;
  /** The key that can be used to access the data for this provider */
  providerKey?: Maybe<Scalars['String']>;
  /** Section type string constant that determines the section's behavior and data structure */
  type: Scalars['String'];
  /** The date the row was last updated */
  updatedAt: Scalars['DateTime'];
  /** Array of visibility rule objects that control when this section is shown to users */
  visibility?: Maybe<Array<PmSectionVisibilityRule>>;
};

/** PM Section App Data union type - The data structure varies by section type. PMSectionAppDataPlacement for 'placement' sections (personalized recommendations), PMSectionAppDataContinueWatching for 'continue-watching'/'continue-watching-only'/'continue-watching-v3' sections, PMSectionAppDataContentList for 'content-list' sections (curated lists with tabs), PMSectionAppDataHeaderSection for 'header' sections (screen headers with images), PMSectionAppDataMemberHomeFirstTouch for 'member-home-first-touch' (first member home rails). */
export type PmSectionAppData = PmSectionAppDataContentList | PmSectionAppDataContinueWatching | PmSectionAppDataHeaderSection | PmSectionAppDataMemberHomeFirstTouch | PmSectionAppDataPlacement;

/** PM Section App Data Content Item */
export type PmSectionAppDataContentItem = {
  __typename?: 'PMSectionAppDataContentItem';
  /** The label */
  label?: Maybe<Scalars['String']>;
  /** The list id */
  listId: Scalars['ID'];
};

/** PM Section App Data for Content List types */
export type PmSectionAppDataContentList = {
  __typename?: 'PMSectionAppDataContentList';
  /** Array of content items with listId and label */
  content?: Maybe<Array<PmSectionAppDataContentItem>>;
  /** The context for the section to be used in event reporting */
  contextType?: Maybe<Scalars['String']>;
  /** The display mode */
  displayMode?: Maybe<Scalars['String']>;
  /** Enable content preferences filtering */
  enableContentPreferencesFiltering?: Maybe<Scalars['Boolean']>;
  /** Enable user hidden content */
  enableUserHiddenContent?: Maybe<Scalars['Boolean']>;
  /** The footer data */
  footer?: Maybe<PmSectionAppDataFooter>;
  /** The header data */
  header?: Maybe<PmSectionAppDataHeader>;
  /** Hide watched content */
  hideWatched?: Maybe<Scalars['Boolean']>;
  /** Log section visibility */
  logSectionVisibility?: Maybe<Scalars['Boolean']>;
  /** The recommendation ID from Recombee for tracking purposes */
  recommId?: Maybe<Scalars['String']>;
  /** The render data which determines how the section will be displayed */
  render?: Maybe<PmSectionAppDataRender>;
  /** The sort order */
  sortOrder?: Maybe<Scalars['String']>;
  /** The tabs data (complex computed structure) */
  tabs: Array<PmSectionAppDataTab>;
};

/** PM Section App Data for Continue Watching type */
export type PmSectionAppDataContinueWatching = {
  __typename?: 'PMSectionAppDataContinueWatching';
  /** The context for the section to be used in event reporting */
  contextType?: Maybe<Scalars['String']>;
  /** The description */
  description?: Maybe<Scalars['String']>;
  /** The header data */
  header?: Maybe<PmSectionAppDataHeader>;
  /** The render data which determines how the section will be displayed */
  render?: Maybe<PmSectionAppDataRender>;
  /** The tabs data (complex computed structure) */
  tabs: Array<PmSectionAppDataTab>;
  /** The title */
  title?: Maybe<Scalars['String']>;
};

/** PM Section App Data Footer */
export type PmSectionAppDataFooter = {
  __typename?: 'PMSectionAppDataFooter';
  /** The text for the footer of the section */
  label?: Maybe<Scalars['String']>;
};

/** PM Section App Data Header */
export type PmSectionAppDataHeader = {
  __typename?: 'PMSectionAppDataHeader';
  /** The text for the header of the section */
  label?: Maybe<Scalars['String']>;
};

/** PM Section App Data for Header section type */
export type PmSectionAppDataHeaderSection = {
  __typename?: 'PMSectionAppDataHeaderSection';
  /** The asset linked to this header section (resolved from image.asset) */
  asset?: Maybe<Asset>;
  /** The description from the associated pmList */
  description?: Maybe<Scalars['String']>;
  /** The image linked to this header section (resolved from imageId) */
  image?: Maybe<Image>;
  /**
   * The image id. Deprecated: use asset field instead.
   * @deprecated Use asset field instead
   */
  imageId?: Maybe<Scalars['String']>;
  /**
   * The image URL (computed). Deprecated: use asset.renderUrl instead.
   * @deprecated Use asset.renderUrl instead
   */
  imageUrl?: Maybe<Scalars['String']>;
  /** The title from the associated pmList */
  title?: Maybe<Scalars['String']>;
};

/** PM Section App Data for member-home-first-touch (CMS copy + personalized tabs; RFY prefers Recombee with embeddings fallback) */
export type PmSectionAppDataMemberHomeFirstTouch = {
  __typename?: 'PMSectionAppDataMemberHomeFirstTouch';
  /** Context for analytics (member-home-first-touch) */
  contextType?: Maybe<Scalars['String']>;
  /** CMS body copy / secondary line */
  description?: Maybe<Scalars['String']>;
  /** CMS display mode (e.g. generic, course, series, ai-focused) */
  displayMode?: Maybe<Scalars['String']>;
  /** Recombee recommendation id when the RFY slot was filled from Recombee (omitted when embeddings fallback was used) */
  recommId?: Maybe<Scalars['String']>;
  /** Two personalized rails: first is continue-watching (single top item), second is recommended-for-you (Recombee when available, otherwise embedding-based recs). */
  tabs: Array<PmSectionAppDataMemberHomeFirstTouchTab>;
  /** CMS headline */
  title?: Maybe<Scalars['String']>;
};

/** Tab row for member-home-first-touch: each row is a fixed UI slot with stable identifiers for clients. */
export type PmSectionAppDataMemberHomeFirstTouchTab = {
  __typename?: 'PMSectionAppDataMemberHomeFirstTouchTab';
  tabContent: Array<PmSectionAppTabContent>;
  /** Localized tab heading */
  tabLabel?: Maybe<Scalars['String']>;
  /** Slot id for the client, e.g. continue-watching, watch-next-episode, recommended-for-you, next-step, todays-practice */
  tabType?: Maybe<Scalars['String']>;
};

/** PM Section App Data for Placement type */
export type PmSectionAppDataPlacement = {
  __typename?: 'PMSectionAppDataPlacement';
  /** The context for the section to be used in event reporting */
  contextType?: Maybe<Scalars['String']>;
  /** The placement name */
  placement?: Maybe<Scalars['String']>;
  /** The recommendation ID from Recombee for tracking purposes */
  recommId?: Maybe<Scalars['String']>;
  /** The render data which determines how the section will be displayed */
  render?: Maybe<PmSectionAppDataRender>;
  /** The tabs data (complex computed structure) */
  tabs: Array<PmSectionAppDataTab>;
};

/** PM Section App Data Render */
export type PmSectionAppDataRender = {
  __typename?: 'PMSectionAppDataRender';
  /** The background to render */
  background?: Maybe<Scalars['String']>;
  /** A link to the content */
  link?: Maybe<Scalars['String']>;
  /** The display width */
  tileCount?: Maybe<Scalars['String']>;
  /** The render type */
  type?: Maybe<Scalars['String']>;
};

/** PM Section App Tab */
export type PmSectionAppDataTab = {
  __typename?: 'PMSectionAppDataTab';
  /** The merchandising event ID */
  merchEventId?: Maybe<Scalars['ID']>;
  /** The type of payload (merchandising-content, featured-content-impression, etc.) */
  payloadType?: Maybe<Scalars['String']>;
  /** The recommendation score at tab level */
  pineScore?: Maybe<Scalars['Float']>;
  /** The source in pine for the score at tab level */
  pineSource?: Maybe<Scalars['String']>;
  /** The campaign slug for tracking */
  slug?: Maybe<Scalars['String']>;
  /** The tab content */
  tabContent: Array<PmSectionAppTabContent>;
  /** The tab label */
  tabLabel?: Maybe<Scalars['String']>;
  /** The view mode for content display */
  viewMode?: Maybe<Scalars['String']>;
};

/** PM Section App Tab Content */
export type PmSectionAppTabContent = {
  __typename?: 'PMSectionAppTabContent';
  /** The content for this tab */
  content?: Maybe<Array<Maybe<Content>>>;
  /** The content ID */
  contentId?: Maybe<Scalars['ID']>;
  /** The content type */
  contentType?: Maybe<Scalars['String']>;
  /** Live Access spotlight: milliseconds until event start; 0 when live or no upcoming session */
  countdown?: Maybe<Scalars['Int']>;
  /** Live Access spotlight: session covering now */
  currentSession?: Maybe<LiveAccessSpotlightSessionSummary>;
  /** Live Access spotlight: body text */
  description?: Maybe<Scalars['String']>;
  /** Live Access spotlight: desktop background image URL */
  desktopBackgroundUrl?: Maybe<Scalars['String']>;
  /** Live Access spotlight: long event description */
  eventDescriptionLong?: Maybe<Scalars['String']>;
  /** Live Access spotlight: live event id */
  eventId?: Maybe<Scalars['ID']>;
  /** Live Access spotlight: event type e.g. LIVE, AMA */
  eventType?: Maybe<Scalars['String']>;
  /** The content label */
  label?: Maybe<Scalars['String']>;
  /** Live Access spotlight: manual/stream live flag from track */
  liveStreamActive?: Maybe<Scalars['Boolean']>;
  /** Live Access spotlight: hero/background image URL */
  mobileBackgroundUrl?: Maybe<Scalars['String']>;
  /** Live Access spotlight: mobile CTA label */
  mobileButtonText?: Maybe<Scalars['String']>;
  /** Live Access spotlight: mobile body copy */
  mobileDescription?: Maybe<Scalars['String']>;
  /** Live Access spotlight: mobile header copy */
  mobileHeader?: Maybe<Scalars['String']>;
  /** Live Access spotlight: large mobile spotlight image URL */
  mobileImageLargeUrl?: Maybe<Scalars['String']>;
  /** Live Access spotlight: small mobile spotlight image URL */
  mobileImageSmallUrl?: Maybe<Scalars['String']>;
  /** Live Access spotlight: mobile subheader copy */
  mobileSubHeader?: Maybe<Scalars['String']>;
  /** Live Access spotlight: next session after current */
  nextSession?: Maybe<LiveAccessSpotlightSessionSummary>;
  /** The recommendation score */
  pineScore?: Maybe<Scalars['Float']>;
  /** The source in pine for the score */
  pineSource?: Maybe<Scalars['String']>;
  /** Live Access spotlight: playback URL for stream */
  playbackUrl?: Maybe<Scalars['String']>;
  /** Live Access spotlight: event route path */
  route?: Maybe<Scalars['String']>;
  /** Live Access spotlight: first track schedule (REST `tracks[0].schedule`) */
  schedule?: Maybe<Array<LiveAccessSpotlightSessionSummary>>;
  /** The seed question if this is a seed question e.g. type 'prompt' */
  seedQuestion?: Maybe<SeedQuestion>;
  /** Live Access spotlight: ms remaining in current session when live */
  sessionTimeRemaining?: Maybe<Scalars['Int']>;
  /** Live Access spotlight: primary speaker display name */
  speakerName?: Maybe<Scalars['String']>;
  /** Live Access spotlight: spotlight row id (REST payload `id`) */
  spotlightId?: Maybe<Scalars['ID']>;
  /** Live Access spotlight: subtitle */
  subTitle?: Maybe<Scalars['String']>;
  /** Live Access spotlight: main heading */
  title?: Maybe<Scalars['String']>;
  /** Live Access spotlight: TV/fullscreen background URL */
  tvBackgroundUrl?: Maybe<Scalars['String']>;
  /** Live Access spotlight: TV thumbnail URL */
  tvThumbnailUrl?: Maybe<Scalars['String']>;
  /**
   * The type of tab content (e.g., 'chat', 'prompt')
   * NOTE: this will only be present for seed questions.
   */
  type?: Maybe<PmSectionAppTabContentType>;
  /** The video taste segment */
  videoTasteSegment?: Maybe<Scalars['String']>;
  /** Live Access spotlight: webview URL */
  webviewUrl?: Maybe<Scalars['String']>;
};


/** PM Section App Tab Content */
export type PmSectionAppTabContentContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum PmSectionAppTabContentType {
  /** chat */
  Chat = 'CHAT',
  /** prompt */
  Prompt = 'PROMPT'
}

/** PM Section create input */
export type PmSectionCreateInput = {
  /** Administrative title */
  adminTitle: Scalars['String'];
  /** PM section availability of client attributes such as no restrictions, only with or blocked with */
  availabilityClientAttributes?: InputMaybe<Scalars['Int']>;
  /** The client attributes to apply in combination with availability_client_attributes ordered ASC */
  clientAttributes?: InputMaybe<Array<Scalars['String']>>;
  /** JSON object specific to this section type */
  data?: InputMaybe<Scalars['JSON']>;
  /** Section is hidden when not enabled */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Two letter language code */
  language: Scalars['String'];
  /** Section placement order within a screen */
  order?: InputMaybe<Scalars['Int']>;
  /** The Screen this Section belongs to */
  pmScreenId?: InputMaybe<Scalars['ID']>;
  /** The provider for the data of this section e.g. personalize */
  provider?: InputMaybe<Scalars['String']>;
  /** The key that can be used to access the data for this provider */
  providerKey?: InputMaybe<Scalars['String']>;
  /** Section type string constant */
  type: Scalars['String'];
  /** Array of visibility rule objects */
  visibility?: InputMaybe<Array<PmSectionVisibilityRuleInput>>;
};

/** PM Section create response */
export type PmSectionCreateResponse = {
  __typename?: 'PMSectionCreateResponse';
  /** The created PM Section */
  pmSection: PmSection;
  /** Whether the creation was successful */
  success: Scalars['Boolean'];
};

/** PM Section delete response */
export type PmSectionDeleteResponse = {
  __typename?: 'PMSectionDeleteResponse';
  /** The deleted PM Section */
  pmSection: PmSection;
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** PM Section filter input */
export type PmSectionFilterInput = {
  /** The language to filter the rows by */
  language?: InputMaybe<Scalars['String']>;
  /** The type to filter the rows by */
  type?: InputMaybe<Scalars['String']>;
};

/** PM Section list response */
export type PmSectionListResponse = {
  __typename?: 'PMSectionListResponse';
  /** The total number of PM Sections matching the query */
  count?: Maybe<Scalars['Int']>;
  /** The limit used in the query */
  limit: Scalars['Int'];
  /** The offset used in the query */
  offset: Scalars['Int'];
  /** A list of PM Section */
  pmSections: Array<PmSection>;
};

/** PM Section update input */
export type PmSectionUpdateInput = {
  /** Administrative title */
  adminTitle?: InputMaybe<Scalars['String']>;
  /** PM section availability of client attributes such as no restrictions, only with or blocked with */
  availabilityClientAttributes?: InputMaybe<Scalars['Int']>;
  /** The client attributes to apply in combination with availability_client_attributes ordered ASC */
  clientAttributes?: InputMaybe<Array<Scalars['String']>>;
  /** JSON object specific to this section type */
  data?: InputMaybe<Scalars['JSON']>;
  /** Section is hidden when not enabled */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** The primary identifier for this record */
  id: Scalars['ID'];
  /** Two letter language code */
  language?: InputMaybe<Scalars['String']>;
  /** Section placement order within a screen */
  order?: InputMaybe<Scalars['Int']>;
  /** The Screen this Section belongs to */
  pmScreenId?: InputMaybe<Scalars['ID']>;
  /** The provider for the data of this section e.g. personalize */
  provider?: InputMaybe<Scalars['String']>;
  /** The key that can be used to access the data for this provider */
  providerKey?: InputMaybe<Scalars['String']>;
  /** Section type string constant */
  type?: InputMaybe<Scalars['String']>;
  /** Array of visibility rule objects */
  visibility?: InputMaybe<Array<PmSectionVisibilityRuleInput>>;
};

/** PM Section update response */
export type PmSectionUpdateResponse = {
  __typename?: 'PMSectionUpdateResponse';
  /** The updated PM Section */
  pmSection: PmSection;
  /** Whether the update was successful */
  success: Scalars['Boolean'];
};

/** PM Section Visibility Rule */
export type PmSectionVisibilityRule = {
  __typename?: 'PMSectionVisibilityRule';
  /** Array of content items (required for user-following, user-has-watched, content-impression types) */
  content?: Maybe<Array<PmSectionVisibilityRuleContent>>;
  /** Whether to invert the rule */
  inverse?: Maybe<Scalars['Boolean']>;
  /** Array of subscription option IDs (required for user-entitlement type) */
  subscriptions?: Maybe<Array<Scalars['Int']>>;
  /** Threshold value (required for user-view-count, my-series-min-items, followed-series-min-items types) */
  threshold?: Maybe<Scalars['Int']>;
  /** The visibility rule type */
  type: PmSectionVisibilityRuleType;
};

/** PM Section Visibility Rule Content */
export type PmSectionVisibilityRuleContent = {
  __typename?: 'PMSectionVisibilityRuleContent';
  /** The content ID */
  contentId: Scalars['Int'];
  /** The content type */
  contentType: Scalars['String'];
};

/** PM Section Visibility Rule Content Input */
export type PmSectionVisibilityRuleContentInput = {
  /** The content ID */
  contentId: Scalars['Int'];
  /** The content type */
  contentType: Scalars['String'];
};

/** PM Section Visibility Rule Input */
export type PmSectionVisibilityRuleInput = {
  /** Array of content items (required for user-following, user-has-watched, content-impression types) */
  content?: InputMaybe<Array<PmSectionVisibilityRuleContentInput>>;
  /** Whether to invert the rule */
  inverse?: InputMaybe<Scalars['Boolean']>;
  /** Array of subscription option IDs (required for user-entitlement type) */
  subscriptions?: InputMaybe<Array<Scalars['Int']>>;
  /** Threshold value (required for user-view-count, my-series-min-items, followed-series-min-items types) */
  threshold?: InputMaybe<Scalars['Int']>;
  /** The visibility rule type */
  type: PmSectionVisibilityRuleType;
};

/** PM Section Visibility Rule Type */
export enum PmSectionVisibilityRuleType {
  /** Content impression rule */
  ContentImpression = 'CONTENT_IMPRESSION',
  /** FMTV only rule */
  FmtvOnly = 'FMTV_ONLY',
  /** Followed series minimum items rule */
  FollowedSeriesMinItems = 'FOLLOWED_SERIES_MIN_ITEMS',
  /** User must be logged in */
  LoggedIn = 'LOGGED_IN',
  /** My series minimum items rule */
  MySeriesMinItems = 'MY_SERIES_MIN_ITEMS',
  /** User must have onboarded terms */
  OnboardUserTerms = 'ONBOARD_USER_TERMS',
  /** Tenure rules */
  Tenure = 'TENURE',
  /** UBS rules */
  Ubs = 'UBS',
  /** User entitlement rule */
  UserEntitlement = 'USER_ENTITLEMENT',
  /** User following rule */
  UserFollowing = 'USER_FOLLOWING',
  /** User has watched rule */
  UserHasWatched = 'USER_HAS_WATCHED',
  /** User RC terms rule */
  UserRcTerms = 'USER_RC_TERMS',
  /** User test group rule */
  UserTestGroup = 'USER_TEST_GROUP',
  /** User view count rule */
  UserViewCount = 'USER_VIEW_COUNT',
  /** VTS rules */
  Vts = 'VTS'
}

/** PM Section where admin title input type */
export type PmSectionWhereAdminTitleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** PM Section where availability client attributes input type */
export type PmSectionWhereAvailabilityClientAttributesInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** PM Section where client attributes input type */
export type PmSectionWhereClientAttributesInput = {
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** PM Section where enabled input type */
export type PmSectionWhereEnabledInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

/** PM Section where id input type */
export type PmSectionWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** PM Section where conditions to filter rows */
export type PmSectionWhereInput = {
  /** The enabled field where clause */
  enabled?: InputMaybe<PmSectionWhereEnabledInput>;
  /** The id field where clause */
  id?: InputMaybe<PmSectionWhereIdInput>;
  /** The language field where clause */
  language?: InputMaybe<PmSectionWhereLanguageInput>;
  /** The pm screen id field where clause */
  pmScreenId?: InputMaybe<PmSectionWherePmScreenIdInput>;
  /** The type field where clause */
  type?: InputMaybe<PmSectionWhereTypeInput>;
};

/** PM Section where language input type */
export type PmSectionWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** PM Section where order input type */
export type PmSectionWhereOrderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Int']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Int']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Int']>;
};

/** PM Section where pm screen id input type */
export type PmSectionWherePmScreenIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** PM Section where provider input type */
export type PmSectionWhereProviderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** PM Section where provider key input type */
export type PmSectionWhereProviderKeyInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** PM Section where type input type */
export type PmSectionWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Pagination information for cursor-based pagination */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Cursor for the last item in the result set */
  endCursor?: Maybe<Scalars['String']>;
  /** Whether there are more results available */
  hasNextPage: Scalars['Boolean'];
  /** Whether there are previous results available */
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  /** Cursor for the first item in the result set */
  startCursor?: Maybe<Scalars['String']>;
};

/** Path redirect */
export type PathRedirect = {
  __typename?: 'PathRedirect';
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The fragment to append to the redirect path */
  fragment?: Maybe<Scalars['String']>;
  /** The full URL for the redirect destination path (includes query & fragment) */
  fullUrl?: Maybe<Scalars['String']>;
  /** The primary key for this record */
  id?: Maybe<Scalars['ID']>;
  /** The query to append to the redirect path */
  query?: Maybe<Scalars['String']>;
  /** The redirect destination path */
  redirect?: Maybe<Scalars['String']>;
  /** The path to match */
  source?: Maybe<Scalars['String']>;
  /** The content associated with this path redirect by source path */
  sourceContent?: Maybe<Array<Maybe<Content>>>;
  /** The HTTP response code (301 or 302) */
  type?: Maybe<Scalars['Int']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Path redirect list response */
export type PathRedirectListResponse = {
  __typename?: 'PathRedirectListResponse';
  /** A list of content reference */
  pathRedirects?: Maybe<Array<Maybe<PathRedirect>>>;
};

/** Content path redirect type where input type */
export type PathRedirectWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Path redirect where conditions to filter rows */
export type PathRedirectWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<PathRedirectWhereIdInput>;
  /** The source field where clause */
  source?: InputMaybe<PathRedirectWhereSourceInput>;
};

/** Path redirect id where input type */
export type PathRedirectWhereSourceInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Payment Method Type */
export enum PaymentMethodType {
  ApplePay = 'ApplePay',
  CreditCard = 'CreditCard',
  GooglePay = 'GooglePay',
  PayPal = 'PayPal'
}

/** Oracle AI: A high-engagement post from a followed topic */
export type PickedPost = {
  __typename?: 'PickedPost';
  author: Scalars['String'];
  id: Scalars['String'];
  reactionsCount: Scalars['Int'];
  repliesCount: Scalars['Int'];
  snippet: Scalars['String'];
  timeAgo: Scalars['String'];
  title: Scalars['String'];
  topic: Scalars['String'];
  topicSlug: Scalars['String'];
};

/** How countries list applies for Country eligibility rule */
export enum PlanEligibilityCountryOperator {
  /** Request country ISO must be in countries */
  In = 'IN',
  /** Request country ISO must not be in countries */
  NotIn = 'NOT_IN'
}

/** Numeric comparison operator for Lifetime Value and Tenure rules */
export enum PlanEligibilityNumericOperator {
  /** Greater than */
  Gt = 'GT',
  /** Greater than or equal */
  Gte = 'GTE',
  /** Less than */
  Lt = 'LT',
  /** Less than or equal */
  Lte = 'LTE'
}

/** Plan eligibility page */
export enum PlanEligibilityPage {
  /** Checkout (sign up) */
  Checkout = 'checkout',
  /** Plan change */
  PlanChange = 'planChange'
}

/** Plan eligibility rule type */
export enum PlanEligibilityRuleType {
  /** Request country (geo) allowlist or blocklist */
  Country = 'Country',
  /** Lifetime value condition */
  LifetimeValue = 'LifetimeValue',
  /** Max number of purchases (sign up or plan change into this plan) */
  MaxPurchases = 'MaxPurchases',
  /** Months since last purchase of this plan */
  MonthsSinceLastPurchase = 'MonthsSinceLastPurchase',
  /** Current plan category must be in list */
  PlanCategory = 'PlanCategory',
  /** SKU-based rule (ecommerce and/or plan SKUs) */
  Sku = 'SKU',
  /** Tenure (days entitled) condition */
  Tenure = 'Tenure'
}

/** Plan eligibility rule scope */
export enum PlanEligibilityScope {
  /** Both checkout and plan change */
  All = 'all',
  /** Checkout (sign up) */
  Checkout = 'checkout',
  /** Plan change */
  PlanChange = 'planChange'
}

/** Plan Grid Device Type */
export enum PlanGridDeviceType {
  /** Desktop */
  Desktop = 'Desktop',
  /** Mobile */
  Mobile = 'Mobile'
}

/** Playlist row */
export type Playlist = {
  __typename?: 'Playlist';
  /** Cover photo URL */
  coverPhoto?: Maybe<PlaylistCoverPhoto>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Optional user-written description */
  description?: Maybe<Scalars['String']>;
  /** Number of users following this playlist */
  followerCount?: Maybe<Scalars['Int']>;
  /** The primary identifier for this playlist record */
  id?: Maybe<Scalars['ID']>;
  /** Whether the authenticated user follows this playlist */
  isFollowing?: Maybe<Scalars['Boolean']>;
  /** Total number of items in the playlist */
  itemCount?: Maybe<Scalars['Int']>;
  /** The playlist items linked to this playlist */
  playlistItems?: Maybe<Array<Maybe<PlaylistItem>>>;
  /** The playlist name */
  playlistName?: Maybe<Scalars['String']>;
  /** Playlist type (default | offline | yoga | custom) */
  playlistType?: Maybe<Scalars['String']>;
  /** User id of the playlist */
  uid?: Maybe<Scalars['ID']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The playlist creator's community profile (null if no profile or visibility restricted) */
  userProfile?: Maybe<UserProfile>;
  /** The playlist visibility level */
  visibility?: Maybe<PlaylistVisibility>;
};

/** Playlist cover photo with URL */
export type PlaylistCoverPhoto = {
  __typename?: 'PlaylistCoverPhoto';
  /** Full-size URL */
  url: Scalars['String'];
};

/** Response from requesting a playlist cover photo upload */
export type PlaylistCoverPhotoUploadRequest = {
  __typename?: 'PlaylistCoverPhotoUploadRequest';
  /** When the presigned URL expires */
  expiresAt: Scalars['DateTime'];
  /** UUID for the pending image */
  imageUuid: Scalars['ID'];
  /** Presigned S3 PUT URL */
  uploadUrl: Scalars['String'];
};

/** Response from confirming a playlist cover photo upload */
export type PlaylistCoverPhotoUploadResponse = {
  __typename?: 'PlaylistCoverPhotoUploadResponse';
  /** The cover photo URL */
  coverPhoto?: Maybe<PlaylistCoverPhoto>;
  /** Whether the upload was confirmed successfully */
  success: Scalars['Boolean'];
};

/** Playlist create playlist input */
export type PlaylistCreatePlaylistInput = {
  /** Optional description for the playlist */
  description?: InputMaybe<Scalars['String']>;
  /** The playlist name */
  playlistName?: InputMaybe<Scalars['String']>;
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']>;
};

/** Playlist create a playlist item input playlist data */
export type PlaylistCreatePlaylistItemPlaylistInput = {
  /** The primary key */
  id?: InputMaybe<Scalars['ID']>;
  /** The playlist name */
  playlistName?: InputMaybe<Scalars['String']>;
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']>;
};

/** Playlist create a playlist item input playlist item data */
export type PlaylistCreatePlaylistItemPlaylistItemInput = {
  /** Content content id for this playlist item */
  contentId?: InputMaybe<Scalars['Int']>;
  /** Content content type for this playlist item */
  contentType?: InputMaybe<Scalars['String']>;
  /** The position of the item in the playlist, the highest number is the start of the playlist with zero being the last item */
  playlistPosition?: InputMaybe<Scalars['Int']>;
};

/** Repsonse when creating a playlist item */
export type PlaylistCreatePlaylistItemResponse = {
  __typename?: 'PlaylistCreatePlaylistItemResponse';
  /** The playlist for the created playlist item */
  playlist?: Maybe<Playlist>;
  /** The playlist item which was created */
  playlistItem?: Maybe<PlaylistItem>;
};

/** Repsonse when creating a playlist item */
export type PlaylistCreateResponse = {
  __typename?: 'PlaylistCreateResponse';
  /** The playlist that was created */
  playlist?: Maybe<Playlist>;
};

/** Item input for bulk playlist creation */
export type PlaylistCreateWithItemsItemInput = {
  /** Content id for this playlist item */
  contentId: Scalars['Int'];
  /** Content type for this playlist item, defaults to video */
  contentType?: InputMaybe<Scalars['String']>;
};

/** Response when creating a playlist with items */
export type PlaylistCreateWithItemsResponse = {
  __typename?: 'PlaylistCreateWithItemsResponse';
  /** The playlist that was created */
  playlist?: Maybe<Playlist>;
  /** The playlist items that were created */
  playlistItems?: Maybe<Array<Maybe<PlaylistItem>>>;
};

/** Playlist delete playlist input */
export type PlaylistDeletePlaylistInput = {
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']>;
};

/** Playlist delete a playlist item input playlist data */
export type PlaylistDeletePlaylistItemPlaylistInput = {
  /** The primary key */
  id?: InputMaybe<Scalars['ID']>;
  /** The playlist name */
  playlistName?: InputMaybe<Scalars['String']>;
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']>;
};

/** Playlist item to delete */
export type PlaylistDeletePlaylistItemPlaylistItemInput = {
  /** Content content id for this playlist item */
  contentId?: InputMaybe<Scalars['Int']>;
  /** Content content type for this playlist item */
  contentType?: InputMaybe<Scalars['String']>;
  /** The playlist item id */
  id?: InputMaybe<Scalars['ID']>;
};

/** Repsonse when deleting a playlist item */
export type PlaylistDeletePlaylistItemResponse = {
  __typename?: 'PlaylistDeletePlaylistItemResponse';
  /** The playlist for the deleted playlist item */
  playlist?: Maybe<Playlist>;
  /** The playlist item which was deleted */
  playlistItem?: Maybe<PlaylistItem>;
};

/** Repsonse when creating a playlist item */
export type PlaylistDeleteResponse = {
  __typename?: 'PlaylistDeleteResponse';
  /** The playlist that was deleted */
  playlist?: Maybe<Playlist>;
};

/** Engagement data for a playlist */
export type PlaylistEngagement = {
  __typename?: 'PlaylistEngagement';
  /** Number of users following this playlist */
  followerCount: Scalars['Int'];
  /** The playlist ID */
  playlistId: Scalars['ID'];
};

/** Cursor-based connection for followed playlists */
export type PlaylistFollowedConnection = {
  __typename?: 'PlaylistFollowedConnection';
  /** List of playlist edges */
  edges: Array<PlaylistFollowedEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total count of followed playlists */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A single followed playlist edge */
export type PlaylistFollowedEdge = {
  __typename?: 'PlaylistFollowedEdge';
  /** Cursor for this edge */
  cursor: Scalars['String'];
  /** When the user followed this playlist */
  followedAt: Scalars['DateTime'];
  /** The playlist node */
  node: Playlist;
};

/** PlaylistItem row */
export type PlaylistItem = {
  __typename?: 'PlaylistItem';
  /** The playlist items content */
  content?: Maybe<Array<Maybe<Content>>>;
  /** Content content id for this playlist item */
  contentId?: Maybe<Scalars['Int']>;
  /** Content content type (video | series) */
  contentType?: Maybe<Scalars['String']>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The primary key */
  id?: Maybe<Scalars['ID']>;
  /** The playlist linked to this playlist item */
  playlist?: Maybe<Playlist>;
  /** ID for the playlist this item is tied to */
  playlistId?: Maybe<Scalars['ID']>;
  /** The position of the item in the playlist, the highest number is the start of the playlist with zero being the last item */
  playlistPosition?: Maybe<Scalars['Int']>;
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: Maybe<Scalars['String']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/** PlaylistItem row */
export type PlaylistItemContentArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Playlist item list input to match by playlist */
export type PlaylistItemListPlaylistInput = {
  /** The playlist id */
  id?: InputMaybe<Scalars['ID']>;
  /** The playlist name when creating a playlist */
  playlistName?: InputMaybe<Scalars['String']>;
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']>;
};

/** PlaylistItem asset response */
export type PlaylistItemListResponse = {
  __typename?: 'PlaylistItemListResponse';
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
  /** A list of playlistItem */
  playlistItems?: Maybe<Array<Maybe<PlaylistItem>>>;
};

/** The where clause for a playlistItem id field */
export type PlaylistItemWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value not equal to the field */
  ne?: InputMaybe<Scalars['ID']>;
};

/** The where conditions to filter rows */
export type PlaylistItemWhereInput = {
  /** The id */
  id?: InputMaybe<PlaylistItemWhereIdInput>;
};

/** Playlist asset response */
export type PlaylistListResponse = {
  __typename?: 'PlaylistListResponse';
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
  /** A list of playlist */
  playlists?: Maybe<Array<Maybe<Playlist>>>;
};

/** Cursor-based connection for playlist search results */
export type PlaylistSearchConnection = {
  __typename?: 'PlaylistSearchConnection';
  /** List of playlist edges */
  edges: Array<PlaylistSearchEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total count of matching playlists */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A single playlist search result edge */
export type PlaylistSearchEdge = {
  __typename?: 'PlaylistSearchEdge';
  /** Cursor for this edge */
  cursor: Scalars['String'];
  /** The playlist node */
  node: Playlist;
};

/** Sort order for playlist search results */
export enum PlaylistSearchOrder {
  /** Sort alphabetically by name */
  Alphabetical = 'ALPHABETICAL',
  /** Sort by newest first */
  Newest = 'NEWEST',
  /** Sort by recently updated */
  RecentlyUpdated = 'RECENTLY_UPDATED',
  /** Sort by relevance to the search query (default) */
  Relevance = 'RELEVANCE'
}

/** Input for updating a playlist's metadata */
export type PlaylistUpdateInput = {
  /** New description (max 5000 chars) */
  description?: InputMaybe<Scalars['String']>;
  /** New playlist name (max 64 chars) */
  playlistName?: InputMaybe<Scalars['String']>;
};

/** Playlist update a playlist item input playlist data */
export type PlaylistUpdatePlaylistItemPlaylistInput = {
  /** The primary key */
  id?: InputMaybe<Scalars['ID']>;
  /** The playlist name */
  playlistName?: InputMaybe<Scalars['String']>;
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']>;
};

/** Playlist create a playlist item input playlist data */
export type PlaylistUpdatePlaylistItemPlaylistItemInput = {
  /** Content content id for this playlist item */
  contentId?: InputMaybe<Scalars['Int']>;
  /** Content content type for this playlist item */
  contentType?: InputMaybe<Scalars['String']>;
  /** The playlist item id */
  id?: InputMaybe<Scalars['ID']>;
  /** The position of the item in the playlist, the highest number is the start of the playlist with zero being the last item */
  playlistPosition?: InputMaybe<Scalars['Int']>;
};

/** Repsonse when updating a playlist item */
export type PlaylistUpdatePlaylistItemResponse = {
  __typename?: 'PlaylistUpdatePlaylistItemResponse';
  /** The playlist for the updated playlist item */
  playlist?: Maybe<Playlist>;
  /** The playlist item which was updated */
  playlistItem?: Maybe<PlaylistItem>;
};

/** Response when updating a playlist */
export type PlaylistUpdateResponse = {
  __typename?: 'PlaylistUpdateResponse';
  /** The updated playlist */
  playlist?: Maybe<Playlist>;
};

/** Response when updating playlist visibility */
export type PlaylistUpdateVisibilityResponse = {
  __typename?: 'PlaylistUpdateVisibilityResponse';
  /** The playlist with updated visibility */
  playlist?: Maybe<Playlist>;
};

/** Playlist visibility level */
export enum PlaylistVisibility {
  /** Playlist is searchable but owner is hidden */
  Anonymous = 'ANONYMOUS',
  /** Playlist is not searchable, only visible to owner */
  Private = 'PRIVATE',
  /** Playlist is searchable and shows author with profile link */
  Public = 'PUBLIC'
}

/** The where clause for a playlist id field */
export type PlaylistWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** The where conditions to filter rows */
export type PlaylistWhereInput = {
  /** The id */
  id?: InputMaybe<PlaylistWhereIdInput>;
  /** The number of items in the playlist */
  itemCount?: InputMaybe<PlaylistWhereItemCountInput>;
  /** The playlist name */
  playlistName?: InputMaybe<PlaylistWherePlaylistNameInput>;
  /** The uid */
  uid?: InputMaybe<PlaylistWhereUidInput>;
};

/** The where clause for a playlist item count field */
export type PlaylistWhereItemCountInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Int']>;
};

/** The where clause for a playlist playlist name field */
export type PlaylistWherePlaylistNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Exclude rows where the value is in the list */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** The where clause for a playlist uid field */
export type PlaylistWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** A popular onboarding topic ranked by video reference count */
export type PopularTopic = {
  __typename?: 'PopularTopic';
  /** The content ID of the center tag */
  contentId: Scalars['Int'];
  /** The display title of the center tag */
  title: Scalars['String'];
  /** The title group ID of the center tag */
  titleGroupId: Scalars['String'];
  /** The number of unique published videos referencing this tag */
  videoRefCount: Scalars['Int'];
};

/** Response wrapper for the popularTopics query */
export type PopularTopicsResponse = {
  __typename?: 'PopularTopicsResponse';
  /** Length of topics in this response (equals topics.length; not a pre-limit total) */
  count: Scalars['Int'];
  /** The list of popular topics */
  topics: Array<PopularTopic>;
};

/** Live engagement data for a community post (used by AI service for ranking) */
export type PostEngagement = {
  __typename?: 'PostEngagement';
  /** Username of the post author */
  authorUsername: Scalars['String'];
  /** When the post was created (ISO 8601) */
  createdAt: Scalars['String'];
  /** The post UUID */
  postId: Scalars['ID'];
  /** Total count of all reactions (REACTED + LIKED) */
  reactionsCount: Scalars['Int'];
  /** Total count of direct replies/comments */
  repliesCount: Scalars['Int'];
};

/** Aggregated reaction data for a single emoji */
export type PostReactionSummary = {
  __typename?: 'PostReactionSummary';
  /** Number of users who reacted with this emoji */
  count: Scalars['Int'];
  /** Whether the current user has reacted with this emoji */
  reacted: Scalars['Boolean'];
  /** The reaction emoji or custom key (e.g., '❤️' or 'gaia_earth') */
  reaction: Scalars['String'];
};

/** Product Change Log Entity Name */
export enum ProductChangeLogEntityName {
  /** Bonus */
  Bonus = 'Bonus',
  /** Bonus Campaign */
  BonusCampaign = 'BonusCampaign',
  /** BillingDiscount */
  Discount = 'Discount',
  /** BillingProviderProduct */
  Plan = 'Plan',
  /** BillingPlanGrid */
  PlanGrid = 'PlanGrid',
  /** BillingProviderProductPricing */
  Price = 'Price',
  /** BillingProduct */
  Product = 'Product',
  /** BillingProvider */
  Provider = 'Provider',
  /** BillingProviderProductText */
  Text = 'Text'
}

/** Product Change Log Type */
export enum ProductChangeLogType {
  /** Create */
  Create = 'Create',
  /** Delete */
  Delete = 'Delete',
  /** Update */
  Update = 'Update'
}

/** Product Platform */
export enum ProductPlatform {
  /** Gaia */
  Gaia = 'Gaia',
  /** Yoga International */
  YogaInternational = 'YogaInternational'
}

/** Profile banner image with URL */
export type ProfileBannerImage = {
  __typename?: 'ProfileBannerImage';
  /** Full-size banner URL */
  url: Scalars['String'];
};

/** Profile picture with predefined size variants (signed imgix URLs) */
export type ProfilePicture = {
  __typename?: 'ProfilePicture';
  /** 190x266 profile card */
  card: Scalars['String'];
  /** 28x28 thumbnail */
  small: Scalars['String'];
  /** Full-size signed imgix URL */
  url: Scalars['String'];
};

/** Response from requesting a profile picture upload */
export type ProfilePictureUploadRequest = {
  __typename?: 'ProfilePictureUploadRequest';
  /** When the presigned URL expires */
  expiresAt: Scalars['DateTime'];
  /** UUID for the pending image */
  imageUuid: Scalars['ID'];
  /** Presigned S3 PUT URL */
  uploadUrl: Scalars['String'];
};

/** Response from confirming a profile picture upload */
export type ProfilePictureUploadResponse = {
  __typename?: 'ProfilePictureUploadResponse';
  /** The profile picture URLs */
  profilePicture?: Maybe<ProfilePicture>;
  /** Whether the upload was confirmed successfully */
  success: Scalars['Boolean'];
};

/** Profile picture URLs */
export type ProfilePictureUrls = {
  __typename?: 'ProfilePictureUrls';
  /** Profile picture URL in HDTV 190x266 size */
  hdtv_190x266?: Maybe<Scalars['String']>;
  /** Profile picture URL in small 28x28 size */
  small_28x28?: Maybe<Scalars['String']>;
};

/** Profile-level visibility */
export enum ProfileVisibility {
  Private = 'private',
  Public = 'public'
}

/** Provider Product Language */
export enum ProviderProductLanguage {
  /** German */
  De = 'de',
  /** English */
  En = 'en',
  /** Spanish */
  Es = 'es',
  /** French */
  Fr = 'fr'
}

/** Provider Product Primary Stakeholder */
export enum ProviderProductPrimaryStakeholder {
  /** Marketing stakeholder */
  Marketing = 'marketing',
  /** Product stakeholder */
  Product = 'product'
}

/** Provider Product Term Type */
export enum ProviderProductTermType {
  /** day */
  Day = 'day',
  /** month */
  Month = 'month',
  /** week */
  Week = 'week',
  /** year */
  Year = 'year'
}

/** Provider Product Type */
export enum ProviderProductType {
  /** Course */
  Course = 'Course',
  /** Gift */
  Gift = 'Gift',
  /** Recurring subscription product */
  Recurring = 'Recurring'
}

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']>;
  aiSearch: SearchResult;
  /** @deprecated Use search instead. */
  aiSearchContent: SearchContentResponse;
  aiSearchPlaylists: SearchPlaylistsResponse;
  aiSearchProfiles: Array<SearchProfileResult>;
  /** Generate a coherent, ordered playlist from a free-text prompt */
  alchemizePlaylist: AlchemizePlaylistResult;
  /** Get a list of Ambassador lead */
  ambassadorLeadsCount: AmbassadorLeadsCountResponse;
  /** Get a list of Ambassador lead */
  ambassadorLeadsList?: Maybe<AmbassadorLeadsListResponse>;
  apiKeyList?: Maybe<ApiKeyListResponse>;
  /** Get a list of assetProviders */
  assetProvidersList?: Maybe<AssetProvidersListResponse>;
  /** Get a list of assets */
  assetsList?: Maybe<AssetsListResponse>;
  /** Get a list of userInfo reference */
  authRoleList?: Maybe<AuthRoleListResponse>;
  /**
   * Check scope tokens for OAuth/API use: each entry is split on spaces like the OAuth2 `scope` parameter.
   * Allowed values match OIDC built-ins (`openid`, `profile`, `email`, `offline_access`) or `auth_scope.name` rows.
   * Public read (no auth); does not grant access by itself.
   */
  authScopeCheck: AuthScopeCheckResponse;
  authScopeList?: Maybe<AuthScopeListResponse>;
  /**
   * Same behavior as GET /v1/authentication/check: returns the authenticated principal and applies optional
   * `requiredRoles` / `requiredScopes` / `requiredScopesAnd` / `enableScopeChecks` predicates via
   * `reqAuthorizationRoleIsAllowed` (see `docs/scopes-roles-and-authentication.md`).
   *
   * The field uses `@auth(enableScopeChecks: false)` so registry scope policy is driven only by resolver arguments,
   * matching the REST endpoint (not the directive’s default-deny layer). Implemented by `resolveAuthenticationCheck` in `server/authentication/index.ts`.
   */
  authenticationCheck: AuthenticationCheckPayload;
  /** Get a list of billing accounts */
  billingAccountList: BillingAccountListResponse;
  billingDiscountEligible?: Maybe<BillingDiscountEligibilityResult>;
  /** List billing discounts (admin). Filter by code, enabled, sku, active. */
  billingDiscountList?: Maybe<BillingDiscountListResponse>;
  /**
   * Get a count of billing events. Useful for understanding payment activity volume
   * without loading all event data. Use where filters to count specific event types,
   * payment providers, or time periods.
   */
  billingEventCount: BillingEventCountResponse;
  /**
   * Get a list of billing events. Use this to analyze a user's payment history and
   * determine their current payment state.
   *
   * Best Practices for Payment State Analysis:
   * 1. Filter by uid to get events for a specific user
   * 2. Filter by source if user has multiple payment providers
   * 3. Order by txnDate DESC to get most recent events first
   * 4. Filter by txnType to focus on specific event types (e.g., "payment", "renewal")
   * 5. Use limit to focus on recent events (most recent 10-20 events often sufficient)
   *
   * Example queries:
   * - Recent successful payments: where: { uid: { eq: "123" } }, order: [["txnDate", "DESC"]]
   * - Payment failures: where: { uid: { eq: "123" }, txnType: { eq: "payment" } }
   * - Specific provider: where: { uid: { eq: "123" }, source: { eq: "google" } }
   */
  billingEventList?: Maybe<BillingEventListResponse>;
  /** Get a list of billingInvoice */
  billingInvoiceList?: Maybe<BillingInvoiceListResponse>;
  /** Get a list of BillingOneTimePurchases */
  billingOneTimePurchaseList?: Maybe<BillingOneTimePurchaseListResponse>;
  /** Get a list of billingPayments */
  billingPaymentList?: Maybe<BillingPaymentListResponse>;
  /** Get a list of billingProviderProductPricing */
  billingPaymentMethodList?: Maybe<BillingPaymentMethodListResponse>;
  /** Get a list of billingPlanGrids */
  billingPlanGridList?: Maybe<BillingPlanGridListResponse>;
  /** Get a list of billingProducts */
  billingProductChangeLogList?: Maybe<BillingProductChangeLogListResponse>;
  /** Get a list of unique users who made billing product changes */
  billingProductChangeLogUsers?: Maybe<BillingProductChangeLogUserListResponse>;
  /** Get a list of billingProducts */
  billingProductList?: Maybe<BillingProductListResponse>;
  /** Get a list of billingProviderCurrency */
  billingProviderCurrencyList?: Maybe<BillingProviderCurrencyListResponse>;
  /** Get a list of billingProviders */
  billingProviderList?: Maybe<BillingProviderListResponse>;
  /** Check eligibility for a plan on a given page (checkout or planChange). Optional customer JWT for user-specific rules. */
  billingProviderProductEligibility?: Maybe<BillingProviderProductEligibilityResult>;
  /** List eligibility rules (admin). Filter by plan, scope, rule type, enabled. */
  billingProviderProductEligibilityList?: Maybe<BillingProviderProductEligibilityListResponse>;
  /** Get a list of billingProviderProducts */
  billingProviderProductList?: Maybe<BillingProviderProductListResponse>;
  /** Get a list of billingProviderProductPricing */
  billingProviderProductPricingList?: Maybe<BillingProviderProductPricingListResponse>;
  /** Get a list of billingProviderProductText reference */
  billingProviderProductTextList?: Maybe<BillingProviderProductTextListResponse>;
  billingProviderProductTextTranslate?: Maybe<BillingProviderProductTextTranslateResponse>;
  /** Verify billingProviderProductTexts */
  billingProviderProductTextVerify?: Maybe<Array<Maybe<BillingProviderProductTextVerifyError>>>;
  /** Get a list of billingRefunds */
  billingRefundList?: Maybe<BillingRefundListResponse>;
  /** Get a list of user accounts */
  billingSubscriptionList?: Maybe<BillingSubscriptionListResponse>;
  /** Get a list of billingSubscriptionOrders */
  billingSubscriptionOrderList?: Maybe<BillingSubscriptionOrderListResponse>;
  /** Get a list of user accounts */
  billingSubscriptionOrderPlanList?: Maybe<BillingSubscriptionOrderPlanListResponse>;
  /** Get a list of billingSubscriptionPlans */
  billingSubscriptionPlanList?: Maybe<BillingSubscriptionPlanListResponse>;
  /** Oracle AI: List channel prompt sets */
  channelPromptSetList: ChannelPromptSetListResponse;
  /** Get a list of Chat history */
  chatHistoryList?: Maybe<ChatHistoryListResponse>;
  /** Get a list of Chat session */
  chatSessionList?: Maybe<ChatSessionsListResponse>;
  /** CMS playlist videos: ids, names, and parent Brightcove video id (clip_source_video_id or clip_source) for admin import preview */
  clipBrightcovePlaylistVideos: Array<ClipBrightcovePlaylistVideoRow>;
  /** Returns a randomized list of published vertical clips with their parent video context */
  clipList?: Maybe<ContentListResponse>;
  /** Get a list of comments */
  commentList?: Maybe<CommentsListResponse>;
  /** Get a single community event by ID */
  communityEvent?: Maybe<CommunityEvent>;
  /** Get calendar invite (ICS format) */
  communityEventCalendarInvite: Scalars['String'];
  /** List events in a feed */
  communityEventsByFeed: CommunityEventConnection;
  /** Get a single community feed by ID */
  communityFeed?: Maybe<CommunityFeed>;
  /** Get a list of community feeds with cursor-based pagination */
  communityFeedList: CommunityFeedConnection;
  /** Get all members in a community feed */
  communityFeedMembers: UserProfileConnection;
  /** Get community leaderboard */
  communityLeaderboard: Array<CommunityLeaderboardEntry>;
  /** Get moderation queue (admin only) */
  communityModerationQueue: CommunityModerationReportConnection;
  /** Get a single community post by ID */
  communityPost?: Maybe<CommunityPost>;
  /** Bulk post engagement data for AI service ranking — returns reactions, replies, author, and created date for given post IDs */
  communityPostEngagement: Array<PostEngagement>;
  /** Get a list of community posts with cursor-based pagination */
  communityPostList: CommunityPostConnection;
  /** Bulk community posts for AI service ingestion — returns all posts across all feeds without membership filtering */
  communityPostsForIngest: CommunityPostConnection;
  /** Get the list of users who reacted with a specific emoji */
  communityReactionParticipants: UserProfileConnection;
  /** Bulk community replies for AI service ingestion — returns comments/replies across all feeds without membership filtering */
  communityRepliesForIngest: CommunityPostConnection;
  /** Search community content */
  communitySearch: CommunityPostConnection;
  /** Fetch AI-generated summary and transcript metadata by media asset or content and language. */
  contentAIMetadata?: Maybe<MediaAssetAiMetadata>;
  /** Get a list of Content analytic */
  contentAnalyticsList?: Maybe<ContentAnalyticsListResponse>;
  /** Get a list of content asset reference types */
  contentAssetReferenceTypesList?: Maybe<ContentAssetReferenceTypesListResponse>;
  /** Get a list of content asset reference types */
  contentAssetReferencesList?: Maybe<ContentAssetReferencesListResponse>;
  /** Get a list of content reference */
  contentFilterList?: Maybe<ContentFilterListResponse>;
  /** Get a list of content reference */
  contentFilterSetList?: Maybe<ContentFilterSetListResponse>;
  /** Get a list of content reference */
  contentList?: Maybe<ContentListResponse>;
  /** Get a list of content reference */
  contentListCriteriaList?: Maybe<ContentListCriteriaListResponse>;
  /** Get a list of content reference */
  contentPolicyList?: Maybe<ContentPolicyListResponse>;
  /** Get a list of content reference */
  contentProviderList?: Maybe<ContentProviderListResponse>;
  /** Get a list of content reference types */
  contentReferenceTypesList?: Maybe<ContentReferenceTypesListResponse>;
  /** Get a list of content references allowed */
  contentReferencesAllowedList?: Maybe<ContentReferencesAllowedResponse>;
  /** Get a list of content reference */
  contentReferencesList?: Maybe<ContentReferencesListResponse>;
  /** Get a list of media */
  contentSearchList?: Maybe<ContentSearchListResponse>;
  /** Get a list of userInfo reference */
  contentSetList?: Maybe<ContentSetListResponse>;
  /** Get all profiles in the current authenticated user's account */
  currentAccountProfiles: Array<AccountMemberProfile>;
  /** Get a custom emoji by ID or key */
  customEmoji?: Maybe<CustomEmoji>;
  /** List all custom emojis */
  customEmojiList: Array<CustomEmoji>;
  /** Get demographics data for an email address */
  demographics?: Maybe<DemographicsResponse>;
  /** Fetch a divination collection by id. */
  divinationCollection?: Maybe<DivinationCollection>;
  /** Fetch a divination collection by type and collection key. */
  divinationCollectionByKey?: Maybe<DivinationCollection>;
  /** Fetch all divination collections for a type. */
  divinationCollectionsByType: Array<DivinationCollection>;
  /** Fetch bundled divination feature state for tarot/oracle/horoscope. */
  divinationFeatureState: DivinationFeatureStates;
  /** Fetch a divination object by id. */
  divinationObject?: Maybe<DivinationObject>;
  /**
   * Oracle AI: Get divination seed questions by feature
   * @deprecated Use featureSeedQuestionList instead
   */
  divinationSeedQuestionList: SeedQuestionListResponse;
  /** Oracle AI: Distinct front-image keys for divination objects this user has pulled, ordered by most recent pull (newest first). Optional `type` selects tarot (default) or oracle card readings. */
  divinationUniquePulledCardImageKeyList: Array<Scalars['String']>;
  /**
   * List **`document_abstracts`** via Knex **`documentAbstractListByPaginated`** / **`documentAbstractCount`** (same idea as **`embeddingConfigsList`**).
   *
   * **`query`:** When non-empty after trim, the text is embedded with the **`document_abstracts`** embedding config (**`documentQueryEmbedding`**), then rows are ranked by pgvector **cosine distance** (`<=>`) on **`summary_embedding`** (**`documentAbstractListByCosineSimilarity`**). Optional **`where`** applies before ranking. **`order`** is ignored in this mode; use **`limit`** / **`offset`** on the ranked list.
   *
   * **`useMaster`:** Read from primary when true (e.g. post-mutation consistency).
   */
  documentAbstractList?: Maybe<DocumentAbstractListResponse>;
  /**
   * List **`document_embeddings`** rows with `where` / `order` / pagination. Use for operational queries and precise metadata filters.
   *
   * **`query`:** When non-empty after trim, the text is embedded via the same path as **`documentQueryEmbedding`** / **`Content.relatedDocumentEmbeddings`** (`documentQueryEmbedding` loader with the live **`document_embeddings`** embedding config), then rows are ranked by pgvector **cosine distance** (`<=>`) against each chunk's stored vector. Optional **`where`** scopes rows before ranking (same filters as the non-semantic list). **`order`** in this mode sorts the ranked window (default **`[['score','ASC']]`** — best match first; **`score`** matches **`DocumentEmbedding.queryRelevance`**). Use **`limit`** / **`offset`** on that ordered list.
   *
   * **List mode (no `query`):** When **`order`** is omitted, it defaults to **`[['documentsId','ASC'],['documentNumber','ASC']]`**.
   *
   * **MCP hint:** For content-scoped chunk retrieval, use **`Content.relatedDocumentEmbeddings`** with **`query`**. Use this list for admin-style global or metadata-filtered semantic search over **`document_embeddings`**.
   */
  documentEmbeddingsList?: Maybe<DocumentEmbeddingsListResponse>;
  /** Generate multiple queries from a single input query */
  documentMultiQuery?: Maybe<DocumentMultiQueryResponse>;
  /** Generate an embedding using a query; model is resolved from embedding_config for the given key */
  documentQueryEmbedding?: Maybe<DocumentQueryEmbeddingResponse>;
  /**
   * Semantic search over document chunk embeddings (e.g. transcript/VTT) with optional stitched playback metadata.
   * Requires an authenticated user with an elevated role (Editor, Editor Plus, Site Admin, Customer Service, or QA).
   */
  documentSemanticSearch: DocumentSemanticSearchResult;
  /** Using natural language run chains against documents embedding data to get answers */
  documentsCallChain?: Maybe<Array<Maybe<DocumentCallChainResponse>>>;
  /** List documents filter by where clauses */
  documentsList?: Maybe<DocumentsListResponse>;
  /**
   * Returns a personalized page layout for the authenticated user.
   * The layout is a list of typed blocks that the frontend renders
   * via a block registry.
   */
  dynamicLayout: DynamicLayoutResponse;
  /** Get a list of ecommerce sku mappings */
  ecommerceSkuMappingBonusEligibilitiesList: EcommerceSkuMappingBonusEligibilitiesListResponse;
  /** Get a list of ecommerce sku mappings */
  ecommerceSkuMappingsList: EcommerceSkuMappingsListResponse;
  /** List embedding configuration rows with optional filters (site admin only) */
  embeddingConfigsList?: Maybe<EmbeddingConfigsListResponse>;
  entityRecognition: EntityRecognitionResult;
  /** Oracle AI: Get seed questions by feature */
  featureSeedQuestionList: SeedQuestionListResponse;
  /** Get playlists followed by a user with cursor-based pagination */
  followedPlaylists: PlaylistFollowedConnection;
  /**
   * Get exchange rates for a list of currency pairs.
   * If a pair is missing from the database or has a stale rate, a fresh rate is
   * fetched from the CurrencyLayer service and the database is updated before returning.
   */
  forexRatesList?: Maybe<Array<Maybe<ForexRate>>>;
  /** Look up a Shopify gift card by code (balance and status) */
  giftCardByCode?: Maybe<GiftCardDetails>;
  /** Get a list of image content relationships */
  imageContentRelationshipsList?: Maybe<ImageContentRelationshipsListResponse>;
  /** Get a list of image content relationships */
  imageContentRelationshipsListByContent?: Maybe<ImageContentRelationshipsListResponse>;
  /** Get a list of images */
  imagesList?: Maybe<ImagesListResponse>;
  /** Oracle AI: List available interest topic options */
  interestTopicOptions: Array<InterestTopicOption>;
  /** Check if a profile is visible to a viewer. Used by video-analytics for Option B (public profile watch history). Viewer must be the authenticated user. */
  isProfileVisibleToViewer: Scalars['Boolean'];
  /** Get a list of media assets */
  mediaAssetsList?: Maybe<MediaAssetListResponse>;
  /** Get a list of media */
  mediaList?: Maybe<MediaListResponse>;
  /** Get all feeds the authenticated user is a member of with cursor-based pagination */
  myCommunityFeeds: CommunityFeedConnection;
  /** Oracle AI: Find cross-topic nudge post and feed suggestion */
  nudgeAndSuggestion: NudgeAndSuggestionResult;
  /** Get a list of OAuth clients (admin only) */
  oauthClientList?: Maybe<OAuthClientListResponse>;
  /** Oracle AI: Get current onboarding settings for the user */
  onboardingSettings: OnboardingSettings;
  /** Oracle AI: Get onboarding state for the current user */
  onboardingState: OnboardingState;
  /** Oracle AI: Get a chat session by ID */
  oracleChatSession?: Maybe<OracleChatSession>;
  /**
   * Oracle AI: Get chat sessions with optional filtering
   *
   *         Available ordering fields:
   *         - createdAt: Order by chat session creation time
   *         - updatedAt: Order by chat session last update time
   *         - name: Order by chat session name
   *         - id: Order by chat session ID
   *         - exportIndex: Order by export index
   *         - activityUpdatedAt: Order by most recent message activity (COALESCE of latest message created_at, fallback to session created_at)
   *
   *         Order format: [["fieldName", "ASC|DESC"], ...]
   *         Example: [["activityUpdatedAt", "DESC"], ["name", "ASC"]]
   */
  oracleChatSessionList: OracleChatSessionListResponse;
  /** Oracle AI: Semantic search over transcript chunks (VTT) by language */
  oracleChunkSemanticSearch: Array<OracleTranscriptChunk>;
  /** Oracle AI: Get server health status and version information */
  oracleHealth: OracleHealthResponse;
  /** Oracle AI: List scoped LLM config sets */
  oracleLlmConfigSetList: OracleLlmConfigSetListResponse;
  /** Oracle AI: Get individual messages, optionally filtered by chat session */
  oracleMessageList: OracleMessageListResponse;
  /** Oracle AI: Get a message pair by ID */
  oracleMessagePair?: Maybe<OracleMessagePair>;
  /** Oracle AI: Get message pairs with optional filtering */
  oracleMessagePairList: OracleMessagePairListResponse;
  /** Oracle AI: Get assistant variants for a message pair */
  oracleMessagePairVariants: Array<OracleMessagePairVariant>;
  /** Oracle AI: Get all personalities */
  oraclePersonalityList: OraclePersonalityListResponse;
  /** Oracle AI: Generate a personalized playlist (no session) */
  oraclePlaylistGenerate: OraclePlaylistGenerateResult;
  /** Oracle AI: Personalized search powered by the AI agent */
  oracleSearch: OracleSearchResult;
  /** Oracle AI: Public read access for a shared message pair snapshot */
  oracleSharedMessagePair?: Maybe<OracleSharedMessagePair>;
  /** Oracle AI: Curated visualizer catalog for site admins (launch paths under /api/visualizer). */
  oracleVisualizerCatalog: OracleVisualizerCatalog;
  /** Get a list of content reference */
  pathRedirectList?: Maybe<PathRedirectListResponse>;
  /** Bulk playlist engagement data for AI service ranking */
  playlistEngagement: Array<PlaylistEngagement>;
  /** Get a list of PlaylistItem */
  playlistItemList?: Maybe<PlaylistItemListResponse>;
  /** Get a list of Playlist */
  playlistList?: Maybe<PlaylistListResponse>;
  /** Search public/anonymous playlists by name or description using full-text search */
  playlistSearch: PlaylistSearchConnection;
  /** Find public/anonymous playlists containing given content IDs (for AI search) */
  playlistsByContentIds: Array<ContentPlaylistMapping>;
  /** Get a list of PM Lists */
  pmListList?: Maybe<PmListListResponse>;
  /** Get a list of PM Screens */
  pmScreenList?: Maybe<PmScreenListResponse>;
  /**
   * Get a personalized PM Screen considering the request which is used in application
   * UI to display the correct screen
   */
  pmScreenPersonalized: PmScreenPersonalizedResponse;
  /** Get a list of PM Sections */
  pmSectionList?: Maybe<PmSectionListResponse>;
  /** Get popular onboarding topics ranked by video reference count. Requires authentication; any authenticated user may call this query. */
  popularTopics?: Maybe<PopularTopicsResponse>;
  /** Oracle AI: Get current rate limit status for the user */
  rateLimitStatus: RateLimitInfo;
  /** Get a list of raw events */
  rawEventList?: Maybe<RawEventListResponse>;
  /** Get personalized content recommendations for a user, powered by Recombee. Designed for external channel integrations like Braze email campaigns. Target user is optional: pass at most one of uid or uuid; if both are omitted, the authenticated user is used. */
  recommendationList: RecommendationResponse;
  relatedBillingProviderProductList?: Maybe<BillingProviderProductListResponse>;
  /** Primary search query. Returns ranked results (videos, series). Future: playlists, profiles via resultTypes. */
  search: SearchContentResponse;
  /** Search message pairs by text content */
  searchMessagePairs: ConversationSearchResponse;
  /** Oracle AI: Get seed questions with optional filtering and pagination */
  seedQuestionList: SeedQuestionListResponse;
  /** Oracle AI: Multi-table semantic search for carousel candidates */
  semanticSearchCarousel: SemanticSearchCarouselResult;
  /** Get a list of testarossa subjects */
  testarossaSubjectsList?: Maybe<TestarossaSubjectsListResponse>;
  /** Get a list of testarossaUsers */
  testarossaUsersList?: Maybe<TestarossaUsersListResponse>;
  /** Get a count of transactions */
  transactionCount: TransactionCountResponse;
  /** Get a list of transactions */
  transactionList?: Maybe<TransactionListResponse>;
  /** Get a list of user accounts */
  userAccountList?: Maybe<UserAccountListResponse>;
  /** Get a list of userAuditLogs */
  userAuditLogList?: Maybe<UserAuditLogListResponse>;
  /** Get a list of billingPlanGrids for a user */
  userBillingPlanGridList?: Maybe<UserBillingPlanGridListResponse>;
  /** Get a list of ecommerce sku mappings */
  userEcommerceSkuMappingBonusEligibilitiesList: UserEcommerceSkuMappingBonusEligibilitiesListResponse;
  /**
   * Get a list of user entitlements. Returns entitlements based on the provided filters.
   * Access is restricted to users with elevated roles (SITE_ADMIN, CUSTOMER_SERVICE, CUSTOMER_SERVICE_MANAGER)
   * or users accessing their own entitlements (or entitlements for their account).
   */
  userEntitlementList?: Maybe<UserEntitlementListResponse>;
  /** Get a list of user history events */
  userHistoryEventsList?: Maybe<UserHistoryEventsListResponse>;
  /** Get a list of user history which is partitioned by uid consider the userHistory argument with a uid value for better performance */
  userHistoryList?: Maybe<UserHistoryListResponse>;
  /** User info for the user currently making this request */
  userInfoCurrent?: Maybe<UserInfoCurrentResponse>;
  /** Get a list of userInfo reference */
  userInfoList?: Maybe<UserInfoListResponse>;
  /**
   * Get public user profiles by UIDs or UUIDs.
   * Requires authentication. Returns limited public fields for any users.
   * Designed for features where user profiles need to be displayed publicly.
   *
   * Maximum 100 users per request for performance.
   * Uses DataLoader batching for efficient database queries.
   *
   * Example use cases:
   * - Fetch authors for a list of posts
   * - Fetch participants who reacted to content
   * - Display user profile pages
   */
  userInfoPublic: Array<UserInfoPublic>;
  /** Get a paginated list of users who have demographic metadata */
  userInfoWithMetadata: UserInfoWithMetadataResponse;
  /** Get a list of user media positions */
  userMediaPositionList?: Maybe<UserMediaPositionListResponse>;
  /** Get a list of user meta tags */
  userMetaTagList?: Maybe<UserMetaTagListResponse>;
  /** Get the user metadata entries for a user */
  userMetadataList: Array<UserMetadata>;
  /** Get a user profile by UID (requires auth, respects visibility) */
  userProfileByUid?: Maybe<UserProfile>;
  /** Get a user profile by UUID (authenticated) */
  userProfileByUuid?: Maybe<UserProfile>;
  /** Get paginated list of mutual follows (connections) for a user */
  userProfileConnections?: Maybe<UserFollowConnection>;
  /** Get mutual connections of a user by UUID */
  userProfileConnectionsByUuid?: Maybe<UserFollowConnection>;
  /** Get the current authenticated user's profile */
  userProfileCurrent?: Maybe<UserProfile>;
  /** Get paginated list of followers for a user */
  userProfileFollowers?: Maybe<UserFollowConnection>;
  /** Get followers of a user by UUID */
  userProfileFollowersByUuid?: Maybe<UserFollowConnection>;
  /** Get paginated list of users a user follows */
  userProfileFollowing?: Maybe<UserFollowConnection>;
  /** Get users followed by a user, by UUID */
  userProfileFollowingByUuid?: Maybe<UserFollowConnection>;
  /** Get a public user profile by UID (no authentication required, respects visibility settings) */
  userProfilePublic?: Maybe<UserProfile>;
  /** Get a public user profile by UUID (no authentication required, respects visibility) */
  userProfilePublicByUuid?: Maybe<UserProfile>;
  /** Bulk user profiles for AI service ingestion — returns all public profiles with cursor pagination */
  userProfilesForIngest: UserProfileIngestConnection;
  /** Get a list of userInfo reference */
  userRoleList?: Maybe<UserRoleListResponse>;
  /** Get a list of user state entries */
  userStateList?: Maybe<UserStateListResponse>;
  /** Get a list of user state entries filtered by parent content title group id */
  userStateListByParent?: Maybe<UserStateListResponse>;
  /** Get course progress for the current user */
  userStateProgressCourse?: Maybe<UserStateProgressCourseListResponse>;
  /** Get all available user tag options for topic selection */
  userTagOptionsList: Array<UserTagOption>;
  /** List media */
  videoAnalyticsMediaList?: Maybe<VideoAnalyticsMediaListResponse>;
  /** List video */
  videoAnalyticsVideoList?: Maybe<VideoAnalyticsVideoListResponse>;
  /** Generate an on-demand summary for watched video content. */
  videoAutoSummary?: Maybe<VideoAutoSummaryPayload>;
  /** Generate contextual prompt suggestions scoped to a specific concept-dense moment in a video. Unlike videoPromptSuggestions (which considers all captions up to a timestamp), this focuses only on the transcript within the moment's time window and uses the concept label to generate targeted, educational prompts. */
  videoConceptMomentPrompts?: Maybe<VideoConceptMomentPromptsPayload>;
  /** Summarize a specific concept-dense moment in a video transcript. */
  videoConceptMomentSummary?: Maybe<VideoConceptMomentSummaryPayload>;
  /** Identify conceptually dense moments in a video for toast nudge triggers. */
  videoConceptMoments?: Maybe<VideoConceptMomentsPayload>;
  /** Generate contextual prompt suggestions for watched video content. */
  videoPromptSuggestions?: Maybe<VideoPromptSuggestionsPayload>;
  viewerGeoLocation?: Maybe<ViewerGeoLocation>;
  /** Get a list of Content analytic */
  voteList?: Maybe<VotesListResponse>;
  /** Get a list of workers */
  workersList: WorkerListResponse;
};


export type QueryAiSearchArgs = {
  contentLimit?: InputMaybe<Scalars['Int']>;
  contentOffset?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<SearchFilters>;
  language?: InputMaybe<Scalars['String']>;
  playlistLimit?: InputMaybe<Scalars['Int']>;
  playlistOffset?: InputMaybe<Scalars['Int']>;
  profileLimit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['ID']>;
};


export type QueryAiSearchContentArgs = {
  contentLimit?: InputMaybe<Scalars['Int']>;
  contentOffset?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<SearchFilters>;
  language?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['ID']>;
  skipOverview?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<SearchSort>;
};


export type QueryAiSearchPlaylistsArgs = {
  language?: InputMaybe<Scalars['String']>;
  playlistLimit?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  topContentIds: Array<Scalars['Int']>;
  topContentScores: Array<Scalars['Float']>;
};


export type QueryAiSearchProfilesArgs = {
  language?: InputMaybe<Scalars['String']>;
  profileLimit?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QueryAlchemizePlaylistArgs = {
  input: AlchemizePlaylistInput;
};


export type QueryAmbassadorLeadsCountArgs = {
  where?: InputMaybe<AmbassadorLeadsWhereInput>;
};


export type QueryAmbassadorLeadsListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<AmbassadorLeadsWhereInput>;
};


export type QueryApiKeyListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<ApiKeyListWhereInput>;
};


export type QueryAssetProvidersListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<AssetProviderWhereInput>;
};


export type QueryAssetsListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryAuthRoleListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<AuthRoleListWhereInput>;
};


export type QueryAuthScopeCheckArgs = {
  scopes: Array<Scalars['String']>;
};


export type QueryAuthScopeListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<AuthScopeListWhereInput>;
};


export type QueryAuthenticationCheckArgs = {
  enableScopeChecks?: InputMaybe<Scalars['Boolean']>;
  requiredRoles?: InputMaybe<Array<Role>>;
  requiredScopes?: InputMaybe<Array<Scalars['String']>>;
  requiredScopesAnd?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryBillingAccountListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingAccountListWhereInput>;
};


export type QueryBillingDiscountEligibleArgs = {
  billingProviderProductId?: InputMaybe<Scalars['ID']>;
  discountCode: Scalars['String'];
  language: Scalars['String'];
  page: PlanEligibilityPage;
  sku?: InputMaybe<Scalars['String']>;
};


export type QueryBillingDiscountListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  searchString?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<BillingDiscountListWhereInput>;
};


export type QueryBillingEventCountArgs = {
  where?: InputMaybe<BillingEventListWhereInput>;
};


export type QueryBillingEventListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingEventListWhereInput>;
};


export type QueryBillingInvoiceListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingInvoiceListWhereInput>;
};


export type QueryBillingOneTimePurchaseListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingOneTimePurchaseListWhereInput>;
};


export type QueryBillingPaymentListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingPaymentListWhereInput>;
};


export type QueryBillingPaymentMethodListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingPaymentMethodListWhereInput>;
};


export type QueryBillingPlanGridListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingPlanGridListWhereInput>;
};


export type QueryBillingProductChangeLogListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingProductChangeLogListWhereInput>;
};


export type QueryBillingProductChangeLogUsersArgs = {
  where?: InputMaybe<BillingProductChangeLogListWhereInput>;
};


export type QueryBillingProductListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingProductListWhereInput>;
};


export type QueryBillingProviderCurrencyListArgs = {
  billingProvider?: InputMaybe<BillingProviderCurrencyListBillingProviderInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingProviderCurrencyListWhereInput>;
};


export type QueryBillingProviderListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingProviderListWhereInput>;
};


export type QueryBillingProviderProductEligibilityArgs = {
  billingProviderProductId?: InputMaybe<Scalars['ID']>;
  page: PlanEligibilityPage;
  sku?: InputMaybe<Scalars['String']>;
  userInfoUuid?: InputMaybe<Scalars['String']>;
};


export type QueryBillingProviderProductEligibilityListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingProviderProductEligibilityListWhereInput>;
};


export type QueryBillingProviderProductListArgs = {
  billingProduct?: InputMaybe<BillingProviderProductListBillingProductInput>;
  billingProvider?: InputMaybe<BillingProviderProductListBillingProviderInput>;
  currency?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<PlanGridDeviceType>;
  language?: InputMaybe<ProviderProductLanguage>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  page?: InputMaybe<Scalars['String']>;
  planGrid?: InputMaybe<Scalars['Boolean']>;
  searchString?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<BillingProviderProductListWhereInput>;
};


export type QueryBillingProviderProductPricingListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingProviderProductPricingListWhereInput>;
};


export type QueryBillingProviderProductTextListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingProviderProductTextListWhereInput>;
};


export type QueryBillingProviderProductTextTranslateArgs = {
  input?: InputMaybe<BillingProviderProductTextTranslateInput>;
  translationOptions?: InputMaybe<BillingProviderProductTextTranslationOptionsInput>;
};


export type QueryBillingProviderProductTextVerifyArgs = {
  where?: InputMaybe<BillingProviderProductTextVerifyWhereInput>;
};


export type QueryBillingRefundListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingRefundListWhereInput>;
};


export type QueryBillingSubscriptionListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingSubscriptionListWhereInput>;
};


export type QueryBillingSubscriptionOrderListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingSubscriptionOrderListWhereInput>;
};


export type QueryBillingSubscriptionOrderPlanListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingSubscriptionOrderPlanListWhereInput>;
};


export type QueryBillingSubscriptionPlanListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<BillingSubscriptionPlanListWhereInput>;
};


export type QueryChannelPromptSetListArgs = {
  channel?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  status?: InputMaybe<ChannelPromptStatus>;
  useMaster?: Scalars['Boolean'];
};


export type QueryChatHistoryListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<ChatHistoryWhereInput>;
};


export type QueryChatSessionListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<ChatSessionWhereInput>;
};


export type QueryClipBrightcovePlaylistVideosArgs = {
  playlistId: Scalars['String'];
};


export type QueryClipListArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryCommentListArgs = {
  content?: InputMaybe<Array<InputMaybe<CommentContentFilter>>>;
  depthType?: InputMaybe<CommentDepthType>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  userCurrent?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CommentWhereInput>;
};


export type QueryCommunityEventArgs = {
  id: Scalars['ID'];
};


export type QueryCommunityEventCalendarInviteArgs = {
  eventId: Scalars['ID'];
};


export type QueryCommunityEventsByFeedArgs = {
  after?: InputMaybe<Scalars['String']>;
  feedId: Scalars['ID'];
  filter?: InputMaybe<EventListFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryCommunityFeedArgs = {
  id: Scalars['ID'];
};


export type QueryCommunityFeedListArgs = {
  after?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryCommunityFeedMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  feedId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryCommunityLeaderboardArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  timeWindow?: InputMaybe<LeaderboardTimeWindow>;
};


export type QueryCommunityModerationQueueArgs = {
  after?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ModerationStatus>;
};


export type QueryCommunityPostArgs = {
  id: Scalars['ID'];
};


export type QueryCommunityPostEngagementArgs = {
  postIds: Array<Scalars['ID']>;
};


export type QueryCommunityPostListArgs = {
  after?: InputMaybe<Scalars['String']>;
  feedId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CommunityPostOrderBy>;
  parentId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  rootOnly?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryCommunityPostsForIngestArgs = {
  after?: InputMaybe<Scalars['String']>;
  feedId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryCommunityReactionParticipantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  postId: Scalars['ID'];
  reaction: Scalars['String'];
};


export type QueryCommunityRepliesForIngestArgs = {
  after?: InputMaybe<Scalars['String']>;
  feedId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  since?: InputMaybe<Scalars['DateTime']>;
};


export type QueryCommunitySearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QueryContentAiMetadataArgs = {
  input: ContentAiMetadataInput;
};


export type QueryContentAnalyticsListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<ContentAnalyticWhereInput>;
};


export type QueryContentAssetReferenceTypesListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<ContentAssetReferenceTypeWhereInput>;
};


export type QueryContentAssetReferencesListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<ContentAssetReferenceWhereInput>;
};


export type QueryContentFilterListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<ContentFilterWhereInput>;
};


export type QueryContentFilterSetListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<ContentFilterSetWhereInput>;
};


export type QueryContentListArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']>;
  contentProviders?: InputMaybe<Array<InputMaybe<ContentContentProviderFilterInput>>>;
  contentProvidersNot?: InputMaybe<Array<InputMaybe<ContentContentProviderFilterInput>>>;
  contentReferencesFrom?: InputMaybe<Array<InputMaybe<ContentContentReferencesFromFilterInput>>>;
  contentReferencesFromEvery?: InputMaybe<Array<InputMaybe<ContentContentReferencesFromFilterInput>>>;
  contentReferencesFromNot?: InputMaybe<Array<InputMaybe<ContentContentReferencesFromFilterInput>>>;
  contentReferencesTo?: InputMaybe<Array<InputMaybe<ContentContentReferencesToFilterInput>>>;
  contentSearchLegs?: InputMaybe<Array<ContentSearchLeg>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  publishedAtDateHasExpired?: InputMaybe<Scalars['Boolean']>;
  publishedState?: InputMaybe<ContentFilterPublishedState>;
  references?: InputMaybe<Array<InputMaybe<ContentContentReferencesToFilterInput>>>;
  referencesEvery?: InputMaybe<Array<InputMaybe<ContentContentReferencesToFilterInput>>>;
  referencesNot?: InputMaybe<Array<InputMaybe<ContentContentReferencesToFilterInput>>>;
  useMaster?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ContentWhereInput>;
};


export type QueryContentListCriteriaListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<ContentListCriteriaWhereInput>;
};


export type QueryContentPolicyListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<ContentPolicyWhereInput>;
};


export type QueryContentProviderListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  useMaster?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ContentProviderWhereInput>;
};


export type QueryContentReferenceTypesListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<ContentReferenceTypesWhereInput>;
};


export type QueryContentReferencesAllowedListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<ContentReferencesAllowedWhereInput>;
};


export type QueryContentReferencesListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  publishedState?: InputMaybe<ContentFilterPublishedState>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  where?: InputMaybe<ContentReferencesWhereInput>;
};


export type QueryContentSearchListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<ContentSearchWhereInput>;
};


export type QueryContentSetListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<ContentSetListWhereInput>;
};


export type QueryCustomEmojiArgs = {
  id?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
};


export type QueryCustomEmojiListArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryDemographicsArgs = {
  email: Scalars['String'];
};


export type QueryDivinationCollectionArgs = {
  id: Scalars['ID'];
};


export type QueryDivinationCollectionByKeyArgs = {
  collectionKey: Scalars['String'];
  type: Scalars['String'];
};


export type QueryDivinationCollectionsByTypeArgs = {
  type: Scalars['String'];
};


export type QueryDivinationFeatureStateArgs = {
  horoscopeChatSessionId?: InputMaybe<Scalars['ID']>;
  oracleChatSessionId?: InputMaybe<Scalars['ID']>;
  tarotChatSessionId?: InputMaybe<Scalars['ID']>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type QueryDivinationObjectArgs = {
  id: Scalars['ID'];
};


export type QueryDivinationSeedQuestionListArgs = {
  category?: InputMaybe<SeedQuestionCategory>;
  chatSessionId?: InputMaybe<Scalars['ID']>;
  distributedCategories?: InputMaybe<Array<SeedQuestionCategory>>;
  feature: SeedQuestionFeature;
  language?: Scalars['String'];
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<Array<Array<Scalars['String']>>>;
  queryOptions?: InputMaybe<QueryOptions>;
  randomized?: Scalars['Boolean'];
  useMaster?: Scalars['Boolean'];
  where?: InputMaybe<SeedQuestionListWhere>;
};


export type QueryDivinationUniquePulledCardImageKeyListArgs = {
  type?: InputMaybe<DivinationUniqueDrawReadingType>;
};


export type QueryDocumentAbstractListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  query?: InputMaybe<Scalars['String']>;
  useMaster?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<DocumentAbstractWhereInput>;
};


export type QueryDocumentEmbeddingsListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  query?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<DocumentEmbeddingWhereInput>;
};


export type QueryDocumentMultiQueryArgs = {
  query?: InputMaybe<Scalars['String']>;
  queryCount?: InputMaybe<Scalars['Int']>;
};


export type QueryDocumentQueryEmbeddingArgs = {
  embeddingConfigKey?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryDocumentSemanticSearchArgs = {
  input: DocumentSemanticSearchInput;
};


export type QueryDocumentsCallChainArgs = {
  steps?: InputMaybe<Array<InputMaybe<DocumentCallChainStepInput>>>;
};


export type QueryDocumentsListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<DocumentWhereInput>;
};


export type QueryDynamicLayoutArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  route: Scalars['String'];
};


export type QueryEcommerceSkuMappingBonusEligibilitiesListArgs = {
  effectiveDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  searchString?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereInput>;
};


export type QueryEcommerceSkuMappingsListArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  searchString?: InputMaybe<Scalars['String']>;
  userCurrent?: InputMaybe<Scalars['Boolean']>;
  userUuid?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  where?: InputMaybe<EcommerceSkuMappingsWhereInput>;
};


export type QueryEmbeddingConfigsListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<EmbeddingConfigsWhereInput>;
};


export type QueryEntityRecognitionArgs = {
  language?: InputMaybe<Scalars['String']>;
  query: Scalars['String'];
};


export type QueryFeatureSeedQuestionListArgs = {
  category?: InputMaybe<SeedQuestionCategory>;
  chatSessionId?: InputMaybe<Scalars['ID']>;
  distributedCategories?: InputMaybe<Array<SeedQuestionCategory>>;
  feature: SeedQuestionFeature;
  language?: Scalars['String'];
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<Array<Array<Scalars['String']>>>;
  queryOptions?: InputMaybe<QueryOptions>;
  randomized?: Scalars['Boolean'];
  useMaster?: Scalars['Boolean'];
  where?: InputMaybe<SeedQuestionListWhere>;
};


export type QueryFollowedPlaylistsArgs = {
  after?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  uid: Scalars['ID'];
};


export type QueryForexRatesListArgs = {
  pairs: Array<ForexRatePairInput>;
};


export type QueryGiftCardByCodeArgs = {
  giftCardCode: Scalars['String'];
};


export type QueryImageContentRelationshipsListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<ImageContentRelationshipWhereInput>;
};


export type QueryImageContentRelationshipsListByContentArgs = {
  content?: InputMaybe<Array<InputMaybe<ImageContentRelationshipByContentInput>>>;
};


export type QueryImagesListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<ImageWhereInput>;
};


export type QueryIsProfileVisibleToViewerArgs = {
  profileUid: Scalars['ID'];
  viewerUid: Scalars['ID'];
};


export type QueryMediaAssetsListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<MediaAssetWhereInput>;
};


export type QueryMediaListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<MediaWhereInput>;
};


export type QueryMyCommunityFeedsArgs = {
  after?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryNudgeAndSuggestionArgs = {
  input: NudgeAndSuggestionInput;
};


export type QueryOauthClientListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<OAuthClientListWhereInput>;
};


export type QueryOnboardingStateArgs = {
  chatChannel?: InputMaybe<Scalars['String']>;
  chatSessionId?: InputMaybe<Scalars['ID']>;
};


export type QueryOracleChatSessionArgs = {
  id: Scalars['ID'];
  queryOptions?: InputMaybe<QueryOptions>;
  useMaster?: Scalars['Boolean'];
};


export type QueryOracleChatSessionListArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<Array<Array<Scalars['String']>>>;
  personalityId?: InputMaybe<Scalars['ID']>;
  queryOptions?: InputMaybe<QueryOptions>;
  useMaster?: Scalars['Boolean'];
  where?: InputMaybe<OracleChatSessionListWhere>;
};


export type QueryOracleChunkSemanticSearchArgs = {
  input: OracleChunkSemanticSearchInput;
};


export type QueryOracleLlmConfigSetListArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};


export type QueryOracleMessageListArgs = {
  chatSessionId?: InputMaybe<Scalars['ID']>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<Array<Array<Scalars['String']>>>;
  queryOptions?: InputMaybe<QueryOptions>;
  useMaster?: Scalars['Boolean'];
  where?: InputMaybe<OracleMessageListWhere>;
};


export type QueryOracleMessagePairArgs = {
  id: Scalars['ID'];
  queryOptions?: InputMaybe<QueryOptions>;
  useMaster?: Scalars['Boolean'];
};


export type QueryOracleMessagePairListArgs = {
  chatSessionId?: InputMaybe<Scalars['ID']>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<Array<Array<Scalars['String']>>>;
  queryOptions?: InputMaybe<QueryOptions>;
  useMaster?: Scalars['Boolean'];
  where?: InputMaybe<OracleMessagePairListWhere>;
};


export type QueryOracleMessagePairVariantsArgs = {
  messagePairId: Scalars['ID'];
};


export type QueryOraclePersonalityListArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<Array<Array<Scalars['String']>>>;
  queryOptions?: InputMaybe<QueryOptions>;
  useMaster?: Scalars['Boolean'];
  where?: InputMaybe<OraclePersonalityListWhere>;
};


export type QueryOraclePlaylistGenerateArgs = {
  input: OraclePlaylistGenerateInput;
};


export type QueryOracleSearchArgs = {
  input: OracleSearchInput;
};


export type QueryOracleSharedMessagePairArgs = {
  shareId: Scalars['ID'];
};


export type QueryPathRedirectListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<PathRedirectWhereInput>;
};


export type QueryPlaylistEngagementArgs = {
  playlistIds: Array<Scalars['ID']>;
};


export type QueryPlaylistItemListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  playlists?: InputMaybe<Array<InputMaybe<PlaylistItemListPlaylistInput>>>;
  userCurrent?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PlaylistItemWhereInput>;
};


export type QueryPlaylistListArgs = {
  includePrivate?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  userCurrent?: InputMaybe<Scalars['Boolean']>;
  visibility?: InputMaybe<Array<InputMaybe<PlaylistVisibility>>>;
  where?: InputMaybe<PlaylistWhereInput>;
};


export type QueryPlaylistSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PlaylistSearchOrder>;
  query: Scalars['String'];
  uid?: InputMaybe<Scalars['ID']>;
  visibility?: InputMaybe<Array<InputMaybe<PlaylistVisibility>>>;
};


export type QueryPlaylistsByContentIdsArgs = {
  contentIds: Array<Scalars['Int']>;
  excludeCurrentUser?: InputMaybe<Scalars['Boolean']>;
  playlistLimit?: InputMaybe<Scalars['Int']>;
};


export type QueryPmListListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<PmListWhereInput>;
};


export type QueryPmScreenListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<PmScreenWhereInput>;
};


export type QueryPmScreenPersonalizedArgs = {
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>;
  contentNot?: InputMaybe<Array<InputMaybe<ContentNotFilterInput>>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  screenType: Scalars['String'];
};


export type QueryPmSectionListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<PmSectionWhereInput>;
};


export type QueryPopularTopicsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryRateLimitStatusArgs = {
  mode?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type QueryRawEventListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<RawEventListWhereInput>;
};


export type QueryRecommendationListArgs = {
  language?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  scenario: Scalars['String'];
  uid?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['ID']>;
};


export type QueryRelatedBillingProviderProductListArgs = {
  id?: InputMaybe<Scalars['ID']>;
  providerSegmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QuerySearchArgs = {
  contentLimit?: InputMaybe<Scalars['Int']>;
  contentOffset?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<SearchFilters>;
  language?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['ID']>;
  skipOverview?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<SearchSort>;
};


export type QuerySearchMessagePairsArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  query: Scalars['String'];
};


export type QuerySeedQuestionListArgs = {
  language?: Scalars['String'];
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<Array<Array<Scalars['String']>>>;
  personalized?: InputMaybe<SeedQuestionPersonalization>;
  queryOptions?: InputMaybe<QueryOptions>;
  randomized?: Scalars['Boolean'];
  useMaster?: Scalars['Boolean'];
  where?: InputMaybe<SeedQuestionListWhere>;
};


export type QuerySemanticSearchCarouselArgs = {
  input: SemanticSearchCarouselInput;
};


export type QueryTestarossaSubjectsListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<TestarossaSubjectsListWhereInput>;
};


export type QueryTestarossaUsersListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<TestarossaUsersListWhereInput>;
};


export type QueryTransactionCountArgs = {
  where?: InputMaybe<TransactionListWhereInput>;
};


export type QueryTransactionListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<TransactionListWhereInput>;
};


export type QueryUserAccountListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<UserAccountListWhereInput>;
};


export type QueryUserAuditLogListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<UserAuditLogListWhereInput>;
};


export type QueryUserBillingPlanGridListArgs = {
  where?: InputMaybe<UserBillingPlanGridListWhereInput>;
};


export type QueryUserEcommerceSkuMappingBonusEligibilitiesListArgs = {
  ecommerceSku?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  planSku?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  userCurrent?: InputMaybe<Scalars['Boolean']>;
  userUuid?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  where?: InputMaybe<UserEcommerceSkuMappingBonusEligibilitiesWhereIdInput>;
};


export type QueryUserEntitlementListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<UserEntitlementListWhereInput>;
};


export type QueryUserHistoryEventsListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<UserHistoryEventsListWhereInput>;
};


export type QueryUserHistoryListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  userCurrent?: InputMaybe<Scalars['Boolean']>;
  userHistory?: InputMaybe<Array<InputMaybe<UserHistoryFilterInput>>>;
  where?: InputMaybe<UserHistoryListWhereInput>;
};


export type QueryUserInfoListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<UserInfoListWhereInput>;
};


export type QueryUserInfoPublicArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  uuids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryUserInfoWithMetadataArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryUserMediaPositionListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  publishedMediaOnly?: InputMaybe<Scalars['Boolean']>;
  userCurrent?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<UserMediaPositionListWhereInput>;
};


export type QueryUserMetaTagListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  userCurrent?: InputMaybe<Scalars['Boolean']>;
  userMetaTags?: InputMaybe<Array<UserMetaTagFilterInput>>;
  where?: InputMaybe<UserMetaTagWhereInput>;
};


export type QueryUserMetadataListArgs = {
  uid: Scalars['Int'];
};


export type QueryUserProfileByUidArgs = {
  language?: InputMaybe<Scalars['String']>;
  uid: Scalars['ID'];
};


export type QueryUserProfileByUuidArgs = {
  language?: InputMaybe<Scalars['String']>;
  uuid: Scalars['ID'];
};


export type QueryUserProfileConnectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  uid: Scalars['ID'];
};


export type QueryUserProfileConnectionsByUuidArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  uuid: Scalars['ID'];
};


export type QueryUserProfileCurrentArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type QueryUserProfileFollowersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  uid: Scalars['ID'];
};


export type QueryUserProfileFollowersByUuidArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  uuid: Scalars['ID'];
};


export type QueryUserProfileFollowingArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  uid: Scalars['ID'];
};


export type QueryUserProfileFollowingByUuidArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  uuid: Scalars['ID'];
};


export type QueryUserProfilePublicArgs = {
  language?: InputMaybe<Scalars['String']>;
  uid: Scalars['ID'];
};


export type QueryUserProfilePublicByUuidArgs = {
  language?: InputMaybe<Scalars['String']>;
  uuid: Scalars['ID'];
};


export type QueryUserProfilesForIngestArgs = {
  after?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryUserRoleListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<UserRoleListWhereInput>;
};


export type QueryUserStateListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  userCurrent?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<UserStateWhereInput>;
};


export type QueryUserStateListByParentArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  parentContentTitleGroupId: Scalars['String'];
  userCurrent?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<UserStateWhereInput>;
};


export type QueryUserStateProgressCourseArgs = {
  courseTitleGroupIds?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  state?: InputMaybe<UserStateCourse>;
};


export type QueryUserTagOptionsListArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type QueryVideoAnalyticsMediaListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<VideoAnalyticsMediaListWhereInput>;
};


export type QueryVideoAnalyticsVideoListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<VideoAnalyticsVideoListWhereInput>;
};


export type QueryVideoAutoSummaryArgs = {
  input: VideoAutoSummaryInput;
};


export type QueryVideoConceptMomentPromptsArgs = {
  input: VideoConceptMomentPromptsInput;
};


export type QueryVideoConceptMomentSummaryArgs = {
  input: VideoConceptMomentSummaryInput;
};


export type QueryVideoConceptMomentsArgs = {
  input: VideoConceptMomentsInput;
};


export type QueryVideoPromptSuggestionsArgs = {
  input: VideoPromptSuggestionsInput;
};


export type QueryVoteListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  userCurrent?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<VoteWhereInput>;
};


export type QueryWorkersListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  where?: InputMaybe<WorkerWhereInput>;
};

export type QueryOptions = {
  useMaster?: Scalars['Boolean'];
};

export type RateLimitInfo = {
  __typename?: 'RateLimitInfo';
  /** Type of rate limit: 'daily' or 'lifetime' */
  limitType?: Maybe<Scalars['String']>;
  /** The mode this rate limit applies to ('text', 'voice', or null for all) */
  mode?: Maybe<Scalars['String']>;
  /** Whether the user is currently rate limited */
  rateLimited: Scalars['Boolean'];
  /** Number of remaining interactions allowed today */
  remainingInteractions: Scalars['Int'];
  /** Total number of interactions today */
  totalInteractions: Scalars['Int'];
};

/** Raw events */
export type RawEvent = {
  __typename?: 'RawEvent';
  /** The number of attempts */
  attempts?: Maybe<Scalars['Int']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The error level */
  errorLevel?: Maybe<Scalars['Int']>;
  /** Whether failed event has been resolved manually */
  errorResolvedManually?: Maybe<Scalars['Boolean']>;
  /** Link to event */
  eventUuid?: Maybe<Scalars['ID']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** The new run time for the event */
  nextRunTime?: Maybe<Scalars['DateTime']>;
  /** The event payload from the provider */
  payload?: Maybe<Scalars['String']>;
  /** When true the raw event was processed */
  processed?: Maybe<Scalars['Boolean']>;
  /** The processing error */
  processingError?: Maybe<Scalars['String']>;
  /** The event source */
  source?: Maybe<Scalars['String']>;
  /** The transaction type */
  txnType?: Maybe<Scalars['String']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Raw event policy list response */
export type RawEventListResponse = {
  __typename?: 'RawEventListResponse';
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
  /** A list of raw events */
  rawEvents?: Maybe<Array<Maybe<RawEvent>>>;
};

/** Raw event id type where input type */
export type RawEventListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Raw event policy where conditions to filter rows */
export type RawEventListWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<RawEventListWhereIdInput>;
};

export type RawEventUpdateInput = {
  /** Number of attempts made to process this source */
  attempts?: InputMaybe<Scalars['Int']>;
  /** Timestamp when this source was created */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** Error level; e.g., 'info', 'warn', 'error' for this source */
  errorLevel?: InputMaybe<Scalars['Int']>;
  /** Whether an error was resolved manually for this source */
  errorResolvedManually?: InputMaybe<Scalars['Boolean']>;
  /** Unique identifier for the event associated with this source (if applicable) */
  eventUuid?: InputMaybe<Scalars['String']>;
  /** Unique identifier for the source (e.g., a database or file ID) */
  id: Scalars['Int'];
  /** Scheduled timestamp for the next run of this source */
  nextRunTime?: InputMaybe<Scalars['DateTime']>;
  /** Payload data of the event */
  payload?: InputMaybe<Scalars['String']>;
  /** Whether the source has been processed successfully */
  processed?: InputMaybe<Scalars['Boolean']>;
  /** Detailed error message associated with processing errors for this source */
  processingError?: InputMaybe<Scalars['String']>;
  /** Source of the raw event */
  source?: InputMaybe<Scalars['String']>;
  /** Type of transaction associated with this source */
  txnType?: InputMaybe<Scalars['String']>;
  /** Timestamp when this source was last updated */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type RecognizedEntity = {
  __typename?: 'RecognizedEntity';
  confidence: Scalars['Float'];
  contentId: Scalars['Int'];
  contentType: Scalars['String'];
  entityType: Scalars['String'];
  matchType: Scalars['String'];
  name: Scalars['String'];
  titleGroupId: Scalars['String'];
};

/** Response wrapper for the recommendationList query */
export type RecommendationResponse = {
  __typename?: 'RecommendationResponse';
  /** The number of items returned */
  count: Scalars['Int'];
  /** The list of recommended content */
  items: Array<Content>;
  /** The Recombee recommendation ID for attribution tracking */
  recommId?: Maybe<Scalars['String']>;
};

/** Oracle AI: Structured refinement suggestion from Sage */
export type RefinementSuggestion = {
  __typename?: 'RefinementSuggestion';
  /** Duration filter value (exact DB tag, e.g. '15 Minutes') */
  duration?: Maybe<Scalars['String']>;
  /** Content ID for creator_explore refinement type */
  entityId?: Maybe<Scalars['Int']>;
  /** Level filter value (exact DB tag, e.g. 'Level 2-3') */
  level?: Maybe<Scalars['String']>;
  /** Search query override (omits level/duration qualifiers) */
  query?: Maybe<Scalars['String']>;
  /** Classification of refinement behavior */
  refinementType: RefinementType;
  /** Series content ID for series_continue refinement type */
  seriesContentId?: Maybe<Scalars['Int']>;
  /** Human-readable chip label */
  text: Scalars['String'];
};

/** Oracle AI: Refinement chip type classification */
export enum RefinementType {
  AdjacentTerritory = 'ADJACENT_TERRITORY',
  CreatorExplore = 'CREATOR_EXPLORE',
  FormatShift = 'FORMAT_SHIFT',
  MoodShift = 'MOOD_SHIFT',
  SeriesContinue = 'SERIES_CONTINUE',
  TopicDeepen = 'TOPIC_DEEPEN'
}

export enum RegistrationStatus {
  Cancelled = 'CANCELLED',
  None = 'NONE',
  Registered = 'REGISTERED'
}

export enum Role {
  Ambassador = 'AMBASSADOR',
  AmbassadorAdmin = 'AMBASSADOR_ADMIN',
  ApiClient = 'API_CLIENT',
  BillingSupport = 'BILLING_SUPPORT',
  CustomerService = 'CUSTOMER_SERVICE',
  CustomerServiceManager = 'CUSTOMER_SERVICE_MANAGER',
  Editor = 'EDITOR',
  EditorPlus = 'EDITOR_PLUS',
  FullAccessReadOnly = 'FULL_ACCESS_READ_ONLY',
  SiteAdmin = 'SITE_ADMIN',
  User = 'USER',
  ViewContentOnly = 'VIEW_CONTENT_ONLY',
  ViewMediaOnly = 'VIEW_MEDIA_ONLY'
}

export enum S3Acl {
  /** Private */
  Private = 'PRIVATE',
  /** Public read */
  PublicRead = 'PUBLIC_READ'
}

export type S3UpsertNdjsonInput = {
  /** The object access control policy */
  acl?: InputMaybe<S3Acl>;
  /** The s3 object data */
  data: Scalars['JSON'];
  /** The primary identifier for this record */
  key: Scalars['ID'];
};

export type S3UpsertNdjsonResult = {
  __typename?: 'S3UpsertNdjsonResult';
  /** The number of objects upserted */
  count?: Maybe<Scalars['Int']>;
};

export type SearchAdjacentCenter = {
  __typename?: 'SearchAdjacentCenter';
  adjacencyType: Scalars['String'];
  centerId: Scalars['Int'];
  centerName: Scalars['String'];
  sharedContentCount: Scalars['Int'];
};

export type SearchContentReference = {
  __typename?: 'SearchContentReference';
  name: Scalars['String'];
  type: Scalars['String'];
};

export type SearchContentResponse = {
  __typename?: 'SearchContentResponse';
  adjacency: Array<SearchAdjacentCenter>;
  blacklistMessage?: Maybe<Scalars['String']>;
  chatSessionId?: Maybe<Scalars['ID']>;
  content: Array<SearchContentResult>;
  contentTotalCount: Scalars['Int'];
  entities: Array<SearchEntity>;
  intentSignal: SearchIntentSignal;
  topContentIds: Array<Scalars['Int']>;
  topContentScores: Array<Scalars['Float']>;
};

export type SearchContentResult = {
  __typename?: 'SearchContentResult';
  centers?: Maybe<Array<Scalars['String']>>;
  channel: Scalars['String'];
  content?: Maybe<Content>;
  contentId: Scalars['Int'];
  contentReferences?: Maybe<Array<SearchContentReference>>;
  contentType: Scalars['String'];
  displayType?: Maybe<Scalars['String']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  episodeNumber?: Maybe<Scalars['Int']>;
  episodesCount?: Maybe<Scalars['Int']>;
  heroImageUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instructor?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  /** Denormalized tile data — eliminates federation overhead for tile rendering. */
  path?: Maybe<Scalars['String']>;
  personalizationBoost: Scalars['Float'];
  publishedAtDate?: Maybe<Scalars['String']>;
  score: Scalars['Float'];
  seasonNumber?: Maybe<Scalars['Int']>;
  seasonsCount?: Maybe<Scalars['Int']>;
  seriesContentId?: Maybe<Scalars['Int']>;
  seriesTitle?: Maybe<Scalars['String']>;
  sortPopular?: Maybe<Scalars['Int']>;
  studio?: Maybe<Scalars['String']>;
  teaser?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  topics?: Maybe<Array<Scalars['String']>>;
};

export type SearchEntity = {
  __typename?: 'SearchEntity';
  confidence: Scalars['Float'];
  contentId: Scalars['Int'];
  contentType: Scalars['String'];
  entityType: Scalars['String'];
  matchType: Scalars['String'];
  name: Scalars['String'];
  titleGroupId: Scalars['String'];
};

export type SearchFilters = {
  duration?: InputMaybe<Scalars['String']>;
  entityId?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['String']>;
  refinementType?: InputMaybe<SearchRefinementType>;
  seriesContentId?: InputMaybe<Scalars['Int']>;
};

export type SearchIntentSignal = {
  __typename?: 'SearchIntentSignal';
  classification: Scalars['String'];
  reason: Scalars['String'];
  requiresLlm: Scalars['Boolean'];
};

/** Oracle AI: Center adjacency relationship from Brooklyn */
export type SearchOverviewAdjacencyInput = {
  /** Adjacency relationship type */
  adjacencyType?: Scalars['String'];
  /** Content center ID */
  centerId: Scalars['Int'];
  /** Content center display name */
  centerName: Scalars['String'];
  /** Number of shared content items */
  sharedContentCount?: Scalars['Int'];
};

/** Oracle AI: Pre-ranked content result from Brooklyn */
export type SearchOverviewContentInput = {
  /** Center names this content is tagged with */
  centers?: Array<Scalars['String']>;
  /** Search channel that produced this result */
  channel?: Scalars['String'];
  /** D6 content nid */
  contentId: Scalars['Int'];
  /** Content type */
  contentType?: Scalars['String'];
  /** Duration category (e.g. 15-30 min) */
  duration?: Scalars['String'];
  /** Brooklyn Content primary key */
  id: Scalars['ID'];
  /** Primary instructor/teacher name */
  instructor?: Scalars['String'];
  /** Difficulty level (e.g. Beginner, Intermediate) */
  level?: Scalars['String'];
  /** Personalization score boost applied */
  personalizationBoost?: Scalars['Float'];
  /** Brooklyn relevance score */
  score?: Scalars['Float'];
  /** Series title if part of a series */
  seriesTitle?: Scalars['String'];
  /** Content title */
  title?: Scalars['String'];
  /** Topic names this content is tagged with */
  topics?: Array<Scalars['String']>;
};

/** Oracle AI: Entity match from Brooklyn's entity recognition */
export type SearchOverviewEntityInput = {
  /** Match confidence 0-1 */
  confidence?: Scalars['Float'];
  /** Associated content ID if applicable */
  contentId?: InputMaybe<Scalars['Int']>;
  /** Entity type: person, series, topic, etc. */
  entityType: Scalars['String'];
  /** Match type: exact, fuzzy, partial */
  matchType?: Scalars['String'];
  /** Matched entity name */
  name: Scalars['String'];
};

/** Oracle AI: Intent classification from Brooklyn */
export type SearchOverviewIntentInput = {
  /** Intent type: navigate, navigate_topic, specific, vague, explore */
  classification: Scalars['String'];
  /** Human-readable reason for classification */
  reason?: Scalars['String'];
  /** Whether Brooklyn flagged this for LLM processing */
  requiresLlm?: Scalars['Boolean'];
};

/** Oracle AI: Pre-ranked playlist result from Brooklyn */
export type SearchOverviewPlaylistInput = {
  /** Total items in playlist */
  itemCount?: Scalars['Int'];
  /** Number of matched content items in playlist */
  matchedContentCount?: Scalars['Int'];
  /** Brooklyn playlist UUID */
  playlistId: Scalars['String'];
  /** Playlist display name */
  playlistName?: Scalars['String'];
  /** Relevance score */
  score?: Scalars['Float'];
};

/** Oracle AI: Profile result from Brooklyn */
export type SearchOverviewProfileInput = {
  /** User bio */
  bio?: InputMaybe<Scalars['String']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']>;
  /** User location */
  location?: InputMaybe<Scalars['String']>;
  /** Relevance score */
  score?: Scalars['Float'];
  /** User UID */
  uid: Scalars['String'];
};

/** Oracle AI: Input for Brooklyn-powered search overview streaming */
export type SearchOverviewStreamInput = {
  /** Center adjacency relationships */
  adjacency?: Array<SearchOverviewAdjacencyInput>;
  /** Chat session ID from context seeding. When provided without Brooklyn context fields, context is loaded from the stored session turn. */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /** Pre-ranked content results from Brooklyn */
  content?: Array<SearchOverviewContentInput>;
  /** Recognized entities from Brooklyn */
  entities?: Array<SearchOverviewEntityInput>;
  /** Brooklyn's intent classification. Optional when chatSessionId is provided (loaded from DB). */
  intent?: InputMaybe<SearchOverviewIntentInput>;
  /** Language preference */
  language?: Scalars['String'];
  /** Personality to use (Sage default) */
  personalityId?: Scalars['Int'];
  /** Pre-ranked playlist results from Brooklyn */
  playlists?: Array<SearchOverviewPlaylistInput>;
  /** Profile results from Brooklyn */
  profiles?: Array<SearchOverviewProfileInput>;
  /** The user's search query */
  query: Scalars['String'];
  /** Session ID for refinement continuity. 'new' or omit for fresh search. */
  sessionId?: InputMaybe<Scalars['ID']>;
  /** User's computed skill level per center from watch history */
  userLevelContext?: Array<SearchOverviewUserLevelInput>;
};

/** Oracle AI: User's computed skill level per center from watch history */
export type SearchOverviewUserLevelInput = {
  /** Highest level with sufficient completions */
  recommendedLevel: Scalars['String'];
  /** Level reference type: yoga-level, fitness-level */
  refType: Scalars['String'];
  /** One level above recommended */
  stretchLevel: Scalars['String'];
};

export type SearchPlaylistResult = {
  __typename?: 'SearchPlaylistResult';
  creatorDisplayName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  itemCount?: Maybe<Scalars['Int']>;
  matchedContentCount: Scalars['Int'];
  playlist?: Maybe<Playlist>;
  playlistId: Scalars['ID'];
  playlistName: Scalars['String'];
  previewContentTitles: Array<Scalars['String']>;
  previewThumbnailUrls: Array<Scalars['String']>;
  score: Scalars['Float'];
  textRelevance: Scalars['Float'];
  titleRelevance: Scalars['Float'];
};

export type SearchPlaylistsResponse = {
  __typename?: 'SearchPlaylistsResponse';
  playlistTotalCount: Scalars['Int'];
  playlists: Array<SearchPlaylistResult>;
};

export type SearchProfileResult = {
  __typename?: 'SearchProfileResult';
  bio?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  score: Scalars['Float'];
  uid: Scalars['ID'];
  userProfile?: Maybe<UserProfile>;
};

export enum SearchRefinementType {
  AdjacentTerritory = 'adjacent_territory',
  CreatorExplore = 'creator_explore',
  FormatShift = 'format_shift',
  MoodShift = 'mood_shift',
  SeriesContinue = 'series_continue',
  TopicDeepen = 'topic_deepen'
}

export type SearchResult = {
  __typename?: 'SearchResult';
  adjacency: Array<SearchAdjacentCenter>;
  chatSessionId?: Maybe<Scalars['ID']>;
  content: Array<SearchContentResult>;
  contentTotalCount: Scalars['Int'];
  entities: Array<SearchEntity>;
  intentSignal: SearchIntentSignal;
  playlistTotalCount: Scalars['Int'];
  playlists: Array<SearchPlaylistResult>;
  profileTotalCount: Scalars['Int'];
  profiles: Array<SearchProfileResult>;
};

export enum SearchSort {
  AZ = 'A_Z',
  DateAdded = 'DATE_ADDED',
  Popularity = 'POPULARITY',
  Relevance = 'RELEVANCE'
}

/** Oracle AI: A seed question for training or reference */
export type SeedQuestion = {
  __typename?: 'SeedQuestion';
  /** Timestamp of when the seed question was created */
  createdAt: Scalars['DateTime'];
  /** The primary key */
  id: Scalars['ID'];
  /** Language code for the question (e.g., en, es, fr) */
  language: Scalars['String'];
  /** The question text */
  question: Scalars['String'];
  /** Array of tags for categorizing the question */
  tags: Array<Scalars['String']>;
  /** Timestamp of when the seed question was last updated */
  updatedAt: Scalars['DateTime'];
};

export enum SeedQuestionCategory {
  General = 'GENERAL',
  LoveRelationships = 'LOVE_RELATIONSHIPS',
  NonPractice = 'NON_PRACTICE',
  PersonalDevelopment = 'PERSONAL_DEVELOPMENT',
  PracticeBreathwork = 'PRACTICE_BREATHWORK',
  PracticeMeditation = 'PRACTICE_MEDITATION',
  PracticeYoga = 'PRACTICE_YOGA',
  WorkMoney = 'WORK_MONEY'
}

/** Oracle AI: Input for creating a new seed question */
export type SeedQuestionCreateInput = {
  /** Language code for the question (e.g., en, es, fr) */
  language: Scalars['String'];
  /** The question text */
  question: Scalars['String'];
  /** Array of tags for categorizing the question */
  tags: Array<Scalars['String']>;
};

/** Oracle AI: Response envelope for seed question creation */
export type SeedQuestionCreateResponse = {
  __typename?: 'SeedQuestionCreateResponse';
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']>;
  /** The created seed question, if successful */
  seedQuestion?: Maybe<SeedQuestion>;
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean'];
};

/** Oracle AI: Response envelope for seed question deletion */
export type SeedQuestionDeleteResponse = {
  __typename?: 'SeedQuestionDeleteResponse';
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']>;
  /** The deleted seed question, if successful */
  seedQuestion?: Maybe<SeedQuestion>;
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean'];
};

export enum SeedQuestionFeature {
  Alchemize = 'ALCHEMIZE',
  OracleCards = 'ORACLE_CARDS',
  Tarot = 'TAROT'
}

/** Oracle AI: Seed question list response */
export type SeedQuestionListResponse = {
  __typename?: 'SeedQuestionListResponse';
  /** The total number of seed questions available. */
  count: Scalars['Int'];
  /** The number of seed questions returned in this response. */
  limit: Scalars['Int'];
  /** The starting point of the returned seed questions. */
  offset: Scalars['Int'];
  /** A list of seed questions. */
  seedQuestions: Array<SeedQuestion>;
  /** User meta tags for personalization (empty if personalization is not requested). */
  userMetaTags: Array<UserMetaTag>;
};

/** Oracle AI: Filtering options for seed question lists */
export type SeedQuestionListWhere = {
  /** Filter by creation timestamp */
  createdAt?: InputMaybe<OracleDateTimeFilterInput>;
  /** Filter by seed question ID */
  id?: InputMaybe<OracleIdFilterInput>;
  /** Filter by language code (deprecated: use top-level language parameter instead) */
  language?: InputMaybe<OracleStringFilterInput>;
  /** Filter by question text */
  question?: InputMaybe<OracleStringFilterInput>;
  /** Filter by tags using overlap operation */
  tags?: InputMaybe<OracleTagsFilterInput>;
  /** Filter by update timestamp */
  updatedAt?: InputMaybe<OracleDateTimeFilterInput>;
};

export enum SeedQuestionPersonalization {
  RainbowCategory_10 = 'RAINBOW_CATEGORY_10'
}

/** Oracle AI: Input for updating an existing seed question */
export type SeedQuestionUpdateInput = {
  /** The ID of the seed question to update */
  id: Scalars['ID'];
  /** Language code for the question (e.g., en, es, fr) */
  language?: InputMaybe<Scalars['String']>;
  /** The new question text */
  question?: InputMaybe<Scalars['String']>;
  /** The new tags array */
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** Oracle AI: Response envelope for seed question update */
export type SeedQuestionUpdateResponse = {
  __typename?: 'SeedQuestionUpdateResponse';
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']>;
  /** The updated seed question, if successful */
  seedQuestion?: Maybe<SeedQuestion>;
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean'];
};

/** Oracle AI: A semantic search candidate */
export type SemanticSearchCandidate = {
  __typename?: 'SemanticSearchCandidate';
  candidateId: Scalars['String'];
  itemType: Scalars['String'];
  metadata: Scalars['JSON'];
  score: Scalars['Float'];
  title?: Maybe<Scalars['String']>;
};

/** Oracle AI: Input for semantic carousel search */
export type SemanticSearchCarouselInput = {
  language?: Scalars['String'];
  limits: Scalars['JSON'];
  queries: Array<Scalars['String']>;
  types: Array<Scalars['String']>;
};

/** Oracle AI: Semantic carousel search result */
export type SemanticSearchCarouselResult = {
  __typename?: 'SemanticSearchCarouselResult';
  candidates: Array<SemanticSearchCandidate>;
};

/** Server status */
export type ServerStatus = {
  __typename?: 'ServerStatus';
  success: Scalars['Boolean'];
};

/** SKU rule: whether customer must have or must not have purchased */
export enum SkuCheckType {
  HasNotPurchased = 'HAS_NOT_PURCHASED',
  HasPurchased = 'HAS_PURCHASED'
}

/** SKU rule: AND or OR between ecommerce and plan SKU criteria */
export enum SkuOperator {
  And = 'AND',
  Or = 'OR'
}

export type StitchedPlayback = {
  __typename?: 'StitchedPlayback';
  expiresAt?: Maybe<Scalars['String']>;
  manifestUrl?: Maybe<Scalars['String']>;
  /** Full stitched span list in playback order — includes both CONTENT and TRANSITION spans when includeTransitions was true. Null when unavailableReason is not READY. */
  spans?: Maybe<Array<TranscriptSpan>>;
  stitchedWithPartialContent: Scalars['Boolean'];
  /** Signed URL for a synthesized WebVTT track derived from span transcript texts. Null when no text is available. */
  subtitlesUrl?: Maybe<Scalars['String']>;
  unavailableReason: StitchedPlaybackUnavailableReason;
};

export enum StitchedPlaybackUnavailableReason {
  /** Stitcher did not complete (e.g. no spans or not yet available). */
  ManifestStitcherPending = 'MANIFEST_STITCHER_PENDING',
  NoPlayableChunksAfterSkips = 'NO_PLAYABLE_CHUNKS_AFTER_SKIPS',
  /** Stitched HLS master is available; use manifestUrl for playback. */
  Ready = 'READY',
  StitchTimeout = 'STITCH_TIMEOUT',
  Unauthenticated = 'UNAUTHENTICATED',
  UpstreamFailure = 'UPSTREAM_FAILURE',
  UpstreamPlaylistFetchTimeout = 'UPSTREAM_PLAYLIST_FETCH_TIMEOUT'
}

/** Oracle AI: Root subscription operations */
export type Subscription = {
  __typename?: 'Subscription';
  /** Oracle AI: Send a message to the AI agent and stream the response */
  oracleAgentChat: OracleAgentChatSubscriptionPayload;
  /** Oracle AI: Subscribe to real-time health status updates */
  oracleHealth: OracleHealth;
  /** Oracle AI: Stream a personalized overview for Brooklyn's pre-ranked search results */
  oracleSearchOverviewStream: OracleSearchSubscriptionPayload;
  /** Oracle AI: Stream personalized search results */
  oracleSearchStream: OracleSearchSubscriptionPayload;
  /** Subscribe to server status updates */
  serverStatusAuthentication?: Maybe<ServerStatus>;
  /** Subscribe to server status updates */
  serverStatusBrooklyn?: Maybe<ServerStatus>;
  /** Subscribe to server status updates */
  serverStatusTestarossa?: Maybe<ServerStatus>;
  /** Subscribe to server status updates */
  serverStatusVideoAnalytics?: Maybe<ServerStatus>;
  /**
   * Subscribe to text-to-speech audio streaming
   * (this is a test at this time and not for production use)
   */
  textToSpeech?: Maybe<TextToSpeechAudioChunk>;
};


/** Oracle AI: Root subscription operations */
export type SubscriptionOracleAgentChatArgs = {
  input: OracleAgentChatInput;
};


/** Oracle AI: Root subscription operations */
export type SubscriptionOracleHealthArgs = {
  intervalMilliseconds?: Scalars['Int'];
};


/** Oracle AI: Root subscription operations */
export type SubscriptionOracleSearchOverviewStreamArgs = {
  input: SearchOverviewStreamInput;
};


/** Oracle AI: Root subscription operations */
export type SubscriptionOracleSearchStreamArgs = {
  input: OracleSearchStreamInput;
};


/** Oracle AI: Root subscription operations */
export type SubscriptionTextToSpeechArgs = {
  encoding?: InputMaybe<TextToSpeechAudioEncoding>;
  language?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

/** Billing Subscription Order Plan Action */
export enum SubscriptionOrderPlanAction {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Update = 'UPDATE'
}

/** Provider Product Type */
export enum SubscriptionOrderType {
  Cancel = 'CANCEL',
  /** PLAN CHANGE */
  Comp = 'COMP',
  Pause = 'PAUSE',
  Signup = 'SIGNUP'
}

/** Billing Subscription price override reason */
export enum SubscriptionPriceOverrideReason {
  /** Legacy FMTV Price */
  CurrencyOverridePricing = 'CurrencyOverridePricing',
  LatinAmericanPricing = 'LatinAmericanPricing',
  LegacyOfferPricing = 'LegacyOfferPricing',
  PromoCodePricing = 'PromoCodePricing'
}

export enum SubscriptionPricingReplacementType {
  /** Future plan */
  FuturePlan = 'futurePlan',
  /** Next plan */
  NextPlan = 'nextPlan',
  /** None */
  None = 'none',
  /** Current plan */
  Plan = 'plan'
}

/** Billing Subscription Status */
export enum SubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Lapsed = 'Lapsed',
  Paused = 'Paused',
  Pending = 'Pending',
  Suspended = 'Suspended'
}

/** Oracle AI: A suggested feed to explore */
export type SuggestedFeed = {
  __typename?: 'SuggestedFeed';
  category: Scalars['String'];
  feedName: Scalars['String'];
  feedSlug: Scalars['String'];
  memberCount: Scalars['Int'];
  reason: Scalars['String'];
};

/** Sync Billing Provider Products Response */
export type SyncBillingProviderProductsResponse = {
  __typename?: 'SyncBillingProviderProductsResponse';
  /** The created or updated billingProviderProductPrices */
  billingProviderProductPrices?: Maybe<Array<Maybe<BillingProviderProductPricing>>>;
  /** The updated billingProviderProducts */
  billingProviderProducts?: Maybe<Array<Maybe<BillingProviderProduct>>>;
  /** The deleted billingProviderProductPrices */
  deletedBillingProviderProductPrices?: Maybe<Array<Maybe<DeletedBillingProviderProductPricing>>>;
};

/** Tarot document payload for component rendering. */
export type TarotDocument = {
  __typename?: 'TarotDocument';
  acceptedQuestion: Scalars['String'];
  /** Resolve the back image URL for the referenced collection. */
  backImageUrl?: Maybe<Scalars['String']>;
  collectionId?: Maybe<Scalars['ID']>;
  collectionKey?: Maybe<Scalars['String']>;
  objects: Array<TarotDocumentObject>;
  pullId: Scalars['ID'];
  pulledAt?: Maybe<Scalars['String']>;
  readingId: Scalars['ID'];
  spread?: Maybe<Scalars['String']>;
};

/** Divination object reference in a tarot document. */
export type TarotDocumentObject = {
  __typename?: 'TarotDocumentObject';
  displayName?: Maybe<Scalars['String']>;
  /** Resolve the front image URL for this divination object. */
  frontImageUrl?: Maybe<Scalars['String']>;
  objectId: Scalars['ID'];
  objectKey?: Maybe<Scalars['String']>;
  position: Scalars['String'];
  reversed?: Maybe<Scalars['Boolean']>;
};

/** Session-scoped tarot state for UI decisions. */
export type TarotFeatureState = {
  __typename?: 'TarotFeatureState';
  activeReadingHasPull: Scalars['Boolean'];
  activeReadingId?: Maybe<Scalars['ID']>;
  badQuestionOriginal?: Maybe<Scalars['String']>;
  badQuestionRephrasedQuestions: Array<Scalars['String']>;
  canPullCard: Scalars['Boolean'];
  canStartReading: Scalars['Boolean'];
  chatSessionId?: Maybe<Scalars['ID']>;
  hasActiveReading: Scalars['Boolean'];
  hasSession: Scalars['Boolean'];
  isInBadQuestionState: Scalars['Boolean'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  lastUsedSessionId?: Maybe<Scalars['ID']>;
};

/** Tarot summary document payload for component rendering. */
export type TarotSummaryDocument = {
  __typename?: 'TarotSummaryDocument';
  analytics?: Maybe<Scalars['JSON']>;
  /** Resolve the back image URL for the referenced collection. */
  backImageUrl?: Maybe<Scalars['String']>;
  collectionId?: Maybe<Scalars['ID']>;
  collectionKey?: Maybe<Scalars['String']>;
  objects: Array<TarotDocumentObject>;
  pullCount?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
  readingId: Scalars['ID'];
  spread?: Maybe<Scalars['String']>;
};

/** TestarossaSubject row */
export type TestarossaSubject = {
  __typename?: 'TestarossaSubject';
  /** The campaign linked to this testarossa subject */
  campaignUuid?: Maybe<Scalars['ID']>;
  /** The campaign version */
  campaignVersion?: Maybe<Scalars['Int']>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The testarossa subject status */
  status?: Maybe<TestarossaSubjectStatus>;
  /** The user linked to this testarossa subject */
  testarossaUser?: Maybe<TestarossaUser>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user linked to this testarossa subject */
  userUuid?: Maybe<Scalars['ID']>;
  /** The primary key */
  uuid: Scalars['ID'];
  /** State related to a campaign testarossa subject */
  variables?: Maybe<Scalars['JSON']>;
  /** The variation linked to this testarossa subject */
  variationUuid?: Maybe<Scalars['ID']>;
};

/** A testarossa subject status */
export enum TestarossaSubjectStatus {
  Active = 'active',
  Excluded = 'excluded',
  Inactive = 'inactive'
}

/** Testarossa subjects list response */
export type TestarossaSubjectsListResponse = {
  __typename?: 'TestarossaSubjectsListResponse';
  /** A list of testarossaSubjects */
  testarossaSubjects?: Maybe<Array<Maybe<TestarossaSubject>>>;
};

/** The where conditions to filter rows */
export type TestarossaSubjectsListWhereInput = {
  uuid?: InputMaybe<TestarossaSubjectsListWhereUuidInput>;
};

/** The where clause for a testarossa subject uuid field */
export type TestarossaSubjectsListWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Testarossa user row */
export type TestarossaUser = {
  __typename?: 'TestarossaUser';
  /** The testarossaUser access level */
  accessLevel?: Maybe<TestarossaUserAccessLevel>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The user uid */
  drupalUserId?: Maybe<Scalars['ID']>;
  /** The subjects linked to this testarossaUser */
  testarossaSubjects?: Maybe<Array<Maybe<TestarossaSubject>>>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The primary key */
  uuid: Scalars['ID'];
};

/** A testarossaUser access level */
export enum TestarossaUserAccessLevel {
  Manage = 'manage',
  None = 'none',
  Read = 'read',
  Write = 'write'
}

/** Testarossa user list response */
export type TestarossaUsersListResponse = {
  __typename?: 'TestarossaUsersListResponse';
  /** A list of testarossaUsers */
  testarossaUsers?: Maybe<Array<Maybe<TestarossaUser>>>;
};

/** The where conditions to filter rows */
export type TestarossaUsersListWhereInput = {
  uuid?: InputMaybe<TestarossaUsersListWhereUuidInput>;
};

/** The where clause for a testarossaUser uuid field */
export type TestarossaUsersListWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Text-to-speech audio chunk for streaming */
export type TextToSpeechAudioChunk = {
  __typename?: 'TextToSpeechAudioChunk';
  /** Base64 encoded audio data */
  data: Scalars['String'];
  /** Audio encoding type */
  encoding: TextToSpeechAudioEncoding;
  /** Error message if an error occurred during processing */
  error?: Maybe<Scalars['String']>;
  /** Whether this is the final chunk */
  isFinal: Scalars['Boolean'];
  /** Subscription ID for filtering (internal use) */
  subscriptionId: Scalars['String'];
};

/**
 * Text-to-speech audio encoding types
 * Constants defined in: lib/services/speech/encodings.js
 */
export enum TextToSpeechAudioEncoding {
  /** Linear PCM 16-bit encoding (AUDIO_ENCODING_LINEAR16) */
  Linear16 = 'LINEAR16',
  /** OGG Opus encoding (AUDIO_ENCODING_OGG_OPUS) */
  OggOpus = 'OGG_OPUS'
}

/** Transactions */
export type Transaction = {
  __typename?: 'Transaction';
  /** The ccLast4 of the transaction */
  ccLast4?: Maybe<Scalars['String']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The entitledAt of the transaction */
  entitledAt?: Maybe<Scalars['DateTime']>;
  /** The entitlementContentSet of the transaction */
  entitlementContentSet?: Maybe<Scalars['Int']>;
  /** The entitlementEnd of the transaction */
  entitlementEnd?: Maybe<Scalars['DateTime']>;
  /** The errorCode of the transaction */
  errorCode?: Maybe<Scalars['String']>;
  /** The eventUuid of the transaction */
  eventUuid?: Maybe<Scalars['ID']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** The isDone of the transaction */
  isDone?: Maybe<Scalars['Boolean']>;
  /** The isEntitled flag of the transaction */
  isEntitled?: Maybe<Scalars['Boolean']>;
  /** The isValid flag of the transaction */
  isValid?: Maybe<Scalars['Boolean']>;
  /** The lastPolledAt of the transaction */
  lastPolledAt?: Maybe<Scalars['DateTime']>;
  /** The processedAt of the transaction */
  processedAt?: Maybe<Scalars['DateTime']>;
  /** The providerData response of the transaction */
  providerData?: Maybe<Scalars['JSON']>;
  /** The providerGatewayTxnId of the transaction */
  providerGatewayTxnId?: Maybe<Scalars['String']>;
  /** The providerInvoiceNumber of the transaction */
  providerInvoiceNumber?: Maybe<Scalars['String']>;
  /** The providerName of the transaction */
  providerName?: Maybe<Scalars['String']>;
  /** The providerParentTxnId of the transaction */
  providerParentTxnId?: Maybe<Scalars['String']>;
  /** The providerPaymentNumber of the transaction */
  providerPaymentNumber?: Maybe<Scalars['String']>;
  /** The providerProductCode of the transaction */
  providerProductCode?: Maybe<Scalars['String']>;
  /** The providerRecurringPaymentId of the transaction */
  providerRecurringPaymentId?: Maybe<Scalars['String']>;
  /** The providerTxnDt of the transaction */
  providerTxnDt?: Maybe<Scalars['DateTime']>;
  /** The providerTxnId of the transaction */
  providerTxnId?: Maybe<Scalars['String']>;
  /** The providerTxnType of the transaction */
  providerTxnType?: Maybe<Scalars['String']>;
  /** The updateStatus of the transaction */
  updateStatus?: Maybe<Scalars['String']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user UID of the transaction */
  userId?: Maybe<Scalars['ID']>;
  /** The userInfoUuid of the transaction */
  userInfoUuid?: Maybe<Scalars['ID']>;
  /** The validatedAt of the transaction */
  validatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionCountResponse = {
  __typename?: 'TransactionCountResponse';
  /** The count of rows */
  count: Scalars['Int'];
};

/** TransactionCreateInput */
export type TransactionCreateInput = {
  /** The ccLast4 of the transaction */
  ccLast4?: InputMaybe<Scalars['String']>;
  /** The entitledAt of the transaction */
  entitledAt?: InputMaybe<Scalars['DateTime']>;
  /** The entitlementContentSet of the transaction */
  entitlementContentSet?: InputMaybe<Scalars['Int']>;
  /** The entitlementEnd of the transaction */
  entitlementEnd?: InputMaybe<Scalars['DateTime']>;
  /** The errorCode of the transaction */
  errorCode?: InputMaybe<Scalars['String']>;
  /** The eventUuid of the transaction */
  eventUuid: Scalars['String'];
  /** The isDone of the transaction */
  isDone: Scalars['Boolean'];
  /** The isEntitled flag of the transaction */
  isEntitled?: InputMaybe<Scalars['Boolean']>;
  /** The isValid flag of the transaction */
  isValid?: InputMaybe<Scalars['Boolean']>;
  /** The lastPolledAt of the transaction */
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  /** The processedAt of the transaction */
  processedAt?: InputMaybe<Scalars['DateTime']>;
  /** The providerData response of the transaction */
  providerData?: InputMaybe<Scalars['JSON']>;
  /** The providerGatewayTxnId of the transaction */
  providerGatewayTxnId?: InputMaybe<Scalars['String']>;
  /** The providerInvoiceNumber of the transaction */
  providerInvoiceNumber?: InputMaybe<Scalars['String']>;
  /** The providerName of the transaction */
  providerName: Scalars['String'];
  /** The providerParentTxnId of the transaction */
  providerParentTxnId: Scalars['String'];
  /** The providerPaymentNumber of the transaction */
  providerPaymentNumber?: InputMaybe<Scalars['String']>;
  /** The providerProductCode of the transaction */
  providerProductCode: Scalars['String'];
  /** The providerRecurringPaymentId of the transaction */
  providerRecurringPaymentId?: InputMaybe<Scalars['String']>;
  /** The providerTxnDt of the transaction */
  providerTxnDt: Scalars['DateTime'];
  /** The providerTxnId of the transaction */
  providerTxnId: Scalars['String'];
  /** The providerTxnType of the transaction */
  providerTxnType: Scalars['String'];
  /** The updateStatus of the transaction */
  updateStatus?: InputMaybe<Scalars['Int']>;
  /** The user UID of the transaction */
  userId?: InputMaybe<Scalars['ID']>;
  /** The userInfoUuid of the transaction */
  userInfoUuid?: InputMaybe<Scalars['ID']>;
  /** The validatedAt of the transaction */
  validatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Transaction policy list response */
export type TransactionListResponse = {
  __typename?: 'TransactionListResponse';
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
  /** A list of user accounts */
  transactions?: Maybe<Array<Maybe<Transaction>>>;
};

/** Transaction list where Date input type */
export type TransactionListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']>;
};

/** Transaction ID or UUID type where input type */
export type TransactionListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Transaction where conditions to filter rows */
export type TransactionListWhereInput = {
  /** The eventUuid field where clause */
  eventUuid?: InputMaybe<TransactionListWhereIdInput>;
  /** The id field where clause */
  id?: InputMaybe<TransactionListWhereIdInput>;
  /** The providerName field where clause */
  providerName?: InputMaybe<TransactionListWhereStringInput>;
  /** The providerTxnDt field where clause */
  providerTxnDt?: InputMaybe<TransactionListWhereDateInput>;
  /** The providerTxnId field where clause */
  providerTxnId?: InputMaybe<TransactionListWhereStringInput>;
};

/** Transaction where input type string */
export type TransactionListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** TransactionUpdateInput */
export type TransactionUpdateInput = {
  /** The ccLast4 of the transaction */
  ccLast4?: InputMaybe<Scalars['String']>;
  /** The entitledAt of the transaction */
  entitledAt?: InputMaybe<Scalars['DateTime']>;
  /** The entitlementContentSet of the transaction */
  entitlementContentSet?: InputMaybe<Scalars['Int']>;
  /** The entitlementEnd of the transaction */
  entitlementEnd?: InputMaybe<Scalars['DateTime']>;
  /** The errorCode of the transaction */
  errorCode?: InputMaybe<Scalars['String']>;
  /** The eventUuid of the transaction */
  eventUuid?: InputMaybe<Scalars['String']>;
  /** The primary identifier for this record */
  id: Scalars['ID'];
  /** The isDone of the transaction */
  isDone?: InputMaybe<Scalars['Boolean']>;
  /** The isEntitled flag of the transaction */
  isEntitled?: InputMaybe<Scalars['Boolean']>;
  /** The isValid flag of the transaction */
  isValid?: InputMaybe<Scalars['Boolean']>;
  /** The lastPolledAt of the transaction */
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  /** The processedAt of the transaction */
  processedAt?: InputMaybe<Scalars['DateTime']>;
  /** The providerData response of the transaction */
  providerData?: InputMaybe<Scalars['JSON']>;
  /** The providerGatewayTxnId of the transaction */
  providerGatewayTxnId?: InputMaybe<Scalars['String']>;
  /** The providerInvoiceNumber of the transaction */
  providerInvoiceNumber?: InputMaybe<Scalars['String']>;
  /** The providerName of the transaction */
  providerName?: InputMaybe<Scalars['String']>;
  /** The providerParentTxnId of the transaction */
  providerParentTxnId?: InputMaybe<Scalars['String']>;
  /** The providerPaymentNumber of the transaction */
  providerPaymentNumber?: InputMaybe<Scalars['String']>;
  /** The providerProductCode of the transaction */
  providerProductCode?: InputMaybe<Scalars['String']>;
  /** The providerRecurringPaymentId of the transaction */
  providerRecurringPaymentId?: InputMaybe<Scalars['String']>;
  /** The providerTxnDt of the transaction */
  providerTxnDt?: InputMaybe<Scalars['DateTime']>;
  /** The providerTxnId of the transaction */
  providerTxnId?: InputMaybe<Scalars['String']>;
  /** The providerTxnType of the transaction */
  providerTxnType?: InputMaybe<Scalars['String']>;
  /** The updateStatus of the transaction */
  updateStatus?: InputMaybe<Scalars['Int']>;
  /** The user UID of the transaction */
  userId?: InputMaybe<Scalars['ID']>;
  /** The userInfoUuid of the transaction */
  userInfoUuid?: InputMaybe<Scalars['ID']>;
  /** The validatedAt of the transaction */
  validatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TranscriptSpan = {
  __typename?: 'TranscriptSpan';
  content?: Maybe<Content>;
  contentId: Scalars['String'];
  endTimecode: Scalars['String'];
  featureMedia?: Maybe<Media>;
  featureMediaId: Scalars['String'];
  /** Null / absent for CONTENT spans; TRANSITION for injected transition clips. */
  kind?: Maybe<TranscriptSpanKind>;
  /** Best-matching sentence within the chunk relative to the search prompt (keyword overlap). Null when no vocabulary overlap exists. */
  matchedText?: Maybe<Scalars['String']>;
  startTimecode: Scalars['String'];
  /** Full transcript chunk text for this time window (from document_embeddings.document_text). */
  transcriptText?: Maybe<Scalars['String']>;
};

export enum TranscriptSpanKind {
  /** A semantic search result clip from the transcript. */
  Content = 'CONTENT',
  /** An injected transition clip (intro, between-clip, or conclusion). Individually addressable by array position; transitionRole field is deferred to v2. */
  Transition = 'TRANSITION'
}

/** Translation formality options */
export enum TranslationFormality {
  /** Default formality */
  Default = 'default',
  /** Less formal */
  Less = 'less',
  /** More formal */
  More = 'more',
  /** Prefer less formal but not enforced strictly */
  PreferLess = 'prefer_less',
  /** Prefer more formal but not enforced strictly */
  PreferMore = 'prefer_more'
}

/** Translation model options */
export enum TranslationModel {
  /** Optimized for fastest response time */
  LatencyOptimized = 'latency_optimized',
  /** Prefer quality model but not enforced strictly */
  PreferQualityOptimized = 'prefer_quality_optimized',
  /** Optimized for quality */
  QualityOptimized = 'quality_optimized'
}

export enum User_Info_Status {
  /** The user is allowed accss */
  Active = 'active',
  /** The user is denied access */
  Blocked = 'blocked'
}

/** Update billing discount input */
export type UpdateBillingDiscountInput = {
  /** The billing discount allowed for plan change */
  allowedForPlanChange?: InputMaybe<Scalars['Boolean']>;
  /** The billing discount amount discount */
  amountDiscount?: InputMaybe<Scalars['JSON']>;
  /** The billing discount available count */
  availableCount?: InputMaybe<Scalars['Int']>;
  /** The billing discount billing cycles */
  billingCycles?: InputMaybe<Scalars['Int']>;
  /** The billing discount code */
  code?: InputMaybe<Scalars['String']>;
  /** The billing discount countries */
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing discount countries operator */
  countriesOperator?: InputMaybe<InNotInOperator>;
  /** The billing discount currencies */
  currencies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing discount currencies operator */
  currenciesOperator?: InputMaybe<InNotInOperator>;
  /** Human-readable description for admins */
  description?: InputMaybe<Scalars['String']>;
  /** The billing discount ecommerce SKUs */
  ecommerceSkus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing discount ecommerce SKUs operator */
  ecommerceSkusOperator?: InputMaybe<InNotInOperator>;
  /** The billing discount enabled */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** The billing discount end date */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** The billing discount id */
  id: Scalars['ID'];
  /** The billing discount languages */
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing discount languages operator */
  languagesOperator?: InputMaybe<InNotInOperator>;
  /** The billing discount minimum price */
  minimumPrice?: InputMaybe<Scalars['JSON']>;
  /** The billing discount minimum trial segment price */
  minimumTrialSegmentPrice?: InputMaybe<Scalars['JSON']>;
  /** The billing discount percentage discount */
  percentageDiscount?: InputMaybe<Scalars['Float']>;
  /** The billing discount plan categories */
  planCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing discount plan categories operator */
  planCategoriesOperator?: InputMaybe<InNotInOperator>;
  /** The billing discount redemptions per user */
  redemptionsPerUser?: InputMaybe<Scalars['Int']>;
  /** The billing discount redemptions per user months */
  redemptionsPerUserMonths?: InputMaybe<Scalars['Int']>;
  /** The billing discount SKUs */
  skus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing discount SKUs operator */
  skusOperator?: InputMaybe<InNotInOperator>;
  /** The billing discount start date */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** When set, only these user_info.uid values may redeem the discount */
  uids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Update input for Billing Plan Grid */
export type UpdateBillingPlanGridInput = {
  /** The billing plan grid billing product id in */
  billingProductIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** The billing plan grid billing product id not in */
  billingProductIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** The billing plan grid billing provider product id in */
  billingProviderProductIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** The billing plan grid billing provider product id not in */
  billingProviderProductIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** The billing plan grid country in */
  countryIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing plan grid country not in */
  countryNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing plan grid currency in */
  currencyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing plan grid currency not in */
  currencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether this plan grid is the default for the given page */
  defaultPageGrid?: InputMaybe<Scalars['Boolean']>;
  /** The billing plan grid device type in */
  deviceTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing plan grid device type not in */
  deviceTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether the billing plan grid is enabled */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** The billing plan grid end date */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** The best value plan in the plan grid for existing members */
  existingMemberBestValueBillingProviderProductId?: InputMaybe<Scalars['Int']>;
  /** The first plan in the plan grid for existing members */
  existingMemberBillingProviderProductId1?: InputMaybe<Scalars['Int']>;
  /** The second plan in the plan grid for existing members */
  existingMemberBillingProviderProductId2?: InputMaybe<Scalars['Int']>;
  /** The third plan in the plan grid for existing members */
  existingMemberBillingProviderProductId3?: InputMaybe<Scalars['Int']>;
  /** The fourth plan in the plan grid for existing members */
  existingMemberBillingProviderProductId4?: InputMaybe<Scalars['Int']>;
  /** The billing plan grid id */
  id: Scalars['ID'];
  /** The billing plan grid language in */
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The billing plan grid language not in */
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The best value plan in the plan grid for new members */
  newMemberBestValueBillingProviderProductId?: InputMaybe<Scalars['Int']>;
  /** The first plan in the plan grid for new members */
  newMemberBillingProviderProductId1?: InputMaybe<Scalars['Int']>;
  /** The second plan in the plan grid for new members */
  newMemberBillingProviderProductId2?: InputMaybe<Scalars['Int']>;
  /** The third plan in the plan grid for new members */
  newMemberBillingProviderProductId3?: InputMaybe<Scalars['Int']>;
  /** The fourth plan in the plan grid for new members */
  newMemberBillingProviderProductId4?: InputMaybe<Scalars['Int']>;
  /** The billing plan grid page */
  page?: InputMaybe<Scalars['String']>;
  /** The billing plan grid priority */
  priority?: InputMaybe<Scalars['Int']>;
  /** The billing plan grid start date */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** The billing plan grid variant name */
  variantName?: InputMaybe<Scalars['String']>;
};

/** Input for updating an eligibility rule */
export type UpdateBillingProviderProductEligibilityInput = {
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryOperator?: InputMaybe<PlanEligibilityCountryOperator>;
  ecommerceSkus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  lifetimeValue?: InputMaybe<Scalars['Float']>;
  lifetimeValueOperator?: InputMaybe<PlanEligibilityNumericOperator>;
  maxPurchases?: InputMaybe<Scalars['Int']>;
  monthsSinceLastPurchase?: InputMaybe<Scalars['Int']>;
  planCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  planSkus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ruleType?: InputMaybe<PlanEligibilityRuleType>;
  scope?: InputMaybe<PlanEligibilityScope>;
  skuCheckType?: InputMaybe<SkuCheckType>;
  skuOperator?: InputMaybe<SkuOperator>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  tenure?: InputMaybe<Scalars['Int']>;
  tenureOperator?: InputMaybe<PlanEligibilityNumericOperator>;
};

/** Input for updating an existing event */
export type UpdateCommunityEventInput = {
  /** Maximum attendees */
  capacity?: InputMaybe<Scalars['Int']>;
  /** Event description */
  content?: InputMaybe<Scalars['String']>;
  /** Event end date and time */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** Event locations (replaces existing) */
  locations?: InputMaybe<Array<CommunityEventLocationInput>>;
  /** Reminder settings */
  reminderSettings?: InputMaybe<CommunityEventReminderSettingsInput>;
  /** Event start date and time */
  startTime?: InputMaybe<Scalars['DateTime']>;
  /** Event status */
  status?: InputMaybe<CommunityEventStatus>;
  /** IANA timezone */
  timeZone?: InputMaybe<Scalars['String']>;
  /** Event title */
  title?: InputMaybe<Scalars['String']>;
};

/** Input for updating a custom emoji */
export type UpdateCustomEmojiInput = {
  /** Whether the emoji should be active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the emoji to update */
  id: Scalars['ID'];
  /** The new display name */
  name?: InputMaybe<Scalars['String']>;
};

/** Input for uploading a feed image */
export type UploadFeedImageInput = {
  /** The feed ID (UUID) */
  feedId: Scalars['ID'];
  /** Base64-encoded image file (or data URL) */
  fileData: Scalars['String'];
  /** The image type (profile or banner) */
  imageType: FeedImageType;
  /** MIME type of the image (e.g., 'image/png', 'image/jpeg') */
  mimeType: Scalars['String'];
};

/** User accounts */
export type UserAccount = {
  __typename?: 'UserAccount';
  /** The account owner uid */
  accountOwnerUid?: Maybe<Scalars['ID']>;
  /** The account owner uuid */
  accountOwnerUuid?: Maybe<Scalars['ID']>;
  /** The current authentication group id all ids less than this value are invalid */
  authenticationGroupId?: Maybe<Scalars['Int']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** User info associated with this account as the account owner */
  userInfoByAccountOwner?: Maybe<UserInfo>;
};

/** User account policy list response */
export type UserAccountListResponse = {
  __typename?: 'UserAccountListResponse';
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
  /** A list of user accounts */
  userAccounts?: Maybe<Array<Maybe<UserAccount>>>;
};

/** User account id type where input type */
export type UserAccountListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** User account policy where conditions to filter rows */
export type UserAccountListWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<UserAccountListWhereIdInput>;
};

/** User Audit Log */
export type UserAuditLog = {
  __typename?: 'UserAuditLog';
  /** The audit category of user audit */
  auditCategory?: Maybe<AuditCategoryType>;
  /** The billing provider Id of user audit */
  billingProviderId?: Maybe<Scalars['ID']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** When effective date of user audit */
  effectiveDate?: Maybe<Scalars['DateTime']>;
  /** The external account Id of user audit */
  externalAccountId?: Maybe<Scalars['String']>;
  /** The audit field name of user audit */
  fieldName?: Maybe<AuditFieldName>;
  /** The id of the user audit */
  id?: Maybe<Scalars['ID']>;
  /** New data value of user audit */
  newValue?: Maybe<Scalars['String']>;
  /** The performed by user uuid of user audit */
  performedByUuid?: Maybe<Scalars['ID']>;
  /** Previous data value of user audit */
  previousValue?: Maybe<Scalars['String']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user info uuid of user audit */
  userInfoUuid?: Maybe<Scalars['ID']>;
};

/** Create input for User Audit Log */
export type UserAuditLogCreateInput = {
  /** The auditCategory of the user audit log */
  auditCategory: AuditCategoryType;
  /** The billingProviderId of the user audit log */
  billingProviderId: Scalars['ID'];
  /** The effectiveDate of the user audit log */
  effectiveDate: Scalars['DateTime'];
  /** The externalAccountId of the user audit log */
  externalAccountId?: InputMaybe<Scalars['String']>;
  /** The fieldName of the user audit log */
  fieldName: AuditFieldName;
  /** The newValue of the user audit log */
  newValue?: InputMaybe<Scalars['String']>;
  /** The performedByUuid of the user audit log */
  performedByUuid: Scalars['ID'];
  /** The previousValue of the user audit log */
  previousValue?: InputMaybe<Scalars['String']>;
  /** The userInfoUuid of the user audit log */
  userInfoUuid: Scalars['ID'];
};

/** User Audit Log list response */
export type UserAuditLogListResponse = {
  __typename?: 'UserAuditLogListResponse';
  userAuditLogs?: Maybe<Array<Maybe<UserAuditLog>>>;
};

/** User Audit Log boolean where input type */
export type UserAuditLogListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** User Audit Log list where Date input type */
export type UserAuditLogListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']>;
};

/** User Audit Log where type input field Name */
export type UserAuditLogListWhereFieldNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<AuditFieldName>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<AuditFieldName>>>;
};

/** User Audit Log list id where input type */
export type UserAuditLogListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** User Audit Log list where input type */
export type UserAuditLogListWhereInput = {
  /** The auditCategory field where clause */
  auditCategory?: InputMaybe<UserAuditLogListWhereTypeInput>;
  /** The userAuditLog billingProviderId field where clause */
  billingProviderId?: InputMaybe<UserAuditLogListWhereIdInput>;
  /** The userAuditLog effectiveDate field where clause */
  effectiveDate?: InputMaybe<UserAuditLogListWhereDateInput>;
  /** The fieldName field where clause */
  fieldName?: InputMaybe<UserAuditLogListWhereFieldNameInput>;
  /** The userAuditLog id field where clause */
  id?: InputMaybe<UserAuditLogListWhereIdInput>;
  /** The userAuditLog performedByUuid field where clause */
  performedByUuid?: InputMaybe<UserAuditLogListWhereIdInput>;
  /** The userAuditLog userInfoUuid field where clause */
  userInfoUuid?: InputMaybe<UserAuditLogListWhereIdInput>;
};

/** User Audit Log string where input type */
export type UserAuditLogListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** User Audit Log where type input type */
export type UserAuditLogListWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<AuditCategoryType>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<AuditCategoryType>>>;
};

/** Update input for User Audit Log */
export type UserAuditLogUpdateInput = {
  /** The auditCategory of the user audit log */
  auditCategory?: InputMaybe<AuditCategoryType>;
  /** The billingProviderId of the user audit log */
  billingProviderId?: InputMaybe<Scalars['ID']>;
  /** The effectiveDate of the user audit log */
  effectiveDate?: InputMaybe<Scalars['DateTime']>;
  /** The externalAccountId of the user audit log */
  externalAccountId?: InputMaybe<Scalars['String']>;
  /** The fieldName of the user audit log */
  fieldName?: InputMaybe<AuditFieldName>;
  /** The identifier for the user audit log */
  id: Scalars['ID'];
  /** The newValue of the user audit log */
  newValue?: InputMaybe<Scalars['String']>;
  /** The performedByUuid of the user audit log */
  performedByUuid?: InputMaybe<Scalars['ID']>;
  /** The previousValue of the user audit log */
  previousValue?: InputMaybe<Scalars['String']>;
  /** The userInfoUuid of the user audit log */
  userInfoUuid?: InputMaybe<Scalars['ID']>;
};

/** User specific billing plan grid */
export type UserBillingPlanGrid = {
  __typename?: 'UserBillingPlanGrid';
  /** The matching user specific billing plan grid */
  billingPlanGrid?: Maybe<BillingPlanGrid>;
  /** The device type requested */
  deviceType?: Maybe<PlanGridDeviceType>;
};

/** User specific billing plan grid list response */
export type UserBillingPlanGridListResponse = {
  __typename?: 'UserBillingPlanGridListResponse';
  userBillingPlanGrids?: Maybe<Array<Maybe<UserBillingPlanGrid>>>;
};

/** User Billing Plan Grid list where input type */
export type UserBillingPlanGridListWhereInput = {
  /** The filter for the billing plan grid device type */
  deviceType: BillingPlanGridListWhereDeviceTypeInput;
  /** The filter for the billing plan grid language */
  language: ProviderProductLanguage;
  /** The filter for the billing plan grid page */
  page: Scalars['String'];
};

/** User Ecommerce Sku Mapping Bonus Eligibilities list response */
export type UserEcommerceSkuMappingBonusEligibilitiesListResponse = {
  __typename?: 'UserEcommerceSkuMappingBonusEligibilitiesListResponse';
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
  /** A list of ecommerce sku mappings */
  userEcommerceSkuMappingBonusEligibilities?: Maybe<Array<Maybe<UserEcommerceSkuMappingBonusEligibility>>>;
};

/** User Ecommerce Sku Mapping where input type */
export type UserEcommerceSkuMappingBonusEligibilitiesWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** User User Ecommerce Sku Mapping Bonus Eligibilities where conditions to filter rows */
export type UserEcommerceSkuMappingBonusEligibilitiesWhereInput = {
  /** The UserEcommerceSkuMappingBonusEligibilities id field where clause */
  id?: InputMaybe<UserEcommerceSkuMappingBonusEligibilitiesWhereIdInput>;
};

/** User Ecommerce Sku Mapping Bonus Eligibility */
export type UserEcommerceSkuMappingBonusEligibility = {
  __typename?: 'UserEcommerceSkuMappingBonusEligibility';
  /** The Billing Provider Product Text for the item */
  billingProviderProductTextLocalized?: Maybe<Scalars['String']>;
  /** The Billing Provider Product Text Language for the item */
  billingProviderProductTextLocalizedLanguage?: Maybe<Scalars['String']>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The campaign id */
  ecommerceSkuMappingBonusEligibilitiesId?: Maybe<Scalars['Int']>;
  /** The campaigns */
  ecommerceSkuMappingBonusEligibility?: Maybe<EcommerceSkuMappingBonusEligibility>;
  /** The unique id for the given record */
  id?: Maybe<Scalars['ID']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user uuid for the given record */
  userUuid?: Maybe<Scalars['String']>;
};

/**
 * User entitlement represents access rights to a content set for a user or account.
 *
 * Entitlements define what content a user can access and when. They are time-based with start and end dates.
 * An entitlement is considered "active" when the current time is between the start and end dates.
 *
 * Entitlement Types:
 * - User-specific entitlement: userInfoUuid is set, userAccountUuid is null. Applies only to that specific user.
 * - Account-level entitlement: Both userInfoUuid and userAccountUuid are set. Applies to all users in that account.
 *   Account-level entitlements are typically owned by the account owner but accessible by all account members.
 *
 * Entitlements are typically created or updated when billing events are processed (payments, renewals, etc.).
 * The eventId field links back to the billing event that created this entitlement.
 *
 * The reason field describes why the entitlement was created/changed (e.g., "payment", "trial", "gift", etc.).
 * The effectiveChangeDate tracks when the entitlement was last modified.
 *
 * State Information:
 * - Active: current time >= start AND (end is null OR current time <= end)
 * - Expired: current time > end (if end is set)
 * - Future: current time < start
 */
export type UserEntitlement = {
  __typename?: 'UserEntitlement';
  /** Content set for this entitlement. Defines what content this entitlement grants access to. */
  contentSet?: Maybe<ContentSet>;
  /**
   * The content set ID that this entitlement grants access to. Content sets define groups of content
   * (videos, courses, etc.) that users can access.
   */
  contentSetId?: Maybe<Scalars['Int']>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /**
   * Ecommerce SKU (Stock Keeping Unit) identifier for the product that granted this entitlement.
   * Used to link entitlements to specific products in ecommerce systems.
   */
  ecommerceSku?: Maybe<Scalars['String']>;
  /**
   * An Ecommerce SKU Mapping associated with this entitlement. Links the ecommerce SKU
   * to product information and pricing details.
   */
  ecommerceSkuMapping?: Maybe<EcommerceSkuMapping>;
  /**
   * Ecommerce SKU Provider name (e.g., "google", "apple", "paypal"). Identifies which
   * ecommerce system the SKU belongs to.
   */
  ecommerceSkuProvider?: Maybe<Scalars['String']>;
  /**
   * The date when the entitlement was last changed. Tracks when modifications were made to
   * this entitlement record.
   */
  effectiveChangeDate?: Maybe<Scalars['DateTime']>;
  /**
   * The timestamp for when the entitlement ends (Unix timestamp converted to DateTime).
   * If null, the entitlement has no expiration. The entitlement expires at this time.
   */
  end?: Maybe<Scalars['DateTime']>;
  /**
   * Additional event data stored as JSON. Contains provider-specific information about
   * the event that created this entitlement.
   */
  eventData?: Maybe<Scalars['JSON']>;
  /**
   * The event ID linking to the billing event that created or updated this entitlement.
   * This connects the entitlement to the payment transaction that granted access.
   */
  eventId?: Maybe<Scalars['ID']>;
  /** The primary key (auto-incrementing integer) */
  id?: Maybe<Scalars['ID']>;
  /**
   * The reason that caused the entitlement change. Common values: "payment", "trial", "gift",
   * "renewal", "cancellation", etc. Describes the business logic that created this entitlement.
   */
  reason?: Maybe<Scalars['String']>;
  /**
   * The timestamp for when the entitlement starts (Unix timestamp converted to DateTime).
   * The entitlement becomes active at this time.
   */
  start?: Maybe<Scalars['DateTime']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /**
   * User account for this entitlement. Only set if this is an account-level entitlement
   * (userAccountUuid is not null).
   */
  userAccount?: Maybe<UserAccount>;
  /**
   * The user account uuid the entitlement applies to. If set, this is an account-level entitlement
   * that applies to all users in that account. If null, this is a user-specific entitlement.
   */
  userAccountUuid?: Maybe<Scalars['ID']>;
  /**
   * User info for this entitlement. Always set, identifies the user associated with this entitlement.
   * For account-level entitlements, this is typically the account owner.
   */
  userInfo?: Maybe<UserInfo>;
  /**
   * The identifier for the user associated with this record. This is always set and identifies
   * the user who owns or is directly associated with this entitlement.
   */
  userInfoUuid?: Maybe<Scalars['ID']>;
};

/** UserEntitlementCreateInput */
export type UserEntitlementCreateInput = {
  /** The content the entitlement is allowed to access */
  contentSetId: Scalars['Int'];
  /** The date the row was created */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** Ecommerce SKU */
  ecommerceSku?: InputMaybe<Scalars['String']>;
  /** Ecommerce SKU Provider */
  ecommerceSkuProvider?: InputMaybe<Scalars['String']>;
  /** The date when the entitlement was changed */
  effectiveChangeDate?: InputMaybe<Scalars['DateTime']>;
  /** The timestamp for the entitlement end */
  end?: InputMaybe<Scalars['DateTime']>;
  /** The event data */
  eventData?: InputMaybe<Scalars['JSON']>;
  /** The event id */
  eventId?: InputMaybe<Scalars['ID']>;
  /** The event that cause the entitlement change */
  reason?: InputMaybe<Scalars['String']>;
  /** The timestamp for the entitlement start */
  start: Scalars['DateTime'];
  /** The user account uuid the entitlement applies to */
  userAccountUuid?: InputMaybe<Scalars['ID']>;
  /** The identifier for the user associated with this record */
  userInfoUuid: Scalars['ID'];
};

/** User entitlement data */
export type UserEntitlementEventData = {
  __typename?: 'UserEntitlementEventData';
  /** There are no fields defined on this object it needs to be implmented */
  _empty?: Maybe<Scalars['String']>;
};

/** User info policy list response */
export type UserEntitlementListResponse = {
  __typename?: 'UserEntitlementListResponse';
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
  /** A list of userInfo reference */
  userEntitlements?: Maybe<Array<Maybe<UserEntitlement>>>;
};

/** User entitlement id where input type */
export type UserEntitlementListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** User info policy where conditions to filter rows */
export type UserEntitlementListWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<UserEntitlementListWhereIdInput>;
  /** The user account uuid field where clause */
  userAccountUuid?: InputMaybe<UserEntitlementListWhereUserAccountUuidInput>;
  /** The user info uuid field where clause */
  userInfoUuid?: InputMaybe<UserEntitlementListWhereUserInfoUuidInput>;
};

/** User entitlement user account uuid where input type */
export type UserEntitlementListWhereUserAccountUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** User entitlement user info uuid where input type */
export type UserEntitlementListWhereUserInfoUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** UserEntitlementUpdateInput */
export type UserEntitlementUpdateInput = {
  /** The content the entitlement is allowed to access */
  contentSetId?: InputMaybe<Scalars['Int']>;
  /** The timestamp for the entitlement end */
  end?: InputMaybe<Scalars['DateTime']>;
  /** The identifier for the user entitlement record */
  id: Scalars['ID'];
  /** The timestamp for the entitlement start */
  start?: InputMaybe<Scalars['DateTime']>;
  /** The identifier for the user associated with this record */
  userInfoUuid?: InputMaybe<Scalars['ID']>;
};

/** A paginated connection of follow relationships */
export type UserFollowConnection = {
  __typename?: 'UserFollowConnection';
  /** The edges */
  edges: Array<UserFollowEdge>;
  /** Pagination info */
  pageInfo: UserProfilePageInfo;
  /** Total count from denormalized column */
  totalCount: Scalars['Int'];
};

/** An edge in a follow connection */
export type UserFollowEdge = {
  __typename?: 'UserFollowEdge';
  /** Cursor for pagination */
  cursor: Scalars['String'];
  /** When the follow was created */
  followedAt: Scalars['DateTime'];
  /** The user profile */
  node: UserProfile;
};

/** User history row */
export type UserHistory = {
  __typename?: 'UserHistory';
  /** A uuid representing a unique anonymous user */
  anonymousUuid?: Maybe<Scalars['ID']>;
  /** A bit value as int identifying bad data within a record. */
  bad?: Maybe<Scalars['Int']>;
  /** The error code, if any, returned by the Brightcove server. */
  bcCode?: Maybe<Scalars['Int']>;
  /** The error message, if any, returned by the Brightcove server. */
  bcMsg?: Maybe<Scalars['String']>;
  /** The language of text captions if being viewed and not default. */
  capLang?: Maybe<Scalars['String']>;
  /** The {users}.uid claimed by the client for these statistics. */
  clientUid?: Maybe<Scalars['String']>;
  /** The course.nid from the video analytics media linked to this record (if any) */
  courseId?: Maybe<Scalars['ID']>;
  /** The recommId of the Recombee row */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Sums of various time intervals (in seconds) from event array */
  eventSumsArray?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A non-media {node}.nid that references this media. */
  extraNid?: Maybe<Scalars['ID']>;
  /** Array of watched counts (6 seconds per count, 30 seconds per entry) */
  histogramArray?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** in ms) that is used to inc. the view count in each histogram bucket. */
  histogramInterval?: Maybe<Scalars['Int']>;
  /** s) that is used to inc. the view count in each histogram bucket. */
  histogramResolution?: Maybe<Scalars['Int']>;
  /** Hostname of the user who created the record. */
  hostname?: Maybe<Scalars['String']>;
  /** The primary identifier for this history record.UserHistory */
  id?: Maybe<Scalars['ID']>;
  /** A bit value as int identifying ignore data within a record. */
  ign?: Maybe<Scalars['Int']>;
  /** The error code, if any, returned by the Irdeto license server. */
  irdetoCode?: Maybe<Scalars['Int']>;
  /** The error message, if any, returned by the Irdeto license server. */
  irdetoMsg?: Maybe<Scalars['String']>;
  /** in ms) of the last event in the event array table. */
  lastEventTimestamp?: Maybe<Scalars['String']>;
  /** The most recent time the {node} has been viewed. */
  lastPlayed?: Maybe<Scalars['Int']>;
  /** The url of the page the media was played on. */
  location?: Maybe<Scalars['String']>;
  /** The media linked to this user history */
  media?: Maybe<Media>;
  /** The media {node}.nid for these statistics. */
  mediaId?: Maybe<Scalars['ID']>;
  /** The language of the media being played. */
  mediaLang?: Maybe<Scalars['String']>;
  /** The Unix timestamp when media first started to play. */
  playStartedAt?: Maybe<Scalars['Int']>;
  /** The player type (string) that is used by analytics for this record. */
  playerType?: Maybe<Scalars['String']>;
  /** The time code in seconds when this video was last playing. */
  position?: Maybe<Scalars['Int']>;
  /** Auto generated field from sequelize */
  recommId?: Maybe<Scalars['String']>;
  /** A flag indicating this record has already been reported for play counts. */
  reportedCount?: Maybe<Scalars['Int']>;
  /** The language of text subtitles if being viewed and not default. */
  subLang?: Maybe<Scalars['String']>;
  /** The player type (string) that was used for this record. */
  type?: Maybe<Scalars['String']>;
  /** The {users}.uid for these statistics. */
  uid?: Maybe<Scalars['String']>;
  /** Auto generated field from sequelize */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The HTTP User-Agent string of the request that created the record. */
  userAgent?: Maybe<Scalars['String']>;
  /** A list of user history events */
  userHistoryEvents?: Maybe<Array<Maybe<UserHistoryEvent>>>;
  /** The user connected this this user history */
  userInfo?: Maybe<UserInfo>;
  /** The current user media position for this record */
  userMediaPosition?: Maybe<UserMediaPosition>;
  /** The future primary identifier for this history record */
  uuid?: Maybe<Scalars['ID']>;
  /** The current record version identifier. */
  ver?: Maybe<Scalars['Int']>;
  /** The video analytics media for this record */
  videoAnalyticsMedia?: Maybe<VideoAnalyticsMedia>;
  /** The video analytics video for this record */
  videoAnalyticsVideo?: Maybe<VideoAnalyticsVideo>;
  /** The region/country where the video was viewed (based on IP address). */
  viewRegion?: Maybe<Scalars['String']>;
  /** The elapsed seconds of the video played. */
  watched?: Maybe<Scalars['Int']>;
  /** The elapsed seconds the user has watched the video. */
  watchedPeriod?: Maybe<Scalars['Int']>;
};


/** User history row */
export type UserHistoryUserHistoryEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** User history event row */
export type UserHistoryEvent = {
  __typename?: 'UserHistoryEvent';
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The index of the event */
  idx?: Maybe<Scalars['ID']>;
  /** Optional value specifying the kind of event. */
  kind?: Maybe<Scalars['String']>;
  /** Optional language (used with subtitle and caption events) */
  lang?: Maybe<Scalars['String']>;
  /** The name of the event. */
  name?: Maybe<Scalars['String']>;
  /** The current resume position at the moment of this event */
  position?: Maybe<Scalars['Int']>;
  /** The event moment (in ms) since year 0 */
  timestamp?: Maybe<Scalars['String']>;
  /** The date the row was updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user history linked to this event */
  userHistory?: Maybe<UserHistory>;
  /** The foreign key for the user history table */
  userHistoryId?: Maybe<Scalars['ID']>;
};

/** User history list response */
export type UserHistoryEventsListResponse = {
  __typename?: 'UserHistoryEventsListResponse';
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
  /** A list of user history events */
  userHistoryEvents?: Maybe<Array<Maybe<UserHistoryEvent>>>;
};

/** User history list where clause for idx */
export type UserHistoryEventsListWhereIdxInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value before the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value before or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** User history list where clause */
export type UserHistoryEventsListWhereInput = {
  /** Filter by the idx field */
  idx?: InputMaybe<UserHistoryEventsListWhereIdxInput>;
  /** Filter by the id field */
  userHistoryId?: InputMaybe<UserHistoryEventsListWhereUserHistoryIdInput>;
};

/** User history list where clause for user history id */
export type UserHistoryEventsListWhereUserHistoryIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value before the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value before or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** User history input for array filtering */
export type UserHistoryFilterInput = {
  /** The id of the user history record */
  id?: InputMaybe<Scalars['ID']>;
  /** The uid of the user history record */
  uid?: InputMaybe<Scalars['ID']>;
  /** The uuid of the user history record */
  uuid?: InputMaybe<Scalars['ID']>;
};

/** User history list response */
export type UserHistoryListResponse = {
  __typename?: 'UserHistoryListResponse';
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
  /** A list of user history */
  userHistory?: Maybe<Array<Maybe<UserHistory>>>;
};

/** User history list where clause for hidden by user (from user media position) */
export type UserHistoryListWhereHiddenByUserInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** User history list where clause for id */
export type UserHistoryListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** User history list where clause */
export type UserHistoryListWhereInput = {
  /** Filter by the hidden by user flag from user media position */
  hiddenByUser?: InputMaybe<UserHistoryListWhereHiddenByUserInput>;
  /** Filter by the id field */
  id?: InputMaybe<UserHistoryListWhereIdInput>;
  /** Filter by the media id field */
  mediaId?: InputMaybe<UserHistoryListWhereMediaIdInput>;
  /** Filter by the user uid field */
  uid?: InputMaybe<UserHistoryListWhereUidInput>;
  /** Filter by the updated at field */
  updatedAt?: InputMaybe<UserHistoryListWhereUpdatedAtInput>;
  /** Filter by the uuid field */
  uuid?: InputMaybe<UserHistoryListWhereUuidInput>;
};

/** User history list where clause for media id */
export type UserHistoryListWhereMediaIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** User history list where clause for user uid */
export type UserHistoryListWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** User history list where clause for updated at */
export type UserHistoryListWhereUpdatedAtInput = {
  /** Is the value equal to the date */
  eq?: InputMaybe<Scalars['DateTime']>;
  /** Is the value greater than the date */
  gt?: InputMaybe<Scalars['DateTime']>;
  /** Is the value greater than or equal to the date */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Are the values in the date range */
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** Is the value before the date */
  lt?: InputMaybe<Scalars['DateTime']>;
  /** Is the value before or equal to the date */
  lte?: InputMaybe<Scalars['DateTime']>;
};

/** User history list where clause for uuid */
export type UserHistoryListWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** User information */
export type UserInfo = {
  __typename?: 'UserInfo';
  /** Where the user was acquired from */
  acquisitionSource?: Maybe<Scalars['String']>;
  /** Average AI Chat sessions per week over the last 4 weeks (28 days). A session is defined as an OracleChatSession record (conversation thread). Calculation: (total oracle_chat_sessions in last 28 days) / 4. Returns 0.0 if no chat sessions in time period, null on error. Example: 12 sessions in last 28 days = 3.0 sessions/week */
  aiChatUsageFrequency?: Maybe<Scalars['Float']>;
  /** Total number of AI Guide interactions (lifetime count). An interaction is any user message sent to AI Guide (message pair). This is a cumulative lifetime counter, NOT time-bounded. Returns 0 if user has never used AI Guide, null on error. */
  aiGuideInteractionCount?: Maybe<Scalars['Int']>;
  /**
   * Current authentication group_id. Authentication groups are used for security and session management.
   * All authentication tokens with a group_id less than this value are invalid. Used to invalidate
   * all sessions when security events occur (password change, account compromise, etc.).
   */
  authenticationGroupId?: Maybe<Scalars['Int']>;
  /** External ID for referencing user billing information */
  billingAccountId?: Maybe<Scalars['String']>;
  /** Additional external Number for referencing user billing information */
  billingAccountNumber?: Maybe<Scalars['String']>;
  /**
   * User billing events associated to this user. Billing events are payment events sent from payment providers
   * (Google Play, Apple App Store, PayPal, Amazon, Adyen, Zuora, etc.) when transactions occur.
   *
   * These raw events represent the complete payment history and are used to:
   * - Create and update user entitlements (access rights)
   * - Track payment history and subscription lifecycle
   * - Calculate financial metrics (see billingEventsOverview)
   * - Determine current payment state and subscription status
   *
   * Understanding Payment State:
   * To determine if a user has active payments, examine the billingEvents:
   * 1. Filter events by paymentStatus="completed" (successful payments only)
   * 2. Check paidThroughDate: if in the future, user has paid access
   * 3. Look for recent "payment" or "renewal" events (not cancelled/refunded)
   * 4. Check endDate/expiresDate to see if subscription is still active
   * 5. Review errorCode for any payment failures that may affect access
   *
   * Payment State Indicators:
   * - Active Payment: Recent event with paymentStatus="completed" AND paidThroughDate in future
   * - Payment Issue: paymentStatus="failed" or "pending" OR errorCode is set
   * - Cancelled: Recent "cancellation" event (but may still have access until paidThroughDate)
   * - Refunded: Recent "refund" event (entitlements may be revoked)
   * - Trial: isTrialPeriod=true (may convert to paid subscription)
   *
   * Events are linked to this user via the uid field. Query with where filters to analyze
   * specific payment providers, transaction types, or time periods.
   */
  billingEvents?: Maybe<Array<Maybe<BillingEvent>>>;
  /**
   * The overview of all billing events for this user, providing aggregated financial metrics.
   * Includes profit calculations (gross, net, tax), loss totals, and currency information.
   * Useful for understanding the user's overall payment history and financial status.
   */
  billingEventsOverview?: Maybe<BillingEventsOverview>;
  /** A biographical description of the user */
  bio?: Maybe<Scalars['String']>;
  /** Users birthday */
  birthday?: Maybe<Scalars['String']>;
  /**
   * The datetime of when the user is locked out until. If set and in the future, the user
   * is temporarily blocked. If null or in the past, the user is not blocked (unless status is 'blocked').
   * Used for temporary account locks after failed login attempts.
   */
  blockedUntil?: Maybe<Scalars['String']>;
  /**
   * The number of consecutive failed login attempts. Used for security purposes to detect
   * potential brute force attacks. Typically resets after successful login or after blockedUntil expires.
   */
  consecutiveFailedLoginAttempts?: Maybe<Scalars['Int']>;
  /** Get course progress for this user */
  courseProgress?: Maybe<UserStateProgressCourseListResponse>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Source service from which user was created */
  creationSource?: Maybe<Scalars['String']>;
  /** Count of unique days with video viewership in the last 7 days. Only counts days with qualified views (15+ seconds watched). Counts distinct calendar days where user had any qualified video watch activity. Returns 0 if no qualified viewership in the time period. Example: User watched videos on Mon, Wed, Fri = 3 days */
  daysWithViewershipLast7Days?: Maybe<Scalars['Int']>;
  /** The user email */
  email?: Maybe<Scalars['String']>;
  /** Indicates email registered in both Gaia and an external system */
  emailRegisteredExternally?: Maybe<Scalars['Boolean']>;
  /** User engagement cohort based on video viewing frequency in last 7 days. Calculated from daysWithViewershipLast7Days: DAU (6-7 days), WAU (2-5 days), MAU (0-1 days). Used for PostHog A/B testing to track cohort migration and measure engagement improvements. */
  engagementCohort?: Maybe<Scalars['String']>;
  /** First name of the user */
  firstName?: Maybe<Scalars['String']>;
  /** External ID for referencing user billing information for FMTV PayPal recurring */
  fmtvPayPalRecurringId?: Maybe<Scalars['String']>;
  /** External ID for referencing FMTV user information */
  fmtvUserId?: Maybe<Scalars['Int']>;
  /**
   * True when this user has no entitlement rows with NULL ecommerce_sku.
   * Empty or missing entitlement list is treated as eligible (zero NULL-SKU rows).
   */
  freeTrialEligible?: Maybe<Scalars['Boolean']>;
  /** Full name of the user */
  fullName?: Maybe<Scalars['String']>;
  /** gcsi uuid for this user */
  gcsiUserUuid?: Maybe<Scalars['String']>;
  /** A list of user languages in priority order i.e. index 0 is their primary language */
  language?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Last name of the user */
  lastName?: Maybe<Scalars['String']>;
  /** Learner level scores for this user (own user, customer service, or site admin) */
  learnerLevels: Array<UserLearnerLevel>;
  /** The USD lifetime value of the user */
  lifetimeValue?: Maybe<Scalars['Float']>;
  /** The comma-separated city and state where the user is located */
  location?: Maybe<Scalars['String']>;
  /** Median minutes watched per week over the last 4 weeks (28 days). Only includes qualified views (15+ seconds watched). Calculates watch time for each of the 4 weeks from qualified views, then returns the median value. Returns 0.0 if no qualified watch time in the time period. Example: Week totals [120, 45, 90, 60] = median 75.0 minutes */
  medianWatchTimePerWeek?: Maybe<Scalars['Float']>;
  /** Optional member support notes about the user */
  memberSupportNotes?: Maybe<Scalars['String']>;
  /** External ID for referencing user billing information for MYO PayPal recurring */
  myoPayPalRecurringId?: Maybe<Scalars['String']>;
  /** User setting for app tracking transparency and 3rd party data sharing */
  optOutOfDataSharing?: Maybe<Scalars['Boolean']>;
  /** A playlist associated with this user */
  playlist?: Maybe<Playlist>;
  /** Braze-hosted email preference center URL for the signed-in user only (via getPreferenceCenterUrlForUser). Null if unauthenticated, not this user, Braze is unavailable, or the feature is not configured. Treat as sensitive. */
  preferenceCenterUrl?: Maybe<Scalars['String']>;
  /** Profile picture URLs in different sizes (ready to use in frontend) */
  profilePicture?: Maybe<ProfilePictureUrls>;
  /** UUID for referencing user profile image */
  profilePictureUuid?: Maybe<Scalars['ID']>;
  /** Computed target readability grade level for personalized content. Based on education level and reading interests from user demographics. Returns values: grade_8, grade_9, grade_10, grade_11, or grade_12. Defaults to grade_8 if no demographic data available. */
  readabilityLevel?: Maybe<Scalars['String']>;
  /** Personalized seed questions based on the user's rainbow categories */
  seedQuestions: Array<SeedQuestion>;
  /**
   * The status of the user. 'active' means the user can access the system.
   * 'blocked' means the user is denied access, potentially until blockedUntil date.
   */
  status?: Maybe<User_Info_Status>;
  /** The user id */
  uid?: Maybe<Scalars['ID']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /**
   * User account associated with this user. If this user is a profile, this is the account they belong to.
   * If this user is an account owner, this is the account they own. If null, user is standalone.
   */
  userAccount?: Maybe<UserAccount>;
  /** UUID for referencing the UserAccount this user belongs to. If null, user is standalone or is an account owner */
  userAccountId?: Maybe<Scalars['ID']>;
  /**
   * User entitlements linked to this user. Entitlements represent access rights to content sets.
   *
   * Entitlements can be:
   * - User-specific: Only apply to this specific user (userAccountUuid is null)
   * - Account-level: Apply to all users in the account (userAccountUuid is set)
   *
   * When userAccount=true, returns entitlements from the account owner (for profiles to access owner's entitlements).
   * When active=true, filters to entitlements where current time is between start and end dates.
   *
   * Entitlements are typically created from billing events when payments are processed.
   */
  userEntitlements?: Maybe<Array<Maybe<UserEntitlement>>>;
  /**
   * User entitlements which are currently active, filtered by user account. This is the recommended field
   * for applications and third parties that need to check current entitlement status.
   *
   * Returns active entitlements from the account owner if this user belongs to an account, otherwise
   * returns active entitlements for this user directly.
   */
  userEntitlementsActiveByUserAccount?: Maybe<Array<Maybe<UserEntitlement>>>;
  /** The user history records for this user */
  userHistory: Array<UserHistory>;
  /** The user media positions for this user e.g. the resume position and statistics for use video playback */
  userMediaPositions: Array<UserMediaPosition>;
  /** The user media positions for this user e.g. the resume position and statistics for use video playback */
  userMetaTags: Array<UserMetaTag>;
  /** The user metadata entries for this user */
  userMetadata: Array<UserMetadata>;
  /** The user roles associated with this user */
  userRoles?: Maybe<Array<Maybe<UserRole>>>;
  /**
   * Days the user has been entitled (has had active access). For account owners, calculated from their entitlements.
   * For profiles, calculated from profile creation date. For frozen users, extracted from email pattern.
   */
  userTenureDays?: Maybe<Scalars['Int']>;
  /** The unique username for the user */
  username?: Maybe<Scalars['String']>;
  /** The user uuid */
  uuid?: Maybe<Scalars['ID']>;
  /** Video completion rate as a ratio (0.0 to 1.0). Calculated as: (completed videos) / (qualified started videos) over last 30 days. Only counts qualified views (15+ seconds watched). Completed = watchedSum/duration >= 0.80 (80%). Returns 0.0 if no qualified videos watched in the time period. Example: 5 completions out of 30 qualified videos = 0.167 (16.7%) */
  videoCompletionRate?: Maybe<Scalars['Float']>;
  /** Count of unique videos watched in the last 7 days. Only counts qualified views (15+ seconds watched). Counts distinct contentId values from user's watch history where lastPlayed is within 7 days. Returns 0 if no qualified videos watched in the time period. */
  videosLast7Days?: Maybe<Scalars['Int']>;
  /** The user media positions for this user e.g. the resume position and statistics for use video playback */
  votes: Array<Vote>;
  /** External ID for referencing Yoga International user information */
  yogaInternationalUserId?: Maybe<Scalars['String']>;
};


/** User information */
export type UserInfoBillingEventsArgs = {
  where?: InputMaybe<BillingEventListWhereInput>;
};


/** User information */
export type UserInfoCourseProgressArgs = {
  courseTitleGroupIds?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  state?: InputMaybe<UserStateCourse>;
};


/** User information */
export type UserInfoLearnerLevelsArgs = {
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
  origin?: InputMaybe<Scalars['String']>;
  tagContentContentId?: InputMaybe<Scalars['Int']>;
};


/** User information */
export type UserInfoPlaylistArgs = {
  playlistType?: InputMaybe<Scalars['String']>;
};


/** User information */
export type UserInfoSeedQuestionsArgs = {
  language?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


/** User information */
export type UserInfoUserEntitlementsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  userAccount?: InputMaybe<Scalars['Boolean']>;
};


/** User information */
export type UserInfoUserEntitlementsActiveByUserAccountArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** User information */
export type UserInfoUserHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
};


/** User information */
export type UserInfoUserMediaPositionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
};


/** User information */
export type UserInfoUserMetaTagsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** User information */
export type UserInfoUserMetadataArgs = {
  names?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Scalars['String']>;
};


/** User information */
export type UserInfoVotesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>>;
};

/** Request information for the current user */
export type UserInfoCurrentAuthenticationResponse = {
  __typename?: 'UserInfoCurrentAuthenticationResponse';
  /** The client attributes assigned during authentication creation */
  clientAttributes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The country assigned during authentication creation */
  country?: Maybe<Scalars['String']>;
  /** The roles assigned during authentication creation */
  roles?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** The subscriptions assigned during authentication creation */
  subscriptions?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** The user uuid */
  uuid?: Maybe<Scalars['ID']>;
};

/** Request information for the current user */
export type UserInfoCurrentRequestResponse = {
  __typename?: 'UserInfoCurrentRequestResponse';
  /** The request country */
  country?: Maybe<Scalars['String']>;
};

/** User info for the user currently making this request response */
export type UserInfoCurrentResponse = {
  __typename?: 'UserInfoCurrentResponse';
  /** The authentication information */
  authentication?: Maybe<UserInfoCurrentAuthenticationResponse>;
  /** The request information for the current user */
  request?: Maybe<UserInfoCurrentRequestResponse>;
  /** User info for the user currently making this request */
  userInfo?: Maybe<UserInfo>;
};

/** User info policy list response */
export type UserInfoListResponse = {
  __typename?: 'UserInfoListResponse';
  /** A list of userInfo reference */
  userInfo?: Maybe<Array<Maybe<UserInfo>>>;
};

/** User info billing account id type where input type */
export type UserInfoListWhereBillingAccountIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** User info billing account number type where input type */
export type UserInfoListWhereBillingAccountNumberInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** User info user account id type where input type */
export type UserInfoListWhereEmailInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** User info policy where conditions to filter rows */
export type UserInfoListWhereInput = {
  /** The billing account id field where clause */
  billingAccountId?: InputMaybe<UserInfoListWhereBillingAccountIdInput>;
  /** The billing account number field where clause */
  billingAccountNumber?: InputMaybe<UserInfoListWhereBillingAccountNumberInput>;
  /** The email field where clause */
  email?: InputMaybe<UserInfoListWhereEmailInput>;
  /** The uid field where clause */
  uid?: InputMaybe<UserInfoListWhereUidInput>;
  /** The user account id field where clause */
  userAccountId?: InputMaybe<UserInfoListWhereUserAccountIdInput>;
  /** The uuid field where clause */
  uuid?: InputMaybe<UserInfoListWhereUuidInput>;
  /** The yoga international user id field where clause */
  yogaInternationalUserId?: InputMaybe<UserInfoListWhereYogaInternationalUserIdInput>;
};

/** User info uid type where input type */
export type UserInfoListWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** User info user account id type where input type */
export type UserInfoListWhereUserAccountIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** User info uuid type where input type */
export type UserInfoListWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** User info yoga international user id type where input type */
export type UserInfoListWhereYogaInternationalUserIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/**
 * Public user profile safe for public display.
 * Returns minimal identity fields for any user.
 * Requires authentication but can view any user's public profile.
 * Brooklyn extends this type with avatar (profile picture) and displayName via federation.
 */
export type UserInfoPublic = {
  __typename?: 'UserInfoPublic';
  /** Public username */
  username?: Maybe<Scalars['String']>;
  /** User UUID */
  uuid: Scalars['ID'];
};

/** Input for updating user info fields */
export type UserInfoUpdateInput = {
  /** Update first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** Update last name */
  lastName?: InputMaybe<Scalars['String']>;
  /** Update name visibility (public or private) */
  nameVisibility?: InputMaybe<Scalars['String']>;
  /** Update username */
  username?: InputMaybe<Scalars['String']>;
};

/** Input for account owner to update a profile's first and last name */
export type UserInfoUpdateProfileInput = {
  /** Update first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** Update last name */
  lastName?: InputMaybe<Scalars['String']>;
  /** UUID of the profile to update (must be a profile in the requester's account) */
  profileUuid: Scalars['ID'];
};

/** Response from userInfoUpdate mutation */
export type UserInfoUpdateResponse = {
  __typename?: 'UserInfoUpdateResponse';
  /** Whether the update was successful */
  success: Scalars['Boolean'];
  /** The updated user info */
  userInfo?: Maybe<UserInfo>;
};

/** User info with metadata response */
export type UserInfoWithMetadataResponse = {
  __typename?: 'UserInfoWithMetadataResponse';
  /** Total count of users with demographic metadata */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
  /** A list of user info */
  userInfo: Array<UserInfo>;
};

/** Learner level score for a user on a tag topic */
export type UserLearnerLevel = {
  __typename?: 'UserLearnerLevel';
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Source of the score e.g. onboarding-v5 */
  origin: Scalars['String'];
  /** Score 1-10 */
  score: Scalars['Int'];
  /** Tag content content_id */
  tagContentContentId: Scalars['Int'];
  /** The user id */
  uid: Scalars['Int'];
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserLearnerLevelDeleteResult = {
  __typename?: 'UserLearnerLevelDeleteResult';
  deleted: Scalars['Int'];
};

/** Input for creating or updating learner level rows. For most callers the effective user id comes from the JWT; see uid field. */
export type UserLearnerLevelInput = {
  origin: Scalars['String'];
  score: Scalars['Int'];
  tagContentContentId: Scalars['Int'];
  /** Optional user id. Only editor, editor-plus, and site-admin may set this to write for another user. For all other authenticated callers the value is ignored and the JWT user id is used. */
  uid?: InputMaybe<Scalars['Int']>;
};

export type UserLearnerLevelMutationResult = {
  __typename?: 'UserLearnerLevelMutationResult';
  created: Scalars['Int'];
  updated: Scalars['Int'];
  userLearnerLevels: Array<UserLearnerLevel>;
};

/** User media position row */
export type UserMediaPosition = {
  __typename?: 'UserMediaPosition';
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** User has hidden this media from their watch history when true */
  hiddenByUser?: Maybe<Scalars['Boolean']>;
  /** User has hidden this media from showing up in Continue Watching */
  hiddenFromContinue?: Maybe<Scalars['Boolean']>;
  /** The most recent time the media has been played. */
  lastPlayed?: Maybe<Scalars['BigInt']>;
  /** The media linked from this user media position */
  media?: Maybe<Media>;
  /** The node nid that was played. */
  mediaId?: Maybe<Scalars['ID']>;
  /** The time offset (in seconds) when this media was last playing (resume point). */
  position?: Maybe<Scalars['BigInt']>;
  /** The time this video was last searched by this user (in seconds) */
  searchedTime?: Maybe<Scalars['Int']>;
  /** The users uid that played the node nid. */
  uid?: Maybe<Scalars['ID']>;
  /** The date the row was updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user connected this this user history */
  userInfo?: Maybe<UserInfo>;
  /** The video analytics media for this record */
  videoAnalyticsMedia?: Maybe<VideoAnalyticsMedia>;
  /** The video analytics video for this record */
  videoAnalyticsVideo?: Maybe<VideoAnalyticsVideo>;
  /** The total number of views of this media by this user. */
  watchedCount?: Maybe<Scalars['Int']>;
  /** The total seconds watched of all views of this media by this user. */
  watchedSum?: Maybe<Scalars['BigInt']>;
};

/** User media position list response */
export type UserMediaPositionListResponse = {
  __typename?: 'UserMediaPositionListResponse';
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
  /** A list of user media positions */
  userMediaPositions?: Maybe<Array<Maybe<UserMediaPosition>>>;
};

/** Filter by hidden_by_user flag */
export type UserMediaPositionListWhereHiddenByUserInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']>;
};

/** User media position list where clause */
export type UserMediaPositionListWhereInput = {
  /** Filter by hidden_by_user flag */
  hiddenByUser?: InputMaybe<UserMediaPositionListWhereHiddenByUserInput>;
  /** Filter by last_played timestamp */
  lastPlayed?: InputMaybe<UserMediaPositionListWhereLastPlayedInput>;
  /** Filter by media id */
  mediaId?: InputMaybe<UserMediaPositionListWhereMediaIdInput>;
  /** Filter by user uid */
  uid?: InputMaybe<UserMediaPositionListWhereUidInput>;
  /** Filter by watched_sum seconds */
  watchedSum?: InputMaybe<UserMediaPositionListWhereWatchedSumInput>;
};

/** Filter by last_played timestamp */
export type UserMediaPositionListWhereLastPlayedInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['BigInt']>;
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['BigInt']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['BigInt']>;
};

/** User media position list where clause for media id */
export type UserMediaPositionListWhereMediaIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** User media position list where clause for user uid */
export type UserMediaPositionListWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Filter by watched_sum seconds */
export type UserMediaPositionListWhereWatchedSumInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['BigInt']>;
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['BigInt']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['BigInt']>;
};

/** User meta tags */
export type UserMetaTag = {
  __typename?: 'UserMetaTag';
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The primary key for this record */
  id: Scalars['ID'];
  /** The numeric key for tag name i.e. 2 */
  key: Scalars['Int'];
  /** The tag name i.e. 'transformation' */
  name: Scalars['String'];
  /** The number of seconds a user could have watched for engaged views in this category/segment */
  potentialSeconds: Scalars['Int'];
  /** The source of this data (VA, Brooklyn, ColdStart) */
  source: Scalars['String'];
  /** The type of meta tag (UBS, RC, TOPIC) */
  tagType: Scalars['String'];
  /** The user id */
  uid: Scalars['Int'];
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user linked to this user meta tag */
  userInfo?: Maybe<UserInfo>;
  /** The number of engaged views (where a user has watched more than 25% of a video) */
  viewCount: Scalars['Int'];
  /** The number of seconds watched for engaged views (> 25%) only */
  viewSeconds: Scalars['Int'];
  /** A fractional value indicating the percentage of all engaged for tag within the type */
  weight?: Maybe<Scalars['Float']>;
};

/** User meta tag filter input type */
export type UserMetaTagFilterInput = {
  /** The numeric key for tag name i.e. 2 */
  key?: InputMaybe<Scalars['Int']>;
  /** The source of this data (VA, Brooklyn, ColdStart) */
  source?: InputMaybe<Scalars['String']>;
  /** The type of meta tag (UBS, RC, TOPIC) */
  type?: InputMaybe<Scalars['String']>;
  /** The user id */
  uid?: InputMaybe<Scalars['Int']>;
};

/** User meta tag list response */
export type UserMetaTagListResponse = {
  __typename?: 'UserMetaTagListResponse';
  /** A list of user meta tags */
  userMetaTags: Array<UserMetaTag>;
};

/** User meta tag where conditions to filter rows */
export type UserMetaTagWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<UserMetaTagWhereIntInput>;
  /** The key field where clause */
  key?: InputMaybe<UserMetaTagWhereIntInput>;
  /** The name field where clause */
  name?: InputMaybe<UserMetaTagWhereStringInput>;
  /** The source field where clause */
  source?: InputMaybe<UserMetaTagWhereStringInput>;
  /** The tag_type field where clause */
  tagType?: InputMaybe<UserMetaTagWhereStringInput>;
  /** The uid field where clause */
  uid?: InputMaybe<UserMetaTagWhereIntInput>;
};

/** User meta tag id where input type */
export type UserMetaTagWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** User meta tag id where input type */
export type UserMetaTagWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** User metadata entry */
export type UserMetadata = {
  __typename?: 'UserMetadata';
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The export index for this record */
  exportIndex: Scalars['Int'];
  /** The metadata name */
  name: Scalars['String'];
  /** The metadata type */
  type: Scalars['String'];
  /** The user id */
  uid: Scalars['Int'];
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The metadata value */
  value?: Maybe<Scalars['String']>;
};

/** User metadata input */
export type UserMetadataInput = {
  /** The metadata name */
  name: Scalars['String'];
  /** The metadata type */
  type: Scalars['String'];
  /** The user id */
  uid: Scalars['Int'];
  /** The metadata value */
  value?: InputMaybe<Scalars['String']>;
};

/** User metadata mutation response */
export type UserMetadataMutationResult = {
  __typename?: 'UserMetadataMutationResult';
  /** The total number of rows created */
  created: Scalars['Int'];
  /** The total number of rows updated */
  updated: Scalars['Int'];
  /** The resulting user metadata rows */
  userMetadata: Array<UserMetadata>;
};

/** User profile from Brooklyn, extended by AI service with identity vibe */
export type UserProfile = {
  __typename?: 'UserProfile';
  /** User's chosen identity archetype */
  archetype?: Maybe<Scalars['String']>;
  /** Archetype field visibility */
  archetypeVisibility?: Maybe<FieldVisibility>;
  /** Profile picture (resolved from user_profiles.profile_picture_s3_key) */
  avatar?: Maybe<ProfilePicture>;
  /** Profile banner image */
  bannerImage?: Maybe<ProfileBannerImage>;
  /** Short bio */
  bio?: Maybe<Scalars['String']>;
  /** Bio field visibility */
  bioVisibility?: Maybe<FieldVisibility>;
  /** Birthday (ISO date string) */
  birthday?: Maybe<Scalars['String']>;
  /** Birthday field visibility */
  birthdayVisibility?: Maybe<FieldVisibility>;
  /** Denormalized mutual-follow (connection) count */
  connectionCount?: Maybe<Scalars['Int']>;
  /** Date the profile was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Visibility of the user's Currently Watching list. Persisted owner intent; the video-analytics subgraph will consume it via @requires to gate UserProfile.inProgress. */
  currentlyWatchingVisibility?: Maybe<FieldVisibility>;
  /** User-editable display name (defaults to username, null if no profile row exists) */
  displayName?: Maybe<Scalars['String']>;
  /** User's Favorites system playlist (null when hidden by visibility/cascade) */
  favorites?: Maybe<Playlist>;
  /** Denormalized follower count */
  followerCount?: Maybe<Scalars['Int']>;
  /** Denormalized following count */
  followingCount?: Maybe<Scalars['Int']>;
  /** AI-generated identity vibe for this user */
  identityVibe?: Maybe<OracleIdentityVibe>;
  /** In-progress videos for this user's profile. Shows recent videos with watch progress. Only visible when profile is public or viewer has permission. */
  inProgress: Array<UserMediaPosition>;
  /** City/region location */
  location?: Maybe<Scalars['String']>;
  /** Location field visibility */
  locationVisibility?: Maybe<FieldVisibility>;
  /** Member-since field visibility */
  memberSinceVisibility?: Maybe<FieldVisibility>;
  /** Profile visibility setting */
  profileVisibility?: Maybe<ProfileVisibility>;
  /** Recent videos watched by this user. Only visible when profile is public or viewer has permission. */
  recentVideos: Array<UserHistory>;
  /** Top genres / rainbow categories (from user meta tags). Only present when profile is visible. */
  topGenres: Array<UserProfileTopGenre>;
  /** Selected onboarding centers (from user_profiles.center_content_ids) */
  topics?: Maybe<Array<Maybe<UserProfileTag>>>;
  /** Topics field visibility */
  topicsVisibility?: Maybe<FieldVisibility>;
  /** User UID */
  uid: Scalars['ID'];
  /** Date the profile was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** User UUID (privacy-safe public identifier) */
  uuid: Scalars['ID'];
  /** Count of unique videos watched in the last 7 days. Only visible when profile is public or viewer has permission. */
  videosLast7Days?: Maybe<Scalars['Int']>;
  /** Viewer-relative context */
  viewerContext?: Maybe<UserProfileViewerContext>;
  /** Watch history for this user's profile, filterable by completion status. Only visible when profile is public or viewer has permission. */
  watchHistory: Array<UserMediaPosition>;
  /** Visibility of the user's full Watch History. Persisted owner intent; the video-analytics subgraph will consume it via @requires to gate UserProfile.watchHistory. */
  watchHistoryVisibility?: Maybe<FieldVisibility>;
  /** User's Watch Later system playlist (null when hidden by visibility/cascade) */
  watchLater?: Maybe<Playlist>;
  /** Western zodiac sun sign (e.g. aries, pisces) — one of the 12 canonical lowercase signs */
  westernZodiacSunSign?: Maybe<Scalars['String']>;
  /** User's journey description */
  yourJourney?: Maybe<Scalars['String']>;
  /** Your-journey field visibility */
  yourJourneyVisibility?: Maybe<FieldVisibility>;
};


/** User profile from Brooklyn, extended by AI service with identity vibe */
export type UserProfileInProgressArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/** User profile from Brooklyn, extended by AI service with identity vibe */
export type UserProfileRecentVideosArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/** User profile from Brooklyn, extended by AI service with identity vibe */
export type UserProfileTopGenresArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/** User profile from Brooklyn, extended by AI service with identity vibe */
export type UserProfileTopicsArgs = {
  language?: InputMaybe<Scalars['String']>;
};


/** User profile from Brooklyn, extended by AI service with identity vibe */
export type UserProfileWatchHistoryArgs = {
  filter?: InputMaybe<WatchHistoryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Connection type for UserProfile pagination */
export type UserProfileConnection = {
  __typename?: 'UserProfileConnection';
  /** List of user edges */
  edges: Array<UserProfileEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
};

/** Edge type for UserProfile pagination */
export type UserProfileEdge = {
  __typename?: 'UserProfileEdge';
  /** Cursor for this edge */
  cursor: Scalars['String'];
  /** The user node */
  node: UserProfile;
};

/** Response from following or unfollowing a user */
export type UserProfileFollowResponse = {
  __typename?: 'UserProfileFollowResponse';
  /** The profile of the followed/unfollowed user */
  profile?: Maybe<UserProfile>;
};

/** A paginated connection for user profile ingestion */
export type UserProfileIngestConnection = {
  __typename?: 'UserProfileIngestConnection';
  /** The edges */
  edges: Array<UserProfileIngestEdge>;
  /** Pagination info */
  pageInfo: UserProfilePageInfo;
};

/** An edge in a user profile ingest connection */
export type UserProfileIngestEdge = {
  __typename?: 'UserProfileIngestEdge';
  /** Cursor for pagination */
  cursor: Scalars['String'];
  /** The user profile */
  node: UserProfile;
};

/** Pagination info */
export type UserProfilePageInfo = {
  __typename?: 'UserProfilePageInfo';
  /** Cursor for the last edge */
  endCursor?: Maybe<Scalars['String']>;
  /** Whether there are more results */
  hasNextPage: Scalars['Boolean'];
};

/** A selected onboarding center (centers-bundle tag; contentId matches popularTopics) */
export type UserProfileTag = {
  __typename?: 'UserProfileTag';
  /** English center tag content_id (stored value; aligns with popularTopics.contentId) */
  contentId: Scalars['Int'];
  /** Display title (localized when language arg differs from en) */
  title: Scalars['String'];
  /** Title group of the center tag */
  titleGroupId: Scalars['String'];
};

/** Top genre / rainbow category for profile (from user meta tags, visibility follows profile) */
export type UserProfileTopGenre = {
  __typename?: 'UserProfileTopGenre';
  /** Cleaned name with numbered prefix and RC suffix stripped (e.g. '3 - Meditation RC' → 'Meditation') */
  cleanName: Scalars['String'];
  /** Display name e.g. Meditation & Mindfulness */
  name: Scalars['String'];
  /** Engaged view count */
  viewCount?: Maybe<Scalars['Int']>;
  /** Weight within type (0–1) */
  weight?: Maybe<Scalars['Float']>;
};

/** Input for updating a user profile */
export type UserProfileUpdateInput = {
  /** Identity archetype (max 256 chars) */
  archetype?: InputMaybe<Scalars['String']>;
  /** Archetype field visibility */
  archetypeVisibility?: InputMaybe<FieldVisibility>;
  /** Short bio (max 500 characters) */
  bio?: InputMaybe<Scalars['String']>;
  /** Bio field visibility */
  bioVisibility?: InputMaybe<FieldVisibility>;
  /** Birthday (ISO date) */
  birthday?: InputMaybe<Scalars['String']>;
  /** Birthday field visibility */
  birthdayVisibility?: InputMaybe<FieldVisibility>;
  /** Center tag content IDs from popularTopics (English rows), max 5, order preserved; omit to leave unchanged */
  centerContentIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Currently-watching list visibility (forced to private when profile is private) */
  currentlyWatchingVisibility?: InputMaybe<FieldVisibility>;
  /** Display name (max 64 characters) */
  displayName?: InputMaybe<Scalars['String']>;
  /** City/region location (max 128 characters) */
  location?: InputMaybe<Scalars['String']>;
  /** Location field visibility */
  locationVisibility?: InputMaybe<FieldVisibility>;
  /** Member-since field visibility */
  memberSinceVisibility?: InputMaybe<FieldVisibility>;
  /** Profile visibility */
  profileVisibility?: InputMaybe<ProfileVisibility>;
  /** Topics field visibility */
  topicsVisibility?: InputMaybe<FieldVisibility>;
  /** Watch history visibility (forced to private when profile is private) */
  watchHistoryVisibility?: InputMaybe<FieldVisibility>;
  /** Western zodiac sun sign — must be one of the 12 canonical lowercase signs, or null to clear */
  westernZodiacSunSign?: InputMaybe<Scalars['String']>;
  /** Journey description (max 100 chars) */
  yourJourney?: InputMaybe<Scalars['String']>;
  /** Your-journey field visibility */
  yourJourneyVisibility?: InputMaybe<FieldVisibility>;
};

/** Response from updating a user profile */
export type UserProfileUpdateResponse = {
  __typename?: 'UserProfileUpdateResponse';
  /** The updated user profile */
  profile?: Maybe<UserProfile>;
};

/** Viewer-relative context for a user profile */
export type UserProfileViewerContext = {
  __typename?: 'UserProfileViewerContext';
  /** Does this profile follow the viewer */
  isFollowedBy: Scalars['Boolean'];
  /** Does the viewer follow this profile */
  isFollowing: Scalars['Boolean'];
  /** Is the viewer the owner of this profile */
  isOwner: Scalars['Boolean'];
  /** Visibility level for the viewer: owner, member, public */
  visibilityLevel: Scalars['String'];
};

/** User role */
export type UserRole = {
  __typename?: 'UserRole';
  /** The auth role associated with this record */
  authRole?: Maybe<AuthRole>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The primary key */
  id?: Maybe<Scalars['ID']>;
  /** The auth role id */
  role?: Maybe<Scalars['ID']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user info associated with this record */
  userInfo?: Maybe<UserInfo>;
  /** The identifier for the user associated with this record */
  userInfoUuid?: Maybe<Scalars['ID']>;
};

/** User role list response */
export type UserRoleListResponse = {
  __typename?: 'UserRoleListResponse';
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
  /** A list of userInfo reference */
  userRoles?: Maybe<Array<Maybe<UserRole>>>;
};

/** User role id where input type */
export type UserRoleListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** User role where conditions to filter rows */
export type UserRoleListWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<UserRoleListWhereIdInput>;
  /** The user role role file where clause */
  role?: InputMaybe<UserRoleListWhereRoleInput>;
  /** The user info uuid field where clause */
  userInfoUuid?: InputMaybe<UserRoleListWhereUserInfoUuidInput>;
};

/** User role user role where input type */
export type UserRoleListWhereRoleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** User role user user info uuid where input type */
export type UserRoleListWhereUserInfoUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** User state entry for tracking progress */
export type UserState = {
  __typename?: 'UserState';
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The parent content title group id (course) */
  parentContentTitleGroupId: Scalars['String'];
  /** The id of the progress item. For videos, this should be the contentTitleGroupId. For assets, this should be the asset UUID. */
  progressItemId: Scalars['String'];
  /** The type of progress item */
  progressItemType: UserStateProgressItemType;
  /** The state of the progress item */
  state: UserStateState;
  /** The user id */
  uid: Scalars['Int'];
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum UserStateCourse {
  /** The course is complete */
  Complete = 'COMPLETE',
  /** The course is in progress */
  InProgress = 'IN_PROGRESS',
  /** The course has not been started */
  NotStarted = 'NOT_STARTED'
}

/** User state input */
export type UserStateInput = {
  /** The parent content title group id (course) */
  parentContentTitleGroupId: Scalars['String'];
  /** The id of the progress item. For videos, this should be the contentTitleGroupId. For assets, this should be the asset UUID. */
  progressItemId: Scalars['String'];
  /** The type of progress item */
  progressItemType: UserStateProgressItemType;
  /** The state of the progress item */
  state: UserStateState;
  /** The user id (admin only, defaults to current user) */
  userUid?: InputMaybe<Scalars['Int']>;
};

/** User state list response */
export type UserStateListResponse = {
  __typename?: 'UserStateListResponse';
  /** The total number of user state entries matching the query */
  count?: Maybe<Scalars['Int']>;
  /** The limit used in the query */
  limit?: Maybe<Scalars['Int']>;
  /** The offset used in the query */
  offset?: Maybe<Scalars['Int']>;
  /** A list of user state entries */
  userState: Array<UserState>;
};

/** Course metrics */
export type UserStateMetricsCourse = {
  __typename?: 'UserStateMetricsCourse';
  /** Number of completed videos */
  completedItems: Scalars['Int'];
  /** Number of completed modules */
  completedModules: Scalars['Int'];
  /** Percentage of items completed (0.0 to 100.0) */
  percentageItemsComplete: Scalars['Float'];
  /** Percentage of modules completed (0.0 to 100.0) */
  percentageModulesComplete: Scalars['Float'];
  /** Total number of videos in the course */
  totalItems: Scalars['Int'];
  /** Total number of modules in the course */
  totalModules: Scalars['Int'];
};

/** Course module metrics */
export type UserStateMetricsCourseModule = {
  __typename?: 'UserStateMetricsCourseModule';
  /** Number of completed videos */
  completedItems: Scalars['Int'];
  /** Percentage of items completed (0.0 to 100.0) */
  percentageItemsComplete: Scalars['Float'];
  /** Total number of videos in the module */
  totalItems: Scalars['Int'];
};

/** Course progress */
export type UserStateProgressCourse = {
  __typename?: 'UserStateProgressCourse';
  /** The number of times the course has been completed */
  completionCount: Scalars['Int'];
  /** The course title group id */
  courseTitleGroupId: Scalars['String'];
  /** The course metrics */
  metrics: UserStateMetricsCourse;
  /** The current state of the course. If the course has production_status of 'active-production', this will return IN_PROGRESS instead of COMPLETE even when all videos are complete. */
  state: UserStateCourse;
};

/** Course item progress */
export type UserStateProgressCourseItem = {
  __typename?: 'UserStateProgressCourseItem';
  /** The asset (if item is an asset) */
  asset?: Maybe<Asset>;
  /** The content (if item is a video) */
  content?: Maybe<Content>;
  /** The item id (video or asset id) */
  itemId: Scalars['String'];
  /** The type of item */
  itemType: UserStateProgressItemType;
  /** The current state of the item */
  state: UserStateState;
};

/** Course progress list response */
export type UserStateProgressCourseListResponse = {
  __typename?: 'UserStateProgressCourseListResponse';
  /** The total number of course progress entries matching the query */
  count?: Maybe<Scalars['Int']>;
  /** A list of course progress entries */
  courseProgress: Array<UserStateProgressCourse>;
  /** The limit used in the query */
  limit?: Maybe<Scalars['Int']>;
  /** The offset used in the query */
  offset?: Maybe<Scalars['Int']>;
};

/** Course module progress */
export type UserStateProgressCourseModule = {
  __typename?: 'UserStateProgressCourseModule';
  /** The module title group id */
  courseModuleTitleGroupId: Scalars['String'];
  /** The module metrics */
  metrics: UserStateMetricsCourseModule;
  /** The module content */
  module?: Maybe<Content>;
  /** The current state of the module */
  state: UserStateCourse;
};

export enum UserStateProgressItemType {
  /** An asset progress item */
  Asset = 'ASSET',
  /** A video progress item */
  Video = 'VIDEO'
}

export enum UserStateState {
  /** The item is complete */
  Complete = 'COMPLETE',
  /** The item is in progress */
  InProgress = 'IN_PROGRESS'
}

/** User state where id input type */
export type UserStateWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** User state where conditions to filter rows */
export type UserStateWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<UserStateWhereIdInput>;
  /** The uid field where clause */
  uid?: InputMaybe<UserStateWhereUidInput>;
};

/** User state where uid input type */
export type UserStateWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

export type UserTagOption = {
  __typename?: 'UserTagOption';
  /** Category grouping */
  category?: Maybe<Scalars['String']>;
  /** Tag option ID */
  id: Scalars['ID'];
  /** Translated display label */
  label: Scalars['String'];
  /** Internal tag name */
  tag: Scalars['String'];
};

/** Video analytics media row */
export type VideoAnalyticsMedia = {
  __typename?: 'VideoAnalyticsMedia';
  /** Rotating accumulators for distinct play counts per time period (hourly) */
  countBuckets?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Rotating accumulators for distinct play counts per time period (hourly) */
  countBuckets_de?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Rotating accumulators for distinct play counts per time period (hourly) */
  countBuckets_en?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Rotating accumulators for distinct play counts per time period (hourly) */
  countBuckets_es?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Rotating accumulators for distinct play counts per time period (hourly) */
  countBuckets_fr?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Lifetime count of distinct plays */
  countLifetime?: Maybe<Scalars['Int']>;
  /** Lifetime count of distinct plays */
  countLifetime_de?: Maybe<Scalars['Int']>;
  /** Lifetime count of distinct plays */
  countLifetime_en?: Maybe<Scalars['Int']>;
  /** Lifetime count of distinct plays */
  countLifetime_es?: Maybe<Scalars['Int']>;
  /** Lifetime count of distinct plays */
  countLifetime_fr?: Maybe<Scalars['Int']>;
  /** The course.nid referenced in this video that contains this media */
  courseId?: Maybe<Scalars['String']>;
  /** Auto generated field from sequelize */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The total length of this media (in seconds) */
  duration?: Maybe<Scalars['Int']>;
  /** Is this media a feature (true) or a preview (false) */
  isFeature?: Maybe<Scalars['Boolean']>;
  /** flag indicating the media has been published */
  isPublished?: Maybe<Scalars['Boolean']>;
  /** qualified string identifier for the media */
  lemonadeContentId?: Maybe<Scalars['String']>;
  /** The media linked from this video analytics media */
  media?: Maybe<Media>;
  /** VideoAnalyticsMedia creation date */
  mediaCreated?: Maybe<Scalars['String']>;
  /** The feature_nid */
  mediaId?: Maybe<Scalars['String']>;
  /** update to the media */
  mediaUpdated?: Maybe<Scalars['DateTime']>;
  /** The series.nid referenced in this video that contains this media */
  seriesId?: Maybe<Scalars['String']>;
  /** Auto generated field from sequelize */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Video analytics media list response */
export type VideoAnalyticsMediaListResponse = {
  __typename?: 'VideoAnalyticsMediaListResponse';
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
  /** A list of media */
  videoAnalyticsMedia?: Maybe<Array<Maybe<VideoAnalyticsMedia>>>;
};

/** Video analytics media list where clause for the course id */
export type VideoAnalyticsMediaListWhereCourseIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['Int']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Video analytics media list where clause for the id */
export type VideoAnalyticsMediaListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['Int']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Video analytics media list where clause */
export type VideoAnalyticsMediaListWhereInput = {
  /** Filter by course id */
  courseId?: InputMaybe<VideoAnalyticsMediaListWhereCourseIdInput>;
  /** Filter by media id */
  mediaId?: InputMaybe<VideoAnalyticsMediaListWhereIdInput>;
  /** Filter by series id */
  seriesId?: InputMaybe<VideoAnalyticsMediaListWhereSeriesIdInput>;
};

/** Video analytics media list where clause for the series id */
export type VideoAnalyticsMediaListWhereSeriesIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['Int']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Video analytics video row */
export type VideoAnalyticsVideo = {
  __typename?: 'VideoAnalyticsVideo';
  /** The course.nid referenced in this video */
  courseId?: Maybe<Scalars['ID']>;
  /** Auto generated field from sequelize */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** A flag indicating the video has been published */
  isPublished?: Maybe<Scalars['Boolean']>;
  /** The language of the video content */
  language: Scalars['String'];
  /** The media linked from this video analytics video */
  media?: Maybe<Media>;
  /** The feature.nid referenced in this video */
  mediaId?: Maybe<Scalars['ID']>;
  /** The content ID of the next episode in the series */
  nextEpisodeContentId?: Maybe<Scalars['ID']>;
  /** The publication date of the next episode in the series */
  nextEpisodePublishedAtDate?: Maybe<Scalars['DateTime']>;
  /** Status of the next episode in the series */
  nextEpisodeStatus?: Maybe<Scalars['String']>;
  /** The preview.nid referenced in this video */
  previewId?: Maybe<Scalars['ID']>;
  /** The primary language of the video content */
  primaryLanguage: Scalars['String'];
  /** The publication date of the video */
  publishedAtDate?: Maybe<Scalars['DateTime']>;
  /** The rainbow category (name) this video belongs to */
  rainbowCategory?: Maybe<Scalars['String']>;
  /** The rainbow category (key) this video belongs to */
  rainbowKey?: Maybe<Scalars['Int']>;
  /** The series.nid referenced in this video */
  seriesId?: Maybe<Scalars['ID']>;
  /** The title for this video */
  title?: Maybe<Scalars['String']>;
  /** The array of topics this video belongs to */
  topics?: Maybe<Array<Maybe<VideoAnalyticsVideoTopics>>>;
  /** The UBS segment (key) this video belongs to */
  ubsKey?: Maybe<Scalars['Int']>;
  /** The UBS segment (name) this video belongs to */
  ubsSegment?: Maybe<Scalars['String']>;
  /** Auto generated field from sequelize */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** VideoAnalyticsVideo creation date */
  videoCreated?: Maybe<Scalars['String']>;
  /** The video.nid */
  videoId: Scalars['ID'];
  /** Last update to the video */
  videoUpdated?: Maybe<Scalars['DateTime']>;
};

/** Video analytics video list response */
export type VideoAnalyticsVideoListResponse = {
  __typename?: 'VideoAnalyticsVideoListResponse';
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']>;
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']>;
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']>;
  /** A list of videos */
  videoAnalyticsVideos?: Maybe<Array<Maybe<VideoAnalyticsVideo>>>;
};

/** Video analytics video list where clause for the course id */
export type VideoAnalyticsVideoListWhereCourseIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Video analytics video list where clause for the id */
export type VideoAnalyticsVideoListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Video analytics video list where clause */
export type VideoAnalyticsVideoListWhereInput = {
  /** Filter by course id */
  courseId?: InputMaybe<VideoAnalyticsVideoListWhereCourseIdInput>;
  /** Filter by media id */
  mediaId?: InputMaybe<VideoAnalyticsVideoListWhereMediaIdInput>;
  /** Filter by series id */
  seriesId?: InputMaybe<VideoAnalyticsVideoListWhereSeriesIdInput>;
  /** Filter by video id */
  videoId?: InputMaybe<VideoAnalyticsVideoListWhereIdInput>;
};

/** Video analytics video list where clause for the media id */
export type VideoAnalyticsVideoListWhereMediaIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Video analytics video list where clause for the series id */
export type VideoAnalyticsVideoListWhereSeriesIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Video analytics video row topics */
export type VideoAnalyticsVideoTopics = {
  __typename?: 'VideoAnalyticsVideoTopics';
  /** The topic key (content id) */
  key?: Maybe<Scalars['Int']>;
  /** The topic title */
  title?: Maybe<Scalars['String']>;
};

/** Input payload for requesting a video auto summary. */
export type VideoAutoSummaryInput = {
  /** Oracle content identifier. */
  contentId: Scalars['String'];
  /** Feature media identifier. */
  featureMediaId: Scalars['String'];
  /** Language code for generated summary (en, es, de, fr). Defaults to en. */
  language?: Scalars['String'];
  /** Playback position in seconds; captions up to this timestamp are summarized. */
  pausedAtSeconds: Scalars['Float'];
};

/** Summary result for the watched portion of a video. */
export type VideoAutoSummaryPayload = {
  __typename?: 'VideoAutoSummaryPayload';
  /** Number of caption segments included in the summary. */
  captionCount: Scalars['Int'];
  /** Server timestamp when the summary was generated. */
  generatedAt: Scalars['DateTime'];
  /** Timestamp of the final caption considered (ISO or HH:MM:SS string). */
  lastCaptionTime?: Maybe<Scalars['String']>;
  /** LLM generated summary text. */
  summary: Scalars['String'];
};

/** A conceptually dense moment identified in a video. */
export type VideoConceptMoment = {
  __typename?: 'VideoConceptMoment';
  /** Short label describing the key concept in this moment. */
  conceptLabel: Scalars['String'];
  /** Normalized density score (0-1) indicating conceptual density. */
  densityScore: Scalars['Float'];
  /** End position in seconds. */
  endSeconds: Scalars['Float'];
  /** End timecode (HH:MM:SS) of the concept moment. */
  endTimecode: Scalars['String'];
  /** Start position in seconds. */
  startSeconds: Scalars['Float'];
  /** Start timecode (HH:MM:SS) of the concept moment. */
  startTimecode: Scalars['String'];
};

/** Input payload for requesting concept moment prompt suggestions. */
export type VideoConceptMomentPromptsInput = {
  /** The concept label from the moment (e.g. 'DNA Activation') — used to focus prompt generation. */
  conceptLabel: Scalars['String'];
  /** Oracle content identifier. */
  contentId: Scalars['String'];
  /** End of the concept moment window in seconds (from videoConceptMoments response). */
  endSeconds: Scalars['Float'];
  /** Previously shown/clicked prompt texts to exclude from results. */
  excludePrompts?: InputMaybe<Array<Scalars['String']>>;
  /** Feature media identifier. */
  featureMediaId: Scalars['String'];
  /** Language code for generated prompts (en, es, de, fr). Defaults to en. */
  language?: Scalars['String'];
  /** Start of the concept moment window in seconds (from videoConceptMoments response). */
  startSeconds: Scalars['Float'];
};

/** Result payload for concept moment prompt suggestions. */
export type VideoConceptMomentPromptsPayload = {
  __typename?: 'VideoConceptMomentPromptsPayload';
  /** The concept label these prompts were generated for. */
  conceptLabel: Scalars['String'];
  /** Server timestamp when prompts were generated. */
  generatedAt: Scalars['DateTime'];
  /** List of suggested prompts scoped to this concept moment. */
  prompts: Array<VideoPromptSuggestion>;
};

/** Input payload for requesting a concept moment summary. */
export type VideoConceptMomentSummaryInput = {
  /** Concept label from the moment (used to focus the summary). */
  conceptLabel: Scalars['String'];
  /** Oracle content identifier. */
  contentId: Scalars['String'];
  /** End of the dense section in seconds (from videoConceptMoments response). */
  endSeconds: Scalars['Float'];
  /** Feature media identifier. */
  featureMediaId: Scalars['String'];
  /** Language code for the generated summary (en, es, de, fr). Defaults to en. */
  language?: Scalars['String'];
  /** Start of the dense section in seconds (from videoConceptMoments response). */
  startSeconds: Scalars['Float'];
};

/** Summary of a specific concept moment in a video. */
export type VideoConceptMomentSummaryPayload = {
  __typename?: 'VideoConceptMomentSummaryPayload';
  /** Number of transcript segments included in the summary. */
  captionCount: Scalars['Int'];
  /** The concept label that was summarized. */
  conceptLabel: Scalars['String'];
  /** End timecode (HH:MM:SS) of the summarized section. */
  endTimecode: Scalars['String'];
  /** Server timestamp when the summary was generated. */
  generatedAt: Scalars['DateTime'];
  /** Start timecode (HH:MM:SS) of the summarized section. */
  startTimecode: Scalars['String'];
  /** LLM-generated summary of the concept moment. */
  summary: Scalars['String'];
};

/** Input payload for requesting video concept moments. */
export type VideoConceptMomentsInput = {
  /** Oracle content identifier. */
  contentId: Scalars['String'];
  /** Feature media identifier. */
  featureMediaId: Scalars['String'];
  /** Language code for generated concept labels (en, es, de, fr). Defaults to en. */
  language?: Scalars['String'];
  /** Maximum number of concept moments to return. Set to 0 to auto-compute from video duration. */
  maxMoments?: Scalars['Int'];
};

/** Result payload for video concept moments analysis. */
export type VideoConceptMomentsPayload = {
  __typename?: 'VideoConceptMomentsPayload';
  /** Whether the result was served from cache. */
  fromCache: Scalars['Boolean'];
  /** Server timestamp when the moments were generated or retrieved from cache. */
  generatedAt: Scalars['DateTime'];
  /** List of identified concept moments, ordered by timecode. */
  moments: Array<VideoConceptMoment>;
  /** Status indicating why no moments were returned. Null when moments are present. Values: NO_TRANSCRIPT, INSUFFICIENT_SPEECH, NO_DENSE_MOMENTS. */
  status?: Maybe<Scalars['String']>;
  /** Estimated video duration in seconds based on last chunk timecode, or null if unavailable. */
  videoDurationEstimate?: Maybe<Scalars['Float']>;
};

/** Single prompt suggestion with metadata. */
export type VideoPromptSuggestion = {
  __typename?: 'VideoPromptSuggestion';
  /** The focus area or topic of the suggestion. */
  focus: Scalars['String'];
  /** The suggested prompt/question text. */
  prompt: Scalars['String'];
  /** Explanation of why this suggestion was made. */
  rationale: Scalars['String'];
};

/** Input payload for requesting video prompt suggestions. */
export type VideoPromptSuggestionsInput = {
  /** Oracle content identifier. */
  contentId: Scalars['String'];
  /** Playback position in seconds; captions up to this timestamp are considered. */
  currentTimeSeconds: Scalars['Float'];
  /** Optional list of prompt texts to exclude from results (e.g., previously shown prompts). */
  excludePrompts?: InputMaybe<Array<Scalars['String']>>;
  /** Feature media identifier. */
  featureMediaId: Scalars['String'];
  /** Language code for generated prompts (en, es, de, fr). Defaults to en. */
  language?: Scalars['String'];
};

/** Result payload for video prompt suggestions. */
export type VideoPromptSuggestionsPayload = {
  __typename?: 'VideoPromptSuggestionsPayload';
  /** Number of chunk segments actually included in the context excerpt. */
  contextChunksUsed: Scalars['Int'];
  /** End timecode (HH:MM:SS) of the context coverage, or null if unavailable. */
  coverageEndTimecode?: Maybe<Scalars['String']>;
  /** Start timecode (HH:MM:SS) of the context coverage, or null if unavailable. */
  coverageStartTimecode?: Maybe<Scalars['String']>;
  /** Server timestamp when the suggestions were generated. */
  generatedAt: Scalars['DateTime'];
  /** List of suggested prompts/questions. */
  suggestions: Array<VideoPromptSuggestion>;
  /** Total number of chunk segments considered from the database. */
  totalChunksConsidered: Scalars['Int'];
};

export type ViewerGeoLocation = {
  __typename?: 'ViewerGeoLocation';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  formattedLocation?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

/** Content analytic */
export type Vote = {
  __typename?: 'Vote';
  /** The content linked to this vote */
  content?: Maybe<Array<Maybe<Content>>>;
  /** The id of the content */
  contentId?: Maybe<Scalars['Int']>;
  /** The content type for the content id */
  contentType?: Maybe<Scalars['String']>;
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']>;
  /** The id of the user */
  uid?: Maybe<Scalars['Int']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user info linked to this vote */
  userInfo?: Maybe<UserInfo>;
  /** The vote direction */
  voteDirection?: Maybe<VoteDirection>;
};


/** Content analytic */
export type VoteContentArgs = {
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum VoteDirection {
  /** This is a down vote */
  Down = 'DOWN',
  /** This is a love vote */
  Love = 'LOVE',
  /** This is an up vote */
  Up = 'UP'
}

/** Content analytic where id input type */
export type VoteWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** Content analytic where conditions to filter rows */
export type VoteWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<VoteWhereIdInput>;
  /** The id field where clause */
  uid?: InputMaybe<VoteWhereUidInput>;
};

/** Content analytic where uid input type */
export type VoteWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** Content analytic list response */
export type VotesListResponse = {
  __typename?: 'VotesListResponse';
  /** The total number of votes matching the query */
  count?: Maybe<Scalars['Int']>;
  /** The limit used in the query */
  limit?: Maybe<Scalars['Int']>;
  /** The offset used in the query */
  offset?: Maybe<Scalars['Int']>;
  /** A list of Content analytic */
  votes?: Maybe<Array<Maybe<Vote>>>;
};

/** Filter for watch history completion status */
export enum WatchHistoryFilter {
  /** All watch history */
  All = 'ALL',
  /** Only completed videos (watched_sum/duration >= 80%) */
  Completed = 'COMPLETED',
  /** Only in-progress videos (watched_sum/duration < 80%) */
  InProgress = 'IN_PROGRESS'
}

/** Worker */
export type Worker = {
  __typename?: 'Worker';
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Additional data the the worker would need to maintain proper state */
  data?: Maybe<Scalars['JSON']>;
  /** When true the worker is allowed to run when false it shoudl not do any work */
  enabled?: Maybe<Scalars['Boolean']>;
  /** When the worker last stopped or went idle */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The primary identifier for this record */
  id: Scalars['ID'];
  /** The last value processed by this worker, an example could be an db offset or id for the last row processed */
  lastProcessedValue?: Maybe<Scalars['String']>;
  /** When the worker lock expires or null if there is no lock */
  lockExpiresDate?: Maybe<Scalars['DateTime']>;
  /** Identifier of the process holding the lock (e.g. pod name) */
  lockHolder?: Maybe<Scalars['String']>;
  /** The human readable name of the worker */
  name: Scalars['String'];
  /** The run state of the worker */
  runState?: Maybe<WorkerState>;
  /** When the woker last started */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Worker create input */
export type WorkerCreateInput = {
  /** Additional data the the worker would need to maintain proper state */
  data?: InputMaybe<Scalars['JSON']>;
  /** When true the worker is allowed to run when false it shoudl not do any work */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** When the worker last stopped or went idle */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** The last value processed by this worker, an example could be an db offset or id for the last row processed */
  lastProcessedValue?: InputMaybe<Scalars['String']>;
  /** When the worker lock expires or null if there is no lock */
  lockExpiresDate?: InputMaybe<Scalars['DateTime']>;
  /** Identifier of the process holding the lock (e.g. pod name) */
  lockHolder?: InputMaybe<Scalars['String']>;
  /** The worker name */
  name: Scalars['String'];
  /** The run state of the worker */
  runState?: InputMaybe<WorkerState>;
  /** When the woker last started */
  startDate?: InputMaybe<Scalars['DateTime']>;
};

/** Worker delete input */
export type WorkerDeleteInput = {
  /** The worker id */
  id?: InputMaybe<Scalars['ID']>;
  /** The worker name */
  name?: InputMaybe<Scalars['String']>;
};

/** Worker response */
export type WorkerListResponse = {
  __typename?: 'WorkerListResponse';
  /** A list of workers */
  workers?: Maybe<Array<Maybe<Worker>>>;
};

/** Worker mutation response */
export type WorkerMutationResponse = {
  __typename?: 'WorkerMutationResponse';
  /** When true mutation was successful */
  success?: Maybe<Scalars['Boolean']>;
  /** The worker which was mutated */
  worker?: Maybe<Worker>;
};

export enum WorkerState {
  /** The worker is idle */
  Idle = 'IDLE',
  /** The worker is running */
  Running = 'RUNNING',
  /** The worker is stopped */
  Stopped = 'STOPPED'
}

/** Worker update input */
export type WorkerUpdateInput = {
  /** Additional data the the worker would need to maintain proper state */
  data?: InputMaybe<Scalars['JSON']>;
  /** When true the worker is allowed to run when false it shoudl not do any work */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** When the worker last stopped or went idle */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** The primary identifier for this record */
  id?: InputMaybe<Scalars['ID']>;
  /** The last value processed by this worker, an example could be an db offset or id for the last row processed */
  lastProcessedValue?: InputMaybe<Scalars['String']>;
  /** When the worker lock expires or null if there is no lock */
  lockExpiresDate?: InputMaybe<Scalars['DateTime']>;
  /** Identifier of the process holding the lock (e.g. pod name) */
  lockHolder?: InputMaybe<Scalars['String']>;
  /** The worker name */
  name?: InputMaybe<Scalars['String']>;
  /** The run state of the worker */
  runState?: InputMaybe<WorkerState>;
  /** When the woker last started */
  startDate?: InputMaybe<Scalars['DateTime']>;
};

/** The where clause for a worker id field */
export type WorkerWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']>;
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']>;
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']>;
};

/** Worker where input */
export type WorkerWhereInput = {
  /** Worker where id clause */
  id?: InputMaybe<WorkerWhereIdInput>;
  /** Worker where name clause */
  name?: InputMaybe<WorkerWhereNameInput>;
};

/** The where clause for a worker name field */
export type WorkerWhereNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']>;
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type CreateBillingProductInput = {
  /** The content set id of the billing product */
  contentSetId: Scalars['Int'];
  /** The name of the billing Product */
  name: Scalars['String'];
  /** The name of the billing product platform */
  platform: ProductPlatform;
};

export type CreateBillingProviderInput = {
  /** The name of the billing provider */
  name: BillingProviderName;
  /** Whether the billing provider has subscription management */
  subscriptionManagement: Scalars['Boolean'];
};

/** Repsonse when creating an ecommerce sku mapping bonus eligibility item */
export type EcommerceSkuMappingBonusEligibilityCreateResponse = {
  __typename?: 'ecommerceSkuMappingBonusEligibilityCreateResponse';
  /** The ecommerce sku mapping bonus eligibility that was created */
  ecommerceSkuMappingBonusEligibility?: Maybe<EcommerceSkuMappingBonusEligibility>;
};

/** Repsonse when deleting an ecommerce sku mapping bonus eligibility item */
export type EcommerceSkuMappingBonusEligibilityDeleteByIdResponse = {
  __typename?: 'ecommerceSkuMappingBonusEligibilityDeleteByIdResponse';
  /** The ecommerce sku mapping bonus eligibility that was deleted */
  ecommerceSkuMappingBonusEligibility?: Maybe<EcommerceSkuMappingBonusEligibility>;
};

/** Repsonse when updating an ecommerce sku mapping bonus eligibility item */
export type EcommerceSkuMappingBonusEligibilityUpdateByIdResponse = {
  __typename?: 'ecommerceSkuMappingBonusEligibilityUpdateByIdResponse';
  /** The ecommerce sku mapping bonus eligibility that was updated */
  ecommerceSkuMappingBonusEligibility?: Maybe<EcommerceSkuMappingBonusEligibility>;
};

/** Repsonse when creating an ecommerce sku mapping */
export type EcommerceSkuMappingCreateResponse = {
  __typename?: 'ecommerceSkuMappingCreateResponse';
  /** The ecommerce sku mapping that was created */
  ecommerceSkuMapping?: Maybe<EcommerceSkuMapping>;
};

/** Repsonse when updating an ecommerce sku mapping */
export type EcommerceSkuMappingUpdateByProviderAndEcommerceSkuResponse = {
  __typename?: 'ecommerceSkuMappingUpdateByProviderAndEcommerceSkuResponse';
  /** The ecommerce sku mapping that was updated */
  ecommerceSkuMapping?: Maybe<EcommerceSkuMapping>;
};

export type UpdateBillingProductInput = {
  /** The content set id of the billing product */
  contentSetId?: InputMaybe<Scalars['Int']>;
  /** The id of the billing product */
  id: Scalars['ID'];
  /** The name of the billing Product */
  name?: InputMaybe<Scalars['String']>;
  /** The name of the billing product platform */
  platform?: InputMaybe<ProductPlatform>;
};

export type UpdateBillingProviderInput = {
  /** The id of the billing provider */
  id: Scalars['ID'];
  /** The name of the billing provider */
  name?: InputMaybe<BillingProviderName>;
  /** Whether the billing provider has subscription management */
  subscriptionManagement?: InputMaybe<Scalars['Boolean']>;
};
